"use strict";

function n(r) {
  return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  })(r);
}

function r(n, r) {
  if (!(n instanceof r)) throw new TypeError("Cannot call a class as a function");
}

function t(n, r) {
  for (var t = 0; t < r.length; t++) {
    var e = r[t];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
  }
}

function e(n, r, e) {
  return r && t(n.prototype, r), e && t(n, e), n;
}

function i(n, r, t) {
  return r in n ? Object.defineProperty(n, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = t, n;
}

function a(n, r) {
  var t = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(n);
    r && (e = e.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, e);
  }

  return t;
}

var o,
    u = {
  ALIGN_COUNT: 8,
  ALIGN_AUTO: 0,
  ALIGN_FLEX_START: 1,
  ALIGN_CENTER: 2,
  ALIGN_FLEX_END: 3,
  ALIGN_STRETCH: 4,
  ALIGN_BASELINE: 5,
  ALIGN_SPACE_BETWEEN: 6,
  ALIGN_SPACE_AROUND: 7,
  DIMENSION_COUNT: 2,
  DIMENSION_WIDTH: 0,
  DIMENSION_HEIGHT: 1,
  DIRECTION_COUNT: 3,
  DIRECTION_INHERIT: 0,
  DIRECTION_LTR: 1,
  DIRECTION_RTL: 2,
  DISPLAY_COUNT: 2,
  DISPLAY_FLEX: 0,
  DISPLAY_NONE: 1,
  EDGE_COUNT: 9,
  EDGE_LEFT: 0,
  EDGE_TOP: 1,
  EDGE_RIGHT: 2,
  EDGE_BOTTOM: 3,
  EDGE_START: 4,
  EDGE_END: 5,
  EDGE_HORIZONTAL: 6,
  EDGE_VERTICAL: 7,
  EDGE_ALL: 8,
  EXPERIMENTAL_FEATURE_COUNT: 1,
  EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: 0,
  FLEX_DIRECTION_COUNT: 4,
  FLEX_DIRECTION_COLUMN: 0,
  FLEX_DIRECTION_COLUMN_REVERSE: 1,
  FLEX_DIRECTION_ROW: 2,
  FLEX_DIRECTION_ROW_REVERSE: 3,
  JUSTIFY_COUNT: 6,
  JUSTIFY_FLEX_START: 0,
  JUSTIFY_CENTER: 1,
  JUSTIFY_FLEX_END: 2,
  JUSTIFY_SPACE_BETWEEN: 3,
  JUSTIFY_SPACE_AROUND: 4,
  JUSTIFY_SPACE_EVENLY: 5,
  LOG_LEVEL_COUNT: 6,
  LOG_LEVEL_ERROR: 0,
  LOG_LEVEL_WARN: 1,
  LOG_LEVEL_INFO: 2,
  LOG_LEVEL_DEBUG: 3,
  LOG_LEVEL_VERBOSE: 4,
  LOG_LEVEL_FATAL: 5,
  MEASURE_MODE_COUNT: 3,
  MEASURE_MODE_UNDEFINED: 0,
  MEASURE_MODE_EXACTLY: 1,
  MEASURE_MODE_AT_MOST: 2,
  NODE_TYPE_COUNT: 2,
  NODE_TYPE_DEFAULT: 0,
  NODE_TYPE_TEXT: 1,
  OVERFLOW_COUNT: 3,
  OVERFLOW_VISIBLE: 0,
  OVERFLOW_HIDDEN: 1,
  OVERFLOW_SCROLL: 2,
  POSITION_TYPE_COUNT: 2,
  POSITION_TYPE_RELATIVE: 0,
  POSITION_TYPE_ABSOLUTE: 1,
  PRINT_OPTIONS_COUNT: 3,
  PRINT_OPTIONS_LAYOUT: 1,
  PRINT_OPTIONS_STYLE: 2,
  PRINT_OPTIONS_CHILDREN: 4,
  UNIT_COUNT: 4,
  UNIT_UNDEFINED: 0,
  UNIT_POINT: 1,
  UNIT_PERCENT: 2,
  UNIT_AUTO: 3,
  WRAP_COUNT: 3,
  WRAP_NO_WRAP: 0,
  WRAP_WRAP: 1,
  WRAP_WRAP_REVERSE: 2
},
    f = function () {
  function n(t, e, i, a, o, u) {
    r(this, n), this.left = t, this.right = e, this.top = i, this.bottom = a, this.width = o, this.height = u;
  }

  return e(n, [{
    key: "fromJS",
    value: function value(n) {
      n(this.left, this.right, this.top, this.bottom, this.width, this.height);
    }
  }, {
    key: "toString",
    value: function value() {
      return "<Layout#".concat(this.left, ":").concat(this.right, ";").concat(this.top, ":").concat(this.bottom, ";").concat(this.width, ":").concat(this.height, ">");
    }
  }]), n;
}(),
    A = function () {
  function n(t, e) {
    r(this, n), this.width = t, this.height = e;
  }

  return e(n, null, [{
    key: "fromJS",
    value: function value(r) {
      return new n(r.width, r.height);
    }
  }]), e(n, [{
    key: "fromJS",
    value: function value(n) {
      n(this.width, this.height);
    }
  }, {
    key: "toString",
    value: function value() {
      return "<Size#".concat(this.width, "x").concat(this.height, ">");
    }
  }]), n;
}(),
    c = function () {
  function n(t, e) {
    r(this, n), this.unit = t, this.value = e;
  }

  return e(n, [{
    key: "fromJS",
    value: function value(n) {
      n(this.unit, this.value);
    }
  }, {
    key: "toString",
    value: function value() {
      switch (this.unit) {
        case u.UNIT_POINT:
          return String(this.value);

        case u.UNIT_PERCENT:
          return "".concat(this.value, "%");

        case u.UNIT_AUTO:
          return "auto";

        default:
          return "".concat(this.value, "?");
      }
    }
  }, {
    key: "valueOf",
    value: function value() {
      return this.value;
    }
  }]), n;
}(),
    l = function l(n, r) {
  function t(n, r, t) {
    var e = n[r];

    n[r] = function () {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
        r[i] = arguments[i];
      }

      return t.call.apply(t, [this, e].concat(r));
    };
  }

  for (var e = function e() {
    var n,
        e = l[o],
        a = (i(n = {}, u.UNIT_POINT, r.Node.prototype[e]), i(n, u.UNIT_PERCENT, r.Node.prototype["".concat(e, "Percent")]), i(n, u.UNIT_AUTO, r.Node.prototype["".concat(e, "Auto")]), n);
    t(r.Node.prototype, e, function (n) {
      for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
        t[i - 1] = arguments[i];
      }

      var o,
          f,
          A,
          l,
          s = t.pop();
      if ("auto" === s) o = u.UNIT_AUTO, f = void 0;else if (s instanceof c) o = s.unit, f = s.valueOf();else if (o = "string" == typeof s && s.endsWith("%") ? u.UNIT_PERCENT : u.UNIT_POINT, f = parseFloat(s), !Number.isNaN(s) && Number.isNaN(f)) throw new Error("Invalid value ".concat(s, " for ").concat(e));
      if (!a[o]) throw new Error('Failed to execute "'.concat(e, "\": Unsupported unit '").concat(s, "'"));
      return void 0 !== f ? (A = a[o]).call.apply(A, [this].concat(t, [f])) : (l = a[o]).call.apply(l, [this].concat(t));
    });
  }, o = 0, l = ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]; o < l.length; o++) {
    e();
  }

  return t(r.Config.prototype, "free", function () {
    r.Config.destroy(this);
  }), t(r.Node, "create", function (n, t) {
    return t ? r.Node.createWithConfig(t) : r.Node.createDefault();
  }), t(r.Node.prototype, "free", function () {
    r.Node.destroy(this);
  }), t(r.Node.prototype, "freeRecursive", function () {
    for (var n = 0, r = this.getChildCount(); n < r; ++n) {
      this.getChild(0).freeRecursive();
    }

    this.free();
  }), t(r.Node.prototype, "setMeasureFunc", function (n, r) {
    return r ? n.call(this, function () {
      return A.fromJS(r.apply(void 0, arguments));
    }) : this.unsetMeasureFunc();
  }), t(r.Node.prototype, "calculateLayout", function (n) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : NaN,
        t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : NaN,
        e = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : u.DIRECTION_LTR;
    return n.call(this, r, t, e);
  }), function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? a(Object(t), !0).forEach(function (r) {
        i(n, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : a(Object(t)).forEach(function (r) {
        Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }

    return n;
  }({
    Config: r.Config,
    Node: r.Node,
    Layout: n("Layout", f),
    Size: n("Size", A),
    Value: n("Value", c)
  }, u);
},
    s = (o = "undefined" == typeof document ? new (require("url").URL)("file:" + __filename).href : document.currentScript && document.currentScript.src || new URL("asm.js", document.baseURI).href, function (r) {
  var t;
  (r = void 0 !== (r = r || {}) ? r : {}).ready = new Promise(function (n, r) {
    t = n;
  });
  var e,
      i = {};

  for (e in r) {
    r.hasOwnProperty(e) && (i[e] = r[e]);
  }

  var a = !1,
      u = !1,
      f = !1;
  a = "object" === ("undefined" == typeof window ? "undefined" : n(window)), u = "function" == typeof importScripts, f = "object" === ("undefined" == typeof process ? "undefined" : n(process)) && "object" === n(process.versions) && "string" == typeof process.versions.node;
  var A,
      c = "";

  function l(n) {
    return r.locateFile ? r.locateFile(n, c) : c + n;
  }

  a || f || u ? (a || u) && (u ? c = self.location.href : document.currentScript && (c = document.currentScript.src), o && (c = o), c = 0 !== c.indexOf("blob:") ? c.substr(0, c.lastIndexOf("/") + 1) : "", u && (A = function A(n) {
    try {
      var r = new XMLHttpRequest();
      return r.open("GET", n, !1), r.responseType = "arraybuffer", r.send(null), new Uint8Array(r.response);
    } catch (r) {
      var t = Xt(n);
      if (t) return t;
      throw r;
    }
  })) : (A = function A(r) {
    var t;
    return (t = Xt(r)) ? t : "function" == typeof readbuffer ? new Uint8Array(readbuffer(r)) : (k("object" === n(t = read(r, "binary"))), t);
  }, "undefined" != typeof scriptArgs && scriptArgs, "undefined" != typeof print && ("undefined" == typeof console && (console = {}), console.log = print, console.warn = console.error = "undefined" != typeof printErr ? printErr : print));
  var s = r.print || console.log.bind(console),
      v = r.printErr || console.warn.bind(console);

  for (e in i) {
    i.hasOwnProperty(e) && (r[e] = i[e]);
  }

  i = null, r.arguments && r.arguments, r.thisProgram && r.thisProgram, r.quit && r.quit;

  var d,
      b = function b(n) {};

  r.wasmBinary && (d = r.wasmBinary), r.noExitRuntime && r.noExitRuntime;
  var p,
      h = {
    Memory: function Memory(n) {
      return {
        buffer: new ArrayBuffer(65536 * n.initial),
        grow: function grow(n) {
          return Ht(n);
        }
      };
    },
    Table: function Table(n) {
      var r = new Array(n.initial);
      return r.grow = function (n) {
        r.length >= 231 && ln("Unable to grow wasm table. Use a higher value for RESERVED_FUNCTION_POINTERS or set ALLOW_TABLE_GROWTH."), r.push(null);
      }, r.set = function (n, t) {
        r[n] = t;
      }, r.get = function (n) {
        return r[n];
      }, r;
    },
    Module: function Module(n) {
      return {};
    },
    Instance: function Instance(n, r) {
      return {
        exports: function (n, r, t) {
          var e = new ArrayBuffer(8),
              i = new Int32Array(e),
              a = new Float32Array(e),
              o = new Float64Array(e);

          function u(n) {
            return i[n];
          }

          function f(n, r) {
            i[n] = r;
          }

          function A() {
            return o[0];
          }

          function c(n) {
            o[0] = n;
          }

          function l(n, r) {
            i[0] = n, i[1] = r;
          }

          function s(n) {
            a[0] = n;
          }

          function v() {
            return a[0];
          }

          for (var d = new Uint8Array(123), b = 25; b >= 0; --b) {
            d[48 + b] = 52 + b, d[65 + b] = b, d[97 + b] = 26 + b;
          }

          function p(n, r, t) {
            var e,
                i,
                a = 0,
                o = r,
                u = t.length,
                f = r + (3 * u >> 2);

            for ("=" == t[u - 2] && --f, "=" == t[u - 1] && --f; a < u; a += 4, o += 3) {
              e = d[t.charCodeAt(a + 1)], i = d[t.charCodeAt(a + 2)], n[o] = d[t.charCodeAt(a)] << 2 | e >> 4, o + 1 < f && (n[o + 1] = e << 4 | i >> 2), o + 2 < f && (n[o + 2] = i << 6 | d[t.charCodeAt(a + 3)]);
            }
          }

          d[43] = 62, d[47] = 63;
          var h = new Uint8Array(r.buffer);
          return p(h, 1024, "Q2Fubm90IHNldCBtZWFzdXJlIGZ1bmN0aW9uOiBOb2RlcyB3aXRoIG1lYXN1cmUgZnVuY3Rpb25zIGNhbm5vdCBoYXZlIGNoaWxkcmVuLgBDYW5ub3QgcmVzZXQgYSBub2RlIHdoaWNoIHN0aWxsIGhhcyBjaGlsZHJlbiBhdHRhY2hlZABDYW5ub3QgcmVzZXQgYSBub2RlIHN0aWxsIGF0dGFjaGVkIHRvIGEgb3duZXIAYWxsb2NhdG9yPFQ+OjphbGxvY2F0ZShzaXplX3QgbikgJ24nIGV4Y2VlZHMgbWF4aW11bSBzdXBwb3J0ZWQgc2l6ZQAAAAAAAQAAAAAAwH8AAAAAAADAfwMAAABDb3VsZCBub3QgYWxsb2NhdGUgbWVtb3J5IGZvciBub2RlAENoaWxkIGFscmVhZHkgaGFzIGEgb3duZXIsIGl0IG11c3QgYmUgcmVtb3ZlZCBmaXJzdC4AQ2Fubm90IGFkZCBjaGlsZDogTm9kZXMgd2l0aCBtZWFzdXJlIGZ1bmN0aW9ucyBjYW5ub3QgaGF2ZSBjaGlsZHJlbi4AT25seSBsZWFmIG5vZGVzIHdpdGggY3VzdG9tIG1lYXN1cmUgZnVuY3Rpb25zc2hvdWxkIG1hbnVhbGx5IG1hcmsgdGhlbXNlbHZlcyBhcyBkaXJ0eQBDYW5ub3QgZ2V0IGxheW91dCBwcm9wZXJ0aWVzIG9mIG11bHRpLWVkZ2Ugc2hvcnRoYW5kcwAAAAABAAAAAwAAAAAAAAACAAAAAwAAAAEAAAACAAAAAAAAACVzJWQue1tza2lwcGVkXSAAd206ICVzLCBobTogJXMsIGF3OiAlZiBhaDogJWYgPT4gZDogKCVmLCAlZikgJXMKACVzJWQueyVzACoAAHdtOiAlcywgaG06ICVzLCBhdzogJWYgYWg6ICVmICVzCgAlcyVkLn0lcwB3bTogJXMsIGhtOiAlcywgZDogKCVmLCAlZikgJXMKAE91dCBvZiBjYWNoZSBlbnRyaWVzIQoAU2NhbGUgZmFjdG9yIHNob3VsZCBub3QgYmUgbGVzcyB0aGFuIHplcm8AAAABAAAAAQ=="), p(h, 1864, "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"), p(h, 3936, "5CAAABwPAABEIQAA/CAAAHZpaWlpAAAA5CAAABwPAAB0IQAAdmlpZgAAAAD8IAAAOA8AAEQhAABpaWlpADZMYXlvdXQAAAAA3CEAAJ0PAABpAGRpaQB2aWlkADE1TWVhc3VyZUNhbGxiYWNrAAAAANwhAAC7DwAAUDE1TWVhc3VyZUNhbGxiYWNrAAC8IgAA2A8AAAAAAADQDwAAUEsxNU1lYXN1cmVDYWxsYmFjawC8IgAA/A8AAAEAAADQDwAAQBAAAOwPAAB0IQAAWBAAAHQhAABYEAAANllHU2l6ZQDcIQAAOBAAADEzWUdNZWFzdXJlTW9kZQCQIQAASBAAAGlpaWZpZmkAbm90aWZ5T25EZXN0cnVjdGlvbgBpbXBsZW1lbnQAZXh0ZW5k"), p(h, 4245, "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"), p(h, 7152, "EQAKABEREQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAARAA8KERERAwoHAAETCQsLAAAJBgsAAAsABhEAAAARERE="), p(h, 7233, "CwAAAAAAAAAAEQAKChEREQAKAAACAAkLAAAACQALAAAL"), p(h, 7291, "DA=="), p(h, 7303, "DAAAAAAMAAAAAAkMAAAAAAAMAAAM"), p(h, 7349, "Dg=="), p(h, 7361, "DQAAAAQNAAAAAAkOAAAAAAAOAAAO"), p(h, 7407, "EA=="), p(h, 7419, "DwAAAAAPAAAAAAkQAAAAAAAQAAAQAAASAAAAEhIS"), p(h, 7474, "EgAAABISEgAAAAAAAAk="), p(h, 7523, "Cw=="), p(h, 7535, "CgAAAAAKAAAAAAkLAAAAAAALAAAL"), p(h, 7581, "DA=="), p(h, 7593, "DAAAAAAMAAAAAAkMAAAAAAAMAAAMAAAwMTIzNDU2Nzg5QUJDREVGLTBYKzBYIDBYLTB4KzB4IDB4AGluZgBJTkYAbmFuAE5BTgAuAAAAAGAjAABiYXNpY19zdHJpbmcAYWxsb2NhdG9yPFQ+OjphbGxvY2F0ZShzaXplX3QgbikgJ24nIGV4Y2VlZHMgbWF4aW11bSBzdXBwb3J0ZWQgc2l6ZQB2ZWN0b3IAX19jeGFfZ3VhcmRfYWNxdWlyZSBkZXRlY3RlZCByZWN1cnNpdmUgaW5pdGlhbGl6YXRpb24AUHVyZSB2aXJ0dWFsIGZ1bmN0aW9uIGNhbGxlZCEAc3RkOjpleGNlcHRpb24AAAAAAADcHgAAywAAAMwAAADNAAAAU3Q5ZXhjZXB0aW9uAAAAANwhAADMHgAAAAAAAAgfAAABAAAAzgAAAM8AAABTdDExbG9naWNfZXJyb3IABCIAAPgeAADcHgAAAAAAADwfAAABAAAA0AAAAM8AAABTdDEybGVuZ3RoX2Vycm9yAAAAAAQiAAAoHwAACB8AAFN0OXR5cGVfaW5mbwAAAADcIQAASB8AAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAAAQiAABgHwAAWB8AAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAAAQiAACQHwAAhB8AAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAAAQiAADAHwAAhB8AAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FAAQiAADwHwAA5B8AAE4xMF9fY3h4YWJpdjEyMF9fZnVuY3Rpb25fdHlwZV9pbmZvRQAAAAAEIgAAICAAAIQfAABOMTBfX2N4eGFiaXYxMjlfX3BvaW50ZXJfdG9fbWVtYmVyX3R5cGVfaW5mb0UAAAAEIgAAVCAAAOQfAAAAAAAA1CAAANEAAADSAAAA0wAAANQAAADVAAAATjEwX19jeHhhYml2MTIzX19mdW5kYW1lbnRhbF90eXBlX2luZm9FAAQiAACsIAAAhB8AAHYAAACYIAAA4CAAAERuAACYIAAA7CAAAGIAAACYIAAA+CAAAGMAAACYIAAABCEAAGgAAACYIAAAECEAAGEAAACYIAAAHCEAAHMAAACYIAAAKCEAAHQAAACYIAAANCEAAGkAAACYIAAAQCEAAGoAAACYIAAATCEAAGwAAACYIAAAWCEAAG0AAACYIAAAZCEAAGYAAACYIAAAcCEAAGQAAACYIAAAfCEAAAAAAADIIQAA0QAAANYAAADTAAAA1AAAANcAAABOMTBfX2N4eGFiaXYxMTZfX2VudW1fdHlwZV9pbmZvRQAAAAAEIgAApCEAAIQfAAAAAAAAtB8AANEAAADYAAAA0wAAANQAAADZAAAA2gAAANsAAADcAAAAAAAAAEwiAADRAAAA3QAAANMAAADUAAAA2QAAAN4AAADfAAAA4AAAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAEIgAAJCIAALQfAAAAAAAAqCIAANEAAADhAAAA0wAAANQAAADZAAAA4gAAAOMAAADkAAAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAAAQiAACAIgAAtB8AAAAAAAAUIAAA0QAAAOUAAADTAAAA1AAAAOY="), p(h, 8912, "BQ=="), p(h, 8924, "xA=="), p(h, 8948, "xQAAAMYAAAARJQ=="), p(h, 8972, "Ag=="), p(h, 8987, "//////8="), p(h, 9056, "BQ=="), p(h, 9068, "yQ=="), p(h, 9092, "xQAAAMoAAAAoJQAAAAQ="), p(h, 9116, "AQ=="), p(h, 9131, "Cv////8="), p(h, 9376, "UCk="), function (n, r, e) {
            var i = r.memory,
                a = t,
                o = new n.Int8Array(e),
                d = new n.Int16Array(e),
                b = new n.Int32Array(e),
                p = new n.Uint8Array(e),
                h = new n.Uint16Array(e),
                y = new n.Uint32Array(e),
                m = new n.Float32Array(e),
                k = new n.Float64Array(e),
                g = n.Math.imul,
                _ = n.Math.fround,
                C = n.Math.abs,
                E = n.Math.clz32,
                w = n.Math.min,
                N = n.Math.max,
                W = (n.Math.floor, n.Math.ceil, n.Math.sqrt, r.abort),
                Z = n.NaN,
                T = (n.Infinity, r._embind_register_class_function),
                I = r._embind_register_memory_view,
                R = r._embind_register_integer,
                B = r._embind_register_class_class_function,
                V = r._embind_register_class,
                G = r._embind_register_value_object_field,
                F = r._embind_finalize_value_object,
                X = r._embind_register_value_object,
                O = r._embind_register_std_wstring,
                Q = r._ZN8facebook4yoga24LayoutPassReasonToStringENS0_16LayoutPassReasonE,
                U = r._embind_register_class_constructor,
                Y = r.abort,
                P = r.fd_write,
                D = r._embind_register_float,
                S = r._embind_register_std_string,
                H = r._emval_get_method_caller,
                j = r._embind_create_inheriting_constructor,
                M = r.__cxa_throw,
                x = r.__cxa_allocate_exception,
                J = r.fd_seek,
                $ = r.setTempRet0,
                z = r.emscripten_memcpy_big,
                L = r.emscripten_resize_heap,
                K = r.fd_close,
                q = r._embind_register_emval,
                nn = r._embind_register_bool,
                rn = r._embind_register_void,
                tn = r._emval_incref,
                en = r._emval_run_destructors,
                an = r._emval_call_method,
                on = r._emval_call_void_method,
                un = r._emval_decref,
                fn = 5254160,
                An = 0;

            function cn(n) {
              var r,
                  t = 0,
                  e = 0,
                  i = 0,
                  a = 0,
                  o = 0,
                  u = 0,
                  f = 0,
                  A = 0,
                  c = 0,
                  l = 0,
                  s = 0,
                  v = 0;
              fn = r = fn - 16 | 0;

              n: {
                r: {
                  t: {
                    e: {
                      i: {
                        a: {
                          o: {
                            u: {
                              f: {
                                A: {
                                  c: {
                                    if ((n |= 0) >>> 0 <= 244) {
                                      if (3 & (t = (o = b[2651]) >>> (n = (u = n >>> 0 < 11 ? 16 : n + 11 & -8) >>> 3 | 0) | 0)) {
                                        n = (t = b[10652 + (a = (e = n + (1 & (-1 ^ t)) | 0) << 3) >> 2]) + 8 | 0, (0 | (i = b[t + 8 >> 2])) != (0 | (a = a + 10644 | 0)) ? (b[i + 12 >> 2] = a, b[a + 8 >> 2] = i) : (s = 10604, v = ze(e) & o, b[s >> 2] = v), e <<= 3, b[t + 4 >> 2] = 3 | e, b[4 + (t = t + e | 0) >> 2] = 1 | b[t + 4 >> 2];
                                        break n;
                                      }

                                      if (u >>> 0 <= (A = b[2653]) >>> 0) break c;

                                      if (t) {
                                        e = t = (n = (0 - (n = (0 - (e = 2 << n) | e) & t << n) & n) - 1 | 0) >>> 12 & 16, e |= t = (n = n >>> t | 0) >>> 5 & 8, e |= t = (n = n >>> t | 0) >>> 2 & 4, t = b[10652 + (i = (e = ((e |= t = (n = n >>> t | 0) >>> 1 & 2) | (t = (n = n >>> t | 0) >>> 1 & 1)) + (n >>> t | 0) | 0) << 3) >> 2], (0 | (n = b[t + 8 >> 2])) != (0 | (i = i + 10644 | 0)) ? (b[n + 12 >> 2] = i, b[i + 8 >> 2] = n) : (o = ze(e) & o, b[2651] = o), n = t + 8 | 0, b[t + 4 >> 2] = 3 | u, a = (e <<= 3) - u | 0, b[4 + (f = t + u | 0) >> 2] = 1 | a, b[t + e >> 2] = a, A && (t = 10644 + ((e = A >>> 3 | 0) << 3) | 0, i = b[2656], (e = 1 << e) & o ? e = b[t + 8 >> 2] : (b[2651] = e | o, e = t), b[t + 8 >> 2] = i, b[e + 12 >> 2] = i, b[i + 12 >> 2] = t, b[i + 8 >> 2] = e), b[2656] = f, b[2653] = a;
                                        break n;
                                      }

                                      if (!(l = b[2652])) break c;

                                      for (e = t = (n = (l & 0 - l) - 1 | 0) >>> 12 & 16, e |= t = (n = n >>> t | 0) >>> 5 & 8, e |= t = (n = n >>> t | 0) >>> 2 & 4, t = b[10908 + (((e |= t = (n = n >>> t | 0) >>> 1 & 2) | (t = (n = n >>> t | 0) >>> 1 & 1)) + (n >>> t | 0) << 2) >> 2], i = (-8 & b[t + 4 >> 2]) - u | 0, e = t; (n = b[e + 16 >> 2]) || (n = b[e + 20 >> 2]);) {
                                        i = (e = (a = (-8 & b[n + 4 >> 2]) - u | 0) >>> 0 < i >>> 0) ? a : i, t = e ? n : t, e = n;
                                      }

                                      if (c = b[t + 24 >> 2], (0 | (a = b[t + 12 >> 2])) != (0 | t)) {
                                        n = b[t + 8 >> 2], b[n + 12 >> 2] = a, b[a + 8 >> 2] = n;
                                        break r;
                                      }

                                      if (!(n = b[(e = t + 20 | 0) >> 2])) {
                                        if (!(n = b[t + 16 >> 2])) break A;
                                        e = t + 16 | 0;
                                      }

                                      for (; f = e, a = n, (n = b[(e = n + 20 | 0) >> 2]) || (e = a + 16 | 0, n = b[a + 16 >> 2]);) {
                                        ;
                                      }

                                      b[f >> 2] = 0;
                                      break r;
                                    }

                                    if (u = -1, !(n >>> 0 > 4294967231) && (u = -8 & (t = n + 11 | 0), A = b[2652])) {
                                      e = 0 - u | 0, o = 0, (t = t >>> 8 | 0) && (o = 31, u >>> 0 > 16777215 || (o = 28 + ((n = ((o = (t <<= i = t + 1048320 >>> 16 & 8) << (n = t + 520192 >>> 16 & 4)) << (t = o + 245760 >>> 16 & 2) >>> 15 | 0) - (t | n | i) | 0) << 1 | u >>> n + 21 & 1) | 0));

                                      l: {
                                        s: {
                                          if (i = b[10908 + (o << 2) >> 2]) for (t = u << (31 == (0 | o) ? 0 : 25 - (o >>> 1 | 0) | 0), n = 0;;) {
                                            if (!((f = (-8 & b[i + 4 >> 2]) - u | 0) >>> 0 >= e >>> 0 || (a = i, e = f))) {
                                              e = 0, n = i;
                                              break s;
                                            }

                                            if (f = b[i + 20 >> 2], i = b[16 + ((t >>> 29 & 4) + i | 0) >> 2], n = f ? (0 | f) == (0 | i) ? n : f : n, t <<= 0 != (0 | i), !i) break;
                                          } else n = 0;

                                          if (!(n | a)) {
                                            if (!(n = (0 - (n = 2 << o) | n) & A)) break c;
                                            i = t = (n = (n & 0 - n) - 1 | 0) >>> 12 & 16, i |= t = (n = n >>> t | 0) >>> 5 & 8, i |= t = (n = n >>> t | 0) >>> 2 & 4, n = b[10908 + (((i |= t = (n = n >>> t | 0) >>> 1 & 2) | (t = (n = n >>> t | 0) >>> 1 & 1)) + (n >>> t | 0) << 2) >> 2];
                                          }

                                          if (!n) break l;
                                        }

                                        for (; e = (t = (i = (-8 & b[n + 4 >> 2]) - u | 0) >>> 0 < e >>> 0) ? i : e, a = t ? n : a, n = (t = b[n + 16 >> 2]) || b[n + 20 >> 2];) {
                                          ;
                                        }
                                      }

                                      if (!(!a | e >>> 0 >= b[2653] - u >>> 0)) {
                                        if (f = b[a + 24 >> 2], (0 | a) != (0 | (t = b[a + 12 >> 2]))) {
                                          n = b[a + 8 >> 2], b[n + 12 >> 2] = t, b[t + 8 >> 2] = n;
                                          break t;
                                        }

                                        if (!(n = b[(i = a + 20 | 0) >> 2])) {
                                          if (!(n = b[a + 16 >> 2])) break f;
                                          i = a + 16 | 0;
                                        }

                                        for (; o = i, t = n, (n = b[(i = n + 20 | 0) >> 2]) || (i = t + 16 | 0, n = b[t + 16 >> 2]);) {
                                          ;
                                        }

                                        b[o >> 2] = 0;
                                        break t;
                                      }
                                    }
                                  }

                                  if ((t = b[2653]) >>> 0 >= u >>> 0) {
                                    n = b[2656], (e = t - u | 0) >>> 0 >= 16 ? (b[2653] = e, i = n + u | 0, b[2656] = i, b[i + 4 >> 2] = 1 | e, b[n + t >> 2] = e, b[n + 4 >> 2] = 3 | u) : (b[2656] = 0, b[2653] = 0, b[n + 4 >> 2] = 3 | t, b[4 + (t = n + t | 0) >> 2] = 1 | b[t + 4 >> 2]), n = n + 8 | 0;
                                    break n;
                                  }

                                  if ((i = b[2654]) >>> 0 > u >>> 0) {
                                    t = i - u | 0, b[2654] = t, e = (n = b[2657]) + u | 0, b[2657] = e, b[e + 4 >> 2] = 1 | t, b[n + 4 >> 2] = 3 | u, n = n + 8 | 0;
                                    break n;
                                  }

                                  if (n = 0, e = a = u + 47 | 0, b[2769] ? t = b[2771] : (b[2772] = -1, b[2773] = -1, b[2770] = 4096, b[2771] = 4096, b[2769] = r + 12 & -16 ^ 1431655768, b[2774] = 0, b[2762] = 0, t = 4096), (e = (o = e + t | 0) & (f = 0 - t | 0)) >>> 0 <= u >>> 0) break n;
                                  if ((t = b[2761]) && (c = (A = b[2759]) + e | 0) >>> 0 <= A >>> 0 | c >>> 0 > t >>> 0) break n;
                                  if (4 & p[11048]) break a;

                                  c: {
                                    l: {
                                      if (t = b[2657]) for (n = 11052;;) {
                                        if ((A = b[n >> 2]) + b[n + 4 >> 2] >>> 0 > t >>> 0 && A >>> 0 <= t >>> 0) break l;
                                        if (!(n = b[n + 8 >> 2])) break;
                                      }
                                      if (-1 == (0 | (t = Dr(0)))) break o;
                                      if (o = e, (i = (n = b[2770]) + -1 | 0) & t && (o = (e - t | 0) + (t + i & 0 - n) | 0), o >>> 0 <= u >>> 0 | o >>> 0 > 2147483646) break o;
                                      if ((n = b[2761]) && (f = (i = b[2759]) + o | 0) >>> 0 <= i >>> 0 | f >>> 0 > n >>> 0) break o;
                                      if ((0 | t) != (0 | (n = Dr(o)))) break c;
                                      break i;
                                    }

                                    if ((o = f & o - i) >>> 0 > 2147483646) break o;
                                    if ((0 | (t = Dr(o))) == (b[n >> 2] + b[n + 4 >> 2] | 0)) break u;
                                    n = t;
                                  }

                                  if (!(-1 == (0 | n) | u + 48 >>> 0 <= o >>> 0)) {
                                    if ((t = (t = b[2771]) + (a - o | 0) & 0 - t) >>> 0 > 2147483646) {
                                      t = n;
                                      break i;
                                    }

                                    if (-1 != (0 | Dr(t))) {
                                      o = t + o | 0, t = n;
                                      break i;
                                    }

                                    Dr(0 - o | 0);
                                    break o;
                                  }

                                  if (t = n, -1 != (0 | n)) break i;
                                  break o;
                                }

                                a = 0;
                                break r;
                              }

                              t = 0;
                              break t;
                            }

                            if (-1 != (0 | t)) break i;
                          }

                          b[2762] = 4 | b[2762];
                        }

                        if (e >>> 0 > 2147483646) break e;
                        if ((t = Dr(e)) >>> 0 >= (n = Dr(0)) >>> 0 | -1 == (0 | t) | -1 == (0 | n)) break e;
                        if ((o = n - t | 0) >>> 0 <= u + 40 >>> 0) break e;
                      }

                      n = b[2759] + o | 0, b[2759] = n, n >>> 0 > y[2760] && (b[2760] = n);

                      i: {
                        a: {
                          o: {
                            if (e = b[2657]) {
                              for (n = 11052;;) {
                                if (((i = b[n >> 2]) + (a = b[n + 4 >> 2]) | 0) == (0 | t)) break o;
                                if (!(n = b[n + 8 >> 2])) break;
                              }

                              break a;
                            }

                            for (t >>> 0 >= (n = b[2655]) >>> 0 && n || (b[2655] = t), n = 0, b[2764] = o, b[2763] = t, b[2659] = -1, b[2660] = b[2769], b[2766] = 0; i = 10644 + (e = n << 3) | 0, b[e + 10652 >> 2] = i, b[e + 10656 >> 2] = i, 32 != (0 | (n = n + 1 | 0));) {
                              ;
                            }

                            i = (n = o + -40 | 0) - (e = t + 8 & 7 ? -8 - t & 7 : 0) | 0, b[2654] = i, e = t + e | 0, b[2657] = e, b[e + 4 >> 2] = 1 | i, b[4 + (n + t | 0) >> 2] = 40, b[2658] = b[2773];
                            break i;
                          }

                          if (!(8 & p[n + 12 | 0] | t >>> 0 <= e >>> 0 | i >>> 0 > e >>> 0)) {
                            b[n + 4 >> 2] = a + o, t = (n = e + 8 & 7 ? -8 - e & 7 : 0) + e | 0, b[2657] = t, n = (i = b[2654] + o | 0) - n | 0, b[2654] = n, b[t + 4 >> 2] = 1 | n, b[4 + (e + i | 0) >> 2] = 40, b[2658] = b[2773];
                            break i;
                          }
                        }

                        t >>> 0 < (a = b[2655]) >>> 0 && (b[2655] = t, a = 0), i = t + o | 0, n = 11052;

                        a: {
                          o: {
                            u: {
                              f: {
                                A: {
                                  c: {
                                    for (;;) {
                                      if ((0 | i) != b[n >> 2]) {
                                        if (n = b[n + 8 >> 2]) continue;
                                        break c;
                                      }

                                      break;
                                    }

                                    if (!(8 & p[n + 12 | 0])) break A;
                                  }

                                  for (n = 11052;;) {
                                    if ((i = b[n >> 2]) >>> 0 <= e >>> 0 && (a = i + b[n + 4 >> 2] | 0) >>> 0 > e >>> 0) break f;
                                    n = b[n + 8 >> 2];
                                  }
                                }

                                if (b[n >> 2] = t, b[n + 4 >> 2] = b[n + 4 >> 2] + o, b[4 + (c = (t + 8 & 7 ? -8 - t & 7 : 0) + t | 0) >> 2] = 3 | u, n = ((t = i + (i + 8 & 7 ? -8 - i & 7 : 0) | 0) - c | 0) - u | 0, f = u + c | 0, (0 | t) == (0 | e)) {
                                  b[2657] = f, n = b[2654] + n | 0, b[2654] = n, b[f + 4 >> 2] = 1 | n;
                                  break o;
                                }

                                if (b[2656] == (0 | t)) {
                                  b[2656] = f, n = b[2653] + n | 0, b[2653] = n, b[f + 4 >> 2] = 1 | n, b[n + f >> 2] = n;
                                  break o;
                                }

                                if (1 == (3 & (e = b[t + 4 >> 2]))) {
                                  l = -8 & e;

                                  A: if (e >>> 0 <= 255) {
                                    if (a = e >>> 3 | 0, e = b[t + 8 >> 2], (0 | (i = b[t + 12 >> 2])) == (0 | e)) {
                                      s = 10604, v = b[2651] & ze(a), b[s >> 2] = v;
                                      break A;
                                    }

                                    b[e + 12 >> 2] = i, b[i + 8 >> 2] = e;
                                  } else {
                                    if (A = b[t + 24 >> 2], (0 | (o = b[t + 12 >> 2])) == (0 | t)) {
                                      if ((u = b[(i = t + 20 | 0) >> 2]) || (u = b[(i = t + 16 | 0) >> 2])) {
                                        for (; e = i, o = u, (u = b[(i = u + 20 | 0) >> 2]) || (i = o + 16 | 0, u = b[o + 16 >> 2]);) {
                                          ;
                                        }

                                        b[e >> 2] = 0;
                                      } else o = 0;
                                    } else e = b[t + 8 >> 2], b[e + 12 >> 2] = o, b[o + 8 >> 2] = e;

                                    if (A) {
                                      e = b[t + 28 >> 2];

                                      c: {
                                        if (b[(i = 10908 + (e << 2) | 0) >> 2] == (0 | t)) {
                                          if (b[i >> 2] = o, o) break c;
                                          s = 10608, v = b[2652] & ze(e), b[s >> 2] = v;
                                          break A;
                                        }

                                        if (b[A + (b[A + 16 >> 2] == (0 | t) ? 16 : 20) >> 2] = o, !o) break A;
                                      }

                                      b[o + 24 >> 2] = A, (e = b[t + 16 >> 2]) && (b[o + 16 >> 2] = e, b[e + 24 >> 2] = o), (e = b[t + 20 >> 2]) && (b[o + 20 >> 2] = e, b[e + 24 >> 2] = o);
                                    }
                                  }

                                  t = t + l | 0, n = n + l | 0;
                                }

                                if (b[t + 4 >> 2] = -2 & b[t + 4 >> 2], b[f + 4 >> 2] = 1 | n, b[n + f >> 2] = n, n >>> 0 <= 255) {
                                  n = 10644 + ((t = n >>> 3 | 0) << 3) | 0, (e = b[2651]) & (t = 1 << t) ? t = b[n + 8 >> 2] : (b[2651] = t | e, t = n), b[n + 8 >> 2] = f, b[t + 12 >> 2] = f, b[f + 12 >> 2] = n, b[f + 8 >> 2] = t;
                                  break o;
                                }

                                if (t = 0, (i = n >>> 8 | 0) && (t = 31, n >>> 0 > 16777215 || (t = 28 + ((t = ((u = (i <<= a = i + 1048320 >>> 16 & 8) << (t = i + 520192 >>> 16 & 4)) << (i = u + 245760 >>> 16 & 2) >>> 15 | 0) - (i | t | a) | 0) << 1 | n >>> t + 21 & 1) | 0)), b[(e = f) + 28 >> 2] = t, b[f + 16 >> 2] = 0, b[f + 20 >> 2] = 0, e = 10908 + (t << 2) | 0, (i = b[2652]) & (a = 1 << t)) {
                                  for (i = n << (31 == (0 | t) ? 0 : 25 - (t >>> 1 | 0) | 0), t = b[e >> 2];;) {
                                    if (e = t, (-8 & b[t + 4 >> 2]) == (0 | n)) break u;
                                    if (t = i >>> 29 | 0, i <<= 1, !(t = b[16 + (a = (4 & t) + e | 0) >> 2])) break;
                                  }

                                  b[a + 16 >> 2] = f;
                                } else b[2652] = i | a, b[e >> 2] = f;

                                b[f + 24 >> 2] = e, b[f + 12 >> 2] = f, b[f + 8 >> 2] = f;
                                break o;
                              }

                              for (f = (n = o + -40 | 0) - (i = t + 8 & 7 ? -8 - t & 7 : 0) | 0, b[2654] = f, i = t + i | 0, b[2657] = i, b[i + 4 >> 2] = 1 | f, b[4 + (n + t | 0) >> 2] = 40, b[2658] = b[2773], b[(i = (n = (a + (a + -39 & 7 ? 39 - a & 7 : 0) | 0) - 47 | 0) >>> 0 < e + 16 >>> 0 ? e : n) + 4 >> 2] = 27, n = b[2766], b[i + 16 >> 2] = b[2765], b[i + 20 >> 2] = n, n = b[2764], b[i + 8 >> 2] = b[2763], b[i + 12 >> 2] = n, b[2765] = i + 8, b[2764] = o, b[2763] = t, b[2766] = 0, n = i + 24 | 0; b[n + 4 >> 2] = 7, t = n + 8 | 0, n = n + 4 | 0, a >>> 0 > t >>> 0;) {
                                ;
                              }

                              if ((0 | e) == (0 | i)) break i;

                              if (b[i + 4 >> 2] = -2 & b[i + 4 >> 2], a = i - e | 0, b[e + 4 >> 2] = 1 | a, b[i >> 2] = a, a >>> 0 <= 255) {
                                n = 10644 + ((t = a >>> 3 | 0) << 3) | 0, (i = b[2651]) & (t = 1 << t) ? t = b[n + 8 >> 2] : (b[2651] = t | i, t = n), b[n + 8 >> 2] = e, b[t + 12 >> 2] = e, b[e + 12 >> 2] = n, b[e + 8 >> 2] = t;
                                break i;
                              }

                              if (b[e + 16 >> 2] = 0, b[e + 20 >> 2] = 0, n = 0, (i = a >>> 8 | 0) && (n = 31, a >>> 0 > 16777215 || (n = 28 + ((n = ((f = (i <<= o = i + 1048320 >>> 16 & 8) << (n = i + 520192 >>> 16 & 4)) << (i = f + 245760 >>> 16 & 2) >>> 15 | 0) - (i | n | o) | 0) << 1 | a >>> n + 21 & 1) | 0)), b[(t = e) + 28 >> 2] = n, t = 10908 + (n << 2) | 0, (i = b[2652]) & (o = 1 << n)) {
                                for (n = a << (31 == (0 | n) ? 0 : 25 - (n >>> 1 | 0) | 0), t = b[t >> 2];;) {
                                  if (i = t, (0 | a) == (-8 & b[t + 4 >> 2])) break a;
                                  if (t = n >>> 29 | 0, n <<= 1, !(t = b[16 + (o = i + (4 & t) | 0) >> 2])) break;
                                }

                                b[o + 16 >> 2] = e, b[e + 24 >> 2] = i;
                              } else b[2652] = i | o, b[t >> 2] = e, b[e + 24 >> 2] = t;

                              b[e + 12 >> 2] = e, b[e + 8 >> 2] = e;
                              break i;
                            }

                            n = b[e + 8 >> 2], b[n + 12 >> 2] = f, b[e + 8 >> 2] = f, b[f + 24 >> 2] = 0, b[f + 12 >> 2] = e, b[f + 8 >> 2] = n;
                          }

                          n = c + 8 | 0;
                          break n;
                        }

                        n = b[i + 8 >> 2], b[n + 12 >> 2] = e, b[i + 8 >> 2] = e, b[e + 24 >> 2] = 0, b[e + 12 >> 2] = i, b[e + 8 >> 2] = n;
                      }

                      if (!((n = b[2654]) >>> 0 <= u >>> 0)) {
                        t = n - u | 0, b[2654] = t, e = (n = b[2657]) + u | 0, b[2657] = e, b[e + 4 >> 2] = 1 | t, b[n + 4 >> 2] = 3 | u, n = n + 8 | 0;
                        break n;
                      }
                    }

                    b[2373] = 48, n = 0;
                    break n;
                  }

                  t: if (f) {
                    n = b[a + 28 >> 2];

                    e: {
                      if (b[(i = 10908 + (n << 2) | 0) >> 2] == (0 | a)) {
                        if (b[i >> 2] = t, t) break e;
                        A = ze(n) & A, b[2652] = A;
                        break t;
                      }

                      if (b[f + (b[f + 16 >> 2] == (0 | a) ? 16 : 20) >> 2] = t, !t) break t;
                    }

                    b[t + 24 >> 2] = f, (n = b[a + 16 >> 2]) && (b[t + 16 >> 2] = n, b[n + 24 >> 2] = t), (n = b[a + 20 >> 2]) && (b[t + 20 >> 2] = n, b[n + 24 >> 2] = t);
                  }

                  t: if (e >>> 0 <= 15) n = e + u | 0, b[a + 4 >> 2] = 3 | n, b[4 + (n = n + a | 0) >> 2] = 1 | b[n + 4 >> 2];else if (b[a + 4 >> 2] = 3 | u, b[4 + (i = a + u | 0) >> 2] = 1 | e, b[e + i >> 2] = e, e >>> 0 <= 255) n = 10644 + ((t = e >>> 3 | 0) << 3) | 0, (e = b[2651]) & (t = 1 << t) ? t = b[n + 8 >> 2] : (b[2651] = t | e, t = n), b[n + 8 >> 2] = i, b[t + 12 >> 2] = i, b[i + 12 >> 2] = n, b[i + 8 >> 2] = t;else {
                    n = 0, (u = e >>> 8 | 0) && (n = 31, e >>> 0 > 16777215 || (n = 28 + ((n = ((f = (u <<= o = u + 1048320 >>> 16 & 8) << (n = u + 520192 >>> 16 & 4)) << (u = f + 245760 >>> 16 & 2) >>> 15 | 0) - (u | n | o) | 0) << 1 | e >>> n + 21 & 1) | 0)), b[(t = i) + 28 >> 2] = n, b[i + 16 >> 2] = 0, b[i + 20 >> 2] = 0, t = 10908 + (n << 2) | 0;

                    e: {
                      if ((u = 1 << n) & A) {
                        for (n = e << (31 == (0 | n) ? 0 : 25 - (n >>> 1 | 0) | 0), u = b[t >> 2];;) {
                          if ((-8 & b[(t = u) + 4 >> 2]) == (0 | e)) break e;
                          if (u = n >>> 29 | 0, n <<= 1, !(u = b[16 + (o = (4 & u) + t | 0) >> 2])) break;
                        }

                        b[o + 16 >> 2] = i;
                      } else b[2652] = u | A, b[t >> 2] = i;

                      b[i + 24 >> 2] = t, b[i + 12 >> 2] = i, b[i + 8 >> 2] = i;
                      break t;
                    }

                    n = b[t + 8 >> 2], b[n + 12 >> 2] = i, b[t + 8 >> 2] = i, b[i + 24 >> 2] = 0, b[i + 12 >> 2] = t, b[i + 8 >> 2] = n;
                  }

                  n = a + 8 | 0;
                  break n;
                }

                r: if (c) {
                  n = b[t + 28 >> 2];

                  t: {
                    if (b[(e = 10908 + (n << 2) | 0) >> 2] == (0 | t)) {
                      if (b[e >> 2] = a, a) break t;
                      s = 10608, v = ze(n) & l, b[s >> 2] = v;
                      break r;
                    }

                    if (b[c + (b[c + 16 >> 2] == (0 | t) ? 16 : 20) >> 2] = a, !a) break r;
                  }

                  b[a + 24 >> 2] = c, (n = b[t + 16 >> 2]) && (b[a + 16 >> 2] = n, b[n + 24 >> 2] = a), (n = b[t + 20 >> 2]) && (b[a + 20 >> 2] = n, b[n + 24 >> 2] = a);
                }

                i >>> 0 <= 15 ? (n = i + u | 0, b[t + 4 >> 2] = 3 | n, b[4 + (n = n + t | 0) >> 2] = 1 | b[n + 4 >> 2]) : (b[t + 4 >> 2] = 3 | u, b[4 + (u = t + u | 0) >> 2] = 1 | i, b[i + u >> 2] = i, A && (n = 10644 + ((e = A >>> 3 | 0) << 3) | 0, a = b[2656], (e = 1 << e) & o ? e = b[n + 8 >> 2] : (b[2651] = e | o, e = n), b[n + 8 >> 2] = a, b[e + 12 >> 2] = a, b[a + 12 >> 2] = n, b[a + 8 >> 2] = e), b[2656] = u, b[2653] = i), n = t + 8 | 0;
              }

              return fn = r + 16 | 0, 0 | n;
            }

            function ln() {
              var n,
                  r = 0;
              fn = n = fn - 720 | 0, V(4048, 4076, 4112, 0, 3912, 41, 3915, 0, 3915, 0, 2468, 3917, 42), b[n + 704 >> 2] = 0, b[n + 708 >> 2] = 1, b[n + 712 >> 2] = 0, b[n + 716 >> 2] = 1, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(4048, 2484, 6, 4128, 4192, 150, 0 | Ue(r + 8 | 0), 1), fn = r + 16 | 0;
              }(n + 704 | 0), V(4416, 4456, 4500, 4048, 3912, 43, 3912, 151, 3912, 152, 2492, 3917, 44), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 153, T(4416, 4200, 2, 4516, 4524, 154, 0 | Bi(n + 12 | 0), 0), fn = n + 16 | 0;
              }(), B(4048, 4220, 2, 4528, 4564, 45, 46), B(4048, 4230, 3, 4612, 3992, 47, 48), V(4780, 4808, 4844, 0, 3912, 49, 3915, 0, 3915, 0, 2515, 3917, 50), b[n + 696 >> 2] = 0, b[n + 700 >> 2] = 1, b[n + 712 >> 2] = 0, b[n + 716 >> 2] = 1, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(4780, 2531, 2, 4860, 4524, 155, 0 | Ue(r + 8 | 0), 1), fn = r + 16 | 0;
              }(n + 696 | 0), V(4984, 5024, 5068, 4780, 3912, 51, 3912, 156, 3912, 157, 2539, 3917, 52), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 158, T(4984, 4200, 2, 5084, 4524, 159, 0 | Bi(n + 12 | 0), 0), fn = n + 16 | 0;
              }(), B(4780, 4220, 2, 5092, 4564, 53, 54), B(4780, 4230, 3, 4612, 3992, 47, 55), X(4160, 2562, 4016, 160, 3917, 161), _t(_t(n + 712 | 0, 2455, 0), 2461, 4), F(4160), X(5140, 2567, 4016, 164, 3917, 165), function (n) {
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 4, G(5140, 2579, 5156, 4564, 168, 0 | Bi(n + 12 | 0), 5156, 5164, 169, 0 | Bi(n + 12 | 0)), fn = n + 16 | 0;
              }(function (n) {
                var r;
                return fn = r = fn - 16 | 0, b[r + 12 >> 2] = 0, G(5140, 2573, 8564, 5124, 166, 0 | Bi(r + 12 | 0), 8564, 3972, 167, 0 | Bi(r + 12 | 0)), fn = r + 16 | 0, n;
              }(n + 712 | 0)), F(5140), V(5176, 5192, 5216, 0, 3912, 56, 3915, 0, 3915, 0, 2584, 3917, 57), function () {
                var n;
                fn = n = fn - 16 | 0, U(5176, 1, 5232, 3912, 59, 58), fn = n + 16 | 0;
              }(), B(5176, 2589, 1, 5232, 3912, 59, 58), B(5176, 2603, 2, 5236, 4564, 60, 61), B(5176, 2620, 2, 5244, 4524, 62, 63), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 64, r = b[n + 716 >> 2], b[n + 688 >> 2] = b[n + 712 >> 2], b[n + 692 >> 2] = r, Ft(2628, n + 688 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 65, r = b[n + 716 >> 2], b[n + 680 >> 2] = b[n + 712 >> 2], b[n + 684 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 2634, 3, 5252, 5164, 171, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 680 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 66, r = b[n + 716 >> 2], b[n + 672 >> 2] = b[n + 712 >> 2], b[n + 676 >> 2] = r, Gt(2644, n + 672 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 67, r = b[n + 716 >> 2], b[n + 664 >> 2] = b[n + 712 >> 2], b[n + 668 >> 2] = r, Nt(2660, n + 664 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 68, r = b[n + 716 >> 2], b[n + 656 >> 2] = b[n + 712 >> 2], b[n + 660 >> 2] = r, Nt(2672, n + 656 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 69, r = b[n + 716 >> 2], b[n + 648 >> 2] = b[n + 712 >> 2], b[n + 652 >> 2] = r, Gt(2691, n + 648 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 70, r = b[n + 716 >> 2], b[n + 640 >> 2] = b[n + 712 >> 2], b[n + 644 >> 2] = r, Gt(2707, n + 640 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 71, r = b[n + 716 >> 2], b[n + 632 >> 2] = b[n + 712 >> 2], b[n + 636 >> 2] = r, Gt(2721, n + 632 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 72, r = b[n + 716 >> 2], b[n + 624 >> 2] = b[n + 712 >> 2], b[n + 628 >> 2] = r, Gt(2734, n + 624 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 73, r = b[n + 716 >> 2], b[n + 616 >> 2] = b[n + 712 >> 2], b[n + 620 >> 2] = r, Gt(2751, n + 616 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 74, r = b[n + 716 >> 2], b[n + 608 >> 2] = b[n + 712 >> 2], b[n + 612 >> 2] = r, Gt(2763, n + 608 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 75, r = b[n + 716 >> 2], b[n + 600 >> 2] = b[n + 712 >> 2], b[n + 604 >> 2] = r, Nt(2781, n + 600 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 76, r = b[n + 716 >> 2], b[n + 592 >> 2] = b[n + 712 >> 2], b[n + 596 >> 2] = r, Nt(2791, n + 592 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 77, r = b[n + 716 >> 2], b[n + 584 >> 2] = b[n + 712 >> 2], b[n + 588 >> 2] = r, Gt(2808, n + 584 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 78, r = b[n + 716 >> 2], b[n + 576 >> 2] = b[n + 712 >> 2], b[n + 580 >> 2] = r, Gt(2822, n + 576 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 79, r = b[n + 716 >> 2], b[n + 568 >> 2] = b[n + 712 >> 2], b[n + 572 >> 2] = r, Gt(2834, n + 568 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 80, r = b[n + 716 >> 2], b[n + 560 >> 2] = b[n + 712 >> 2], b[n + 564 >> 2] = r, It(2845, n + 560 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 81, r = b[n + 716 >> 2], b[n + 552 >> 2] = b[n + 712 >> 2], b[n + 556 >> 2] = r, It(2853, n + 552 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 82, r = b[n + 716 >> 2], b[n + 544 >> 2] = b[n + 712 >> 2], b[n + 548 >> 2] = r, It(2866, n + 544 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 83, r = b[n + 716 >> 2], b[n + 536 >> 2] = b[n + 712 >> 2], b[n + 540 >> 2] = r, It(2886, n + 536 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 84, r = b[n + 716 >> 2], b[n + 528 >> 2] = b[n + 712 >> 2], b[n + 532 >> 2] = r, It(2898, n + 528 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 85, r = b[n + 716 >> 2], b[n + 520 >> 2] = b[n + 712 >> 2], b[n + 524 >> 2] = r, It(2912, n + 520 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 86, r = b[n + 716 >> 2], b[n + 512 >> 2] = b[n + 712 >> 2], b[n + 516 >> 2] = r, It(2921, n + 512 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 87, r = b[n + 716 >> 2], b[n + 504 >> 2] = b[n + 712 >> 2], b[n + 508 >> 2] = r, Ft(2937, n + 504 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 88, r = b[n + 716 >> 2], b[n + 496 >> 2] = b[n + 712 >> 2], b[n + 500 >> 2] = r, It(2950, n + 496 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 89, r = b[n + 716 >> 2], b[n + 488 >> 2] = b[n + 712 >> 2], b[n + 492 >> 2] = r, It(2960, n + 488 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 90, r = b[n + 716 >> 2], b[n + 480 >> 2] = b[n + 712 >> 2], b[n + 484 >> 2] = r, Ft(2977, n + 480 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 91, r = b[n + 716 >> 2], b[n + 472 >> 2] = b[n + 712 >> 2], b[n + 476 >> 2] = r, It(2991, n + 472 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 92, r = b[n + 716 >> 2], b[n + 464 >> 2] = b[n + 712 >> 2], b[n + 468 >> 2] = r, It(3003, n + 464 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 93, r = b[n + 716 >> 2], b[n + 456 >> 2] = b[n + 712 >> 2], b[n + 460 >> 2] = r, It(3022, n + 456 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 94, r = b[n + 716 >> 2], b[n + 448 >> 2] = b[n + 712 >> 2], b[n + 452 >> 2] = r, It(3035, n + 448 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 95, r = b[n + 716 >> 2], b[n + 440 >> 2] = b[n + 712 >> 2], b[n + 444 >> 2] = r, It(3055, n + 440 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 96, r = b[n + 716 >> 2], b[n + 432 >> 2] = b[n + 712 >> 2], b[n + 436 >> 2] = r, It(3067, n + 432 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 97, r = b[n + 716 >> 2], b[n + 424 >> 2] = b[n + 712 >> 2], b[n + 428 >> 2] = r, It(3086, n + 424 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 98, r = b[n + 716 >> 2], b[n + 416 >> 2] = b[n + 712 >> 2], b[n + 420 >> 2] = r, It(3099, n + 416 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 99, r = b[n + 716 >> 2], b[n + 408 >> 2] = b[n + 712 >> 2], b[n + 412 >> 2] = r, It(3119, n + 408 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 100, r = b[n + 716 >> 2], b[n + 400 >> 2] = b[n + 712 >> 2], b[n + 404 >> 2] = r, Nt(3134, n + 400 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 101, r = b[n + 716 >> 2], b[n + 392 >> 2] = b[n + 712 >> 2], b[n + 396 >> 2] = r, Nt(3144, n + 392 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 102, r = b[n + 716 >> 2], b[n + 384 >> 2] = b[n + 712 >> 2], b[n + 388 >> 2] = r, Nt(3155, n + 384 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 103, r = b[n + 716 >> 2], b[n + 376 >> 2] = b[n + 712 >> 2], b[n + 380 >> 2] = r, Bt(3173, n + 376 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 104, r = b[n + 716 >> 2], b[n + 368 >> 2] = b[n + 712 >> 2], b[n + 372 >> 2] = r, Rt(3189, n + 368 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 105, r = b[n + 716 >> 2], b[n + 360 >> 2] = b[n + 712 >> 2], b[n + 364 >> 2] = r, Bt(3201, n + 360 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 106, r = b[n + 716 >> 2], b[n + 352 >> 2] = b[n + 712 >> 2], b[n + 356 >> 2] = r, Bt(3217, n + 352 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 107, r = b[n + 716 >> 2], b[n + 344 >> 2] = b[n + 712 >> 2], b[n + 348 >> 2] = r, Bt(3231, n + 344 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 108, r = b[n + 716 >> 2], b[n + 336 >> 2] = b[n + 712 >> 2], b[n + 340 >> 2] = r, Bt(3244, n + 336 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 109, r = b[n + 716 >> 2], b[n + 328 >> 2] = b[n + 712 >> 2], b[n + 332 >> 2] = r, Bt(3261, n + 328 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 110, r = b[n + 716 >> 2], b[n + 320 >> 2] = b[n + 712 >> 2], b[n + 324 >> 2] = r, Bt(3273, n + 320 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 111, r = b[n + 716 >> 2], b[n + 312 >> 2] = b[n + 712 >> 2], b[n + 316 >> 2] = r, Rt(3291, n + 312 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 112, r = b[n + 716 >> 2], b[n + 304 >> 2] = b[n + 712 >> 2], b[n + 308 >> 2] = r, Wt(3301, n + 304 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 113, r = b[n + 716 >> 2], b[n + 296 >> 2] = b[n + 712 >> 2], b[n + 300 >> 2] = r, Vt(3314, n + 296 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 114, r = b[n + 716 >> 2], b[n + 288 >> 2] = b[n + 712 >> 2], b[n + 292 >> 2] = r, Vt(3326, n + 288 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 115, r = b[n + 716 >> 2], b[n + 280 >> 2] = b[n + 712 >> 2], b[n + 284 >> 2] = r, Wt(3340, n + 280 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 116, r = b[n + 716 >> 2], b[n + 272 >> 2] = b[n + 712 >> 2], b[n + 276 >> 2] = r, Wt(3349, n + 272 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 117, r = b[n + 716 >> 2], b[n + 264 >> 2] = b[n + 712 >> 2], b[n + 268 >> 2] = r, Wt(3359, n + 264 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 118, r = b[n + 716 >> 2], b[n + 256 >> 2] = b[n + 712 >> 2], b[n + 260 >> 2] = r, Wt(3371, n + 256 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 119, r = b[n + 716 >> 2], b[n + 248 >> 2] = b[n + 712 >> 2], b[n + 252 >> 2] = r, Wt(3384, n + 248 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 120, r = b[n + 716 >> 2], b[n + 240 >> 2] = b[n + 712 >> 2], b[n + 244 >> 2] = r, Wt(3396, n + 240 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 121, r = b[n + 716 >> 2], b[n + 232 >> 2] = b[n + 712 >> 2], b[n + 236 >> 2] = r, Vt(3409, n + 232 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 122, r = b[n + 716 >> 2], b[n + 224 >> 2] = b[n + 712 >> 2], b[n + 228 >> 2] = r, Zt(3424, n + 224 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 123, r = b[n + 716 >> 2], b[n + 216 >> 2] = b[n + 712 >> 2], b[n + 220 >> 2] = r, Bt(3434, n + 216 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 124, r = b[n + 716 >> 2], b[n + 208 >> 2] = b[n + 712 >> 2], b[n + 212 >> 2] = r, Bt(3446, n + 208 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 125, r = b[n + 716 >> 2], b[n + 200 >> 2] = b[n + 712 >> 2], b[n + 204 >> 2] = r, Rt(3457, n + 200 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 126, r = b[n + 716 >> 2], b[n + 192 >> 2] = b[n + 712 >> 2], b[n + 196 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3468, 4, 5376, 3952, 180, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 192 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 127, r = b[n + 716 >> 2], b[n + 184 >> 2] = b[n + 712 >> 2], b[n + 188 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3480, 3, 5392, 5164, 181, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 184 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 128, r = b[n + 716 >> 2], b[n + 176 >> 2] = b[n + 712 >> 2], b[n + 180 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3492, 2, 5404, 4564, 182, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 176 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 129, r = b[n + 716 >> 2], b[n + 168 >> 2] = b[n + 712 >> 2], b[n + 172 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3506, 2, 5412, 4564, 183, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 168 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 130, r = b[n + 716 >> 2], b[n + 160 >> 2] = b[n + 712 >> 2], b[n + 164 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3516, 3, 5420, 3992, 184, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 160 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 131, r = b[n + 716 >> 2], b[n + 152 >> 2] = b[n + 712 >> 2], b[n + 156 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3525, 2, 5432, 4564, 185, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 152 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 132, r = b[n + 716 >> 2], b[n + 144 >> 2] = b[n + 712 >> 2], b[n + 148 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3545, 3, 5440, 5164, 186, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 144 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 133, r = b[n + 716 >> 2], b[n + 136 >> 2] = b[n + 712 >> 2], b[n + 140 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3568, 3, 5452, 5164, 187, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 136 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 134, r = b[n + 716 >> 2], b[n + 128 >> 2] = b[n + 712 >> 2], b[n + 132 >> 2] = r, Ft(3583, n + 128 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 135, r = b[n + 716 >> 2], b[n + 120 >> 2] = b[n + 712 >> 2], b[n + 124 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3600, 3, 5464, 5164, 188, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 120 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 136, r = b[n + 716 >> 2], b[n + 112 >> 2] = b[n + 712 >> 2], b[n + 116 >> 2] = r, Ft(3615, n + 112 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 137, r = b[n + 716 >> 2], b[n + 104 >> 2] = b[n + 712 >> 2], b[n + 108 >> 2] = r, Ft(3632, n + 104 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 138, r = b[n + 716 >> 2], b[n + 96 >> 2] = b[n + 712 >> 2], b[n + 100 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3642, 2, 5476, 4564, 189, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 96 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 139, r = b[n + 716 >> 2], b[n + 88 >> 2] = b[n + 712 >> 2], b[n + 92 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3650, 5, 5488, 5508, 190, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 88 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 140, r = b[n + 716 >> 2], b[n + 80 >> 2] = b[n + 712 >> 2], b[n + 84 >> 2] = r, Vt(3666, n + 80 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 141, r = b[n + 716 >> 2], b[n + 72 >> 2] = b[n + 712 >> 2], b[n + 76 >> 2] = r, Vt(3682, n + 72 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 142, r = b[n + 716 >> 2], b[n + 64 >> 2] = b[n + 712 >> 2], b[n + 68 >> 2] = r, Vt(3699, n - -64 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 143, r = b[n + 716 >> 2], b[n + 56 >> 2] = b[n + 712 >> 2], b[n + 60 >> 2] = r, Vt(3714, n + 56 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 144, r = b[n + 716 >> 2], b[n + 48 >> 2] = b[n + 712 >> 2], b[n + 52 >> 2] = r, Vt(3732, n + 48 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 145, r = b[n + 716 >> 2], b[n + 40 >> 2] = b[n + 712 >> 2], b[n + 44 >> 2] = r, Vt(3749, n + 40 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 146, r = b[n + 716 >> 2], b[n + 32 >> 2] = b[n + 712 >> 2], b[n + 36 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(5176, 3767, 2, 5516, 4564, 191, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 32 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 147, r = b[n + 716 >> 2], b[n + 24 >> 2] = b[n + 712 >> 2], b[n + 28 >> 2] = r, Zt(3785, n + 24 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 148, r = b[n + 716 >> 2], b[n + 16 >> 2] = b[n + 712 >> 2], b[n + 20 >> 2] = r, Zt(3803, n + 16 | 0), b[n + 716 >> 2] = 0, b[n + 712 >> 2] = 149, r = b[n + 716 >> 2], b[n + 8 >> 2] = b[n + 712 >> 2], b[n + 12 >> 2] = r, Zt(3821, n + 8 | 0), fn = n + 720 | 0;
            }

            function sn(n, r, t, e, i, a, o, u, f, A, c, l, s, v, d) {
              var h,
                  y,
                  k = _(0),
                  g = 0,
                  C = 0,
                  E = 0,
                  w = 0,
                  N = _(0),
                  W = _(0),
                  Z = _(0),
                  T = _(0),
                  I = 0,
                  R = 0,
                  B = _(0),
                  V = 0,
                  G = _(0),
                  F = _(0),
                  X = _(0),
                  O = _(0),
                  Q = _(0),
                  U = _(0),
                  Y = _(0),
                  P = 0,
                  D = 0,
                  S = _(0),
                  H = 0,
                  j = _(0),
                  M = _(0),
                  x = 0,
                  J = _(0),
                  $ = 0,
                  z = _(0),
                  L = _(0),
                  K = _(0),
                  q = 0,
                  nn = 0,
                  rn = 0,
                  tn = 0,
                  en = 0,
                  an = _(0),
                  on = _(0),
                  un = _(0),
                  An = 0,
                  cn = _(0),
                  ln = 0;

              if (fn = h = fn - 208 | 0, b[h + 204 >> 2] = n, Ge(n, !i | 1 ^ vu(r), 2020), Ge(n, !a | 1 ^ vu(t), 2100), b[(E = (f ? 0 : 4) + c | 0) >> 2] = b[E >> 2] + 1, Ne(n + 288 | 0, y = kt(n, e)), E = pe(2, y), C = pe(0, y), An = h, cn = Ar(n, E, o), m[An + 112 >> 2] = cn, I = n, n = (1 != (0 | y)) << 1, gi(I, m[h + 112 >> 2], n), An = h, cn = cr(I = b[h + 204 >> 2], E, o), m[An + 112 >> 2] = cn, $ = I, I = (1 == (0 | y)) << 1, gi($, m[h + 112 >> 2], I), An = h, cn = Ar(w = b[h + 204 >> 2], C, o), m[An + 112 >> 2] = cn, gi(w, m[h + 112 >> 2], 1), An = h, cn = cr(w = b[h + 204 >> 2], C, o), m[An + 112 >> 2] = cn, gi(w, m[h + 112 >> 2], 3), _i(w = b[h + 204 >> 2], vr(w, E), n), _i(w = b[h + 204 >> 2], sr(w, E), I), _i(w = b[h + 204 >> 2], vr(w, C), 1), _i(w = b[h + 204 >> 2], sr(w, C), 3), An = h, cn = Mn(w = b[h + 204 >> 2], E, o), m[An + 112 >> 2] = cn, Ci(w, m[h + 112 >> 2], n), An = h, cn = ir(n = b[h + 204 >> 2], E, o), m[An + 112 >> 2] = cn, Ci(n, m[h + 112 >> 2], I), An = h, cn = Mn(n = b[h + 204 >> 2], C, o), m[An + 112 >> 2] = cn, Ci(n, m[h + 112 >> 2], 1), An = h, cn = ir(n = b[h + 204 >> 2], C, o), m[An + 112 >> 2] = cn, Ci(n, m[h + 112 >> 2], 3), E = bo(b[h + 204 >> 2]), n = b[h + 204 >> 2], E) Wn(n, r, t, i, a, o, u, c, l, d);else if (I = Xo(n)) {
                if (f || !function (n, r, t, e, i, a, o) {
                  var u,
                      f = _(0),
                      A = _(0),
                      c = 0,
                      l = 0,
                      s = _(0),
                      v = _(0);

                  return fn = u = fn - 16 | 0, (vu(r) || r <= _(0) ^ 1 | 2 != (0 | e)) && (vu(t) || t <= _(0) ^ 1 | 2 != (0 | i)) && 1 != (0 | e) | 1 != (0 | i) || (l = u, s = ea(n, 0, a), m[l + 8 >> 2] = s, A = m[u + 8 >> 2], l = u, s = ea(n, 2, a), m[l >> 2] = s, s = _(0), v = _(r - m[u >> 2]), l = vu(r), f = l ? s : v, hi(n, yt(n, 2, r < _(0) && 2 == (0 | e) ? _(0) : f, a, a), 0), c = 1, e = n, vu(t) ? r = _(0) : (r = _(t - A), r = t < _(0) && 2 == (0 | i) ? _(0) : r), hi(e, yt(n, 0, r, o, a), 1)), fn = u + 16 | 0, c;
                }(b[h + 204 >> 2], r, t, i, a, o, u)) {
                  for (function (n, r) {
                    var t,
                        e = 0,
                        i = 0,
                        a = 0,
                        o = 0,
                        u = 0;
                    if (fn = t = fn - 16 | 0, o = t, u = mo(e = n + 544 | 0), b[o + 8 >> 2] = u, o = t, u = to(e), b[o >> 2] = u, ba(t + 8 | 0, t)) for (e = 0; i = b[t + 8 >> 2], b[b[i >> 2] + 540 >> 2] != (0 | n) && (a = i, i = Ct(b[n + 556 >> 2], b[i >> 2], n, e, r), b[a >> 2] = i, Uo(i, n)), e = e + 1 | 0, Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                      ;
                    }
                    fn = t + 16 | 0;
                  }(b[h + 204 >> 2], l), Ro(b[h + 204 >> 2], 0), $i(h + 112 | 0, au(b[h + 204 >> 2])), g = Oi(R = pe(Li(h + 112 | 0), y), y), V = Yo(R), Hi(h + 112 | 0, au(b[h + 204 >> 2])), H = qi(h + 112 | 0), An = h, cn = _e(b[h + 204 >> 2], g, o), m[An + 112 >> 2] = cn, N = m[h + 112 >> 2], j = re(b[h + 204 >> 2], R, o), Q = re(b[h + 204 >> 2], g, o), An = h, cn = ea(b[h + 204 >> 2], 2, o), m[An + 112 >> 2] = cn, L = m[h + 112 >> 2], An = h, cn = ea(b[h + 204 >> 2], 0, o), m[An + 112 >> 2] = cn, K = m[h + 112 >> 2], An = h, ln = au(b[h + 204 >> 2]), b[An + 200 >> 2] = ln, An = h, ln = au(b[h + 204 >> 2]), b[An + 192 >> 2] = ln, ei(h + 184 | 0, h + 200 | 0, 0), b[h + 12 >> 2] = b[h + 184 >> 2], An = h, cn = Kt(h + 12 | 0, o), m[An + 112 >> 2] = cn, k = m[h + 112 >> 2], ii(h + 176 | 0, h + 192 | 0, 0), b[h + 8 >> 2] = b[h + 176 >> 2], An = h, cn = Kt(h + 8 | 0, o), m[An + 112 >> 2] = cn, Z = m[h + 112 >> 2], ei(h + 168 | 0, h + 200 | 0, 1), b[h + 4 >> 2] = b[h + 168 >> 2], An = h, cn = Kt(h + 4 | 0, u), m[An + 112 >> 2] = cn, F = m[h + 112 >> 2], ii(h + 160 | 0, h + 192 | 0, 1), b[h >> 2] = b[h + 160 >> 2], An = h, cn = Kt(h, u), m[An + 112 >> 2] = cn, O = m[h + 112 >> 2], W = On(b[h + 204 >> 2], 2, r, o, o), Y = On(b[h + 204 >> 2], 0, t, u, o), G = V ? W : Y, n = V ? i : a, d = function (n, r, t, e, i, a, o, u, f, A, c, l, s) {
                    var v,
                        d,
                        p = 0,
                        h = 0,
                        y = _(0),
                        k = 0,
                        g = 0,
                        C = _(0);

                    fn = v = fn - 32 | 0, d = Lo(n);

                    n: if (1 == (0 | (Yo(o) ? e : i))) {
                      k = v, g = mo(d), b[k + 8 >> 2] = g, k = v, g = to(d), b[k + 24 >> 2] = g;

                      r: if (ba(v + 8 | 0, v + 24 | 0)) {
                        for (;;) {
                          if (pt(p = b[b[v + 8 >> 2] >> 2])) {
                            if (h) break r;
                            if (mt(dr(p), _(0))) break r;
                            if (h = p, mt(Ln(p), _(0))) break r;
                          }

                          if (Zo(v + 8 | 0), !ba(v + 8 | 0, v + 24 | 0)) break;
                        }

                        break n;
                      }

                      h = 0;
                    }

                    if (k = v, g = mo(d), b[k + 24 >> 2] = g, k = v, g = to(d), b[k + 16 >> 2] = g, ba(v + 24 | 0, v + 16 | 0)) for (; Fn(p = b[b[v + 24 >> 2] >> 2]), Yi(v + 8 | 0, au(p)), 1 != (0 | na(v + 8 | 0)) ? (f && jn(p, kt(p, a), Yo(o) ? r : t, Yo(o) ? t : r, r), Ui(v + 8 | 0, au(p)), 1 != (0 | na(v + 8 | 0)) && ((0 | p) != (0 | h) ? hn(n, p, r, e, t, r, t, i, a, u, A, c, l, s) : (Do(h, s), lo(v, _(0)), Po(h, m[v >> 2])), k = v, C = xt(m[Ko(p) + 80 >> 2], ea(p, o, r)), m[k + 8 >> 2] = C, y = _(y + m[v + 8 >> 2]))) : (Et(p, c), ru(p), ae(p, 0)), Zo(v + 24 | 0), ba(v + 24 | 0, v + 16 | 0);) {
                      ;
                    }
                    return fn = v + 32 | 0, y;
                  }(b[h + 204 >> 2], W, Y, i, a, y, R, A, f, c, l, s, v) > G, P = H && 2 == (0 | n) && d ? 1 : n, q = d & 0 != (0 | n), B = V ? Y : W, nn = (n = 1 == (0 | (D = V ? a : i))) & (1 ^ f), F = _((V ? k : F) - j), O = _((V ? Z : O) - j), M = V ? u : o, S = V ? o : u, rn = 1 ^ V, tn = -3 & D, en = n & !H, jo(20 + (C = h + 112 | 0) | 0), a = 0, n = 0;;) {
                    w = n, Cn(h - -64 | 0, h + 204 | 0, e, S, W, G, E = a, n), _r(C, h - -64 | 0), du(h - -64 | 0), a = b[C + 16 >> 2], n = C;

                    n: {
                      r: {
                        t: {
                          if (1 != (0 | P)) {
                            if (d = vu(F), (!(m[C + 4 >> 2] < F) || (k = F, d)) && (d = vu(O), !(m[C + 4 >> 2] > O) || (k = O, d))) {
                              e: if (!p[b[b[h + 204 >> 2] + 556 >> 2] + 11 | 0]) {
                                if (An = vu(m[C + 8 >> 2]), ln = 0, !(m[C + 8 >> 2] == _(0) ? An : ln)) {
                                  if (!vu(dr(b[h + 204 >> 2]))) break e;
                                  if (dr(b[h + 204 >> 2]) != _(0)) break e;
                                }

                                G = m[C + 4 >> 2];
                              }

                              if (k = G, p[b[b[h + 204 >> 2] + 556 >> 2] + 11 | 0] && be(b[h + 204 >> 2] + 288 | 0, 2, 1), !p[b[b[h + 204 >> 2] + 556 >> 2] + 11 | 0]) break t;
                            }
                          } else k = G;

                          if (!vu(k)) {
                            G = _(k - m[C + 4 >> 2]);
                            break r;
                          }
                        }

                        if (G = k, !((Z = m[C + 4 >> 2]) < _(0))) break n;
                        G = _(-Z);
                      }

                      m[n + 32 >> 2] = G, G = k;
                    }

                    if (nn || lt(b[h + 204 >> 2], C, R, g, S, G, B, W, Y, q, D, f, A, c, l, s, v), d = Xa(Ko(n = b[h + 204 >> 2])), Ro(n, m[C + 32 >> 2] < _(0) | d), yn(b[h + 204 >> 2], C, E, R, g, P, D, S, o, G, B, W, f, l), Z = B, tn || (Z = _(yt(b[h + 204 >> 2], g, _(Q + m[C + 40 >> 2]), M, o) - Q)), en ? (m[C + 40 >> 2] = B, k = B) : k = m[C + 40 >> 2], k = _(yt(b[h + 204 >> 2], g, _(Q + k), M, o) - Q), m[C + 40 >> 2] = k, !(!f | E >>> 0 >= a >>> 0)) {
                      for (;;) {
                        Yi(h - -64 | 0, au(n = Qe(b[h + 204 >> 2], E)));

                        n: if (1 != (0 | na(h - -64 | 0))) if (Ui(h - -64 | 0, au(n)), 1 != (0 | na(h - -64 | 0))) {
                          $ = n;

                          r: if (4 != (0 | (d = Pt(b[h + 204 >> 2], n))) || (st(h - -64 | 0, n, g), 3 == b[h + 68 >> 2] || (vt(h + 56 | 0, n, g), 3 == b[h + 60 >> 2]))) {
                            if (k = xr(n, g, W), st(h - -64 | 0, n, g), T = _(Z - k), 3 != b[h + 68 >> 2] || (vt(h + 56 | 0, n, g), 3 != b[h + 60 >> 2])) {
                              if (vt(h - -64 | 0, n, g), k = N, 3 != b[h + 68 >> 2]) if (st(h - -64 | 0, n, g), 3 != b[h + 68 >> 2]) {
                                if ((d = d + -1 | 0) >>> 0 <= 1) {
                                  if (k = N, d - 1) break r;
                                  k = _(N + _(T * _(.5)));
                                } else k = _(N + T);
                              } else k = _(N + Fe(_(0), T));
                            } else k = _(N + Fe(_(0), _(T * _(.5))));
                          } else {
                            if (k = N, Qn(n, g, B)) break r;
                            d = wo(Ko(n) + 288 | 0, b[wo(1848, R) >> 2]), k = m[d >> 2], b[h + 56 >> 2] = b[d >> 2], x = au(n), m[h + 64 >> 2] = m[x + 188 >> 2], d = h, Eo(h - -64 | 0) ? X = m[C + 40 >> 2] : (An = h, cn = ea(n, g, W), m[An + 40 >> 2] = cn, T = m[x + 188 >> 2], X = m[h + 40 >> 2], V ? (m[h + 32 >> 2] = T, J = _(k / m[h + 32 >> 2])) : (m[h + 32 >> 2] = T, J = _(m[h + 32 >> 2] * k)), X = _(X + J)), m[d + 48 >> 2] = X, An = h, cn = ea(n, R, W), m[An + 64 >> 2] = cn, m[h + 56 >> 2] = m[h - -64 >> 2] + k, b[h + 40 >> 2] = 1, b[h + 32 >> 2] = 1, Sn(n, R, G, W, h + 40 | 0, h + 56 | 0), Sn(n, g, B, W, h + 32 | 0, h + 48 | 0), k = m[h + 48 >> 2], T = m[h + 56 >> 2], zi(h - -64 | 0, au(b[h + 204 >> 2])), d = 0 != (0 | H) & 4 != (0 | ra(h - -64 | 0)), pn(n, X = V ? T : k, k = V ? k : T, y, x = 1 ^ (vu(X) | d & rn), 1 ^ (vu(k) | d & V), W, Y, 1, 2, A, c, l, s, v), k = N;
                          }

                          yi($, _(k + _(U + m[wo(Ko(n), b[wo(2184, g) >> 2]) >> 2])), b[wo(2184, g) >> 2]);
                        } else {
                          if (hr(n, g) && (An = h, cn = Pn(n, g, B), m[An + 64 >> 2] = cn, k = m[h - -64 >> 2], T = vr(b[h + 204 >> 2], g), An = h, cn = Ar(n, g, W), m[An + 56 >> 2] = cn, yi(n, _(_(k + T) + m[h + 56 >> 2]), b[wo(2184, g) >> 2]), !vu(m[wo(Ko(n), b[wo(2184, g) >> 2]) >> 2]))) break n;
                          k = vr(b[h + 204 >> 2], g), An = h, cn = Ar(n, g, W), m[An + 64 >> 2] = cn, yi(n, _(k + m[h - -64 >> 2]), b[wo(2184, g) >> 2]);
                        }

                        if ((0 | (E = E + 1 | 0)) == (0 | a)) break;
                      }

                      k = m[C + 40 >> 2];
                    }

                    if (n = w + 1 | 0, U = _(U + k), z = Fe(z, m[C + 36 >> 2]), !(a >>> 0 < I >>> 0)) break;
                  }

                  n: if (f && (H || er(b[h + 204 >> 2]))) {
                    O = _(0);

                    r: {
                      t: if (!(vu(B) || (zi(h - -64 | 0, au(b[h + 204 >> 2])), (e = ra(h - -64 | 0) + -2 | 0) >>> 0 > 5))) {
                        k = _(B - U);

                        e: switch (e - 1 | 0) {
                          default:
                            N = _(N + _(k * _(.5)));
                            break t;

                          case 1:
                            if (!(B > U)) break t;
                            O = _(k / _(n >>> 0));
                            break t;

                          case 4:
                            if (B > U) {
                              if (N = _(N + _(k / _(n << 1 >>> 0))), n >>> 0 < 2) break t;
                              O = _(k / _(n >>> 0));
                              break r;
                            }

                            N = _(N + _(k * _(.5)));
                            break t;

                          case 3:
                            if (B > U ^ 1 | n >>> 0 < 2) break t;
                            O = _(k / _(w >>> 0));
                            break r;

                          case 2:
                            break t;

                          case 0:
                        }

                        N = _(N + k);
                      }

                      if (!n) break n;
                    }

                    for (d = 0, n = 0, a = 0;;) {
                      if (F = _(0), Z = _(0), k = _(0), E = n, T = _(0), X = O, n >>> 0 < I >>> 0) {
                        r: {
                          for (;;) {
                            if (Yi(h - -64 | 0, au(e = Qe(b[h + 204 >> 2], E))), 1 != (0 | na(h - -64 | 0)) && (Ui(h - -64 | 0, au(e)), !na(h - -64 | 0))) {
                              if (a = E, b[e + 536 >> 2] != (0 | d)) break r;
                              Te(e, g) && (T = m[wo(Ko(e) + 288 | 0, b[wo(1848, g) >> 2]) >> 2], An = h, cn = ea(e, g, W), m[An + 64 >> 2] = cn, k = Fe(k, _(T + m[h - -64 >> 2]))), 5 == (0 | Pt(b[h + 204 >> 2], e)) && (T = Un(e, l), An = h, cn = Ar(e, 0, W), m[An + 64 >> 2] = cn, an = m[h - -64 >> 2], on = m[wo(Ko(e) + 288 | 0, 1) >> 2], An = h, cn = ea(e, 0, W), m[An + 64 >> 2] = cn, un = m[h - -64 >> 2], J = k, Z = Fe(Z, k = _(T + an)), F = Fe(F, _(_(on + un) - k)), k = Fe(J, _(Z + F)));
                            }

                            if ((0 | I) == (0 | (E = E + 1 | 0))) break;
                          }

                          a = I;
                        }

                        T = Z;
                      }

                      if (k = _(X + k), n >>> 0 >= a >>> 0) N = _(N + k);else {
                        for (X = _(N + k), T = _(N + T);;) {
                          Yi(h - -64 | 0, au(e = Qe(b[h + 204 >> 2], n)));

                          r: if (1 != (0 | na(h - -64 | 0)) && (Ui(h - -64 | 0, au(e)), !(na(h - -64 | 0) || (E = Pt(b[h + 204 >> 2], e) + -1 | 0) >>> 0 > 4))) {
                            t: switch (E - 1 | 0) {
                              default:
                                An = h, cn = Ar(e, g, W), m[An + 64 >> 2] = cn, yi(e, _(N + m[h - -64 >> 2]), b[wo(2184, g) >> 2]);
                                break r;

                              case 1:
                                An = h, cn = cr(e, g, W), m[An + 64 >> 2] = cn, yi(e, _(_(X - m[h - -64 >> 2]) - m[wo(Ko(e) + 288 | 0, b[wo(1848, g) >> 2]) >> 2]), b[wo(2184, g) >> 2]);
                                break r;

                              case 0:
                                yi(e, _(N + _(_(k - m[wo(Ko(e) + 288 | 0, b[wo(1848, g) >> 2]) >> 2]) * _(.5))), b[wo(2184, g) >> 2]);
                                break r;

                              case 2:
                                if (An = h, cn = Ar(e, g, W), m[An + 64 >> 2] = cn, yi(e, _(N + m[h - -64 >> 2]), b[wo(2184, g) >> 2]), Qn(e, g, B)) break r;
                                if (V ? (Z = m[wo(Ko(e) + 288 | 0, 0) >> 2], An = h, cn = ea(e, R, W), m[An + 64 >> 2] = cn, F = k, Z = _(Z + m[h - -64 >> 2])) : (Z = m[wo(Ko(e) + 288 | 0, 1) >> 2], An = h, cn = ea(e, g, W), m[An + 64 >> 2] = cn, F = _(Z + m[h - -64 >> 2]), Z = k), mt(Z, m[wo(Ko(e) + 288 | 0, 0) >> 2]) && mt(F, m[wo(Ko(e) + 288 | 0, 1) >> 2])) break r;
                                pn(e, Z, F, y, 1, 1, W, Y, 1, 3, A, c, l, s, v);
                                break r;

                              case 3:
                            }

                            Z = Un(e, l), An = h, cn = Pn(e, 0, B), m[An + 64 >> 2] = cn, yi(e, _(_(T - Z) + m[h - -64 >> 2]), 1);
                          }

                          if ((0 | a) == (0 | (n = n + 1 | 0))) break;
                        }

                        N = X;
                      }
                      if (e = (0 | d) != (0 | w), d = d + 1 | 0, n = a, !e) break;
                    }
                  }

                  if (hi(n = b[h + 204 >> 2], yt(n, 2, _(r - L), o, o), 0), hi(n = b[h + 204 >> 2], yt(n, 0, _(t - K), u, o), 1), P && (Si(h - -64 | 0, au(b[h + 204 >> 2])), 2 == (0 | qi(h - -64 | 0)) | 2 != (0 | P)) ? 2 == (0 | P) && (Si(h - -64 | 0, au(b[h + 204 >> 2])), 2 == (0 | qi(h - -64 | 0)) && (An = h, cn = Rn(n = b[h + 204 >> 2], R, m[lo(h + 24 | 0, z) >> 2], S), m[An + 64 >> 2] = cn, hi(n, Fe(Xe(_(j + G), m[h - -64 >> 2]), j), b[wo(1848, R) >> 2]))) : hi(n = b[h + 204 >> 2], r = yt(n, R, z, S, o), b[wo(1848, R) >> 2]), D && (Si(h - -64 | 0, au(b[h + 204 >> 2])), (n = 2 != (0 | D)) | 2 == (0 | qi(h - -64 | 0))) ? n || (Si(h - -64 | 0, au(b[h + 204 >> 2])), 2 == (0 | qi(h - -64 | 0)) && (An = h, cn = Rn(n = b[h + 204 >> 2], g, m[lo(h + 16 | 0, _(Q + U)) >> 2], M), m[An + 64 >> 2] = cn, hi(n, Fe(Xe(_(Q + B), m[h - -64 >> 2]), Q), b[wo(1848, g) >> 2]))) : hi(n = b[h + 204 >> 2], r = yt(n, g, _(Q + U), M, o), b[wo(1848, g) >> 2]), f) {
                    if (Hi(h - -64 | 0, au(b[h + 204 >> 2])), 2 == (0 | qi(h - -64 | 0))) for (a = I >>> 0 > 1 ? I : 1, n = 0; Ui(h - -64 | 0, au(e = ci(b[h + 204 >> 2], n))), na(h - -64 | 0) || yi(e, _(_(m[wo(Ko(b[h + 204 >> 2]) + 288 | 0, b[wo(1848, g) >> 2]) >> 2] - m[wo(Ko(e), b[wo(2184, g) >> 2]) >> 2]) - m[wo(Ko(e) + 288 | 0, b[wo(1848, g) >> 2]) >> 2]), b[wo(2184, g) >> 2]), (0 | a) != (0 | (n = n + 1 | 0));) {
                      ;
                    }
                    if (An = h, ln = mo(n = Lo(b[h + 204 >> 2])), b[An + 56 >> 2] = ln, An = h, ln = to(n), b[An + 48 >> 2] = ln, ba(h + 56 | 0, h + 48 | 0)) for (n = V ? P : i; Ui(h - -64 | 0, au(e = b[b[h + 56 >> 2] >> 2])), 1 == (0 | na(h - -64 | 0)) && bn(b[h + 204 >> 2], e, W, n, Y, y, A, c, l, s, v), Zo(h + 56 | 0), ba(h + 56 | 0, h + 48 | 0);) {
                      ;
                    }
                    if (i = -3 & R, 1 == (0 | (a = -3 & g)) || 1 == (0 | i)) for (f = I >>> 0 > 1 ? I : 1, n = 0; Yi(h - -64 | 0, au(e = Qe(b[h + 204 >> 2], n))), 1 != (0 | na(h - -64 | 0)) && (1 == (0 | i) && Lr(b[h + 204 >> 2], e, R), 1 == (0 | a) && Lr(b[h + 204 >> 2], e, g)), (0 | f) != (0 | (n = n + 1 | 0));) {
                      ;
                    }
                  }

                  du(C);
                }
              } else !function (n, r, t, e, i, a, o) {
                var u,
                    f = _(0),
                    A = _(0),
                    c = _(0),
                    l = _(0),
                    s = 0,
                    v = _(0);

                fn = u = fn - 16 | 0, f = re(n, 2, a), A = re(n, 0, a), s = u, v = ea(n, 2, a), m[s + 8 >> 2] = v, c = m[u + 8 >> 2], s = u, v = ea(n, 0, a), m[s >> 2] = v, l = m[u >> 2], hi(n, yt(n, 2, -3 & e ? _(r - c) : f, a, a), 0), hi(n, yt(n, 0, -3 & i ? _(t - l) : A, o, a), 1), fn = u + 16 | 0;
              }(b[h + 204 >> 2], r, t, i, a, o, u);
              fn = h + 208 | 0;
            }

            function vn(n, r, t, e, i) {
              var u,
                  f,
                  A,
                  c = 0,
                  l = 0,
                  s = 0,
                  v = 0,
                  h = 0,
                  y = 0,
                  m = 0,
                  _ = 0,
                  C = 0,
                  E = 0,
                  w = 0,
                  N = 0;
              fn = u = fn - 80 | 0, b[u + 76 >> 2] = r, A = u + 55 | 0, f = u + 56 | 0, r = 0;

              n: {
                r: {
                  t: for (;;) {
                    (0 | C) < 0 || ((0 | r) > (2147483647 - C | 0) ? (b[2373] = 61, C = -1) : C = r + C | 0);

                    e: {
                      i: {
                        a: {
                          o: {
                            u: {
                              f: {
                                A: {
                                  c: {
                                    l: {
                                      s: {
                                        v: {
                                          d: {
                                            b: {
                                              if (v = b[u + 76 >> 2], s = p[0 | (r = v)]) {
                                                for (;;) {
                                                  p: {
                                                    h: {
                                                      y: if (c = 255 & s) {
                                                        if (37 != (0 | c)) break h;

                                                        for (s = r;;) {
                                                          if (37 != p[r + 1 | 0]) break y;
                                                          if (c = r + 2 | 0, b[u + 76 >> 2] = c, s = s + 1 | 0, l = p[r + 2 | 0], r = c, 37 != (0 | l)) break;
                                                        }
                                                      } else s = r;

                                                      if (r = s - v | 0, n && aa(n, v, r), r) continue t;
                                                      E = -1, s = 1, c = u, h = !fo(o[b[u + 76 >> 2] + 1 | 0]), r = b[u + 76 >> 2], h | 36 != p[r + 2 | 0] || (E = o[r + 1 | 0] + -48 | 0, w = 1, s = 3), r = s + r | 0, b[c + 76 >> 2] = r, s = 0;

                                                      y: if ((l = (m = o[0 | r]) + -32 | 0) >>> 0 > 31) c = r;else if (c = r, 75913 & (l = 1 << l)) for (;;) {
                                                        if (c = r + 1 | 0, b[u + 76 >> 2] = c, s |= l, (l = (m = o[r + 1 | 0]) + -32 | 0) >>> 0 > 31) break y;
                                                        if (r = c, !(75913 & (l = 1 << l))) break;
                                                      }

                                                      y: if (42 != (0 | m)) {
                                                        if ((0 | (_ = dt(u + 76 | 0))) < 0) break r;
                                                        r = b[u + 76 >> 2];
                                                      } else {
                                                        if (h = u, fo(o[c + 1 | 0]) && (r = b[u + 76 >> 2], 36 == p[r + 2 | 0])) b[((o[r + 1 | 0] << 2) + i | 0) - 192 >> 2] = 10, _ = b[((o[r + 1 | 0] << 3) + e | 0) - 384 >> 2], w = 1, r = r + 3 | 0;else {
                                                          if (w) break r;
                                                          w = 0, _ = 0, n && (r = b[t >> 2], b[t >> 2] = r + 4, _ = b[r >> 2]), r = b[u + 76 >> 2] + 1 | 0;
                                                        }
                                                        if (b[h + 76 >> 2] = r, (0 | _) > -1) break y;
                                                        _ = 0 - _ | 0, s |= 8192;
                                                      }

                                                      l = -1;

                                                      y: if (46 == p[0 | r]) if (42 != p[r + 1 | 0]) b[u + 76 >> 2] = r + 1, l = dt(u + 76 | 0), r = b[u + 76 >> 2];else {
                                                        if (fo(o[r + 2 | 0]) && (r = b[u + 76 >> 2], 36 == p[r + 3 | 0])) {
                                                          b[((o[r + 2 | 0] << 2) + i | 0) - 192 >> 2] = 10, l = b[((o[r + 2 | 0] << 3) + e | 0) - 384 >> 2], r = r + 4 | 0, b[u + 76 >> 2] = r;
                                                          break y;
                                                        }

                                                        if (w) break r;
                                                        n ? (r = b[t >> 2], b[t >> 2] = r + 4, l = b[r >> 2]) : l = 0, r = b[u + 76 >> 2] + 2 | 0, b[u + 76 >> 2] = r;
                                                      }

                                                      for (c = 0;;) {
                                                        if (N = c, y = -1, o[0 | r] + -65 >>> 0 > 57) break n;
                                                        if (m = r + 1 | 0, b[u + 76 >> 2] = m, c = o[0 | r], r = m, !((c = p[7087 + (c + g(N, 58) | 0) | 0]) + -1 >>> 0 < 8)) break;
                                                      }

                                                      if (!c) break n;

                                                      y: {
                                                        m: {
                                                          k: {
                                                            if (19 == (0 | c)) {
                                                              if ((0 | E) <= -1) break k;
                                                              break n;
                                                            }

                                                            if ((0 | E) < 0) break m;
                                                            b[(E << 2) + i >> 2] = c, c = b[4 + (r = (E << 3) + e | 0) >> 2], b[u + 64 >> 2] = b[r >> 2], b[u + 68 >> 2] = c;
                                                          }

                                                          if (r = 0, !n) continue t;
                                                          break y;
                                                        }

                                                        if (!n) break e;
                                                        In(u - -64 | 0, c, t), m = b[u + 76 >> 2];
                                                      }

                                                      if (h = -65537 & s, s = 8192 & s ? h : s, y = 0, E = 7120, c = f, r = o[m + -1 | 0], (m = (r = N && 3 == (15 & r) ? -33 & r : r) + -88 | 0) >>> 0 <= 32) break p;

                                                      y: {
                                                        m: {
                                                          k: {
                                                            g: {
                                                              if ((h = r + -65 | 0) >>> 0 > 6) {
                                                                if (83 != (0 | r)) break i;
                                                                if (!l) break g;
                                                                c = b[u + 64 >> 2];
                                                                break m;
                                                              }

                                                              switch (h - 1 | 0) {
                                                                case 1:
                                                                  break k;

                                                                case 0:
                                                                case 2:
                                                                  break i;

                                                                default:
                                                                  break b;
                                                              }
                                                            }

                                                            r = 0, Xr(n, 32, _, 0, s);
                                                            break y;
                                                          }

                                                          b[u + 12 >> 2] = 0, b[u + 8 >> 2] = b[u + 64 >> 2], b[u + 64 >> 2] = u + 8, l = -1, c = u + 8 | 0;
                                                        }

                                                        r = 0;

                                                        m: {
                                                          for (;;) {
                                                            if (!(v = b[c >> 2])) break m;

                                                            if (!((h = (0 | (v = ia(u + 4 | 0, v))) < 0) | v >>> 0 > l - r >>> 0)) {
                                                              if (c = c + 4 | 0, l >>> 0 > (r = r + v | 0) >>> 0) continue;
                                                              break m;
                                                            }

                                                            break;
                                                          }

                                                          if (y = -1, h) break n;
                                                        }

                                                        if (Xr(n, 32, _, r, s), r) for (l = 0, c = b[u + 64 >> 2];;) {
                                                          if (!(v = b[c >> 2])) break y;
                                                          if ((0 | (l = (v = ia(u + 4 | 0, v)) + l | 0)) > (0 | r)) break y;
                                                          if (aa(n, u + 4 | 0, v), c = c + 4 | 0, !(l >>> 0 < r >>> 0)) break;
                                                        } else r = 0;
                                                      }

                                                      Xr(n, 32, _, r, 8192 ^ s), r = (0 | _) > (0 | r) ? _ : r;
                                                      continue t;
                                                    }

                                                    c = r + 1 | 0, b[u + 76 >> 2] = c, s = p[r + 1 | 0], r = c;
                                                    continue;
                                                  }

                                                  break;
                                                }

                                                switch (m - 1 | 0) {
                                                  case 28:
                                                    break u;

                                                  case 21:
                                                    break f;

                                                  case 23:
                                                    break c;

                                                  case 22:
                                                    break l;

                                                  case 11:
                                                  case 16:
                                                    break s;

                                                  case 10:
                                                    break v;

                                                  case 26:
                                                    break d;

                                                  case 8:
                                                  case 12:
                                                  case 13:
                                                  case 14:
                                                    break b;

                                                  case 0:
                                                  case 1:
                                                  case 2:
                                                  case 3:
                                                  case 4:
                                                  case 5:
                                                  case 6:
                                                  case 7:
                                                  case 9:
                                                  case 15:
                                                  case 17:
                                                  case 18:
                                                  case 19:
                                                  case 20:
                                                  case 24:
                                                  case 25:
                                                  case 27:
                                                  case 29:
                                                  case 30:
                                                    break i;

                                                  default:
                                                    break A;
                                                }
                                              }

                                              if (y = C, n) break n;
                                              if (!w) break e;

                                              for (r = 1;;) {
                                                if (n = b[(r << 2) + i >> 2]) {
                                                  if (In((r << 3) + e | 0, n, t), y = 1, 10 != (0 | (r = r + 1 | 0))) continue;
                                                  break n;
                                                }

                                                break;
                                              }

                                              if (y = 1, r >>> 0 > 9) break n;

                                              for (; n = r, !b[((r = r + 1 | 0) << 2) + i >> 2] && 10 != (0 | r);) {
                                                ;
                                              }

                                              y = n >>> 0 < 9 ? -1 : 1;
                                              break n;
                                            }

                                            r = 0 | a[199](n, k[u + 64 >> 3], _, l, s, r);
                                            continue;
                                          }

                                          c = (r = Hn(v = (r = b[u + 64 >> 2]) || 7130, l)) || l + v | 0, s = h, l = r ? r - v | 0 : l;
                                          break i;
                                        }

                                        o[u + 55 | 0] = b[u + 64 >> 2], l = 1, v = A, s = h;
                                        break i;
                                      }

                                      if (r = h = b[u + 68 >> 2], v = b[u + 64 >> 2], (0 | r) < -1 || (0 | r) <= -1 && !(v >>> 0 > 4294967295)) {
                                        r = 0 - (r + (0 < v >>> 0) | 0) | 0, v = 0 - v | 0, b[u + 64 >> 2] = v, b[u + 68 >> 2] = r, y = 1, E = 7120;
                                        break o;
                                      }

                                      if (2048 & s) {
                                        y = 1, E = 7121;
                                        break o;
                                      }

                                      E = (y = 1 & s) ? 7122 : 7120;
                                      break o;
                                    }

                                    if (v = te(b[u + 64 >> 2], b[u + 68 >> 2], f), !(8 & s)) break a;
                                    l = (0 | l) > (0 | (r = f - v | 0)) ? l : r + 1 | 0;
                                    break a;
                                  }

                                  l = l >>> 0 > 8 ? l : 8, s |= 8, r = 120;
                                }

                                if (v = Ut(b[u + 64 >> 2], b[u + 68 >> 2], f, 32 & r), !(8 & s) | !(b[u + 64 >> 2] | b[u + 68 >> 2])) break a;
                                E = 7120 + (r >>> 4 | 0) | 0, y = 2;
                                break a;
                              }

                              if (r = 0, (c = 255 & N) >>> 0 > 7) continue;

                              f: switch (c - 1 | 0) {
                                default:
                                case 0:
                                  b[b[u + 64 >> 2] >> 2] = C;
                                  continue;

                                case 1:
                                  c = b[u + 64 >> 2], b[c >> 2] = C, b[c + 4 >> 2] = C >> 31;
                                  continue;

                                case 2:
                                  d[b[u + 64 >> 2] >> 1] = C;
                                  continue;

                                case 3:
                                  o[b[u + 64 >> 2]] = C;
                                  continue;

                                case 5:
                                  b[b[u + 64 >> 2] >> 2] = C;
                                  continue;

                                case 4:
                                  continue;

                                case 6:
                              }

                              c = b[u + 64 >> 2], b[c >> 2] = C, b[c + 4 >> 2] = C >> 31;
                              continue;
                            }

                            v = b[u + 64 >> 2], r = b[u + 68 >> 2], E = 7120;
                          }

                          v = lr(v, r, f);
                        }

                        s = (0 | l) > -1 ? -65537 & s : s, h = r = b[u + 68 >> 2], !!(r | (m = b[u + 64 >> 2])) | l ? l = (0 | l) > (0 | (r = !(h | m) + (f - v | 0) | 0)) ? l : r : (v = f, l = 0);
                      }

                      Xr(n, 32, r = (0 | _) < (0 | (c = (l = (0 | l) < (0 | (h = c - v | 0)) ? h : l) + y | 0)) ? c : _, c, s), aa(n, E, y), Xr(n, 48, r, c, 65536 ^ s), Xr(n, 48, l, h, 0), aa(n, v, h), Xr(n, 32, r, c, 8192 ^ s);
                      continue;
                    }

                    break;
                  }

                  y = 0;
                  break n;
                }

                y = -1;
              }

              return fn = u + 80 | 0, y;
            }

            function dn(n) {
              var r = 0,
                  t = 0,
                  e = 0,
                  i = 0,
                  a = 0,
                  o = 0,
                  u = 0,
                  f = 0,
                  A = 0;

              n: if (n |= 0) {
                a = (e = n + -8 | 0) + (n = -8 & (t = b[n + -4 >> 2])) | 0;

                r: if (!(1 & t)) {
                  if (!(3 & t)) break n;
                  if ((e = e - (t = b[e >> 2]) | 0) >>> 0 < y[2655]) break n;

                  if (n = n + t | 0, b[2656] == (0 | e)) {
                    if (3 == (3 & (t = b[a + 4 >> 2]))) return b[2653] = n, b[a + 4 >> 2] = -2 & t, b[e + 4 >> 2] = 1 | n, void (b[n + e >> 2] = n);
                  } else {
                    if (t >>> 0 <= 255) {
                      if (i = b[e + 8 >> 2], t = t >>> 3 | 0, (0 | (r = b[e + 12 >> 2])) == (0 | i)) {
                        f = 10604, A = b[2651] & ze(t), b[f >> 2] = A;
                        break r;
                      }

                      b[i + 12 >> 2] = r, b[r + 8 >> 2] = i;
                      break r;
                    }

                    if (u = b[e + 24 >> 2], (0 | e) == (0 | (t = b[e + 12 >> 2]))) {
                      if ((r = b[(i = e + 20 | 0) >> 2]) || (r = b[(i = e + 16 | 0) >> 2])) {
                        for (; o = i, (r = b[(i = (t = r) + 20 | 0) >> 2]) || (i = t + 16 | 0, r = b[t + 16 >> 2]);) {
                          ;
                        }

                        b[o >> 2] = 0;
                      } else t = 0;
                    } else r = b[e + 8 >> 2], b[r + 12 >> 2] = t, b[t + 8 >> 2] = r;
                    if (!u) break r;
                    i = b[e + 28 >> 2];

                    t: {
                      if (b[(r = 10908 + (i << 2) | 0) >> 2] == (0 | e)) {
                        if (b[r >> 2] = t, t) break t;
                        f = 10608, A = b[2652] & ze(i), b[f >> 2] = A;
                        break r;
                      }

                      if (b[u + (b[u + 16 >> 2] == (0 | e) ? 16 : 20) >> 2] = t, !t) break r;
                    }

                    if (b[t + 24 >> 2] = u, (r = b[e + 16 >> 2]) && (b[t + 16 >> 2] = r, b[r + 24 >> 2] = t), !(r = b[e + 20 >> 2])) break r;
                    b[t + 20 >> 2] = r, b[r + 24 >> 2] = t;
                  }
                }

                if (!(a >>> 0 <= e >>> 0) && 1 & (t = b[a + 4 >> 2])) {
                  r: {
                    if (!(2 & t)) {
                      if (b[2657] == (0 | a)) {
                        if (b[2657] = e, n = b[2654] + n | 0, b[2654] = n, b[e + 4 >> 2] = 1 | n, b[2656] != (0 | e)) break n;
                        return b[2653] = 0, void (b[2656] = 0);
                      }

                      if (b[2656] == (0 | a)) return b[2656] = e, n = b[2653] + n | 0, b[2653] = n, b[e + 4 >> 2] = 1 | n, void (b[n + e >> 2] = n);
                      n = (-8 & t) + n | 0;

                      t: if (t >>> 0 <= 255) {
                        if (t = t >>> 3 | 0, (0 | (r = b[a + 8 >> 2])) == (0 | (i = b[a + 12 >> 2]))) {
                          f = 10604, A = b[2651] & ze(t), b[f >> 2] = A;
                          break t;
                        }

                        b[r + 12 >> 2] = i, b[i + 8 >> 2] = r;
                      } else {
                        if (u = b[a + 24 >> 2], (0 | a) == (0 | (t = b[a + 12 >> 2]))) {
                          if ((r = b[(i = a + 20 | 0) >> 2]) || (r = b[(i = a + 16 | 0) >> 2])) {
                            for (; o = i, (r = b[(i = (t = r) + 20 | 0) >> 2]) || (i = t + 16 | 0, r = b[t + 16 >> 2]);) {
                              ;
                            }

                            b[o >> 2] = 0;
                          } else t = 0;
                        } else r = b[a + 8 >> 2], b[r + 12 >> 2] = t, b[t + 8 >> 2] = r;

                        if (u) {
                          i = b[a + 28 >> 2];

                          e: {
                            if (b[(r = 10908 + (i << 2) | 0) >> 2] == (0 | a)) {
                              if (b[r >> 2] = t, t) break e;
                              f = 10608, A = b[2652] & ze(i), b[f >> 2] = A;
                              break t;
                            }

                            if (b[u + (b[u + 16 >> 2] == (0 | a) ? 16 : 20) >> 2] = t, !t) break t;
                          }

                          b[t + 24 >> 2] = u, (r = b[a + 16 >> 2]) && (b[t + 16 >> 2] = r, b[r + 24 >> 2] = t), (r = b[a + 20 >> 2]) && (b[t + 20 >> 2] = r, b[r + 24 >> 2] = t);
                        }
                      }

                      if (b[e + 4 >> 2] = 1 | n, b[n + e >> 2] = n, b[2656] != (0 | e)) break r;
                      return void (b[2653] = n);
                    }

                    b[a + 4 >> 2] = -2 & t, b[e + 4 >> 2] = 1 | n, b[n + e >> 2] = n;
                  }

                  if (n >>> 0 <= 255) return t = 10644 + ((n = n >>> 3 | 0) << 3) | 0, (r = b[2651]) & (n = 1 << n) ? n = b[t + 8 >> 2] : (b[2651] = n | r, n = t), b[t + 8 >> 2] = e, b[n + 12 >> 2] = e, b[e + 12 >> 2] = t, void (b[e + 8 >> 2] = n);
                  b[e + 16 >> 2] = 0, b[e + 20 >> 2] = 0, r = 0, (i = n >>> 8 | 0) && (r = 31, n >>> 0 > 16777215 || (r = (t = i) << (i = i + 1048320 >>> 16 & 8), r = 28 + ((r = ((r <<= u = r + 520192 >>> 16 & 4) << (o = r + 245760 >>> 16 & 2) >>> 15 | 0) - (o | i | u) | 0) << 1 | n >>> r + 21 & 1) | 0)), b[(a = e) + 28 >> 2] = r, o = 10908 + (r << 2) | 0;

                  r: {
                    t: {
                      if ((i = b[2652]) & (t = 1 << r)) {
                        for (i = n << (31 == (0 | r) ? 0 : 25 - (r >>> 1 | 0) | 0), t = b[o >> 2];;) {
                          if (r = t, (-8 & b[t + 4 >> 2]) == (0 | n)) break t;
                          if (t = i >>> 29 | 0, i <<= 1, !(t = b[16 + (o = r + (4 & t) | 0) >> 2])) break;
                        }

                        b[o + 16 >> 2] = e, b[e + 24 >> 2] = r;
                      } else b[2652] = t | i, b[o >> 2] = e, b[e + 24 >> 2] = o;

                      b[e + 12 >> 2] = e, b[e + 8 >> 2] = e;
                      break r;
                    }

                    n = b[r + 8 >> 2], b[n + 12 >> 2] = e, b[r + 8 >> 2] = e, b[e + 24 >> 2] = 0, b[e + 12 >> 2] = r, b[e + 8 >> 2] = n;
                  }

                  if (n = b[2659] + -1 | 0, b[2659] = n, !n) {
                    for (e = 11060; e = (n = b[e >> 2]) + 8 | 0, n;) {
                      ;
                    }

                    b[2659] = -1;
                  }
                }
              }
            }

            function bn(n, r, t, e, i, a, o, u, f, A, c) {
              var l,
                  s,
                  v,
                  d,
                  p = _(0),
                  h = _(0),
                  y = 0,
                  k = 0,
                  g = _(0),
                  C = _(0),
                  E = _(0),
                  w = _(0),
                  N = 0,
                  W = _(0);

              fn = l = fn + -64 | 0, $i(l + 32 | 0, au(n)), v = Oi(s = pe(Li(l + 32 | 0), a), a), d = Yo(s), N = l, W = ea(r, 2, t), m[N + 32 >> 2] = W, g = m[l + 32 >> 2], N = l, W = ea(r, 0, t), m[N + 32 >> 2] = W, C = m[l + 32 >> 2], Qn(r, 2, t) ? (oe(l + 32 | 0, r), y = ko(l + 32 | 0, 0), k = b[y + 4 >> 2], y = b[y >> 2], b[l + 16 >> 2] = y, b[l + 20 >> 2] = k, b[l + 48 >> 2] = y, b[l + 52 >> 2] = k, N = l, W = wr(l + 16 | 0, t), m[N + 56 >> 2] = W, p = _(g + m[l + 56 >> 2])) : (p = _(Z), hr(r, 2) && pr(r, 2) && (p = m[wo(Ko(n) + 288 | 0, 0) >> 2], h = vr(n, 2), E = sr(n, 2), N = l, W = xt(Pn(r, 2, t), Dn(r, 2, t)), m[N + 32 >> 2] = W, p = yt(r, 2, _(_(p - _(h + E)) - m[l + 32 >> 2]), t, t))), Qn(r, 0, i) ? (oe(l + 32 | 0, r), y = ko(l + 32 | 0, 1), k = b[y + 4 >> 2], y = b[y >> 2], b[l + 8 >> 2] = y, b[l + 12 >> 2] = k, b[l + 24 >> 2] = y, b[l + 28 >> 2] = k, N = l, W = wr(l + 8 | 0, i), m[N + 56 >> 2] = W, h = _(C + m[l + 56 >> 2])) : (h = _(Z), hr(r, 0) && pr(r, 0) && (h = m[wo(Ko(n) + 288 | 0, 1) >> 2], E = vr(n, 0), w = sr(n, 0), N = l, W = xt(Pn(r, 0, i), Dn(r, 0, i)), m[N + 32 >> 2] = W, h = yt(r, 0, _(_(h - _(E + w)) - m[l + 32 >> 2]), i, t))), k = au(r), 1 == (vu(p) ^ vu(h)) && (m[l + 32 >> 2] = m[k + 188 >> 2], Eo(l + 32 | 0) || (vu(p) ? (m[l + 32 >> 2] = m[k + 188 >> 2], p = _(g + _(_(h - C) * m[l + 32 >> 2]))) : vu(h) && (m[l + 32 >> 2] = m[k + 188 >> 2], h = _(C + _(_(p - g) / m[l + 32 >> 2]))))), (vu(p) || vu(h)) && (k = 1 ^ vu(p), y = 1 ^ vu(h), d || !e | !vu(p) || (p = (e = (1 ^ vu(t)) & t > _(0)) ? t : p, k = e ? 2 : k), pn(r, p, h, a, k, y, p, h, 0, 6, o, u, f, A, c), p = m[wo(Ko(r) + 288 | 0, 0) >> 2], N = l, W = ea(r, 2, t), m[N + 32 >> 2] = W, h = m[l + 32 >> 2], g = m[wo(Ko(r) + 288 | 0, 1) >> 2], N = l, W = ea(r, 0, t), m[N + 32 >> 2] = W, p = _(p + h), h = _(g + m[l + 32 >> 2])), pn(r, p, h, a, 1, 1, p, h, 1, 1, o, u, f, A, c), !pr(r, s) || hr(r, s) ? hr(r, s) || (ji(l + 32 | 0, au(n)), 1 != (0 | Ki(l + 32 | 0))) ? hr(r, s) || (ji(l + 32 | 0, au(n)), 2 == (0 | Ki(l + 32 | 0)) && yi(r, _(m[wo(Ko(n) + 288 | 0, b[wo(1848, s) >> 2]) >> 2] - m[wo(Ko(r) + 288 | 0, b[wo(1848, s) >> 2]) >> 2]), b[wo(1596, s) >> 2])) : yi(r, _(_(m[wo(Ko(n) + 288 | 0, b[wo(1848, s) >> 2]) >> 2] - m[wo(Ko(r) + 288 | 0, b[wo(1848, s) >> 2]) >> 2]) * _(.5)), b[wo(1596, s) >> 2]) : (p = m[wo(Ko(n) + 288 | 0, b[wo(1848, s) >> 2]) >> 2], h = m[wo(Ko(r) + 288 | 0, b[wo(1848, s) >> 2]) >> 2], g = sr(n, s), N = l, W = cr(r, s, t), m[N + 32 >> 2] = W, C = m[l + 32 >> 2], N = l, W = Dn(r, s, d ? t : i), m[N + 56 >> 2] = W, yi(r, _(_(_(_(p - h) - g) - C) - m[l + 56 >> 2]), b[wo(1596, s) >> 2])), !pr(r, v) || hr(r, v) ? hr(r, v) || 2 != (0 | Pt(n, r)) ? hr(r, v) || (e = Pt(n, r), Hi(l + 32 | 0, au(n)), (3 == (0 | e) | 0) != (2 == (0 | qi(l + 32 | 0)) | 0) && yi(r, _(m[wo(Ko(n) + 288 | 0, b[wo(1848, v) >> 2]) >> 2] - m[wo(Ko(r) + 288 | 0, b[wo(1848, v) >> 2]) >> 2]), b[wo(1596, v) >> 2])) : yi(r, _(_(m[wo(Ko(n) + 288 | 0, b[wo(1848, v) >> 2]) >> 2] - m[wo(Ko(r) + 288 | 0, b[wo(1848, v) >> 2]) >> 2]) * _(.5)), b[wo(1596, v) >> 2]) : (p = m[wo(Ko(n) + 288 | 0, b[wo(1848, v) >> 2]) >> 2], h = m[wo(Ko(r) + 288 | 0, b[wo(1848, v) >> 2]) >> 2], g = sr(n, v), N = l, W = cr(r, v, t), m[N + 32 >> 2] = W, C = m[l + 32 >> 2], N = l, W = Dn(r, v, d ? i : t), m[N + 56 >> 2] = W, yi(r, _(_(_(_(p - h) - g) - C) - m[l + 56 >> 2]), b[wo(1596, v) >> 2])), fn = l - -64 | 0;
            }

            function pn(n, r, t, e, i, a, o, u, f, A, c, l, s, v, d) {
              var h,
                  g,
                  C = 0,
                  E = 0,
                  w = 0,
                  N = 0,
                  W = _(0),
                  Z = _(0),
                  T = 0,
                  I = 0,
                  R = 0,
                  B = 0,
                  V = _(0);

              fn = h = fn - 176 | 0, g = Ko(n), R = Pa(n), B = 0, ((b[g + 84 >> 2] != (0 | d) ? R : B) || (w = 0, b[g + 88 >> 2] != (0 | e))) && (b[g + 296 >> 2] = -1082130432, b[g + 300 >> 2] = -1082130432, b[g + 92 >> 2] = 0, b[g + 312 >> 2] = -1082130432, b[g + 316 >> 2] = -1082130432, b[g + 304 >> 2] = 0, b[g + 308 >> 2] = 0, w = 1), E = v + 1 | 0;

              n: {
                r: {
                  t: {
                    e: {
                      i: {
                        a: {
                          o: {
                            u: if (bo(n)) {
                              if (R = h, V = ea(n, 2, o), m[R + 168 >> 2] = V, W = m[h + 168 >> 2], R = h, V = ea(n, 0, o), m[R + 168 >> 2] = V, Z = m[h + 168 >> 2], Bn(i, r, a, t, b[g + 304 >> 2], m[g + 296 >> 2], b[g + 308 >> 2], m[g + 300 >> 2], m[g + 312 >> 2], m[g + 316 >> 2], W, Z, c)) {
                                v = g + 296 | 0;
                                break o;
                              }

                              if (!b[g + 92 >> 2]) break u;

                              for (C = g + 96 | 0, v = 0;;) {
                                if (Bn(i, r, a, t, b[ao(C, v) + 8 >> 2], m[ao(C, v) >> 2], b[ao(C, v) + 12 >> 2], m[ao(C, v) + 4 >> 2], m[ao(C, v) + 16 >> 2], m[ao(C, v) + 20 >> 2], W, Z, c)) {
                                  v = ao(C, v);
                                  break o;
                                }

                                if (!((v = v + 1 | 0) >>> 0 < y[g + 92 >> 2])) break;
                              }
                            } else if (f) {
                              if (mt(m[g + 296 >> 2], r) && !(!mt(m[g + 300 >> 2], t) | b[g + 304 >> 2] != (0 | i))) {
                                v = b[g + 308 >> 2] == (0 | a) ? g + 296 | 0 : 0;
                                break o;
                              }
                            } else {
                              if (!b[g + 92 >> 2]) break u;

                              for (C = g + 96 | 0, v = 0;;) {
                                if (mt(m[ao(C, v) >> 2], r) && mt(m[ao(C, v) + 4 >> 2], t) && b[ao(C, v) + 8 >> 2] == (0 | i) && b[ao(C, v) + 12 >> 2] == (0 | a)) {
                                  v = ao(C, v);
                                  break o;
                                }

                                if (!((v = v + 1 | 0) >>> 0 < y[g + 92 >> 2])) break;
                              }
                            }

                            C = 1 ^ w, v = 0;
                            break a;
                          }

                          if (T = 0 != (0 | v), !(!v | !(C = 1 ^ w))) {
                            if (e = b[v + 16 >> 2], R = wo(c = g + 288 | 0, 0), B = e, b[R >> 2] = B, e = b[v + 20 >> 2], T = 1, R = wo(c, 1), B = e, b[R >> 2] = B, b[(e = (f ? 12 : 16) + l | 0) >> 2] = b[e >> 2] + 1, p[9456]) break i;
                            break r;
                          }
                        }

                        if (p[9456] && (b[h + 152 >> 2] = w ? 1703 : 1705, b[h + 148 >> 2] = E, R = h, B = fa(E), b[R + 144 >> 2] = B, he(n, 4, 1694, h + 144 | 0), Ze(n, s), N = ki(i, f), I = ki(a, f), R = h, B = 0 | Q(0 | A), b[R + 136 >> 2] = B, k[h + 128 >> 3] = t, k[h + 120 >> 3] = r, b[h + 116 >> 2] = I, b[h + 112 >> 2] = N, he(n, 4, 1706, h + 112 | 0)), sn(n, r, t, e, i, a, o, u, f, c, l, s, E, d, A), p[9456] && (b[h + 104 >> 2] = w ? 1703 : 1705, b[h + 100 >> 2] = E, R = h, B = fa(E), b[R + 96 >> 2] = B, he(n, 4, 1740, h + 96 | 0), Ze(n, s), c = ki(i, f), E = ki(a, f), o = m[wo(N = g + 288 | 0, 0) >> 2], u = m[wo(N, 1) >> 2], R = h, B = 0 | Q(0 | A), b[R + 88 >> 2] = B, k[h + 80 >> 3] = u, k[h + 72 >> 3] = o, b[h + 68 >> 2] = E, b[h + 64 >> 2] = c, he(n, 4, 1749, h - -64 | 0)), b[g + 88 >> 2] = e, v) break n;
                        if ((e = (v = b[g + 92 >> 2]) + 1 | 0) >>> 0 > y[l + 8 >> 2] && (b[l + 8 >> 2] = e), 8 == (0 | v) && (v = 0, p[9456] && he(n, 4, 1781, 0), b[g + 92 >> 2] = 0), !f) break e;
                        e = g + 296 | 0;
                        break t;
                      }

                      if (!p[9457]) break r;
                      b[h + 52 >> 2] = E, R = h, B = fa(E), b[R + 48 >> 2] = B, he(n, 4, 1628, h + 48 | 0), Ze(n, s), e = ki(i, f), i = ki(a, f), o = m[v + 16 >> 2], u = m[v + 20 >> 2], R = h, B = 0 | Q(0 | A), b[R + 40 >> 2] = B, k[h + 32 >> 3] = u, k[h + 24 >> 3] = o, k[h + 16 >> 3] = t, k[h + 8 >> 3] = r, b[h + 4 >> 2] = i, b[h >> 2] = e, he(n, 4, 1645, h);
                      break r;
                    }

                    e = ao(g + 96 | 0, v), b[g + 92 >> 2] = b[g + 92 >> 2] + 1;
                  }

                  b[e + 12 >> 2] = a, b[e + 8 >> 2] = i, m[e + 4 >> 2] = t, m[e >> 2] = r, v = 0, R = e, B = b[wo(i = g + 288 | 0, 0) >> 2], b[R + 16 >> 2] = B, R = e, B = b[wo(i, 1) >> 2], b[R + 20 >> 2] = B;
                  break n;
                }

                C = 1;
              }

              return f ? (mi(n, m[wo(Ko(n) + 288 | 0, 0) >> 2], 0), mi(n, m[wo(Ko(n) + 288 | 0, 1) >> 2], 1), ru(n), ae(n, 0), n = C ? ((g + 296 | 0) == (0 | v)) << 1 : 0) : n = T ? 3 : 1, b[g + 84 >> 2] = d, b[h + 172 >> 2] = s, b[h + 168 >> 2] = n, fn = h + 176 | 0, !v | w;
            }

            function hn(n, r, t, e, i, a, o, u, f, A, c, l, s, v) {
              var d,
                  p,
                  h,
                  y,
                  k,
                  g = 0,
                  C = 0,
                  E = 0,
                  w = _(0),
                  N = _(0),
                  W = _(0),
                  T = _(0),
                  I = 0,
                  R = 0,
                  B = _(0);

              fn = d = fn - 144 | 0, $i(d + 88 | 0, au(n)), p = Yo(h = pe(Li(d + 88 | 0), f)), Yn(d + 112 | 0, r), g = b[d + 116 >> 2], b[d + 40 >> 2] = b[d + 112 >> 2], b[d + 44 >> 2] = g, R = d, B = wr(d + 40 | 0, p ? a : o), m[R + 120 >> 2] = B, y = Qn(r, 2, a), k = Qn(r, 0, o);

              n: if (Eo(d + 120 | 0) || vu(p ? t : i)) {
                if ((I = 1 ^ p) | 1 ^ y) {
                  if (1 ^ k | p) {
                    b[d + 136 >> 2] = 2143289344, b[d + 140 >> 2] = 2143289344, b[d + 132 >> 2] = 0, b[d + 128 >> 2] = 0, R = d, B = ea(r, 2, a), m[R + 88 >> 2] = B, W = m[d + 88 >> 2], R = d, B = ea(r, 0, a), m[R + 88 >> 2] = B, T = m[d + 88 >> 2], w = _(Z), N = _(Z), y && (oe(d + 88 | 0, r), E = ko(d + 88 | 0, 0), g = b[E + 4 >> 2], E = b[E >> 2], b[d + 16 >> 2] = E, b[d + 20 >> 2] = g, b[d + 72 >> 2] = E, b[d + 76 >> 2] = g, R = d, B = wr(d + 16 | 0, a), m[R + 56 >> 2] = B, N = _(W + m[d + 56 >> 2]), m[d + 140 >> 2] = N, b[d + 132 >> 2] = 1, E = 1), k && (oe(d + 88 | 0, r), C = ko(d + 88 | 0, 1), g = b[C + 4 >> 2], C = b[C >> 2], b[d + 8 >> 2] = C, b[d + 12 >> 2] = g, b[d + 64 >> 2] = C, b[d + 68 >> 2] = g, R = d, B = wr(d + 8 | 0, o), m[R + 56 >> 2] = B, w = _(T + m[d + 56 >> 2]), m[d + 136 >> 2] = w, b[d + 128 >> 2] = 1, C = 1), (!p && (Si(d + 88 | 0, au(n)), 2 == (0 | qi(d + 88 | 0))) || (Si(d + 56 | 0, au(n)), 2 != (0 | qi(d + 56 | 0)))) && vu(N) && (vu(t) || (E = 2, b[d + 132 >> 2] = 2, m[d + 140 >> 2] = t, N = t)), (p && (Si(d + 88 | 0, au(n)), 2 == (0 | qi(d + 88 | 0))) || (Si(d + 56 | 0, au(n)), 2 != (0 | qi(d + 56 | 0)))) && vu(w) && (vu(i) || (C = 2, b[d + 128 >> 2] = 2, m[d + 136 >> 2] = i, w = i)), g = au(r), m[d + 88 >> 2] = m[g + 188 >> 2];

                    r: if (!Eo(d + 88 | 0)) {
                      if (1 ^ I | 1 != (0 | E)) {
                        if (1 ^ p | 1 != (0 | C)) break r;
                        m[d + 88 >> 2] = m[g + 188 >> 2], m[d + 140 >> 2] = W + _(_(w - T) * m[d + 88 >> 2]), b[d + 132 >> 2] = 1;
                      } else m[d + 88 >> 2] = m[g + 188 >> 2], m[d + 136 >> 2] = T + _(_(N - W) / m[d + 88 >> 2]), b[d + 128 >> 2] = 1;

                      C = 1, E = 1;
                    }

                    p | y | 1 != (0 | e) | vu(t) | 4 != (0 | Pt(n, r)) | 1 == (0 | E) || (b[d + 132 >> 2] = 1, m[d + 140 >> 2] = t, m[d + 88 >> 2] = m[g + 188 >> 2], Eo(d + 88 | 0) || (m[d + 88 >> 2] = m[g + 188 >> 2], m[d + 136 >> 2] = _(t - W) / m[d + 88 >> 2], C = 1, b[d + 128 >> 2] = 1)), k | I | 1 != (0 | u) | (e = vu(i)) | 4 != (0 | Pt(n, r)) | 1 == (0 | C) || (b[d + 128 >> 2] = 1, m[d + 136 >> 2] = i, m[d + 88 >> 2] = m[g + 188 >> 2], Eo(d + 88 | 0) || (m[d + 88 >> 2] = m[g + 188 >> 2], m[d + 140 >> 2] = _(i - T) * m[d + 88 >> 2], b[d + 132 >> 2] = 1)), Sn(r, 2, a, a, d + 132 | 0, d + 140 | 0), Sn(r, 0, o, a, d + 128 | 0, d + 136 | 0), pn(r, m[d + 140 >> 2], m[d + 136 >> 2], f, b[d + 132 >> 2], b[d + 128 >> 2], a, o, 0, 5, A, c, l, s, v), Po(r, m[lo(d + 48 | 0, Fe(m[wo(Ko(r) + 288 | 0, b[wo(1848, h) >> 2]) >> 2], re(r, h, a))) >> 2]);
                  } else e = lo(d + 56 | 0, re(r, 0, a)), oe(d + 88 | 0, r), u = ko(d + 88 | 0, 1), n = b[u + 4 >> 2], u = b[u >> 2], b[d + 24 >> 2] = u, b[d + 28 >> 2] = n, b[d + 80 >> 2] = u, b[d + 84 >> 2] = n, Po(r, At(wr(d + 24 | 0, o), m[e >> 2]));
                } else e = lo(d + 56 | 0, re(r, 2, a)), oe(d + 88 | 0, r), u = ko(d + 88 | 0, 0), n = b[u + 4 >> 2], u = b[u >> 2], b[d + 32 >> 2] = u, b[d + 36 >> 2] = n, b[d + 104 >> 2] = u, b[d + 108 >> 2] = n, Po(r, At(wr(d + 32 | 0, a), m[e >> 2]));
              } else {
                if (!Eo(Ko(r) + 80 | 0)) {
                  if (!wa(b[r + 556 >> 2], 0)) break n;
                  if (b[Ko(r) + 76 >> 2] == (0 | v)) break n;
                }

                n = lo(d + 88 | 0, re(r, h, a)), Po(r, At(m[d + 120 >> 2], m[n >> 2]));
              }

              Do(r, v), fn = d + 144 | 0;
            }

            function yn(n, r, t, e, i, a, o, u, f, A, c, l, s, v) {
              var d,
                  p = 0,
                  h = _(0),
                  k = 0,
                  g = 0,
                  C = _(0),
                  E = _(0),
                  w = _(0),
                  N = _(0),
                  W = _(0),
                  Z = _(0),
                  T = _(0),
                  I = 0,
                  R = _(0);

              if (fn = d = fn - 368 | 0, k = au(n), I = d, R = _e(n, e, f), m[I + 32 >> 2] = R, C = m[d + 32 >> 2], I = d, R = Ce(n, e, f), m[I + 32 >> 2] = R, E = m[d + 32 >> 2], m[r + 32 >> 2] > _(0) ^ 1 | 2 != (0 | a) || (Mt(Qo(zo(k), b[wo(1848, e) >> 2])) || (a = b[Qo(zo(k), b[wo(1848, e) >> 2]) >> 2], b[d + 12 >> 2] = a, b[d + 360 >> 2] = a, I = d, R = Kt(d + 12 | 0, u), m[I + 32 >> 2] = R, Eo(d + 32 | 0)) ? b[r + 32 >> 2] = 0 : (a = b[Qo(zo(k), b[wo(1848, e) >> 2]) >> 2], b[d + 8 >> 2] = a, b[d + 352 >> 2] = a, I = d, R = Kt(d + 8 | 0, u), m[I + 32 >> 2] = R, I = r, R = Fe(_(0), _(_(_(m[d + 32 >> 2] - C) - E) - _(A - m[r + 32 >> 2]))), m[I + 32 >> 2] = R)), y[r + 16 >> 2] > t >>> 0) for (a = t; Ui(d + 32 | 0, au(g = Qe(n, a))), na(d + 32 | 0) || (st(d + 32 | 0, g, e), k = b[d + 36 >> 2], vt(d + 32 | 0, g, e), p = ((3 == (0 | k)) + p | 0) + (3 == b[d + 36 >> 2]) | 0), (a = a + 1 | 0) >>> 0 < y[r + 16 >> 2];) {
                ;
              }
              ji(d + 32 | 0, au(n)), a = Ki(d + 32 | 0), u = _(0), h = _(0);

              n: if (!(p || (a = a + -1 | 0, h = _(0), a >>> 0 > 4))) {
                r: switch (a - 1 | 0) {
                  default:
                    h = _(m[r + 32 >> 2] * _(.5));
                    break n;

                  case 0:
                    h = m[r + 32 >> 2];
                    break n;

                  case 1:
                    if (h = _(0), y[r >> 2] < 2) break n;
                    u = _(Fe(m[r + 32 >> 2], _(0)) / _(b[r >> 2] + -1 >>> 0)), h = _(0);
                    break n;

                  case 3:
                    h = u = _(m[r + 32 >> 2] / _(b[r >> 2] + 1 >>> 0));
                    break n;

                  case 2:
                }

                u = _(m[r + 32 >> 2] / _(y[r >> 2])), h = _(u * _(.5));
              }

              if (f = h, b[r + 40 >> 2] = 0, m[r + 36 >> 2] = C + h, k = er(n), y[r + 16 >> 2] > t >>> 0) for (o = (1 ^ s) & 1 == (0 | o), a = d + 112 | 0, w = _(0 | p);;) {
                g = au(p = Qe(n, t)), _n(d + 32 | 0, Ko(p), 320);

                n: if (1 != (0 | Da(g))) if (1 == (0 | $a(g)) && hr(p, e)) {
                  if (!s) break n;
                  I = d, R = Pn(p, e, A), m[I + 16 >> 2] = R, C = m[d + 16 >> 2], h = vr(n, e), I = d, R = Ar(p, e, l), m[I + 24 >> 2] = R, yi(p, _(_(C + h) + m[d + 24 >> 2]), b[wo(2184, e) >> 2]);
                } else if ($a(g)) s && yi(p, _(f + _(m[wo(d + 32 | 0, b[wo(2184, e) >> 2]) >> 2] + vr(n, e))), b[wo(2184, e) >> 2]);else {
                  if (st(d + 16 | 0, p, e), 3 == b[d + 20 >> 2] && (m[r + 36 >> 2] = m[r + 36 >> 2] + _(m[r + 32 >> 2] / w)), s && yi(p, _(m[wo(d + 32 | 0, b[wo(2184, e) >> 2]) >> 2] + m[r + 36 >> 2]), b[wo(2184, e) >> 2]), vt(d + 16 | 0, p, e), 3 == b[d + 20 >> 2] && (m[r + 36 >> 2] = m[r + 36 >> 2] + _(m[r + 32 >> 2] / w)), o) {
                    I = d, R = ea(p, e, l), m[I + 16 >> 2] = R, m[r + 36 >> 2] = m[r + 36 >> 2] + _(m[a >> 2] + _(u + m[d + 16 >> 2])), m[r + 40 >> 2] = c;
                    break n;
                  }

                  if (h = xr(p, e, l), m[r + 36 >> 2] = m[r + 36 >> 2] + _(u + h), k) {
                    Z = Un(p, v), I = d, R = Ar(p, 0, l), m[I + 16 >> 2] = R, h = m[d + 16 >> 2], T = m[wo(Ko(p) + 288 | 0, 1) >> 2], I = d, R = ea(p, 0, l), m[I + 16 >> 2] = R, C = m[d + 16 >> 2], N = Fe(N, h = _(Z + h)), W = Fe(W, _(_(T + C) - h));
                    break n;
                  }

                  I = r, R = Fe(m[r + 40 >> 2], xr(p, i, l)), m[I + 40 >> 2] = R;
                }

                if (!((t = t + 1 | 0) >>> 0 < y[r + 16 >> 2])) break;
              }
              m[r + 36 >> 2] = E + m[r + 36 >> 2], k && (m[r + 40 >> 2] = W + N), fn = d + 368 | 0;
            }

            function mn(n, r, t, e, i, a, o, u, f, A, c, l, s, v, d, p, h) {
              var y,
                  k,
                  g = _(0),
                  C = 0,
                  E = _(0),
                  w = _(0),
                  N = 0,
                  W = _(0),
                  Z = _(0),
                  T = 0,
                  I = _(0),
                  R = 0,
                  B = 0,
                  V = 0,
                  G = _(0);

              if (fn = y = fn + -64 | 0, k = Yo(t), Hi(y + 56 | 0, au(r)), C = qi(y + 56 | 0), B = y, V = mo(N = n + 20 | 0), b[B + 48 >> 2] = V, B = y, V = to(N), b[B + 40 >> 2] = V, ba(y + 48 | 0, y + 40 | 0)) for (R = !C | 1 ^ A;;) {
                B = y, G = Rn(A = b[b[y + 48 >> 2] >> 2], t, m[Ko(A) + 80 >> 2], i), m[B + 56 >> 2] = G, w = m[y + 56 >> 2];

                n: if ((N = vu(m[n + 32 >> 2])) | (g = m[n + 32 >> 2]) < _(0) ^ 1) C = vu(g), g = w, m[n + 32 >> 2] > _(0) && (g = w, C || (C = vu(E = dr(A)), g = w, E != _(0) && (g = w, C || (g = yt(A, t, _(w + _(E * _(m[n + 32 >> 2] / m[n + 8 >> 2]))), a, u)))));else {
                  if (g = w, (E = _(w * _(-Ln(A)))) == _(0)) break n;
                  T = vu(m[n + 12 >> 2]), C = A, N = t, g = w, W = m[n + 12 >> 2], (T || W != _(0)) && (E = _(E * _(m[n + 32 >> 2] / W))), g = yt(C, N, _(g + E), a, u);
                }

                if (B = y, G = ea(A, t, u), m[B + 56 >> 2] = G, E = m[y + 56 >> 2], B = y, G = ea(A, e, u), m[B + 56 >> 2] = G, W = m[y + 56 >> 2], Z = _(g + E), m[y + 32 >> 2] = Z, b[y + 24 >> 2] = 1, C = au(A), m[y + 56 >> 2] = m[C + 188 >> 2], Eo(y + 56 | 0) ? vu(o) || !R | Qn(A, e, o) | 1 != (0 | c) || 4 != (0 | Pt(r, A)) || (st(y + 56 | 0, A, e), 3 == b[y + 60 >> 2] || (vt(y + 16 | 0, A, e), 3 == b[y + 20 >> 2])) ? Qn(A, e, o) ? (ti(y + 8 | 0, A, b[wo(1848, e) >> 2]), C = b[y + 12 >> 2], b[y >> 2] = b[y + 8 >> 2], b[y + 4 >> 2] = C, B = y, G = wr(y, o), m[B + 56 >> 2] = G, E = _(W + m[y + 56 >> 2]), m[y + 36 >> 2] = E, ti(y + 56 | 0, A, b[wo(1848, e) >> 2]), C = b[y + 60 >> 2], B = y, V = 1 ^ (vu(E) | 2 == (0 | C) & 1 != (0 | c)), b[B + 28 >> 2] = V) : (m[y + 36 >> 2] = o, B = y, V = vu(o) ? 0 : 2, b[B + 28 >> 2] = V) : (b[y + 28 >> 2] = 1, m[y + 36 >> 2] = o) : (E = _(Z - E), Z = m[C + 188 >> 2], k ? (m[y + 56 >> 2] = Z, E = _(E / m[y + 56 >> 2])) : (m[y + 56 >> 2] = Z, E = _(E * m[y + 56 >> 2])), b[y + 28 >> 2] = 1, m[y + 36 >> 2] = W + E), w = _(g - w), Sn(A, t, a, u, y + 24 | 0, y + 32 | 0), Sn(A, e, o, u, y + 28 | 0, y + 36 | 0), C = 0, Qn(A, e, o) || 4 == (0 | Pt(r, A)) && (st(y + 56 | 0, A, e), 3 != b[y + 60 >> 2] && (vt(y + 16 | 0, A, e), C = 3 != b[y + 20 >> 2])), I = _(I + w), N = b[y + 24 >> 2], T = b[y + 28 >> 2], w = m[y + 32 >> 2], g = m[y + 36 >> 2], C = (-1 ^ C) & l, pn(A, k ? w : g, k ? g : w, Qa(Ko(r)), k ? N : T, k ? T : N, u, f, C, C ? 4 : 7, s, v, d, p, h), Ro(r, Xa(Ko(r)) | Xa(Ko(A))), Zo(y + 48 | 0), !ba(y + 48 | 0, y + 40 | 0)) break;
              }
              return fn = y - -64 | 0, I;
            }

            function kn(n, r, t, e) {
              var i,
                  a,
                  u = 0,
                  f = 0,
                  A = 0,
                  c = _(0),
                  l = _(0),
                  s = _(0),
                  v = 0,
                  d = _(0);

              fn = i = fn - 208 | 0, b[i + 152 >> 2] = 0, Zn(i + 152 | 0, 0, 56), A = 1, Oo(), Fn(n), v = i, a = au(n), b[v + 144 >> 2] = a, u = n, Qn(n, 2, r) ? (ti(i + 136 | 0, n, b[wo(1848, 2) >> 2]), f = b[i + 140 >> 2], b[i + 24 >> 2] = b[i + 136 >> 2], b[i + 28 >> 2] = f, v = i, d = xt(wr(i + 24 | 0, r), ea(n, 2, r)), m[v + 40 >> 2] = d, c = m[i + 40 >> 2]) : (ii(i + 128 | 0, i + 144 | 0, 0), b[i + 36 >> 2] = b[i + 128 >> 2], v = i, d = Kt(i + 36 | 0, r), m[v + 40 >> 2] = d, Eo(i + 40 | 0) ? (A = 1 ^ vu(r), c = r) : (ii(i + 120 | 0, i + 144 | 0, 0), b[i + 32 >> 2] = b[i + 120 >> 2], v = i, d = Kt(i + 32 | 0, r), m[v + 40 >> 2] = d, A = 2, c = m[i + 40 >> 2])), s = c, Qn(n, 0, t) ? (ti(i + 112 | 0, n, b[wo(1848, 0) >> 2]), f = b[i + 116 >> 2], b[i + 8 >> 2] = b[i + 112 >> 2], b[i + 12 >> 2] = f, v = i, d = xt(wr(i + 8 | 0, t), ea(n, 0, r)), m[v + 40 >> 2] = d, f = 1, l = m[i + 40 >> 2]) : (ii(i + 104 | 0, i + 144 | 0, 1), b[i + 20 >> 2] = b[i + 104 >> 2], v = i, d = Kt(i + 20 | 0, t), m[v + 40 >> 2] = d, Eo(i + 40 | 0) ? (f = 1 ^ vu(t), l = t) : (ii(i + 96 | 0, i + 144 | 0, 1), b[i + 16 >> 2] = b[i + 96 >> 2], v = i, d = Kt(i + 16 | 0, t), m[v + 40 >> 2] = d, f = 2, l = m[i + 40 >> 2])), pn(u, s, l, e, A, f, r, t, 1, 0, b[n + 556 >> 2], i + 152 | 0, 0, 0, b[2363]) && (jn(n, Qa(Ko(n)), r, t, r), Vn(n, +m[b[n + 556 >> 2] + 16 >> 2], 0, 0)), b[i + 40 >> 2] = 0, b[i + 44 >> 2] = i + 152, p[b[n + 556 >> 2] + 12 | 0] && function (n) {
                var r,
                    t = 0,
                    e = 0,
                    i = 0;
                fn = r = fn - 16 | 0, t = 1;

                n: if (!Oa(n + 216 | 0) && (e = r, i = mo(n = n + 544 | 0), b[e + 8 >> 2] = i, e = r, i = to(n), b[e >> 2] = i, t = 0, ba(r + 8 | 0, r))) for (;;) {
                  if (n = Oa(b[b[r + 8 >> 2] >> 2] + 216 | 0)) {
                    t = 1;
                    break n;
                  }

                  if (t |= n, Zo(r + 8 | 0), !ba(r + 8 | 0, r)) break;
                }

                return fn = r + 16 | 0, 1 & t;
              }(n) && (Fn(u = function n(r) {
                var t,
                    e,
                    i,
                    a = 0,
                    o = 0,
                    u = 0;
                if (fn = t = fn - 32 | 0, a = function (n) {
                  var r,
                      t = 0;
                  return r = ie(28), b[r + 24 >> 2] = b[n + 24 >> 2], t = b[n + 20 >> 2], b[r + 16 >> 2] = b[n + 16 >> 2], b[r + 20 >> 2] = t, t = b[n + 12 >> 2], b[r + 8 >> 2] = b[n + 8 >> 2], b[r + 12 >> 2] = t, t = b[n + 4 >> 2], b[r >> 2] = b[n >> 2], b[r + 4 >> 2] = t, fn = n = fn - 16 | 0, fn = n + 16 | 0, b[2360] = b[2360] + 1, r;
                }(b[r + 556 >> 2]), e = Qr(ie(576), r), b[e + 556 >> 2] = a, p[a + 10 | 0] && ue(e), Uo(e, 0), b[t + 16 >> 2] = b[e + 556 >> 2], Jt(a = jo(t + 16 | 0), pa(Lo(r))), b[t + 12 >> 2] = 0, r = Lo(r), o = t, u = mo(r), b[o + 8 >> 2] = u, o = t, u = to(r), b[o >> 2] = u, ba(t + 8 | 0, t)) for (; r = n(b[b[t + 8 >> 2] >> 2]), b[t + 12 >> 2] = r, Uo(r, e), li(a, t + 12 | 0), Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                  ;
                }
                return (0 | (i = e + 544 | 0)) != (0 | (r = a)) && function (n, r, t) {
                  var e,
                      i,
                      a = 0;
                  fn = e = fn - 16 | 0;

                  n: if ((i = t - r >> 2) >>> 0 <= ca(n) >>> 0) {
                    if (b[e + 12 >> 2] = t, i >>> 0 > pa(n) >>> 0) {
                      b[e + 12 >> 2] = r, a = pa(n), b[e + 12 >> 2] = b[e + 12 >> 2] + (a << 2), vo(r, b[e + 12 >> 2], b[n >> 2]), Be(n, b[e + 12 >> 2], t, i - pa(n) | 0);
                      break n;
                    }

                    Ma(n, vo(r, t, b[n >> 2]));
                  } else ne(n), Qt(n, Pr(n, i)), Be(n, r, t, i);

                  fn = e + 16 | 0;
                }(i, b[r >> 2], b[r + 4 >> 2]), ni(a), fn = t + 32 | 0, e;
              }(n)), Fi(u), Oo(), function n(r) {
                var t,
                    e = 0,
                    i = 0;
                if (fn = t = fn - 16 | 0, o[b[r + 556 >> 2] + 11 | 0] = 0, r = Lo(r), e = t, i = mo(r), b[e + 8 >> 2] = i, e = t, i = to(r), b[e >> 2] = i, ba(t + 8 | 0, t)) for (; n(b[b[t + 8 >> 2] >> 2]), Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                  ;
                }
                fn = t + 16 | 0;
              }(u), Zn(i + 40 | 0, 0, 56), pn(u, c, l, e, A, f, r, t, 1, 0, b[u + 556 >> 2], i + 40 | 0, 0, 0, b[2363]) && (jn(u, Qa(Ko(u)), r, t, r), Vn(u, +m[b[u + 556 >> 2] + 16 >> 2], 0, 0), be(n + 288 | 0, 3, 1 ^ function n(r, t) {
                var e,
                    i,
                    a,
                    o = 0;
                fn = i = fn - 320 | 0, a = t + 544 | 0;

                n: if ((0 | pa(e = r + 544 | 0)) == (0 | pa(a)) && !function (n, r) {
                  var t, e;
                  return fn = t = fn - 320 | 0, e = n, n = _n(t, r, 320), r = function (n, r) {
                    var t,
                        e = 0,
                        i = 0,
                        a = 0,
                        o = 0,
                        u = 0,
                        f = 0;
                    fn = t = fn - 48 | 0;

                    r: if (Ht(n, r) && function (n, r) {
                      for (var t = 0, e = 0, i = 0; (e = mt(m[wo(n, t = i) >> 2], m[wo(r, t) >> 2])) && (i = 1, !t);) {
                        ;
                      }

                      return e;
                    }(n + 16 | 0, r + 16 | 0) && Ht(n + 24 | 0, r + 24 | 0) && Ht(n + 40 | 0, r + 40 | 0) && Ht(n + 56 | 0, r + 56 | 0) && (0 | Qa(n)) == (0 | Qa(r)) && !((0 | Xa(n)) != (0 | Xa(r)) | b[n + 88 >> 2] != b[r + 88 >> 2] | b[n + 92 >> 2] != b[r + 92 >> 2]) && (i = b[r + 316 >> 2], b[t + 40 >> 2] = b[r + 312 >> 2], b[t + 44 >> 2] = i, i = b[r + 308 >> 2], b[t + 32 >> 2] = b[r + 304 >> 2], b[t + 36 >> 2] = i, i = b[r + 300 >> 2], b[t + 24 >> 2] = b[r + 296 >> 2], b[t + 28 >> 2] = i, wn(n + 296 | 0, t + 24 | 0) && ct(m[n + 80 >> 2], m[r + 80 >> 2]))) for (i = r + 96 | 0, f = n + 96 | 0;;) {
                      if (u = ao(f, a), e = ao(i, a), o = b[e + 20 >> 2], b[t + 16 >> 2] = b[e + 16 >> 2], b[t + 20 >> 2] = o, o = b[e + 12 >> 2], b[t + 8 >> 2] = b[e + 8 >> 2], b[t + 12 >> 2] = o, o = b[e + 4 >> 2], b[t >> 2] = b[e >> 2], b[t + 4 >> 2] = o, !(e = wn(u, t))) break r;
                      if (u = a >>> 0 < 7, a = a + 1 | 0, !u) break;
                    }

                    r: {
                      t: {
                        if (vu(m[wo(n = n + 288 | 0, 0) >> 2])) {
                          if (i = vu(m[wo(r + 288 | 0, 0) >> 2]), a = i & e, i) break r;
                          if (e) break t;
                          break r;
                        }

                        if (a = 0, !e) break r;
                      }

                      a = m[wo(n, 0) >> 2] == m[wo(r + 288 | 0, 0) >> 2];
                    }

                    r: {
                      t: {
                        if (vu(m[wo(n, 1) >> 2])) {
                          if (i = vu(m[wo(r + 288 | 0, 1) >> 2]), e = i & a, i) break r;
                          if (a) break t;
                          break r;
                        }

                        if (e = 0, !a) break r;
                      }

                      e = m[wo(n, 1) >> 2] == m[wo(r + 288 | 0, 1) >> 2];
                    }

                    return fn = t + 48 | 0, e;
                  }(e, n), fn = n + 320 | 0, 1 ^ r;
                }(r + 216 | 0, _n(i, t + 216 | 0, 320)) && (o = 1, pa(e) && pa(e))) {
                  r = 0;

                  r: {
                    for (;;) {
                      if (t = b[Ta(a, r) >> 2], !n(b[Ta(e, r) >> 2], t)) break r;
                      if (!((r = r + 1 | 0) >>> 0 < pa(e) >>> 0)) break;
                    }

                    break n;
                  }

                  o = 0;
                }

                return fn = i + 320 | 0, o;
              }(u, n))), function n(r) {
                var t,
                    e = 0,
                    i = 0,
                    a = 0;
                if (fn = t = fn - 16 | 0, b[r + 556 >> 2] && (b[2360] = b[2360] + -1, (e = b[r + 556 >> 2]) && dn(e)), r = Lo(r), i = t, a = mo(r), b[i + 8 >> 2] = a, i = t, a = to(r), b[i >> 2] = a, ba(t + 8 | 0, t)) for (; n(b[b[t + 8 >> 2] >> 2]), Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                  ;
                }
                fn = t + 16 | 0;
              }(u), function n(r) {
                var t = 0,
                    e = 0;
                if (Xo(r)) for (; e = ci(r, t), b[e + 540 >> 2] == (0 | r) ? (Sr(r, e), n(e)) : t = t + 1 | 0, Xo(r) >>> 0 > t >>> 0;) {
                  ;
                }
                Er(r);
              }(u)), fn = i + 208 | 0;
            }

            function gn(n, r, t, e) {
              var i,
                  a,
                  o,
                  u = 0,
                  c = 0,
                  l = 0;
              fn = i = fn - 32 | 0, a = u = 2147483647 & e, u = u + -1006698496 | 0, t >>> 0 < 0 && (u = u + 1 | 0), o = c = t, c = u, u = a + -1140785152 | 0, (l = t) >>> 0 < 0 && (u = u + 1 | 0);

              n: if ((0 | u) == (0 | c) & o >>> 0 < l >>> 0 | c >>> 0 < u >>> 0) {
                if (u = e << 4 | t >>> 28, t = t << 4 | r >>> 28, l = r &= 268435455, 134217728 == (0 | r) & n >>> 0 >= 1 | r >>> 0 > 134217728) {
                  u = u + 1073741824 | 0, (n = t + 1 | 0) >>> 0 < 1 && (u = u + 1 | 0), c = n;
                  break n;
                }

                if (c = t, u = u - ((t >>> 0 < 0) + -1073741824 | 0) | 0, n | 134217728 ^ l) break n;
                (n = c + (1 & c) | 0) >>> 0 < c >>> 0 && (u = u + 1 | 0), c = n;
              } else (!l & 2147418112 == (0 | a) ? !(n | r) : 2147418112 == (0 | a) & l >>> 0 < 0 | a >>> 0 < 2147418112) ? (c = 0, u = 2146435072, 1140785151 == (0 | a) & l >>> 0 > 4294967295 | a >>> 0 > 1140785151 || (u = 0, (l = a >>> 16 | 0) >>> 0 < 15249 || (function (n, r, t, e, i, a) {
                var o = 0,
                    u = 0,
                    f = 0,
                    A = 0;
                64 & a ? (e = r, r = 31 & (i = a + -64 | 0), 32 <= (63 & i) >>> 0 ? (i = e << r, e = 0) : (i = (1 << r) - 1 & e >>> 32 - r | t << r, e <<= r), r = 0, t = 0) : a && (o = e, f = a, e = 31 & a, 32 <= (63 & a) >>> 0 ? (u = o << e, A = 0) : (u = (1 << e) - 1 & o >>> 32 - e | i << e, A = o << e), e = t, o = r, i = 31 & (a = 64 - a | 0), 32 <= (63 & a) >>> 0 ? (a = 0, e = e >>> i | 0) : (a = e >>> i | 0, e = ((1 << i) - 1 & e) << 32 - i | o >>> i), e |= A, i = a | u, a = r, r = 31 & f, 32 <= (63 & f) >>> 0 ? (u = a << r, r = 0) : (u = (1 << r) - 1 & a >>> 32 - r | t << r, r = a << r), t = u), b[n >> 2] = r, b[n + 4 >> 2] = t, b[n + 8 >> 2] = e, b[n + 12 >> 2] = i;
              }(i + 16 | 0, n, r, t, u = 65535 & e | 65536, l + -15233 | 0), function (n, r, t, e, i, a) {
                var o = 0,
                    u = 0,
                    f = 0,
                    A = 0;
                64 & a ? (r = 31 & (t = a + -64 | 0), 32 <= (63 & t) >>> 0 ? (t = 0, r = i >>> r | 0) : (t = i >>> r | 0, r = ((1 << r) - 1 & i) << 32 - r | e >>> r), e = 0, i = 0) : a && (u = i, f = e, o = 31 & (A = 64 - a | 0), 32 <= (63 & A) >>> 0 ? (u = f << o, A = 0) : (u = (1 << o) - 1 & f >>> 32 - o | u << o, A = f << o), f = r, r = 31 & (o = a), 32 <= (63 & o) >>> 0 ? (o = 0, r = t >>> r | 0) : (o = t >>> r | 0, r = ((1 << r) - 1 & t) << 32 - r | f >>> r), r |= A, t = o | u, o = e, e = 31 & a, 32 <= (63 & a) >>> 0 ? (u = 0, e = i >>> e | 0) : (u = i >>> e | 0, e = ((1 << e) - 1 & i) << 32 - e | o >>> e), i = u), b[n >> 2] = r, b[n + 4 >> 2] = t, b[n + 8 >> 2] = e, b[n + 12 >> 2] = i;
              }(i, n, r, t, u, 15361 - l | 0), t = b[i + 4 >> 2], n = b[i + 8 >> 2], u = b[i + 12 >> 2] << 4 | n >>> 28, c = n << 4 | t >>> 28, t = n = 268435455 & t, 134217728 == (0 | n) & (r = b[i >> 2] | 0 != (b[i + 16 >> 2] | b[i + 24 >> 2]) | 0 != (b[i + 20 >> 2] | b[i + 28 >> 2])) >>> 0 >= 1 | n >>> 0 > 134217728 ? ((n = c + 1 | 0) >>> 0 < 1 && (u = u + 1 | 0), c = n) : r | 134217728 ^ t || ((n = c + (1 & c) | 0) >>> 0 < c >>> 0 && (u = u + 1 | 0), c = n)))) : (c = t << 4 | r >>> 28, u = 524287 & (u = e << 4 | t >>> 28) | 2146959360);

              return fn = i + 32 | 0, f(0, 0 | c), f(1, -2147483648 & e | u), +A();
            }

            function _n(n, r, t) {
              var e,
                  i = 0,
                  a = 0;
              if (t >>> 0 >= 512) return z(0 | n, 0 | r, 0 | t), n;
              e = n + t | 0;

              n: if (3 & (n ^ r)) {
                if (e >>> 0 < 4) t = n;else if ((i = e + -4 | 0) >>> 0 < n >>> 0) t = n;else for (t = n; o[0 | t] = p[0 | r], o[t + 1 | 0] = p[r + 1 | 0], o[t + 2 | 0] = p[r + 2 | 0], o[t + 3 | 0] = p[r + 3 | 0], r = r + 4 | 0, (t = t + 4 | 0) >>> 0 <= i >>> 0;) {
                  ;
                }
              } else {
                r: if ((0 | t) < 1) t = n;else if (3 & n) for (t = n;;) {
                  if (o[0 | t] = p[0 | r], r = r + 1 | 0, (t = t + 1 | 0) >>> 0 >= e >>> 0) break r;
                  if (!(3 & t)) break;
                } else t = n;

                if (!((i = -4 & e) >>> 0 < 64 || t >>> 0 > (a = i + -64 | 0) >>> 0)) for (; b[t >> 2] = b[r >> 2], b[t + 4 >> 2] = b[r + 4 >> 2], b[t + 8 >> 2] = b[r + 8 >> 2], b[t + 12 >> 2] = b[r + 12 >> 2], b[t + 16 >> 2] = b[r + 16 >> 2], b[t + 20 >> 2] = b[r + 20 >> 2], b[t + 24 >> 2] = b[r + 24 >> 2], b[t + 28 >> 2] = b[r + 28 >> 2], b[t + 32 >> 2] = b[r + 32 >> 2], b[t + 36 >> 2] = b[r + 36 >> 2], b[t + 40 >> 2] = b[r + 40 >> 2], b[t + 44 >> 2] = b[r + 44 >> 2], b[t + 48 >> 2] = b[r + 48 >> 2], b[t + 52 >> 2] = b[r + 52 >> 2], b[t + 56 >> 2] = b[r + 56 >> 2], b[t + 60 >> 2] = b[r + 60 >> 2], r = r - -64 | 0, (t = t - -64 | 0) >>> 0 <= a >>> 0;) {
                  ;
                }
                if (t >>> 0 >= i >>> 0) break n;

                for (; b[t >> 2] = b[r >> 2], r = r + 4 | 0, (t = t + 4 | 0) >>> 0 < i >>> 0;) {
                  ;
                }
              }

              if (t >>> 0 < e >>> 0) for (; o[0 | t] = p[0 | r], r = r + 1 | 0, (0 | e) != (0 | (t = t + 1 | 0));) {
                ;
              }
              return n;
            }

            function Cn(n, r, t, e, i, a, o, u) {
              var f,
                  A,
                  c,
                  l = 0,
                  s = _(0),
                  v = _(0),
                  d = _(0),
                  p = 0,
                  h = _(0);

              fn = f = fn - 32 | 0, b[n >> 2] = 0, b[n + 4 >> 2] = 0, b[n + 16 >> 2] = 0, b[n + 8 >> 2] = 0, b[n + 12 >> 2] = 0, A = jo(n + 20 | 0), b[n + 40 >> 2] = 0, b[n + 32 >> 2] = 0, b[n + 36 >> 2] = 0, Jt(A, pa(Lo(b[r >> 2]))), $i(f + 24 | 0, au(b[r >> 2])), t = pe(Li(f + 24 | 0), kt(b[r >> 2], t)), Hi(f + 24 | 0, au(b[r >> 2])), c = qi(f + 24 | 0);

              n: if (!(pa(Lo(b[r >> 2])) >>> 0 <= o >>> 0)) for (;;) {
                if (l = Qe(b[r >> 2], o), b[f + 20 >> 2] = l, Yi(f + 24 | 0, au(l)), 1 != (0 | na(f + 24 | 0)) && (Ui(f + 8 | 0, au(b[f + 20 >> 2])), 1 != (0 | na(f + 8 | 0)))) {
                  if (b[b[f + 20 >> 2] + 536 >> 2] = u, p = f, h = ea(b[f + 20 >> 2], t, i), m[p + 24 >> 2] = h, s = m[f + 24 >> 2], p = f, h = Rn(l = b[f + 20 >> 2], t, m[Ko(l) + 80 >> 2], e), m[p + 24 >> 2] = h, l = b[n >> 2], v = m[f + 24 >> 2], _(s + _(d + v)) > a && !(!l | !c)) break n;
                  b[n >> 2] = l + 1, s = _(s + v), m[n + 4 >> 2] = s + m[n + 4 >> 2], pt(b[f + 20 >> 2]) && (p = n, h = _(dr(b[f + 20 >> 2]) + m[n + 8 >> 2]), m[p + 8 >> 2] = h, v = Ln(b[f + 20 >> 2]), l = Ko(b[f + 20 >> 2]), m[n + 12 >> 2] = m[n + 12 >> 2] - _(v * m[l + 80 >> 2])), d = _(d + s), li(A, f + 20 | 0);
                }

                if (!((o = o + 1 | 0) >>> 0 < pa(Lo(b[r >> 2])) >>> 0)) break;
              }

              (e = m[n + 8 >> 2]) > _(0) ^ 1 | e < _(1) ^ 1 || (b[n + 8 >> 2] = 1065353216), (e = m[n + 12 >> 2]) > _(0) ^ 1 | e < _(1) ^ 1 || (b[n + 12 >> 2] = 1065353216), b[n + 16 >> 2] = o, fn = f + 32 | 0;
            }

            function En(n, r, t, e, i) {
              var a,
                  o = _(0),
                  u = 0,
                  f = _(0),
                  A = _(0),
                  c = _(0),
                  l = _(0),
                  s = 0,
                  v = 0,
                  d = _(0);

              if (fn = a = fn - 32 | 0, s = a, v = mo(u = n + 20 | 0), b[s + 24 >> 2] = v, s = a, v = to(u), b[s + 16 >> 2] = v, ba(a + 24 | 0, a + 16 | 0)) for (;;) {
                s = a, d = Rn(u = b[b[a + 24 >> 2] >> 2], r, m[Ko(u) + 80 >> 2], t), m[s + 8 >> 2] = d, A = m[a + 8 >> 2];

                n: if ((o = m[n + 32 >> 2]) < _(0)) {
                  if (vu(o = _(A * _(-Ln(u)))) | o == _(0)) break n;
                  if (o = yt(u, r, f = _(A + _(o * _(m[n + 32 >> 2] / m[n + 12 >> 2]))), e, i), vu(f)) break n;
                  if (vu(o) | f == o) break n;
                  f = Ln(u), c = m[Ko(u) + 80 >> 2], m[n + 12 >> 2] = m[n + 12 >> 2] + _(f * c), l = _(l + _(o - A));
                } else vu(o) | m[n + 32 >> 2] > _(0) ^ 1 || vu(o = dr(u)) | o == _(0) || (f = yt(u, r, c = _(A + _(o * _(m[n + 32 >> 2] / m[n + 8 >> 2]))), e, i), vu(c) || vu(f) | c == f || (m[n + 8 >> 2] = m[n + 8 >> 2] - o, l = _(l + _(f - A))));

                if (Zo(a + 24 | 0), !ba(a + 24 | 0, a + 16 | 0)) break;
              }
              m[n + 32 >> 2] = m[n + 32 >> 2] - l, fn = a + 32 | 0;
            }

            function wn(n, r) {
              var t = 0,
                  e = _(0),
                  i = 0,
                  a = 0,
                  o = 0;

              n: {
                r: {
                  t: {
                    if (b[n + 8 >> 2] != b[r + 8 >> 2]) {
                      if (!vu(m[n >> 2])) break n;
                    } else {
                      if (a = b[r + 12 >> 2], t = b[n + 12 >> 2], !vu(m[n >> 2])) break t;
                      t = (0 | t) == (0 | a);
                    }

                    if (i = (a = vu(e = m[r >> 2])) & t, a) break n;
                    if (t) break r;
                    break n;
                  }

                  if ((0 | t) != (0 | a)) break n;
                  e = m[r >> 2];
                }

                i = m[n >> 2] == e;
              }

              n: {
                r: {
                  t: {
                    e: {
                      i: {
                        a: {
                          if (vu(m[n + 4 >> 2])) {
                            if (t = (a = vu(e = m[r + 4 >> 2])) & i, a) break i;
                            if (i) break a;
                            break i;
                          }

                          if (!i) break e;
                          e = m[r + 4 >> 2];
                        }

                        t = m[n + 4 >> 2] == e;
                      }

                      if (i = a = n + 16 | 0, vu(m[n + 16 >> 2])) break t;
                      if (i = 0, !t) break n;
                      e = m[r + 16 >> 2];
                      break r;
                    }

                    if (t = 0, !vu(m[n + 16 >> 2])) {
                      i = 0;
                      break n;
                    }

                    i = n + 16 | 0;
                  }

                  if (a = i, i = (o = vu(e = m[r + 16 >> 2])) & t, !t | o) break n;
                }

                i = m[a >> 2] == e;
              }

              n: {
                r: {
                  if (vu(m[n + 20 >> 2])) {
                    if (t = (r = vu(e = m[r + 20 >> 2])) & i, r) break n;
                    if (i) break r;
                    break n;
                  }

                  if (t = 0, !i) break n;
                  e = m[r + 20 >> 2];
                }

                t = m[n + 20 >> 2] == e;
              }

              return t;
            }

            function Nn(n, r, t) {
              var e = 0,
                  i = 0;

              n: if ((0 | n) != (0 | r)) {
                if (!(r + t >>> 0 > n >>> 0 && (i = n + t | 0) >>> 0 > r >>> 0)) return void _n(n, r, t);

                if (e = 3 & (n ^ r), n >>> 0 < r >>> 0) {
                  if (!e) {
                    if (3 & n) for (;;) {
                      if (!t) break n;
                      if (o[0 | n] = p[0 | r], r = r + 1 | 0, t = t + -1 | 0, !(3 & (n = n + 1 | 0))) break;
                    }
                    if (!(t >>> 0 <= 3)) for (; b[n >> 2] = b[r >> 2], r = r + 4 | 0, n = n + 4 | 0, (t = t + -4 | 0) >>> 0 > 3;) {
                      ;
                    }
                  }

                  if (t) for (; o[0 | n] = p[0 | r], n = n + 1 | 0, r = r + 1 | 0, t = t + -1 | 0;) {
                    ;
                  }
                } else {
                  if (!e) {
                    if (3 & i) for (;;) {
                      if (!t) break n;
                      if (o[0 | (e = (t = t + -1 | 0) + n | 0)] = p[r + t | 0], !(3 & e)) break;
                    }
                    if (!(t >>> 0 <= 3)) for (; b[(t = t + -4 | 0) + n >> 2] = b[r + t >> 2], t >>> 0 > 3;) {
                      ;
                    }
                  }

                  if (!t) break n;

                  for (; o[(t = t + -1 | 0) + n | 0] = p[r + t | 0], t;) {
                    ;
                  }
                }
              }
            }

            function Wn(n, r, t, e, i, a, o, u, f, A) {
              var c,
                  l = _(0),
                  s = _(0),
                  v = _(0),
                  d = _(0),
                  p = _(0),
                  h = _(0),
                  y = 0,
                  k = _(0);

              fn = c = fn - 48 | 0, Ge(n, bo(n), 2200), p = re(n, 2, a), h = re(n, 0, a), y = c, k = ea(n, 2, a), m[y + 8 >> 2] = k, l = m[c + 8 >> 2], y = c, k = ea(n, 0, a), m[y + 8 >> 2] = k, s = m[c + 8 >> 2], v = r = e ? r : _(Z), vu(r) || (v = Fe(_(0), _(_(r - l) - p))), d = t = i ? t : _(Z), vu(t) || (d = Fe(_(0), _(_(t - s) - h))), 1 != (0 | e) | 1 != (0 | i) ? (de(c + 40 | 0, n, v, e, d, i, f), b[u + 20 >> 2] = b[u + 20 >> 2] + 1, u = wo(u + 24 | 0, A), b[u >> 2] = b[u >> 2] + 1, b[c + 24 >> 2] = i, m[c + 20 >> 2] = d, b[c + 16 >> 2] = e, m[c + 12 >> 2] = v, b[c + 8 >> 2] = f, b[c + 36 >> 2] = A, u = b[c + 44 >> 2], b[c + 28 >> 2] = b[c + 40 >> 2], b[c + 32 >> 2] = u, hi(n, yt(n, 2, _(-3 & e ? r - l : p + m[c + 40 >> 2]), a, a), 0), hi(n, yt(n, 0, _(-3 & i ? t - s : h + m[c + 44 >> 2]), o, a), 1)) : (hi(n, yt(n, 2, _(r - l), a, a), 0), hi(n, yt(n, 0, _(t - s), o, a), 1)), fn = c + 48 | 0;
            }

            function Zn(n, r, t) {
              var e = 0,
                  i = 0,
                  a = 0,
                  u = 0;
              if (t && (o[(e = n + t | 0) - 1 | 0] = r, o[0 | n] = r, !(t >>> 0 < 3 || (o[e + -2 | 0] = r, o[n + 1 | 0] = r, o[e + -3 | 0] = r, o[n + 2 | 0] = r, t >>> 0 < 7 || (o[e + -4 | 0] = r, o[n + 3 | 0] = r, t >>> 0 < 9 || (i = (e = 0 - n & 3) + n | 0, r = g(255 & r, 16843009), b[i >> 2] = r, b[(e = (t = t - e & -4) + i | 0) - 4 >> 2] = r, t >>> 0 < 9 || (b[i + 8 >> 2] = r, b[i + 4 >> 2] = r, b[e + -8 >> 2] = r, b[e + -12 >> 2] = r, t >>> 0 < 25 || (b[i + 24 >> 2] = r, b[i + 20 >> 2] = r, b[i + 16 >> 2] = r, b[i + 12 >> 2] = r, b[e + -16 >> 2] = r, b[e + -20 >> 2] = r, b[e + -24 >> 2] = r, b[e + -28 >> 2] = r, (t = t - (u = 4 & i | 24) | 0) >>> 0 < 32)))))))) for (e = r, a = r, r = i + u | 0; b[r + 24 >> 2] = a, b[r + 28 >> 2] = e, b[r + 16 >> 2] = a, b[r + 20 >> 2] = e, b[r + 8 >> 2] = a, b[r + 12 >> 2] = e, b[r >> 2] = a, b[r + 4 >> 2] = e, r = r + 32 | 0, (t = t + -32 | 0) >>> 0 > 31;) {
                ;
              }
              return n;
            }

            function Tn(n) {
              var r = 0,
                  t = 0,
                  e = 0,
                  i = 0,
                  a = 0;
              if (s(n), 255 == (0 | (t = (a = u(0)) >>> 23 & 255))) return _(n / n);

              if ((r = a << 1) >>> 0 > 2130706432) {
                if (t) r = 8388607 & a | 8388608;else {
                  if (t = 0, (0 | (r = a << 9)) >= 0) for (; t = t + -1 | 0, (0 | (r <<= 1)) > -1;) {
                    ;
                  }
                  r = a << 1 - t;
                }

                if (e = (0 | (i = r - 8388608 | 0)) > -1, (0 | t) > 127) {
                  for (;;) {
                    if (1 & e && !(r = i)) return _(n * _(0));
                    if (e = (0 | (i = (r <<= 1) - 8388608 | 0)) > -1, !((0 | (t = t + -1 | 0)) > 127)) break;
                  }

                  t = 127;
                }

                if (e && !(r = i)) return _(n * _(0));
                if (r >>> 0 > 8388607) e = r;else for (; t = t + -1 | 0, i = r >>> 0 < 4194304, r = e = r << 1, i;) {
                  ;
                }
                return f(0, -2147483648 & a | ((0 | t) >= 1 ? e + -8388608 | t << 23 : e >>> 1 - t | 0)), v();
              }

              return 2130706432 == (0 | r) ? _(n * _(0)) : n;
            }

            function In(n, r, t) {
              n: {
                if (!(r >>> 0 > 20 || (r = r + -9 | 0) >>> 0 > 9)) {
                  r: switch (r - 1 | 0) {
                    default:
                      return r = b[t >> 2], b[t >> 2] = r + 4, void (b[n >> 2] = b[r >> 2]);

                    case 0:
                      return r = b[t >> 2], b[t >> 2] = r + 4, r = b[r >> 2], b[n >> 2] = r, void (b[n + 4 >> 2] = r >> 31);

                    case 1:
                      return r = b[t >> 2], b[t >> 2] = r + 4, b[n >> 2] = b[r >> 2], void (b[n + 4 >> 2] = 0);

                    case 3:
                      return r = b[t >> 2], b[t >> 2] = r + 4, r = d[r >> 1], b[n >> 2] = r, void (b[n + 4 >> 2] = r >> 31);

                    case 4:
                      return r = b[t >> 2], b[t >> 2] = r + 4, b[n >> 2] = h[r >> 1], void (b[n + 4 >> 2] = 0);

                    case 5:
                      return r = b[t >> 2], b[t >> 2] = r + 4, r = o[0 | r], b[n >> 2] = r, void (b[n + 4 >> 2] = r >> 31);

                    case 6:
                      return r = b[t >> 2], b[t >> 2] = r + 4, b[n >> 2] = p[0 | r], void (b[n + 4 >> 2] = 0);

                    case 2:
                    case 7:
                      break n;

                    case 8:
                  }

                  a[200](n, t);
                }

                return;
              }

              r = b[t >> 2] + 7 & -8, b[t >> 2] = r + 8, t = b[r + 4 >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = t;
            }

            function Rn(n, r, t, e) {
              var i,
                  a,
                  o,
                  u,
                  f = 0,
                  A = _(0);

              fn = i = fn - 80 | 0, a = _o(i + 72 | 0), u = o = _o(i - -64 | 0);

              n: {
                if (So(r)) r = b[Qo(zo(au(n)), 1) >> 2], b[i + 4 >> 2] = r, b[i + 56 >> 2] = r, f = a, A = Kt(i + 4 | 0, e), m[f >> 2] = A, n = b[Qo(Jo(au(n)), 1) >> 2], b[i >> 2] = n, b[i + 48 >> 2] = n, e = Kt(i, e);else {
                  if (!Yo(r)) {
                    e = m[o >> 2];
                    break n;
                  }

                  r = b[Qo(zo(au(n)), 0) >> 2], b[i + 12 >> 2] = r, b[i + 40 >> 2] = r, f = a, A = Kt(i + 12 | 0, e), m[f >> 2] = A, n = b[Qo(Jo(au(n)), 0) >> 2], b[i + 8 >> 2] = n, b[i + 32 >> 2] = n, e = Kt(i + 8 | 0, e);
                }
                m[u >> 2] = e;
              }

              return bi(e, m[lo(i + 24 | 0, _(0)) >> 2]) && We(t, m[o >> 2]) ? t = m[o >> 2] : bi(m[a >> 2], m[lo(i + 16 | 0, _(0)) >> 2]) && (n = function (n, r) {
                var t;
                return fn = t = fn - 16 | 0, m[t >> 2] = r, m[t + 8 >> 2] = n, fn = t + 16 | 0, m[t + 8 >> 2] < m[t >> 2];
              }(t, m[a >> 2]), t = n ? m[a >> 2] : t), fn = i + 80 | 0, t;
            }

            function Bn(n, r, t, e, i, a, o, u, f, A, c, l, s) {
              var v = 0,
                  d = _(0),
                  b = _(0),
                  p = 0,
                  h = _(0),
                  y = _(0),
                  k = _(0),
                  g = 0;

              return !vu(A) && A < _(0) || !vu(f) && f < _(0) || (h = a, y = r, k = e, d = u, s && (d = u, (b = m[s + 16 >> 2]) != _(0) && (y = ur(+r, +b, 0, 0), k = ur(+e, +m[s + 16 >> 2], 0, 0), h = ur(+a, +m[s + 16 >> 2], 0, 0), d = ur(+u, +m[s + 16 >> 2], 0, 0))), b = d, s = 0, (0 | n) == (0 | i) && (s = mt(h, y)), (0 | t) == (0 | o) && (g = mt(b, k)), p = 1, v = 1, s || (v = 1, Ni(n, r = _(r - c), f) || (v = 1, we(n, r, i, f) || (v = ft(n, r, i, a, f)))), n = v, g || Ni(t, r = _(e - l), A) || we(t, r, o, A) || (p = ft(t, r, o, u, A)), p &= n), p;
            }

            function Vn(n, r, t, e) {
              var i = 0,
                  a = _(0),
                  o = 0,
                  u = 0,
                  f = 0,
                  A = 0,
                  c = 0,
                  l = 0,
                  s = 0,
                  v = _(0),
                  d = _(0),
                  b = _(0);

              if (0 != r && (a = m[wo(Ko(n), 0) >> 2], v = m[wo(Ko(n), 1) >> 2], d = m[wo(Ko(n) + 16 | 0, 0) >> 2], b = m[wo(Ko(n) + 16 | 0, 1) >> 2], yi(n, ur(f = +a, r, 0, o = 1 == (0 | (i = ya(p[n + 4 | 0], 3)))), 0), yi(n, ur(A = +v, r, 0, o), 1), o = 0, mt(a = Tn(_((c = +d) * r)), _(0)) || (o = 1 ^ mt(a, _(1))), mt(a = Tn(_((l = +b) * r)), _(0)) || (s = 1 ^ mt(a, _(1))), mi(n, _(ur((t = f + t) + c, r, (i = 1 == (0 | i)) & o, i & (1 ^ o)) - ur(t, r, 0, i)), 0), mi(n, _(ur((e = A + e) + l, r, i & s, i & (1 ^ s)) - ur(e, r, 0, i)), 1), i = Xo(n))) for (; Vn(ci(n, u), r, t, e), (0 | i) != (0 | (u = u + 1 | 0));) {
                ;
              }
            }

            function Gn(n, r) {
              var t,
                  e = 0,
                  i = 0,
                  a = 0,
                  o = 0,
                  u = 0,
                  f = 0,
                  A = 0;
              fn = t = fn - 48 | 0, b[n + 8 >> 2] == b[eu(n) >> 2] && (o = n + 8 | 0, u = n + 4 | 0, (e = b[n + 4 >> 2]) >>> 0 > (i = b[n >> 2]) >>> 0 ? (a = e, e = (1 + (e - i >> 2) | 0) / -2 << 2, f = o, A = vo(a, b[o >> 2], a + e | 0), b[f >> 2] = A, b[u >> 2] = e + b[u >> 2]) : (f = t, A = b[eu(n) >> 2] - b[n >> 2] >> 1, b[f + 24 >> 2] = A, b[t + 44 >> 2] = 1, e = Fr(t + 24 | 0, e = b[Bo(t + 24 | 0, t + 44 | 0) >> 2], e >>> 2 | 0, b[n + 16 >> 2]), i = no(t + 16 | 0, b[n + 4 >> 2]), a = no(t + 8 | 0, b[n + 8 >> 2]), function (n, r, t) {
                var e;
                if (fn = e = fn - 32 | 0, b[e + 24 >> 2] = r, r = function (n, r, t) {
                  var e;
                  return b[n >> 2] = b[r >> 2], e = b[r >> 2], b[n + 8 >> 2] = r, b[n + 4 >> 2] = (t << 2) + e, n;
                }(e + 8 | 0, n + 8 | 0, function (n, r) {
                  var t;
                  return fn = t = fn - 16 | 0, b[t >> 2] = r, b[t + 8 >> 2] = n, n = ha(t, t + 8 | 0), fn = t + 16 | 0, n;
                }(r, t)), b[r >> 2] != b[r + 4 >> 2]) for (; ho(b[n + 16 >> 2], b[r >> 2], b[e + 24 >> 2]), b[r >> 2] = b[r >> 2] + 4, Zo(e + 24 | 0), b[r >> 2] != b[r + 4 >> 2];) {
                  ;
                }
                b[b[r + 8 >> 2] >> 2] = b[r >> 2], fn = e + 32 | 0;
              }(e, b[i >> 2], b[a >> 2]), ye(n, e), ye(u, e + 4 | 0), ye(o, e + 8 | 0), ye(eu(n), eu(e)), Je(e))), ho(b[n + 16 >> 2], b[n + 8 >> 2], r), b[n + 8 >> 2] = b[n + 8 >> 2] + 4, fn = t + 48 | 0;
            }

            function Fn(n) {
              var r,
                  t,
                  e,
                  i = 0,
                  a = 0,
                  o = 0,
                  u = 0,
                  f = 0;
              if (fn = r = fn - 48 | 0, t = au(n), b[r + 44 >> 2] = 2, b[r + 32 >> 2] = 0, b[r + 36 >> 2] = 1, b[r + 40 >> 2] = r + 32, (0 | (i = b[r + 40 >> 2])) != (0 | (e = b[r + 40 >> 2] + (b[r + 44 >> 2] << 2) | 0))) for (o = n + 560 | 0; n = b[i >> 2], Mt(Qo(Jo(t), n)) || (u = r, f = b[Qo(Jo(t), n) >> 2], b[u + 24 >> 2] = f, a = b[Qo(zo(t), n) >> 2], b[r + 16 >> 2] = a, b[r + 4 >> 2] = b[r + 24 >> 2], b[r >> 2] = a, !Ie(r + 4 | 0, r)) ? rr(r + 8 | 0, Qo(Mo(t), n)) : rr(r + 8 | 0, Qo(Jo(t), n)), n = ko(o, n), a = b[r + 12 >> 2], b[n >> 2] = b[r + 8 >> 2], b[n + 4 >> 2] = a, (0 | e) != (0 | (i = i + 4 | 0));) {
                ;
              }
              fn = r + 48 | 0;
            }

            function Xn(n, r) {
              var t,
                  e,
                  i,
                  o = 0;
              return fn = t = fn + -64 | 0, o = b[n >> 2], e = b[o + -4 >> 2], i = b[o + -8 >> 2], b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 8068, b[t + 12 >> 2] = n, b[t + 8 >> 2] = r, o = 0, Zn(t + 24 | 0, 0, 39), n = n + i | 0, ke(e, r, 0) ? (b[t + 56 >> 2] = 1, a[b[b[e >> 2] + 20 >> 2]](e, t + 8 | 0, n, n, 1, 0), o = 1 == b[t + 32 >> 2] ? n : 0) : (a[b[b[e >> 2] + 24 >> 2]](e, t + 8 | 0, n, 1, 0), (n = b[t + 44 >> 2]) >>> 0 > 1 || (n - 1 ? o = 1 == b[t + 48 >> 2] && 1 == b[t + 36 >> 2] && 1 == b[t + 40 >> 2] ? b[t + 28 >> 2] : 0 : 1 != b[t + 32 >> 2] && b[t + 48 >> 2] | 1 != b[t + 36 >> 2] | 1 != b[t + 40 >> 2] || (o = b[t + 24 >> 2]))), fn = t - -64 | 0, o;
            }

            function On(n, r, t, e, i) {
              var a,
                  o = 0,
                  u = _(0),
                  f = _(0),
                  A = 0,
                  c = _(0);

              return fn = a = fn - 48 | 0, o = Yo(r), r = Yo(r), A = a, c = ea(n, o = o ? 2 : 0, i), m[A + 40 >> 2] = c, u = _(t - m[a + 40 >> 2]), t = re(n, o, i), vu(i = _(u - t)) || (r ^= 1, o = b[Qo(zo(au(n)), r) >> 2], b[a + 12 >> 2] = o, b[a + 32 >> 2] = o, A = a, c = Kt(a + 12 | 0, e), m[A + 40 >> 2] = c, Eo(a + 40 | 0) || (f = _(m[a + 40 >> 2] - t)), n = b[Qo(Jo(au(n)), r) >> 2], b[a + 8 >> 2] = n, b[a + 16 >> 2] = n, A = a, c = Kt(a + 8 | 0, e), m[A + 24 >> 2] = c, i = Fe(Xe(i, t = Eo(a + 24 | 0) ? _(34028234663852886e22) : _(m[a + 24 >> 2] - t)), f)), fn = a + 48 | 0, i;
            }

            function Qn(n, r, t) {
              var e,
                  i,
                  a = 0;
              fn = e = fn - 48 | 0, ti(e + 40 | 0, n, b[wo(1848, r) >> 2]), i = vu(m[e + 40 >> 2]), ti(e + 40 | 0, n, b[wo(1848, r) >> 2]);

              n: if (3 != b[e + 44 >> 2] && (ti(e + 32 | 0, n, b[wo(1848, r) >> 2]), b[e + 36 >> 2] && (ti(e + 24 | 0, n, b[wo(1848, r) >> 2]), a = 1, 1 != b[e + 28 >> 2] | i || (ti(e + 16 | 0, n, b[wo(1848, r) >> 2]), !(m[e + 16 >> 2] < _(0)))))) {
                if (ti(e + 8 | 0, n, b[wo(1848, r) >> 2]), 2 != b[e + 12 >> 2] | i) break n;
                if (ti(e, n, b[wo(1848, r) >> 2]), a = 0, m[e >> 2] < _(0)) break n;
                a = 1 ^ vu(t);
              } else a = 0;

              return fn = e + 48 | 0, a;
            }

            function Un(n, r) {
              var t,
                  e = 0,
                  i = 0,
                  o = _(0),
                  u = 0,
                  f = 0;

              fn = t = fn - 32 | 0;

              n: if (b[n + 12 >> 2]) Ge(n, 1 ^ vu(o = function (n, r, t, e) {
                return Vo(p[n + 4 | 0], 5) ? _(a[b[n + 12 >> 2]](n, r, t, e)) : _(a[b[n + 12 >> 2]](n, r, t));
              }(n, m[wo(Ko(n) + 288 | 0, 0) >> 2], m[wo(Ko(n) + 288 | 0, 1) >> 2], r)), 2246);else {
                r: {
                  if (f = Xo(n)) {
                    t: {
                      for (;;) {
                        if (e = ci(n, u), b[e + 536 >> 2]) break t;
                        Ui(t + 8 | 0, au(e));

                        e: {
                          if (1 != (0 | na(t + 8 | 0))) {
                            if (5 == (0 | Pt(n, e))) break e;
                            if (ja(e)) break e;
                            i = i || e;
                          }

                          if ((0 | f) != (0 | (u = u + 1 | 0))) continue;
                          break t;
                        }

                        break;
                      }

                      i = e;
                    }

                    if (i) break r;
                  }

                  o = m[wo(Ko(n) + 288 | 0, 1) >> 2];
                  break n;
                }

                o = _(Un(i, r) + m[wo(Ko(i), 1) >> 2]);
              }

              return fn = t + 32 | 0, o;
            }

            function Yn(n, r) {
              var t,
                  e = 0,
                  i = 0;
              fn = t = fn - 32 | 0, Ka(t + 16 | 0, e = r + 24 | 0), rr(t + 24 | 0, t + 16 | 0);

              n: {
                r: {
                  t: if (!((i = b[t + 28 >> 2]) >>> 0 > 3)) switch (i - 1 | 0) {
                    case 0:
                    case 1:
                      break t;

                    default:
                      break r;
                  }

                  r = b[t + 28 >> 2], b[n >> 2] = b[t + 24 >> 2], b[n + 4 >> 2] = r;
                  break n;
                }

                m[t + 16 >> 2] = m[e + 4 >> 2], !Eo(t + 16 | 0) && (m[t + 8 >> 2] = m[e + 4 >> 2], m[t + 8 >> 2] > _(0)) ? (r = Vo(p[r + 4 | 0], 7) ? 1288 : 1272, e = b[r + 4 >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = e) : (r = b[323], b[n >> 2] = b[322], b[n + 4 >> 2] = r);
              }

              fn = t + 32 | 0;
            }

            function Pn(n, r, t) {
              var e,
                  i,
                  a = 0;
              fn = e = fn + -64 | 0, i = e;

              n: {
                if (!Yo(r) || (a = ou(n + 24 | 0), _u(e + 40 | 0), b[e + 12 >> 2] = b[e + 40 >> 2], qn(e + 48 | 0, a, 4, e + 12 | 0), Mt(e + 48 | 0))) {
                  if (a = ou(n + 24 | 0), n = b[wo(1596, r) >> 2], _u(e + 24 | 0), b[e + 4 >> 2] = b[e + 24 >> 2], qn(e + 48 | 0, a, n, e + 4 | 0), Mt(e + 48 | 0)) {
                    t = m[lo(e + 56 | 0, _(0)) >> 2];
                    break n;
                  }

                  n = b[e + 48 >> 2], b[e + 16 >> 2] = n, b[e >> 2] = n, t = Kt(e, t);
                } else n = b[e + 48 >> 2], b[e + 32 >> 2] = n, b[e + 8 >> 2] = n, t = Kt(e + 8 | 0, t);

                m[i + 56 >> 2] = t;
              }

              return fn = e - -64 | 0, t;
            }

            function Dn(n, r, t) {
              var e,
                  i,
                  a = 0;
              fn = e = fn + -64 | 0, i = e;

              n: {
                if (!Yo(r) || (a = ou(n + 24 | 0), _u(e + 40 | 0), b[e + 12 >> 2] = b[e + 40 >> 2], qn(e + 48 | 0, a, 5, e + 12 | 0), Mt(e + 48 | 0))) {
                  if (a = ou(n + 24 | 0), n = b[wo(1612, r) >> 2], _u(e + 24 | 0), b[e + 4 >> 2] = b[e + 24 >> 2], qn(e + 48 | 0, a, n, e + 4 | 0), Mt(e + 48 | 0)) {
                    t = m[lo(e + 56 | 0, _(0)) >> 2];
                    break n;
                  }

                  n = b[e + 48 >> 2], b[e + 16 >> 2] = n, b[e >> 2] = n, t = Kt(e, t);
                } else n = b[e + 48 >> 2], b[e + 32 >> 2] = n, b[e + 8 >> 2] = n, t = Kt(e + 8 | 0, t);

                m[i + 56 >> 2] = t;
              }

              return fn = e - -64 | 0, t;
            }

            function Sn(n, r, t, e, i, a) {
              var o,
                  u,
                  f = 0,
                  A = _(0),
                  c = 0;

              fn = o = fn - 32 | 0, u = b[Qo(Jo(au(n)), b[wo(1848, r) >> 2]) >> 2], b[o + 12 >> 2] = u, b[o + 16 >> 2] = u, f = o, A = xt(Kt(o + 12 | 0, t), ea(n, r, e)), m[f + 24 >> 2] = A;

              n: if (!((n = b[i >> 2]) >>> 0 > 2)) {
                r: switch (n - 1 | 0) {
                  case 0:
                  case 1:
                    n = a, f = !Eo(o + 24 | 0), c = 0, t = (m[a >> 2] < m[o + 24 >> 2] ^ 1 ? f : c) ? m[o + 24 >> 2] : m[a >> 2], m[n >> 2] = t;
                    break n;
                }

                Eo(o + 24 | 0) || (b[i >> 2] = 2, m[a >> 2] = m[o + 24 >> 2]);
              }

              fn = o + 32 | 0;
            }

            function Hn(n, r) {
              var t = 0;
              t = 0 != (0 | r);

              n: {
                r: {
                  t: {
                    e: if (!(!r | !(3 & n))) for (;;) {
                      if (!p[0 | n]) break t;
                      if (n = n + 1 | 0, t = 0 != (0 | (r = r + -1 | 0)), !r) break e;
                      if (!(3 & n)) break;
                    }

                    if (!t) break r;
                  }

                  if (!p[0 | n]) break n;

                  t: {
                    if (r >>> 0 >= 4) for (;;) {
                      if ((-1 ^ (t = b[n >> 2])) & t + -16843009 & -2139062144) break t;
                      if (n = n + 4 | 0, !((r = r + -4 | 0) >>> 0 > 3)) break;
                    }
                    if (!r) break r;
                  }

                  for (;;) {
                    if (!p[0 | n]) break n;
                    if (n = n + 1 | 0, !(r = r + -1 | 0)) break;
                  }
                }

                return 0;
              }

              return n;
            }

            function jn(n, r, t, e, i) {
              var a,
                  o = 0,
                  u = 0,
                  f = _(0);

              fn = a = fn - 16 | 0, o = b[n + 540 >> 2], $i(a + 8 | 0, n + 24 | 0), o = o ? r : 1, o = Oi(r = pe(Li(a + 8 | 0), o), o), t = Cr(n, r, t), e = Cr(n, o, e), u = a, f = xt(Ar(n, r, i), t), m[u + 8 >> 2] = f, yi(n, m[a + 8 >> 2], b[wo(1596, r) >> 2]), u = a, f = xt(cr(n, r, i), t), m[u + 8 >> 2] = f, yi(n, m[a + 8 >> 2], b[wo(1612, r) >> 2]), u = a, f = xt(Ar(n, o, i), e), m[u + 8 >> 2] = f, yi(n, m[a + 8 >> 2], b[wo(1596, o) >> 2]), u = a, f = xt(cr(n, o, i), e), m[u + 8 >> 2] = f, yi(n, m[a + 8 >> 2], b[wo(1612, o) >> 2]), fn = a + 16 | 0;
            }

            function Mn(n, r, t) {
              var e,
                  i,
                  a,
                  o = _(0);

              return fn = e = fn + -64 | 0, i = b[Qo(tu(n = n + 24 | 0), 4) >> 2], b[e + 20 >> 2] = i, b[e + 48 >> 2] = i, a = e, o = Kt(e + 20 | 0, t), m[a + 56 >> 2] = o, !Yo(r) || Mt(Qo(tu(n), 4)) || Eo(e + 56 | 0) | m[e + 56 >> 2] >= _(0) ^ 1 ? (n = tu(n), r = b[wo(1596, r) >> 2], le(e + 32 | 0), b[e + 16 >> 2] = b[e + 32 >> 2], qn(e + 40 | 0, n, r, e + 16 | 0), b[e + 12 >> 2] = b[e + 40 >> 2], t = At(Kt(e + 12 | 0, t), m[lo(e + 24 | 0, _(0)) >> 2])) : t = m[e + 56 >> 2], fn = e - -64 | 0, t;
            }

            function xn(n, r) {
              var t,
                  e = 0,
                  i = _(0),
                  a = 0,
                  o = 0,
                  A = 0;

              fn = t = fn - 32 | 0, r < _(10842021724855044e-35) ^ 1 | r > _(-10842021724855044e-35) ^ 1 && r != _(0) ? (f(0, -2147483648 & (s(r), u(0)) | 1602224127), i = v(), a = lo(t + 16 | 0, r > _(0xffffff0000000000) || r < _(-0xffffff0000000000) ? i : r), e = b[a >> 2] + -536870912 | 1073741824, b[a >> 2] = e, b[t + 4 >> 2] = e, b[t + 8 >> 2] = e, No(n, t + 4 | 0)) : (o = t, A = b[no(t + 24 | 0, 2139156720) >> 2], b[o >> 2] = A, No(n, t)), fn = t + 32 | 0;
            }

            function Jn(n) {
              var r;
              fn = r = fn - 16 | 0, b[n >> 2] = 0, b[n + 4 >> 2] = 0, _o(n + 4 | 0), b[n + 8 >> 2] = 0, _o(n + 8 | 0), b[n + 12 >> 2] = 0, _o(n + 12 | 0), se(n + 16 | 0), Oe(Zn(n + 20 | 0, 0, 36)), Oe(Zn(n + 56 | 0, 0, 36)), Oe(Zn(n + 92 | 0, 0, 36)), Oe(Zn(n + 128 | 0, 0, 36)), se(r), rr(r + 8 | 0, r), function (n, r) {
                var t;
                fn = t = fn - 16 | 0, function (n, r) {
                  var t = 0;

                  for (t = 2; b[n >> 2] = b[r >> 2], n = n + 4 | 0, t = t + -1 | 0;) {
                    ;
                  }
                }(Ee(n), function (n, r) {
                  var t, e;
                  fn = t = fn - 16 | 0, no(n, 0);

                  n: if (!((e = b[r + 4 >> 2]) >>> 0 > 3)) {
                    r: switch (e - 1 | 0) {
                      default:
                        _u(t + 8 | 0), b[n >> 2] = b[t + 8 >> 2];
                        break n;

                      case 2:
                        se(t + 8 | 0), b[n >> 2] = b[t + 8 >> 2];
                        break n;

                      case 0:
                        $n(t + 8 | 0, m[r >> 2]), b[n >> 2] = b[t + 8 >> 2];
                        break n;

                      case 1:
                    }

                    xn(t + 8 | 0, m[r >> 2]), b[n >> 2] = b[t + 8 >> 2];
                  }

                  return fn = t + 16 | 0, n;
                }(t + 8 | 0, r)), fn = t + 16 | 0;
              }(n + 164 | 0, r + 8 | 0), b[n + 172 >> 2] = 0, b[n + 176 >> 2] = 0, Eu(n + 172 | 0), b[n + 180 >> 2] = 0, b[n + 184 >> 2] = 0, Eu(n + 180 | 0), b[n + 188 >> 2] = 0, _o(n + 188 | 0), zi(r + 8 | 0, n), Za(r + 8 | 0, 1), Di(r + 8 | 0, n), Za(r + 8 | 0, 4), fn = r + 16 | 0;
            }

            function $n(n, r) {
              var t,
                  e = 0,
                  i = _(0),
                  a = 0,
                  o = 0,
                  A = 0;

              fn = t = fn - 32 | 0, r < _(10842021724855044e-35) ^ 1 | r > _(-10842021724855044e-35) ^ 1 && r != _(0) ? (f(0, -2147483648 & (s(r), u(0)) | 1610612735), i = v(), a = lo(t + 16 | 0, r > _(0x1fffffe0000000000) || r < _(-0x1fffffe0000000000) ? i : r), e = b[a >> 2] + -536870912 | 0, b[a >> 2] = e, b[t + 4 >> 2] = e, b[t + 8 >> 2] = e, No(n, t + 4 | 0)) : (o = t, A = b[no(t + 24 | 0, 2140081935) >> 2], b[o >> 2] = A, No(n, t)), fn = t + 32 | 0;
            }

            function zn() {
              var n,
                  r = 0;
              fn = n = fn - 32 | 0, V(3848, 3868, 3896, 0, 3912, 27, 3915, 0, 3915, 0, 2333, 3917, 28), function () {
                var n;
                fn = n = fn - 16 | 0, U(3848, 1, 3920, 3912, 30, 29), fn = n + 16 | 0;
              }(), B(3848, 2340, 1, 3920, 3912, 30, 29), b[n + 28 >> 2] = 0, b[n + 24 >> 2] = 31, r = b[n + 28 >> 2], b[n + 16 >> 2] = b[n + 24 >> 2], b[n + 20 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(3848, 2347, 4, 3936, 3952, 34, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 16 | 0), b[n + 28 >> 2] = 0, b[n + 24 >> 2] = 32, r = b[n + 28 >> 2], b[n + 8 >> 2] = b[n + 24 >> 2], b[n + 12 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(3848, 2377, 3, 3960, 3972, 35, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n + 8 | 0), b[n + 28 >> 2] = 0, b[n + 24 >> 2] = 33, r = b[n + 28 >> 2], b[n >> 2] = b[n + 24 >> 2], b[n + 4 >> 2] = r, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[n + 4 >> 2], b[r + 8 >> 2] = b[n >> 2], b[r + 12 >> 2] = t, T(3848, 2397, 3, 3980, 3992, 36, 0 | Ue(r + 8 | 0), 0), fn = r + 16 | 0;
              }(n), fn = n + 32 | 0;
            }

            function Ln(n) {
              var r,
                  t = _(0),
                  e = 0;

              return fn = r = fn - 16 | 0, t = _(0), b[n + 540 >> 2] && (e = n + 24 | 0, m[r + 8 >> 2] = m[e + 12 >> 2], Eo(r + 8 | 0) ? !Vo(p[n + 4 | 0], 7) && (m[r + 8 >> 2] = m[e + 4 >> 2], !Eo(r + 8 | 0) && (m[r >> 2] = m[e + 4 >> 2], m[r >> 2] < _(0))) ? (m[r + 8 >> 2] = m[e + 4 >> 2], t = _(-m[r + 8 >> 2])) : t = Vo(p[n + 4 | 0], 7) ? _(1) : _(0) : (m[r + 8 >> 2] = m[e + 12 >> 2], t = m[r + 8 >> 2])), fn = r + 16 | 0, t;
            }

            function Kn(n, r, t) {
              var e,
                  i,
                  a,
                  o = 0;
              fn = e = fn - 32 | 0, b[e + 24 >> 2] = r, r = b[n >> 2], i = e, a = mo(n), b[i >> 2] = a, r = r + (ha(e + 24 | 0, e) << 2) | 0;

              n: if (y[n + 4 >> 2] < y[uu(n) >> 2]) {
                if ((0 | (o = b[n + 4 >> 2])) == (0 | r)) {
                  Ae(n, t);
                  break n;
                }

                !function (n, r, t, e) {
                  var i,
                      a,
                      o,
                      u = 0;
                  if (fn = a = fn - 16 | 0, o = b[n + 4 >> 2], i = xe(a, n, t - (e = (o - e | 0) + r | 0) >> 2), t >>> 0 > e >>> 0) for (u = e; ho(uu(n), b[i + 4 >> 2], u), b[i + 4 >> 2] = b[i + 4 >> 2] + 4, (u = u + 4 | 0) >>> 0 < t >>> 0;) {
                    ;
                  }
                  Wa(i), (n = e - r | 0) && Nn(o - n | 0, r, n), fn = a + 16 | 0;
                }(n, r, o, r + 4 | 0), o = r, r >>> 0 <= t >>> 0 && (t = t >>> 0 < y[n + 4 >> 2] ? t + 4 | 0 : t), b[o >> 2] = b[t >> 2];
              } else o = uu(n), Gn(o = Fr(e, Pr(n, pa(n) + 1 | 0), r - b[n >> 2] >> 2, o), t), r = function (n, r, t) {
                var e, i, a;
                return Wo(n), i = b[r + 4 >> 2], e = r + 4 | 0, Le(uu(n), b[n >> 2], t, e), a = t, t = r + 8 | 0, qe(uu(n), a, b[n + 4 >> 2], t), ye(n, e), ye(n + 4 | 0, t), ye(uu(n), eu(r)), b[r >> 2] = b[r + 4 >> 2], qo(n, pa(n)), i;
              }(n, o, r), Je(o);

              Ke(r), fn = e + 32 | 0;
            }

            function qn(n, r, t, e) {
              var i = 0,
                  a = 0;
              return Mt(Qo(r, t)) ? 1 != (-3 & t) || Mt(Qo(r, 7)) ? !(1 << t & 53) | t >>> 0 > 5 || Mt(Qo(r, 6)) ? Mt(Qo(r, 8)) ? void (4 != (-2 & t) ? b[n >> 2] = b[e >> 2] : _u(n)) : (i = n, a = b[Qo(r, 8) >> 2], void (b[i >> 2] = a)) : (i = n, a = b[Qo(r, 6) >> 2], void (b[i >> 2] = a)) : (i = n, a = b[Qo(r, 7) >> 2], void (b[i >> 2] = a)) : (i = n, a = b[Qo(r, t) >> 2], void (b[i >> 2] = a));
            }

            function nr(n, r, t) {
              var e = 0,
                  i = 0,
                  u = 0;

              n: {
                if (!(e = b[t + 16 >> 2])) {
                  if (function (n) {
                    var r = 0;
                    return r = p[n + 74 | 0], o[n + 74 | 0] = r + -1 | r, 8 & (r = b[n >> 2]) ? (b[n >> 2] = 32 | r, -1) : (b[n + 4 >> 2] = 0, b[n + 8 >> 2] = 0, r = b[n + 44 >> 2], b[n + 28 >> 2] = r, b[n + 20 >> 2] = r, b[n + 16 >> 2] = r + b[n + 48 >> 2], 0);
                  }(t)) break n;
                  e = b[t + 16 >> 2];
                }

                if (e - (u = b[t + 20 >> 2]) >>> 0 < r >>> 0) return void a[b[t + 36 >> 2]](t, n, r);

                r: if (!(o[t + 75 | 0] < 0)) {
                  for (e = r;;) {
                    if (!(i = e)) break r;
                    if (10 == p[(e = i + -1 | 0) + n | 0]) break;
                  }

                  if (a[b[t + 36 >> 2]](t, n, i) >>> 0 < i >>> 0) break n;
                  r = r - i | 0, n = n + i | 0, u = b[t + 20 >> 2];
                }

                _n(u, n, r), b[t + 20 >> 2] = b[t + 20 >> 2] + r;
              }
            }

            function rr(n, r) {
              var t = 0,
                  e = _(0);

              n: {
                if (e = m[r >> 2], 2139156720 != (0 | (t = b[r >> 2]))) {
                  if (2140081935 != (0 | t)) {
                    if (2141891242 != (0 | t)) break n;
                    return r = b[323], b[n >> 2] = b[322], void (b[n + 4 >> 2] = r);
                  }

                  return b[n >> 2] = 0, void (b[n + 4 >> 2] = 1);
                }

                return b[n >> 2] = 0, void (b[n + 4 >> 2] = 2);
              }

              if (vu(e)) return r = b[321], b[n >> 2] = b[320], void (b[n + 4 >> 2] = r);
              r = b[r >> 2], b[n + 4 >> 2] = 1073741824 & r ? 2 : 1, b[n >> 2] = 536870912 + (-1073741825 & r);
            }

            function tr(n) {
              var r,
                  t = 0;

              for (b[n >> 2] = 0, b[n + 4 >> 2] = 0, b[n + 76 >> 2] = 0, b[n + 80 >> 2] = 0, b[n + 16 >> 2] = 2143289344, b[n + 20 >> 2] = 2143289344, b[n + 8 >> 2] = 0, b[n + 12 >> 2] = 0, Zn(n + 24 | 0, 0, 49), _o(n + 80 | 0), b[n + 92 >> 2] = 0, b[n + 84 >> 2] = 0, b[n + 88 >> 2] = 0, r = n + 288 | 0, t = n + 96 | 0; (0 | r) != (0 | (t = Ot(t) + 24 | 0));) {
                ;
              }

              return b[n + 288 >> 2] = 2143289344, b[n + 292 >> 2] = 2143289344, Ot(n + 296 | 0), n;
            }

            function er(n) {
              var r,
                  t = 0,
                  e = 0,
                  i = 0;
              fn = r = fn - 16 | 0, $i(r + 8 | 0, au(n)), t = 0;

              n: if (!So(Li(r + 8 | 0)) && (Di(r + 8 | 0, au(n)), t = 1, 5 != (0 | ra(r + 8 | 0)) && (t = 0, i = Xo(n)))) {
                for (;;) {
                  if (Ui(r + 8 | 0, au(t = ci(n, e))), !na(r + 8 | 0) && (Pi(r, au(t)), 5 == (0 | ra(r)))) {
                    t = 1;
                    break n;
                  }

                  if ((0 | i) == (0 | (e = e + 1 | 0))) break;
                }

                t = 0;
              }

              return fn = r + 16 | 0, t;
            }

            function ir(n, r, t) {
              var e,
                  i,
                  a = _(0);

              return fn = e = fn + -64 | 0, i = b[Qo(tu(n = n + 24 | 0), 5) >> 2], b[e + 20 >> 2] = i, b[e + 56 >> 2] = i, a = Kt(e + 20 | 0, t), Yo(r) && bi(a, m[lo(e + 48 | 0, _(0)) >> 2]) || (n = tu(n), r = b[wo(1612, r) >> 2], le(e + 32 | 0), b[e + 16 >> 2] = b[e + 32 >> 2], qn(e + 40 | 0, n, r, e + 16 | 0), b[e + 12 >> 2] = b[e + 40 >> 2], a = At(Kt(e + 12 | 0, t), m[lo(e + 24 | 0, _(0)) >> 2])), fn = e - -64 | 0, a;
            }

            function ar(n, r, t, e) {
              o[n + 53 | 0] = 1;

              n: if (b[n + 4 >> 2] == (0 | t)) {
                if (o[n + 52 | 0] = 1, !(t = b[n + 16 >> 2])) {
                  if (b[n + 36 >> 2] = 1, b[n + 24 >> 2] = e, b[n + 16 >> 2] = r, 1 != (0 | e) | 1 != b[n + 48 >> 2]) break n;
                  return void (o[n + 54 | 0] = 1);
                }

                if ((0 | r) == (0 | t)) {
                  if (2 == (0 | (t = b[n + 24 >> 2])) && (b[n + 24 >> 2] = e, t = e), 1 != b[n + 48 >> 2] | 1 != (0 | t)) break n;
                  return void (o[n + 54 | 0] = 1);
                }

                o[n + 54 | 0] = 1, b[n + 36 >> 2] = b[n + 36 >> 2] + 1;
              }
            }

            function or(n) {
              var r = 0,
                  t = 0,
                  e = 0;

              n: {
                r: if (3 & (r = n)) {
                  if (!p[0 | n]) return 0;

                  for (;;) {
                    if (!(3 & (r = r + 1 | 0))) break r;
                    if (!p[0 | r]) break;
                  }

                  break n;
                }

                for (; t = r, r = r + 4 | 0, !((-1 ^ (e = b[t >> 2])) & e + -16843009 & -2139062144);) {
                  ;
                }

                if (!(255 & e)) return t - n | 0;

                for (; e = p[t + 1 | 0], t = r = t + 1 | 0, e;) {
                  ;
                }
              }

              return r - n | 0;
            }

            function ur(n, r, t, e) {
              var i = _(0),
                  a = 0;

              return mt(i = (i = Tn(_(n *= r))) < _(0) ? _(i + _(1)) : i, _(0)) ? n -= +i : (n -= +i, mt(i, _(1)) || t ? n += 1 : e || (a = 0, vu(i) || (a = 1, i > _(.5) || (a = mt(i, _(.5)) ? 1 : 0)), n += a)), i = _(Z), vu(_(n)) || vu(_(r)) || (i = _(n / r)), i;
            }

            function fr() {
              rn(8420, 5524), nn(8444, 5529, 1, 1, 0), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5534, R(8456, b[n + 12 >> 2], 1, -128, 127), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5539, R(8480, b[n + 12 >> 2], 1, -128, 127), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5551, R(8468, b[n + 12 >> 2], 1, 0, 255), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5565, R(8492, b[n + 12 >> 2], 2, -32768, 32767), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5571, R(8504, b[n + 12 >> 2], 2, 0, 65535), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5586, R(8516, b[n + 12 >> 2], 4, -2147483648, 2147483647), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5590, R(8528, b[n + 12 >> 2], 4, 0, -1), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5603, R(8540, b[n + 12 >> 2], 4, -2147483648, 2147483647), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5608, R(8552, b[n + 12 >> 2], 4, 0, -1), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5622, D(8564, b[n + 12 >> 2], 4), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5628, D(8576, b[n + 12 >> 2], 8), fn = n + 16 | 0;
              }(), S(4736, 5635), S(6380, 5647), O(6468, 4, 5680), O(6560, 2, 5693), O(6652, 4, 5708), q(4556, 5723), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5739, I(6708, 0, b[n + 12 >> 2]), fn = n + 16 | 0;
              }(), Pe(5769), Me(5806), De(5845), Se(5876), He(5916), je(5945), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 5983, I(6988, 4, b[n + 12 >> 2]), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 6013, I(7028, 5, b[n + 12 >> 2]), fn = n + 16 | 0;
              }(), Pe(6052), Me(6084), De(6117), Se(6150), He(6184), je(6217), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 6251, I(7068, 6, b[n + 12 >> 2]), fn = n + 16 | 0;
              }(), function () {
                var n;
                fn = n = fn - 16 | 0, b[n + 12 >> 2] = 6282, I(7108, 7, b[n + 12 >> 2]), fn = n + 16 | 0;
              }();
            }

            function Ar(n, r, t) {
              var e,
                  i = 0;
              return fn = e = fn - 48 | 0, !Yo(r) || Mt(Qo(nu(i = n + 24 | 0), 4)) ? (n = nu(n + 24 | 0), r = b[wo(1596, r) >> 2], le(e + 24 | 0), b[e + 16 >> 2] = b[e + 24 >> 2], qn(e + 32 | 0, n, r, e + 16 | 0), b[e + 12 >> 2] = b[e + 32 >> 2], t = ut(e + 12 | 0, t)) : (n = b[Qo(nu(i), 4) >> 2], b[e + 20 >> 2] = n, b[e + 40 >> 2] = n, t = ut(e + 20 | 0, t)), fn = e + 48 | 0, t;
            }

            function cr(n, r, t) {
              var e,
                  i = 0;
              return fn = e = fn - 48 | 0, !Yo(r) || Mt(Qo(nu(i = n + 24 | 0), 5)) ? (n = nu(n + 24 | 0), r = b[wo(1612, r) >> 2], le(e + 24 | 0), b[e + 16 >> 2] = b[e + 24 >> 2], qn(e + 32 | 0, n, r, e + 16 | 0), b[e + 12 >> 2] = b[e + 32 >> 2], t = ut(e + 12 | 0, t)) : (n = b[Qo(nu(i), 5) >> 2], b[e + 20 >> 2] = n, b[e + 40 >> 2] = n, t = ut(e + 20 | 0, t)), fn = e + 48 | 0, t;
            }

            function lr(n, r, t) {
              var e = 0,
                  i = 0,
                  a = 0;
              if (1 == (0 | r) & n >>> 0 < 0 | r >>> 0 < 1) e = n;else for (; e = Ao(n, r, 10), a = i = An, i = co(e, i, 10), o[0 | (t = t + -1 | 0)] = n - i | 48, i = 9 == (0 | r) & n >>> 0 > 4294967295 | r >>> 0 > 9, n = e, r = a, i;) {
                ;
              }
              if (e) for (; n = (e >>> 0) / 10 | 0, o[0 | (t = t + -1 | 0)] = e - g(n, 10) | 48, r = e >>> 0 > 9, e = n, r;) {
                ;
              }
              return t;
            }

            function sr(n, r) {
              var t,
                  e = _(0),
                  i = 0;

              return fn = t = fn - 32 | 0, Yo(r) && !Mt(Qo(xo(i = n + 24 | 0), 5)) && (rr(t + 24 | 0, Qo(xo(i), 5)), (e = m[t + 24 >> 2]) >= _(0)) || (n = xo(n + 24 | 0), r = b[wo(1612, r) >> 2], le(t + 8 | 0), b[t + 4 >> 2] = b[t + 8 >> 2], qn(t + 16 | 0, n, r, t + 4 | 0), rr(t + 24 | 0, t + 16 | 0), e = Fe(m[t + 24 >> 2], _(0))), fn = t + 32 | 0, e;
            }

            function vr(n, r) {
              var t,
                  e = _(0),
                  i = 0;

              return fn = t = fn - 32 | 0, Yo(r) && !Mt(Qo(xo(i = n + 24 | 0), 4)) && (rr(t + 24 | 0, Qo(xo(i), 4)), (e = m[t + 24 >> 2]) >= _(0)) || (n = xo(n + 24 | 0), r = b[wo(1596, r) >> 2], le(t + 8 | 0), b[t + 4 >> 2] = b[t + 8 >> 2], qn(t + 16 | 0, n, r, t + 4 | 0), rr(t + 24 | 0, t + 16 | 0), e = Fe(m[t + 24 >> 2], _(0))), fn = t + 32 | 0, e;
            }

            function dr(n) {
              var r,
                  t = _(0);

              return fn = r = fn - 16 | 0, b[n + 540 >> 2] && (n = n + 24 | 0, m[r + 8 >> 2] = m[n + 8 >> 2], Eo(r + 8 | 0) ? (m[r + 8 >> 2] = m[n + 4 >> 2], Eo(r + 8 | 0) || (m[r >> 2] = m[n + 4 >> 2], m[r >> 2] > _(0) && (m[r + 8 >> 2] = m[n + 4 >> 2], t = m[r + 8 >> 2]))) : (m[r + 8 >> 2] = m[n + 8 >> 2], t = m[r + 8 >> 2])), fn = r + 16 | 0, t;
            }

            function br(n, r) {
              var t, e;
              return b[n + 8 >> 2] = 0, b[n + 12 >> 2] = 0, d[n + 4 >> 1] = 1, b[n >> 2] = 0, b[n + 16 >> 2] = 0, b[n + 20 >> 2] = 0, Jn(n + 24 | 0), tr(Zn(n + 216 | 0, 0, 320)), b[n + 536 >> 2] = 0, b[n + 540 >> 2] = 0, jo(n + 544 | 0), b[n + 556 >> 2] = r, t = b[321], e = b[320], b[n + 568 >> 2] = e, b[n + 572 >> 2] = t, b[n + 560 >> 2] = e, b[n + 564 >> 2] = t, p[r + 10 | 0] && ue(n), n;
            }

            function pr(n, r) {
              var t,
                  e = 0;
              return fn = t = fn - 48 | 0, Yo(r) && (e = ou(n + 24 | 0), _u(t + 32 | 0), b[t + 12 >> 2] = b[t + 32 >> 2], qn(t + 40 | 0, e, 5, t + 12 | 0), e = 1, !Mt(t + 40 | 0)) || (n = ou(n + 24 | 0), r = b[wo(1612, r) >> 2], _u(t + 16 | 0), b[t + 8 >> 2] = b[t + 16 >> 2], qn(t + 24 | 0, n, r, t + 8 | 0), e = 1 ^ Mt(t + 24 | 0)), fn = t + 48 | 0, e;
            }

            function hr(n, r) {
              var t,
                  e = 0;
              return fn = t = fn - 48 | 0, Yo(r) && (e = ou(n + 24 | 0), _u(t + 32 | 0), b[t + 12 >> 2] = b[t + 32 >> 2], qn(t + 40 | 0, e, 4, t + 12 | 0), e = 1, !Mt(t + 40 | 0)) || (n = ou(n + 24 | 0), r = b[wo(1596, r) >> 2], _u(t + 16 | 0), b[t + 8 >> 2] = b[t + 16 >> 2], qn(t + 24 | 0, n, r, t + 8 | 0), e = 1 ^ Mt(t + 24 | 0)), fn = t + 48 | 0, e;
            }

            function yr(n, r) {
              var t,
                  e = 0,
                  i = 0,
                  a = 0,
                  o = 0;
              fn = t = fn - 32 | 0;

              n: {
                for (;;) {
                  if (a = t, o = b[wo(n, i) >> 2], b[a + 24 >> 2] = o, e = b[wo(r, i) >> 2], b[t + 16 >> 2] = e, b[t + 12 >> 2] = b[t + 24 >> 2], b[t + 8 >> 2] = e, !ht(t + 12 | 0, t + 8 | 0)) {
                    if (e = 1, 9 != (0 | (i = i + 1 | 0))) continue;
                    break n;
                  }

                  break;
                }

                e = 0;
              }

              return fn = t + 32 | 0, e;
            }

            function mr(n, r) {
              var t,
                  e,
                  i = 0;

              if (c(+n), i = 0 | u(1), t = 0 | u(0), e = i, 2047 != (0 | (i = i >>> 20 & 2047))) {
                if (!i) return i = r, 0 == n ? r = 0 : (n = mr(0x10000000000000000 * n, r), r = b[r >> 2] + -64 | 0), b[i >> 2] = r, n;
                b[r >> 2] = i + -1022, f(0, 0 | t), f(1, -2146435073 & e | 1071644672), n = +A();
              }

              return n;
            }

            function kr(n, r) {
              var t,
                  e = 0,
                  i = 0,
                  a = 0,
                  o = 0;
              fn = t = fn - 32 | 0;

              n: {
                for (;;) {
                  if (a = t, o = b[wo(n, e) >> 2], b[a + 24 >> 2] = o, i = b[wo(r, e) >> 2], b[t + 16 >> 2] = i, b[t + 12 >> 2] = b[t + 24 >> 2], b[t + 8 >> 2] = i, !ht(t + 12 | 0, t + 8 | 0)) {
                    if (i = e, e = 1, !i) continue;
                    break n;
                  }

                  break;
                }

                e = 0;
              }

              return fn = t + 32 | 0, e;
            }

            function gr(n, r, t, e, i, a) {
              var u, f;
              fn = u = fn - 48 | 0, f = +an(0 | function () {
                var n = 0,
                    r = 0;
                return 1 & o[9476] || fi(9476) && (fn = n = fn - 16 | 0, r = 0 | H(5, 4592), fn = n + 16 | 0, b[2368] = r, Wi(9476)), b[2368];
              }(), 0 | r, 2484, u + 12 | 0, 0 | function (n, r, t, e, i) {
                var a;
                return fn = a = fn - 16 | 0, b[a + 12 >> 2] = n, xi(a + 12 | 0, m[r >> 2]), Ji(a + 12 | 0, b[t >> 2]), xi(a + 12 | 0, m[e >> 2]), Ji(a + 12 | 0, b[i >> 2]), fn = a + 16 | 0, n;
              }(u + 16 | 0, t, e, i, a)), t = no(u + 8 | 0, b[u + 12 >> 2]), e = b[4 + (r = f < 4294967296 & f >= 0 ? ~~f >>> 0 : 0) >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = e, en(b[t >> 2]), fn = u + 48 | 0;
            }

            function _r(n, r) {
              var t = 0;
              t = b[r + 4 >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = t, b[n + 16 >> 2] = b[r + 16 >> 2], t = b[r + 12 >> 2], b[n + 8 >> 2] = b[r + 8 >> 2], b[n + 12 >> 2] = t, yu(n + 20 | 0, r + 20 | 0), b[n + 40 >> 2] = b[r + 40 >> 2], t = b[r + 36 >> 2], b[n + 32 >> 2] = b[r + 32 >> 2], b[n + 36 >> 2] = t;
            }

            function Cr(n, r, t) {
              var e,
                  i = 0,
                  a = _(0);

              return fn = e = fn - 16 | 0, hr(n, r) ? t = Pn(n, r, t) : (i = e, a = Dn(n, r, t), m[i + 8 >> 2] = a, Eo(e + 8 | 0) ? t = m[e + 8 >> 2] : (n = lo(e, _(-m[e + 8 >> 2])), t = m[n >> 2], b[e + 8 >> 2] = b[n >> 2])), fn = e + 16 | 0, t;
            }

            function Er(n) {
              var r,
                  t,
                  e = 0;
              if (fn = r = fn - 16 | 0, (e = b[n + 540 >> 2]) && (Vr(e, n), Uo(n, 0)), t = Xo(n)) for (e = 0; Uo(ci(n, e), 0), (0 | t) != (0 | (e = e + 1 | 0));) {
                ;
              }
              za(n), b[r + 8 >> 2] = b[n + 556 >> 2], n && dn(so(n)), fn = r + 16 | 0;
            }

            function wr(n, r) {
              var t, e;
              fn = t = fn - 16 | 0;

              n: if ((e = b[n + 4 >> 2] + -1 | 0) >>> 0 <= 1) {
                if (e - 1) {
                  lo(t + 8 | 0, m[n >> 2]);
                  break n;
                }

                lo(t + 8 | 0, _(_(m[n >> 2] * r) * _(.009999999776482582)));
              } else b[t + 8 >> 2] = 0, _o(t + 8 | 0);

              return fn = t + 16 | 0, m[t + 8 >> 2];
            }

            function Nr(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 128 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 128 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Wr(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 172 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 172 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Zr(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 180 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 180 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Tr(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 56 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 56 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Ir(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 20 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 20 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Rr(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 92 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 92 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Br(n, r, t, e) {
              var i, o;
              fn = i = fn - 48 | 0, o = b[r >> 2], r = b[r + 4 >> 2], e = b[e >> 2], b[i + 40 >> 2] = e, b[i + 32 >> 2] = r, b[i + 28 >> 2] = o, b[i + 24 >> 2] = t, b[i + 16 >> 2] = r, b[i + 4 >> 2] = e, b[i + 12 >> 2] = o, b[i + 8 >> 2] = t, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0,
                      c = 0;
                  return fn = e = fn - 48 | 0, u = b[n + 4 >> 2], o = e, f = i = (f = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (u = b[b[i >> 2] + u >> 2]), A = o, c = 0 | a[u](f), b[A + 24 >> 2] = c, Mi(e + 32 | 0, e + 24 | 0, b[n >> 2]), A = e, c = b[Qo(b[e + 32 >> 2] + 164 | 0, b[e + 36 >> 2]) >> 2], b[A + 40 >> 2] = c, n = b[t >> 2], b[e + 16 >> 2] = n, b[e + 12 >> 2] = b[e + 40 >> 2], b[e + 8 >> 2] = n, n = ht(e + 12 | 0, e + 8 | 0), fn = e + 48 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u = 0,
                      f = 0,
                      A = 0;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n + 4 >> 2], i = e, o = u = (u = r) + ((r = b[n + 8 >> 2]) >> 1) | 0, 1 & r && (t = b[t + b[u >> 2] >> 2]), f = i, A = 0 | a[t](o), b[f + 8 >> 2] = A, Mi(e + 16 | 0, e + 8 | 0, b[n >> 2]), b[e + 4 >> 2] = b[e + 24 >> 2], f = Qo(b[e + 16 >> 2] + 164 | 0, b[e + 20 >> 2]), A = b[e + 4 >> 2], b[f >> 2] = A, fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, i + 4 | 0, i + 24 | 0, i + 8 | 0), fn = i + 48 | 0;
            }

            function Vr(n, r) {
              var t,
                  e = 0,
                  i = 0;
              return fn = t = fn - 32 | 0, b[t + 28 >> 2] = r, e = t, i = function (n, r, t) {
                var e;
                fn = e = fn - 16 | 0, b[e >> 2] = r, b[e + 8 >> 2] = n;

                n: if (ba(e + 8 | 0, e)) for (;;) {
                  if (b[b[e + 8 >> 2] >> 2] == b[t >> 2]) break n;
                  if (Zo(e + 8 | 0), !ba(e + 8 | 0, e)) break;
                }

                return fn = e + 16 | 0, b[e + 8 >> 2];
              }(mo(n = n + 544 | 0), to(n), t + 28 | 0), b[e + 24 >> 2] = i, e = t, i = to(n), b[e + 16 >> 2] = i, r = 0, ba(t + 24 | 0, t + 16 | 0) && (function (n, r) {
                var t, e, i;
                fn = t = fn - 16 | 0, b[t + 8 >> 2] = r, e = t, i = mo(n), b[e >> 2] = i, r = ha(t + 8 | 0, t), r = b[n >> 2] + (r << 2) | 0, Ma(n, vo(r + 4 | 0, b[n + 4 >> 2], r)), Ke(r), fn = t + 16 | 0;
              }(n, b[Ea(t + 8 | 0, t + 24 | 0) >> 2]), r = 1), fn = t + 32 | 0, r;
            }

            function Gr(n, r, t) {
              var e;
              if (!(e = b[n + 16 >> 2])) return b[n + 36 >> 2] = 1, b[n + 24 >> 2] = t, void (b[n + 16 >> 2] = r);

              n: {
                if ((0 | r) == (0 | e)) {
                  if (2 != b[n + 24 >> 2]) break n;
                  return void (b[n + 24 >> 2] = t);
                }

                o[n + 54 | 0] = 1, b[n + 24 >> 2] = 2, b[n + 36 >> 2] = b[n + 36 >> 2] + 1;
              }
            }

            function Fr(n, r, t, e) {
              var i,
                  a,
                  o,
                  u = 0;
              return fn = i = fn - 16 | 0, b[i + 12 >> 2] = 0, pu(n + 12 | 0), b[n + 16 >> 2] = e, r && (u = pi(r)), b[n >> 2] = u, t = (t << 2) + u | 0, b[n + 8 >> 2] = t, b[n + 4 >> 2] = t, a = eu(n), o = (r << 2) + u | 0, b[a >> 2] = o, fn = i + 16 | 0, n;
            }

            function Xr(n, r, t, e, i) {
              var a;

              if (fn = a = fn - 256 | 0, !(73728 & i | (0 | t) <= (0 | e))) {
                if (Zn(a, r, (e = (t = t - e | 0) >>> 0 < 256) ? t : 256), !e) for (; aa(n, a, 256), (t = t + -256 | 0) >>> 0 > 255;) {
                  ;
                }
                aa(n, a, t);
              }

              fn = a + 256 | 0;
            }

            function Or(n, r) {
              r |= 0;
              var t,
                  e,
                  i,
                  o,
                  u,
                  f = 0;
              return fn = t = fn - 16 | 0, f = b[(n |= 0) >> 2], e = t, i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (f = b[b[r >> 2] + f >> 2]), o = e, u = 0 | a[f](i), b[o + 12 >> 2] = u, fn = t + 16 | 0, b[t + 12 >> 2];
            }

            function Qr(n, r) {
              var t = 0;
              return function (n, r) {
                var t, e;
                fn = e = fn - 16 | 0, Re(n), (t = pa(r)) && (Qt(n, t), Be(n, b[r >> 2], b[r + 4 >> 2], t)), fn = e + 16 | 0;
              }((n = _n(n, r, 544)) + 544 | 0, r + 544 | 0), b[n + 572 >> 2] = b[r + 572 >> 2], t = b[r + 568 >> 2], b[n + 564 >> 2] = b[r + 564 >> 2], b[n + 568 >> 2] = t, t = b[r + 560 >> 2], b[n + 556 >> 2] = b[r + 556 >> 2], b[n + 560 >> 2] = t, n;
            }

            function Ur(n, r, t) {
              var e, i;
              fn = e = fn - 32 | 0, i = b[r >> 2], r = b[r + 4 >> 2], t = b[t >> 2], b[e + 24 >> 2] = t, b[e + 20 >> 2] = r, b[e + 16 >> 2] = i, b[e + 4 >> 2] = t, b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, function (n, r, t, e) {
                var i, o;
                fn = i = fn - 32 | 0, o = au(n), r = b[r >> 2], b[i + 12 >> 2] = r, b[i + 24 >> 2] = r, function (n, r, t) {
                  var e,
                      i,
                      o,
                      u,
                      f,
                      A = 0;
                  return fn = e = fn - 32 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 16 >> 2] = f, b[e + 24 >> 2] = b[b[e + 16 >> 2] + 16 >> 2], n = b[t >> 2], b[e + 8 >> 2] = n, b[e + 4 >> 2] = b[e + 24 >> 2], b[e >> 2] = n, n = ht(e + 4 | 0, e), fn = e + 32 | 0, n;
                }(t, o, i + 12 | 0) && (t = au(n), b[i + 8 >> 2] = r, b[i + 16 >> 2] = r, function (n, r, t) {
                  var e, i, o, u, f;
                  fn = e = fn - 32 | 0, b[e + 24 >> 2] = b[t >> 2], t = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (t = b[t + b[r >> 2] >> 2]), u = i, f = 0 | a[t](o), b[u + 16 >> 2] = f, b[e + 12 >> 2] = b[e + 24 >> 2], b[b[e + 16 >> 2] + 16 >> 2] = b[e + 12 >> 2], fn = e + 32 | 0;
                }(e, t, i + 8 | 0), bt(n)), fn = i + 32 | 0;
              }(n, e + 4 | 0, e + 16 | 0, e + 8 | 0), fn = e + 32 | 0;
            }

            function Yr(n, r, t, e) {
              var i,
                  o,
                  u,
                  f = 0;
              i = b[n + 4 >> 2], o = n = b[n >> 2], u = r, f = 0, t && (f = r = i >> 8, 1 & i && (f = b[r + b[t >> 2] >> 2])), a[b[b[n >> 2] + 28 >> 2]](o, u, f + t | 0, 2 & i ? e : 2);
            }

            function Pr(n, r) {
              var t,
                  e = 0;
              if (fn = t = fn - 16 | 0, b[t + 12 >> 2] = r, (e = jt(n)) >>> 0 >= r >>> 0) return (n = ca(n)) >>> 0 < e >>> 1 >>> 0 && (b[t + 8 >> 2] = n << 1, e = b[Bo(t + 8 | 0, t + 12 | 0) >> 2]), fn = t + 16 | 0, e;
              su(), W();
            }

            function Dr(n) {
              var r, t;
              return (n = (r = b[2780]) + (t = n + 3 & -4) | 0) >>> 0 <= r >>> 0 && (0 | t) >= 1 || n >>> 0 > wu() << 16 >>> 0 && !L(0 | n) ? (b[2373] = 48, -1) : (b[2780] = n, r);
            }

            function Sr(n, r) {
              var t,
                  e = 0;
              fn = t = fn - 320 | 0, Xo(n) && (e = b[r + 540 >> 2], Vr(n, r) && ((0 | n) == (0 | e) && (_n(r + 216 | 0, tr(Zn(t, 0, 320)), 320), Uo(r, 0)), bt(n))), fn = t + 320 | 0;
            }

            function Hr(n, r) {
              var t = 0;
              return r && (!(r = Xn(r, 8324)) | b[r + 8 >> 2] & (-1 ^ b[n + 8 >> 2]) || ke(b[n + 12 >> 2], b[r + 12 >> 2], 0) && (t = ke(b[n + 16 >> 2], b[r + 16 >> 2], 0))), t;
            }

            function jr(n) {
              var r, t, e;
              fn = r = fn - 576 | 0, Ge(n, !pa(n + 544 | 0), 1104), Ge(n, !b[n + 540 >> 2], 1158), za(n), e = Vo(p[n + 4 | 0], 7), function (n, r) {
                var t = 0;
                t = b[r + 4 >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = t, t = b[r + 20 >> 2], b[n + 16 >> 2] = b[r + 16 >> 2], b[n + 20 >> 2] = t, t = b[r + 12 >> 2], b[n + 8 >> 2] = b[r + 8 >> 2], b[n + 12 >> 2] = t, _n(n + 24 | 0, r + 24 | 0, 192), _n(n + 216 | 0, r + 216 | 0, 328), yu(n + 544 | 0, r + 544 | 0), b[n + 572 >> 2] = b[r + 572 >> 2], t = b[r + 568 >> 2], b[n + 564 >> 2] = b[r + 564 >> 2], b[n + 568 >> 2] = t, t = b[r + 560 >> 2], b[n + 556 >> 2] = b[r + 556 >> 2], b[n + 560 >> 2] = t;
              }(n, t = br(r, b[n + 556 >> 2])), so(t), e && ue(n), fn = r + 576 | 0;
            }

            function Mr(n, r, t) {
              var e,
                  i = 0,
                  a = 0;
              fn = e = fn - 32 | 0, b[e + 28 >> 2] = r, i = e, a = mo(n = n + 544 | 0), b[i + 8 >> 2] = a, i = e, a = function (n, r) {
                var t;
                return fn = t = fn - 16 | 0, b[t + 8 >> 2] = b[n >> 2], b[t + 8 >> 2] = b[t + 8 >> 2] + (r << 2), fn = t + 16 | 0, b[t + 8 >> 2];
              }(e + 8 | 0, t), b[i + 16 >> 2] = a, Kn(n, b[Ea(e + 24 | 0, e + 16 | 0) >> 2], e + 28 | 0), fn = e + 32 | 0;
            }

            function xr(n, r, t) {
              var e,
                  i,
                  a = _(0),
                  o = _(0);

              return fn = e = fn - 16 | 0, a = m[wo(Ko(n) + 288 | 0, b[wo(1848, r) >> 2]) >> 2], i = e, o = xt(Ar(n, r, t), cr(n, r, t)), m[i + 8 >> 2] = o, fn = e + 16 | 0, _(a + m[e + 8 >> 2]);
            }

            function Jr(n, r, t) {
              var e,
                  i,
                  o,
                  u = 0;
              fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[b[r >> 2] + u >> 2]), a[u](i, o), function (n, r, t) {
                var e, i, a, o;
                e = b[n >> 2], i = La(oo(5), r), a = n, o = La(oo(5), r) & t << r | (-1 ^ i) & e, b[a >> 2] = o;
              }(b[e + 8 >> 2], b[e + 12 >> 2], t), fn = e + 16 | 0;
            }

            function $r(n, r, t) {
              var e,
                  i,
                  o,
                  u = 0;
              fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[b[r >> 2] + u >> 2]), a[u](i, o), function (n, r, t) {
                var e, i, a, o;
                e = b[n >> 2], i = La(oo(1), r), a = n, o = La(oo(1), r) & t << r | (-1 ^ i) & e, b[a >> 2] = o;
              }(b[e + 8 >> 2], b[e + 12 >> 2], t), fn = e + 16 | 0;
            }

            function zr(n, r, t) {
              var e,
                  i,
                  o,
                  u = 0;
              fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[b[r >> 2] + u >> 2]), a[u](i, o), function (n, r, t) {
                var e, i, a, o;
                e = b[n >> 2], i = La(oo(2), r), a = n, o = La(oo(2), r) & t << r | (-1 ^ i) & e, b[a >> 2] = o;
              }(b[e + 8 >> 2], b[e + 12 >> 2], t), fn = e + 16 | 0;
            }

            function Lr(n, r, t) {
              var e = _(0);

              e = m[wo(Ko(r) + 288 | 0, b[wo(1848, t) >> 2]) >> 2], yi(r, _(_(m[wo(Ko(n) + 288 | 0, b[wo(1848, t) >> 2]) >> 2] - e) - m[wo(Ko(r), b[wo(2184, t) >> 2]) >> 2]), b[wo(1612, t) >> 2]);
            }

            function Kr(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                return fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, n = yo(m[b[e + 8 >> 2] + 188 >> 2], t), fn = e + 16 | 0, n;
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, m[b[e + 8 >> 2] + 188 >> 2] = t, fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function qr(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                return fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), n = na(e + 8 | 0), fn = e + 16 | 0, (0 | n) != (0 | t);
              }(e + 8 | 0, au(n), t) && ($r(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function nt(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                return fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), n = qi(e + 8 | 0), fn = e + 16 | 0, (0 | n) != (0 | t);
              }(e + 8 | 0, au(n), t) && (zr(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function rt(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                return fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), n = ra(e + 8 | 0), fn = e + 16 | 0, (0 | n) != (0 | t);
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, n = b[n + 4 >> 2], o = r = (n >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), Za(e + 8 | 0, t), fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function tt(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                return fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), n = Ki(e + 8 | 0), fn = e + 16 | 0, (0 | n) != (0 | t);
              }(e + 8 | 0, au(n), t) && (Jr(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function et(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                return fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, n = yo(m[b[e + 8 >> 2] + 4 >> 2], t), fn = e + 16 | 0, n;
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, m[b[e + 8 >> 2] + 4 >> 2] = t, fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function it(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                return fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, n = yo(m[b[e + 8 >> 2] + 8 >> 2], t), fn = e + 16 | 0, n;
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, m[b[e + 8 >> 2] + 8 >> 2] = t, fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function at(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                return fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, n = yo(m[b[e + 8 >> 2] + 12 >> 2], t), fn = e + 16 | 0, n;
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u,
                    f,
                    A = 0;
                fn = e = fn - 16 | 0, A = b[n >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[b[r >> 2] + A >> 2]), u = i, f = 0 | a[A](o), b[u + 8 >> 2] = f, m[b[e + 8 >> 2] + 12 >> 2] = t, fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function ot(n, r, t) {
              var e, i;
              fn = e = fn - 16 | 0, i = b[r >> 2], r = b[r + 4 >> 2], b[e + 12 >> 2] = r, b[e + 8 >> 2] = i, b[e + 4 >> 2] = r, b[e >> 2] = i, r = e, function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                return fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), n = Li(e + 8 | 0), fn = e + 16 | 0, (0 | n) != (0 | t);
              }(e + 8 | 0, au(n), t) && (function (n, r, t) {
                var e,
                    i,
                    o,
                    u = 0;
                fn = e = fn - 16 | 0, u = b[n >> 2], i = e + 8 | 0, n = b[n + 4 >> 2], o = r = (n >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o), Na(e + 8 | 0, t), fn = e + 16 | 0;
              }(r, au(n), t), bt(n)), fn = e + 16 | 0;
            }

            function ut(n, r) {
              var t;
              return fn = t = fn - 32 | 0, Ca(n) ? r = m[lo(t + 24 | 0, _(0)) >> 2] : (n = b[n >> 2], b[t + 12 >> 2] = n, b[t + 16 >> 2] = n, r = Kt(t + 12 | 0, r), m[t + 24 >> 2] = r), fn = t + 32 | 0, r;
            }

            function ft(n, r, t, e, i) {
              var a = 0;
              return 2 != (0 | n) | 2 != (0 | t) || vu(e) || vu(r) || vu(i) | e > r ^ 1 || (a = 1, i <= r || (a = mt(r, i))), a;
            }

            function At(n, r) {
              var t;
              return fn = t = fn - 16 | 0, m[t + 4 >> 2] = r, m[t + 8 >> 2] = n, bi(n, r) ? r = n : We(r, n) || (r = m[(Eo(t + 8 | 0) ? t + 4 | 0 : t + 8 | 0) >> 2]), fn = t + 16 | 0, r;
            }

            function ct(n, r) {
              var t,
                  e = 0;
              return fn = t = fn - 16 | 0, m[t >> 2] = r, m[t + 8 >> 2] = n, e = 1, m[t + 8 >> 2] != m[t >> 2] && (e = 0, Eo(t + 8 | 0) && (e = Eo(t))), fn = t + 16 | 0, e;
            }

            function lt(n, r, t, e, i, a, o, u, f, A, c, l, s, v, d, b, p) {
              var h,
                  y = _(0),
                  k = _(0);

              y = m[r + 32 >> 2], En(r, t, i, a, u), h = r, k = _(y - mn(r, n, t, e, i, a, o, u, f, A, c, l, s, v, d, b, p)), m[h + 32 >> 2] = k;
            }

            function st(n, r, t) {
              rr(n, n = !Yo(t) || Mt(Qo(nu(n = r + 24 | 0), 4)) ? Qo(nu(r + 24 | 0), b[wo(1596, t) >> 2]) : Qo(nu(n), 4));
            }

            function vt(n, r, t) {
              rr(n, n = !Yo(t) || Mt(Qo(nu(n = r + 24 | 0), 5)) ? Qo(nu(r + 24 | 0), b[wo(1612, t) >> 2]) : Qo(nu(n), 5));
            }

            function dt(n) {
              var r = 0,
                  t = 0,
                  e = 0;
              if (fo(o[b[n >> 2]])) for (; r = b[n >> 2], e = o[0 | r], b[n >> 2] = r + 1, t = (g(t, 10) + e | 0) - 48 | 0, fo(o[r + 1 | 0]);) {
                ;
              }
              return t;
            }

            function bt(n) {
              var r;
              fn = r = fn - 16 | 0, Vo(p[n + 4 | 0], 2) || (ae(n, 1), b[r + 8 >> 2] = 0, Po(n, m[_o(r + 8 | 0) >> 2]), (n = b[n + 540 >> 2]) && bt(n)), fn = r + 16 | 0;
            }

            function pt(n) {
              var r,
                  t = 0;
              return fn = r = fn - 16 | 0, Ui(r + 8 | 0, n + 24 | 0), t = 0, na(r + 8 | 0) || (t = 1, dr(n) == _(0) && (t = Ln(n) != _(0))), fn = r + 16 | 0, n = t;
            }

            function ht(n, r) {
              var t;
              return fn = t = fn - 32 | 0, n = b[n >> 2], b[t + 24 >> 2] = n, r = b[r >> 2], b[t + 16 >> 2] = r, b[t + 12 >> 2] = n, b[t + 8 >> 2] = r, fn = t + 32 | 0, b[t + 12 >> 2] == b[t + 8 >> 2] ^ 1;
            }

            function yt(n, r, t, e, i) {
              var a,
                  o,
                  u = _(0);

              return fn = a = fn - 16 | 0, o = a, u = Rn(n, r, m[lo(a, t) >> 2], e), m[o + 8 >> 2] = u, t = Fe(m[a + 8 >> 2], re(n, r, i)), fn = a + 16 | 0, t;
            }

            function mt(n, r) {
              return vu(n) || vu(r) ? vu(n) ? vu(r) : 0 : _(C(_(n - r))) < _(9999999747378752e-20);
            }

            function kt(n, r) {
              var t;
              return fn = t = fn - 16 | 0, Fa(t + 8 | 0, n = n + 24 | 0), r = (0 | r) > 1 ? r : 1, qi(t + 8 | 0) && (Fa(t + 8 | 0, n), r = qi(t + 8 | 0)), fn = t + 16 | 0, r;
            }

            function gt(n, r, t, e, i, o) {
              var u,
                  f,
                  A = 0;
              A = (u = b[n + 4 >> 2]) >> 8, f = n = b[n >> 2], 1 & u && (A = b[b[e >> 2] + A >> 2]), a[b[b[n >> 2] + 20 >> 2]](f, r, t, e + A | 0, 2 & u ? i : 2, o);
            }

            function _t(n, r, t) {
              var e;
              return fn = e = fn - 16 | 0, b[e + 12 >> 2] = t, G(4160, 0 | r, 8564, 5124, 162, 0 | Bi(e + 12 | 0), 8564, 3972, 163, 0 | Bi(e + 12 | 0)), fn = e + 16 | 0, n;
            }

            function Ct(n, r, t, e, i) {
              var o;
              return (o = b[n >> 2]) && (n = p[n + 8 | 0] ? 0 | a[o](r, t, e, i) : 0 | a[o](r, t, e)) || (n = function (n) {
                var r, t;
                return fn = r = fn - 16 | 0, t = Qr(ie(576), n), Ye(b[n + 556 >> 2], 1, 1296), b[r + 8 >> 2] = b[t + 556 >> 2], Uo(t, 0), fn = r + 16 | 0, t;
              }(r)), n;
            }

            function Et(n, r) {
              n |= 0, r |= 0;
              var t = 0;
              fn = t = fn - 320 | 0, tr(t = Zn(t, 0, 320)), _n(Ko(n), t, 320), mi(n, _(0), 0), mi(n, _(0), 1), ru(n), function (n, r) {
                var t,
                    e = 0,
                    i = 0,
                    o = 0,
                    u = 0,
                    f = 0;
                if (fn = t = fn - 16 | 0, u = t, f = mo(e = n + 544 | 0), b[u + 8 >> 2] = f, u = t, f = to(e), b[u >> 2] = f, ba(t + 8 | 0, t)) for (e = 0; i = b[t + 8 >> 2], b[b[i >> 2] + 540 >> 2] != (0 | n) && (o = Ct(b[n + 556 >> 2], b[i >> 2], n, e, r), b[i >> 2] = o, Uo(o, n)), a[24](b[i >> 2], r), e = e + 1 | 0, Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                  ;
                }
                fn = t + 16 | 0;
              }(n, r), fn = t + 320 | 0;
            }

            function wt(n, r) {
              var t;
              Wo(n), t = r + 4 | 0, Le(uu(n), b[n >> 2], b[n + 4 >> 2], t), ye(n, t), ye(n + 4 | 0, r + 8 | 0), ye(uu(n), eu(r)), b[r >> 2] = b[r + 4 >> 2], qo(n, pa(n));
            }

            function Nt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 4, 5280, 5296, 173, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Wt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 2, 5336, 4564, 177, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Zt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 3, 5352, 5364, 179, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Tt(n, r, t, e, i) {
              var o,
                  u,
                  f = 0;
              f = (o = b[n + 4 >> 2]) >> 8, u = n = b[n >> 2], 1 & o && (f = b[b[t >> 2] + f >> 2]), a[b[b[n >> 2] + 24 >> 2]](u, r, t + f | 0, 2 & o ? e : 2, i);
            }

            function It(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 3, 5304, 4022, 174, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Rt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 3, 5324, 3992, 176, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Bt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 2, 5316, 4564, 175, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Vt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 2, 5344, 4018, 178, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Gt(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 3, 5264, 5164, 172, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Ft(n, r) {
              var t, e;
              fn = t = fn - 16 | 0, e = b[r + 4 >> 2], b[t + 8 >> 2] = b[r >> 2], b[t + 12 >> 2] = e, T(5176, 0 | n, 2, 5244, 4524, 170, 0 | Ue(t + 8 | 0), 0), fn = t + 16 | 0;
            }

            function Xt(n, r, t) {
              var e;
              return fn = e = fn - 16 | 0, b[e + 12 >> 2] = t, G(4008, 0 | r, 8576, 4018, 39, 0 | Bi(e + 12 | 0), 8576, 4022, 40, 0 | Bi(e + 12 | 0)), fn = e + 16 | 0, n;
            }

            function Ot(n) {
              return b[n + 16 >> 2] = -1082130432, b[n + 20 >> 2] = -1082130432, b[n + 8 >> 2] = 0, b[n + 12 >> 2] = 0, b[n >> 2] = -1082130432, b[n + 4 >> 2] = -1082130432, n;
            }

            function Qt(n, r) {
              var t, e, i;
              jt(n) >>> 0 < r >>> 0 && (su(), W()), t = pi(r), b[n >> 2] = t, b[n + 4 >> 2] = t, e = uu(n), i = (r << 2) + t | 0, b[e >> 2] = i, qo(n);
            }

            function Ut(n, r, t, e) {
              if (n | r) for (; o[0 | (t = t + -1 | 0)] = p[7616 + (15 & n) | 0] | e, (n = (15 & r) << 28 | n >>> 4) | (r = r >>> 4 | 0);) {
                ;
              }
              return t;
            }

            function Yt(n, r) {
              var t, e, i, a;
              fn = t = fn - 16 | 0, a = function () {
                var n = 0,
                    r = 0;
                return 1 & o[9468] || fi(9468) && (fn = n = fn - 16 | 0, r = 0 | H(1, 4384), fn = n + 16 | 0, b[2366] = r, Wi(9468)), b[2366];
              }(), fn = e = fn - 16 | 0, i = t + 8 | 0, b[e + 12 >> 2] = i, fn = e + 16 | 0, on(0 | a, 0 | n, 0 | r, 0 | i), fn = t + 16 | 0;
            }

            function Pt(n, r) {
              var t = 0;
              return 5 == (0 | (r = Ja(au(r)) ? Ja(au(r)) : Ya(au(n)))) && (t = 1, So(ro(au(n)))) || (t = r), t;
            }

            function Dt(n, r, t, e) {
              r |= 0, t |= 0, e |= 0;
              var i,
                  o = 0;
              o = b[(n |= 0) >> 2], i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (o = b[o + b[r >> 2] >> 2]), a[o](i, t, e);
            }

            function St(n, r, t) {
              r |= 0, t |= 0;
              var e,
                  i = 0;
              return i = b[(n |= 0) >> 2], e = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (i = b[i + b[r >> 2] >> 2]), 0 | a[i](e, t);
            }

            function Ht(n, r) {
              for (var t = 0, e = 0, i = 0; (e = mt(m[wo(n, t) >> 2], m[wo(r, t) >> 2])) && (i = t >>> 0 < 3, t = t + 1 | 0, i);) {
                ;
              }

              return e;
            }

            function jt(n) {
              var r;
              return fn = r = fn - 16 | 0, b[r + 12 >> 2] = 1073741823, b[r + 8 >> 2] = 2147483647, n = b[function (n, r) {
                var t, e;
                return fn = t = fn - 16 | 0, e = Ga(r, n), fn = t + 16 | 0, e ? r : n;
              }(r + 12 | 0, r + 8 | 0) >> 2], fn = r + 16 | 0, n;
            }

            function Mt(n) {
              var r = _(0);

              return r = m[n >> 2], n = 2139156720 == (0 | (n = b[n >> 2])) | 2140081935 == (0 | n) | 2141891242 == (0 | n) ? 0 : vu(r);
            }

            function xt(n, r) {
              var t;
              return fn = t = fn - 32 | 0, m[t + 8 >> 2] = r, m[t + 16 >> 2] = n, n = m[lo(t + 24 | 0, _(m[t + 16 >> 2] + m[t + 8 >> 2])) >> 2], fn = t + 32 | 0, n;
            }

            function Jt(n, r) {
              var t,
                  e = 0;
              fn = t = fn - 32 | 0, ca(n) >>> 0 < r >>> 0 && (e = uu(n), wt(n, n = Fr(t + 8 | 0, r, pa(n), e)), Je(n)), fn = t + 32 | 0;
            }

            function $t(n, r) {
              var t;
              return t = n, r = ge(r ? b[r >> 2] : ee()), b[t >> 2] = r, $e(n + 4 | 0), $e(n + 8 | 0), b[b[n >> 2] >> 2] = n, n;
            }

            function zt(n, r) {
              var t = 0;
              if ((0 | (t = b[n + 4 >> 2])) != (0 | r)) for (; (0 | (t = t + -4 | 0)) != (0 | r);) {
                ;
              }
              b[n + 4 >> 2] = r;
            }

            function Lt(n, r, t) {
              r |= 0, t |= 0;
              var e,
                  i = 0;
              i = b[(n |= 0) >> 2], e = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (i = b[i + b[r >> 2] >> 2]), a[i](e, t);
            }

            function Kt(n, r) {
              var t;
              return fn = t = fn - 16 | 0, rr(t + 8 | 0, n), n = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = n, r = wr(t, r), fn = t + 16 | 0, r;
            }

            function qt(n, r) {
              r |= 0;
              var t,
                  e = 0;
              return e = b[(n |= 0) >> 2], t = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (e = b[b[r >> 2] + e >> 2]), 0 | a[e](t);
            }

            function ne(n) {
              var r = 0,
                  t = 0,
                  e = 0;
              b[n >> 2] && (To(n), r = b[n >> 2], ca(n), dn(r), t = uu(n), e = 0, b[t >> 2] = e, b[n >> 2] = 0, b[n + 4 >> 2] = 0);
            }

            function re(n, r, t) {
              var e,
                  i,
                  a = _(0);

              return fn = e = fn - 16 | 0, i = e, a = xt(_e(n, r, t), Ce(n, r, t)), m[i + 8 >> 2] = a, fn = e + 16 | 0, m[e + 8 >> 2];
            }

            function te(n, r, t) {
              if (n | r) for (; o[0 | (t = t + -1 | 0)] = 7 & n | 48, (n = (7 & r) << 29 | n >>> 3) | (r = r >>> 3 | 0);) {
                ;
              }
              return t;
            }

            function ee() {
              var n = 0,
                  r = 0;
              return 1 & o[9448] || fi(9448) && (n = 9444, r = wi(), b[n >> 2] = r, Wi(9448)), b[2361];
            }

            function ie(n) {
              var r = 0;
              n = n || 1;

              n: {
                for (;;) {
                  if (r = cn(n)) break n;
                  if (!(r = b[2650])) break;
                  a[r]();
                }

                Y(), W();
              }

              return r;
            }

            function ae(n, r) {
              1 == (Vo(p[n + 4 | 0], 2) ^ r) && (be(n + 4 | 0, 2, r), r && (r = b[n + 20 >> 2]) && a[r](n));
            }

            function oe(n, r) {
              var t = 0;
              t = b[r + 564 >> 2], b[n >> 2] = b[r + 560 >> 2], b[n + 4 >> 2] = t, t = b[r + 572 >> 2], b[n + 8 >> 2] = b[r + 568 >> 2], b[n + 12 >> 2] = t;
            }

            function ue(n) {
              var r;
              fn = r = fn - 16 | 0, be(n + 4 | 0, 7, 1), $i(r + 8 | 0, n = n + 24 | 0), Na(r + 8 | 0, 2), zi(r + 8 | 0, n), Za(r + 8 | 0, 4), fn = r + 16 | 0;
            }

            function fe(n, r) {
              var t,
                  e = 0;
              t = n + 4 | 0, e = 0, (r = b[r >> 2]) && (Ge(n, !pa(n + 544 | 0), 1024), e = 1), function (n, r) {
                var t, e, i, a;
                t = p[0 | n], e = La(oo(1), 3), i = n, a = La(oo(1), 3) & r << 3 | (-1 ^ e) & t, o[0 | i] = a;
              }(t, e), b[n + 8 >> 2] = r;
            }

            function Ae(n, r) {
              var t, e;
              fn = e = fn - 16 | 0, t = xe(e, n, 1), ho(uu(n), b[t + 4 >> 2], r), b[t + 4 >> 2] = b[t + 4 >> 2] + 4, Wa(t), fn = e + 16 | 0;
            }

            function ce(n, r) {
              r |= 0;
              var t,
                  e = 0;
              e = b[(n |= 0) >> 2], t = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (e = b[b[r >> 2] + e >> 2]), a[e](t);
            }

            function le(n) {
              var r, t, e;
              fn = r = fn - 16 | 0, t = r, e = b[no(r + 8 | 0, 2140081935) >> 2], b[t + 4 >> 2] = e, No(n, r + 4 | 0), fn = r + 16 | 0;
            }

            function se(n) {
              var r, t, e;
              fn = r = fn - 16 | 0, t = r, e = b[no(r + 8 | 0, 2141891242) >> 2], b[t + 4 >> 2] = e, No(n, r + 4 | 0), fn = r + 16 | 0;
            }

            function ve(n, r) {
              var t;
              return n |= 0, fn = t = fn - 16 | 0, hu(t + 8 | 0, r |= 0), n = 0 | a[n](t + 8 | 0), lu(t + 8 | 0), fn = t + 16 | 0, 0 | n;
            }

            function de(n, r, t, e, i, o, u) {
              Vo(p[r + 4 | 0], 4) ? a[b[r + 8 >> 2]](n, r, t, e, i, o, u) : a[b[r + 8 >> 2]](n, r, t, e, i, o);
            }

            function be(n, r, t) {
              var e,
                  i,
                  a,
                  u = 0;
              e = n, i = (n = p[0 | n]) | 1 << r, a = ze(r) & n, u = t ? i : a, o[0 | e] = u;
            }

            function pe(n, r) {
              return 2 == (0 | r) && ((r = n + -2 | 0) >>> 0 > 1 || (n = 3, r - 1 || (n = 2))), n;
            }

            function he(n, r, t, e) {
              var i;
              fn = i = fn - 16 | 0, b[i + 12 >> 2] = e, Qi(n ? b[n + 556 >> 2] : 0, n, r, t, b[i + 12 >> 2]), fn = i + 16 | 0;
            }

            function ye(n, r) {
              var t;
              fn = t = fn - 16 | 0, b[t + 12 >> 2] = b[n >> 2], b[n >> 2] = b[r >> 2], b[r >> 2] = b[t + 12 >> 2], fn = t + 16 | 0;
            }

            function me(n) {
              var r,
                  t = 0;
              return fn = r = fn - 16 | 0, p[b[no(r + 8 | 0, b[n + 4 >> 2]) >> 2]] || (t = function (n) {
                var r = 0;

                n: {
                  if (n = b[n + 8 >> 2], 1 != (0 | (r = p[0 | n]))) {
                    if (2 & r) break n;
                    o[0 | n] = 2, n = 1;
                  } else n = 0;

                  return n;
                }

                W();
              }(n)), fn = r + 16 | 0, t;
            }

            function ke(n, r, t) {
              return t ? (0 | n) == (0 | r) ? 1 : !function (n, r) {
                var t = 0,
                    e = 0;

                n: if (!(!(t = p[0 | n]) | (0 | (e = p[0 | r])) != (0 | t))) for (;;) {
                  if (e = p[r + 1 | 0], !(t = p[n + 1 | 0])) break n;
                  if (r = r + 1 | 0, n = n + 1 | 0, (0 | t) != (0 | e)) break;
                }

                return t - e | 0;
              }(Ve(n), Ve(r)) : b[n + 4 >> 2] == b[r + 4 >> 2];
            }

            function ge(n) {
              var r, t;
              return fn = r = fn - 16 | 0, t = br(ie(576), n), Ye(n, 1, 1296), b[r + 8 >> 2] = n, fn = r + 16 | 0, t;
            }

            function _e(n, r, t) {
              var e;
              return fn = e = fn - 16 | 0, t = xt(Mn(n, r, t), m[lo(e + 8 | 0, vr(n, r)) >> 2]), fn = e + 16 | 0, t;
            }

            function Ce(n, r, t) {
              var e;
              return fn = e = fn - 16 | 0, t = xt(ir(n, r, t), m[lo(e + 8 | 0, sr(n, r)) >> 2]), fn = e + 16 | 0, t;
            }

            function Ee(n) {
              var r,
                  t = 0;

              for (r = n + 8 | 0, t = n; (0 | r) != (0 | (t = po(t) + 4 | 0));) {
                ;
              }

              return n;
            }

            function we(n, r, t, e) {
              var i = 0;
              return i = 0, 2 != (0 | n) | t || (i = 1, r >= e || (i = mt(r, e))), i;
            }

            function Ne(n, r) {
              var t, e, i, a;
              t = p[0 | n], e = La(oo(2), 0), i = n, a = La(oo(2), 0) & r | (-1 ^ e) & t, o[0 | i] = a;
            }

            function We(n, r) {
              var t;
              return fn = t = fn - 16 | 0, m[t >> 2] = r, m[t + 8 >> 2] = n, fn = t + 16 | 0, m[t + 8 >> 2] > m[t >> 2];
            }

            function Ze(n, r) {
              if (b[n + 16 >> 2]) {
                if (Vo(p[n + 4 | 0], 6)) return void a[b[n + 16 >> 2]](n, r);
                a[b[n + 16 >> 2]](n);
              }
            }

            function Te(n, r) {
              var t = _(0);

              return (t = m[wo(Ko(n) + 288 | 0, b[wo(1848, r) >> 2]) >> 2]) >= _(0) & (1 ^ vu(t));
            }

            function Ie(n, r) {
              var t;
              return fn = t = fn - 16 | 0, rr(t + 8 | 0, n), rr(t, r), n = function (n, r) {
                var t,
                    e = 0;
                return (0 | (t = b[n + 4 >> 2])) == b[r + 4 >> 2] && (e = 1, t && (vu(m[n >> 2]) && vu(m[r >> 2]) || (e = _(C(_(m[n >> 2] - m[r >> 2]))) < _(9999999747378752e-20)))), e;
              }(t + 8 | 0, t), fn = t + 16 | 0, n;
            }

            function Re(n) {
              var r;
              fn = r = fn - 16 | 0, b[n >> 2] = 0, b[n + 4 >> 2] = 0, b[r + 12 >> 2] = 0, pu(n + 8 | 0), fn = r + 16 | 0;
            }

            function Be(n, r, t, e) {
              var i;
              fn = i = fn - 16 | 0, e = xe(i, n, e), qe(uu(n), r, t, e + 4 | 0), Wa(e), fn = i + 16 | 0;
            }

            function Ve(n) {
              var r;
              return b[8 + (r = fn - 16 | 0) >> 2] = n, b[r + 12 >> 2] = b[b[r + 8 >> 2] + 4 >> 2], b[r + 12 >> 2];
            }

            function Ge(n, r, t) {
              var e;
              fn = e = fn - 16 | 0, r || (b[e >> 2] = t, he(n, 5, 1864, e), Zi(t)), fn = e + 16 | 0;
            }

            function Fe(n, r) {
              return vu(n) || vu(r) ? vu(n) ? r : n : function (n, r) {
                return (2147483647 & (s(n), u(0))) >>> 0 <= 2139095040 ? (2147483647 & (s(r), u(0))) >>> 0 > 2139095040 ? n : _(N(n, r)) : r;
              }(n, r);
            }

            function Xe(n, r) {
              return vu(n) || vu(r) ? vu(n) ? r : n : function (n, r) {
                return (2147483647 & (s(n), u(0))) >>> 0 <= 2139095040 ? (2147483647 & (s(r), u(0))) >>> 0 > 2139095040 ? n : _(w(n, r)) : r;
              }(n, r);
            }

            function Oe(n) {
              var r;

              for (r = n + 36 | 0; (0 | r) != (0 | (n = po(n) + 4 | 0));) {
                ;
              }
            }

            function Qe(n, r) {
              return pa(n + 544 | 0) >>> 0 <= r >>> 0 && (Y(), W()), b[b[n + 544 >> 2] + (r << 2) >> 2];
            }

            function Ue(n) {
              var r, t;
              return r = ie(8), t = b[n + 4 >> 2], b[r >> 2] = b[n >> 2], b[r + 4 >> 2] = t, r;
            }

            function Ye(n, r, t) {
              var e;
              fn = e = fn - 16 | 0, r || (b[e >> 2] = t, function (n, r) {
                var t;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = r, Qi(n, 0, 5, 1864, r), fn = t + 16 | 0;
              }(n, e), Zi(t)), fn = e + 16 | 0;
            }

            function Pe(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6748, 0, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function De(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6828, 2, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function Se(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6868, 3, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function He(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6908, 4, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function je(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6948, 5, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function Me(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, I(6788, 1, b[r + 12 >> 2]), fn = r + 16 | 0;
            }

            function xe(n, r, t) {
              return b[n >> 2] = r, r = b[r + 4 >> 2], b[n + 4 >> 2] = r, b[n + 8 >> 2] = r + (t << 2), n;
            }

            function Je(n) {
              var r = 0;
              !function (n, r) {
                if (b[n + 8 >> 2] != (0 | r)) for (; b[n + 8 >> 2] = b[n + 8 >> 2] + -4, b[n + 8 >> 2] != (0 | r);) {
                  ;
                }
              }(n, b[n + 4 >> 2]), b[n >> 2] && (r = b[n >> 2], b[eu(n) >> 2], dn(r));
            }

            function $e(n) {
              var r;
              fn = r = fn - 16 | 0, b[r + 12 >> 2] = 0, b[n >> 2] = b[r + 12 >> 2], fn = r + 16 | 0;
            }

            function ze(n) {
              var r;
              return (-1 >>> (r = 31 & n) & -2) << r | (-1 << (n = 0 - n & 31) & -2) >>> n;
            }

            function Le(n, r, t, e) {
              n = t - r | 0, t = b[e >> 2] - n | 0, b[e >> 2] = t, (0 | n) >= 1 && _n(t, r, n);
            }

            function Ke(n) {
              var r;
              return fn = r = fn - 16 | 0, n = b[no(r + 8 | 0, n) >> 2], fn = r + 16 | 0, n;
            }

            function qe(n, r, t, e) {
              (0 | (n = t - r | 0)) >= 1 && (_n(b[e >> 2], r, n), b[e >> 2] = b[e >> 2] + n);
            }

            function ni(n) {
              var r = 0;
              Wo(n), b[n >> 2] && (iu(n), r = b[n >> 2], ca(n), dn(r));
            }

            function ri(n, r) {
              return b[n + 12 >> 2] = 0, b[n + 4 >> 2] = r, b[n >> 2] = r, b[n + 8 >> 2] = r + 1, n;
            }

            function ti(n, r, t) {
              r = ko(r + 560 | 0, t), t = b[r + 4 >> 2], b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = t;
            }

            function ei(n, r, t) {
              var e, i;
              e = n, i = b[Qo(b[r >> 2] + 172 | 0, t) >> 2], b[e >> 2] = i;
            }

            function ii(n, r, t) {
              var e, i;
              e = n, i = b[Qo(b[r >> 2] + 180 | 0, t) >> 2], b[e >> 2] = i;
            }

            function ai(n, r) {
              vu(r) || Ti(r) ? _u(n) : xn(n, r);
            }

            function oi(n, r) {
              vu(r) || Ti(r) ? _u(n) : $n(n, r);
            }

            function ui(n) {
              var r;
              Gi(r = 0 | x(8), n), b[r >> 2] = 7964, M(0 | r, 7996, 1), W();
            }

            function fi(n) {
              var r;
              return fn = r = fn - 16 | 0, n = me(ri(r, n)), fn = r + 16 | 0, n;
            }

            function Ai(n, r, t) {
              1 == b[n + 28 >> 2] | b[n + 4 >> 2] != (0 | r) || (b[n + 28 >> 2] = t);
            }

            function ci(n, r) {
              return n = pa(Lo(n)) >>> 0 > r >>> 0 ? Qe(n, r) : 0;
            }

            function li(n, r) {
              b[n + 4 >> 2] == b[uu(n) >> 2] ? function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 32 | 0, e = uu(n), e = Fr(t + 8 | 0, Pr(n, pa(n) + 1 | 0), pa(n), e), ho(0, b[e + 8 >> 2], r), b[e + 8 >> 2] = b[e + 8 >> 2] + 4, wt(n, e), Je(e), fn = t + 32 | 0;
              }(n, r) : Ae(n, r);
            }

            function si(n, r) {
              (function (n, r) {
                var t,
                    e = 0,
                    i = 0,
                    a = 0;
                fn = t = fn - 48 | 0;

                n: if ((0 | qa(n)) == (0 | qa(r)) && (0 | ro(n)) == (0 | ro(r)) && (0 | eo(n)) == (0 | eo(r)) && (0 | io(n)) == (0 | io(r)) && (0 | Ya(n)) == (0 | Ya(r)) && (0 | Ja(n)) == (0 | Ja(r)) && (0 | $a(n)) == (0 | $a(r)) && (0 | Sa(n)) == (0 | Sa(r)) && (0 | Ha(n)) == (0 | Ha(r)) && (0 | Da(n)) == (0 | Da(r)) && (Ka(t + 40 | 0, n), Ka(t + 32 | 0, r), b[t + 12 >> 2] = b[t + 40 >> 2], b[t + 8 >> 2] = b[t + 32 >> 2], Ie(t + 12 | 0, t + 8 | 0) && yr(nu(n), nu(r)) && yr(ou(n), ou(r)) && yr(tu(n), tu(r)) && yr(xo(n), xo(r)) && kr(Mo(n), Mo(r)) && kr(zo(n), zo(r))) ? (e = 0, kr(Jo(n), Jo(r)) && (m[t + 24 >> 2] = m[n + 4 >> 2], e = Eo(t + 24 | 0), m[t + 16 >> 2] = m[r + 4 >> 2], e = Eo(t + 16 | 0) ^ e ^ 1)) : e = 0, e && (m[t + 24 >> 2] = m[n + 4 >> 2], (Eo(t + 24 | 0) || (m[t + 16 >> 2] = m[r + 4 >> 2], Eo(t + 16 | 0) || ct(m[n + 4 >> 2], m[r + 4 >> 2]))) && (m[t + 24 >> 2] = m[n + 8 >> 2], e = Eo(t + 24 | 0), m[t + 16 >> 2] = m[r + 8 >> 2], (0 | Eo(t + 16 | 0)) == (0 | e) && (m[t + 24 >> 2] = m[n + 8 >> 2], (Eo(t + 24 | 0) || ct(m[n + 8 >> 2], m[r + 8 >> 2])) && (m[t + 24 >> 2] = m[n + 12 >> 2], e = Eo(t + 24 | 0), m[t + 16 >> 2] = m[r + 12 >> 2], (0 | Eo(t + 16 | 0)) == (0 | e)))))) {
                  if (m[t + 24 >> 2] = m[r + 12 >> 2], e = 1, Eo(t + 24 | 0)) break n;
                  e = ct(m[n + 12 >> 2], m[r + 12 >> 2]);
                } else e = 0;

                m[t + 24 >> 2] = m[n + 188 >> 2];

                n: {
                  r: {
                    if (Eo(t + 24 | 0)) {
                      if (m[t + 16 >> 2] = m[r + 188 >> 2], a = e & (i = Eo(t + 16 | 0)), i) break n;
                      if (e) break r;
                      break n;
                    }

                    if (!e) break n;
                  }

                  a = ct(m[n + 188 >> 2], m[r + 188 >> 2]);
                }

                return fn = t + 48 | 0, a;
              })(au(n), au(r)) || (_n(n + 24 | 0, au(r), 192), bt(n));
            }

            function vi(n) {
              (n |= 0) && (Er(b[n >> 2]), gu(n + 8 | 0), gu(n + 4 | 0), dn(n));
            }

            function di(n, r) {
              var t;
              t = b[n >> 2], b[n >> 2] = r, t && t && dn(t);
            }

            function bi(n, r) {
              return We(n, r) ? 1 : ct(n, r);
            }

            function pi(n) {
              return 1073741823 < n >>> 0 && (ui(1204), W()), ie(n << 2);
            }

            function hi(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 504 | 0, t), i = r, m[e >> 2] = i;
            }

            function yi(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 216 | 0, t), i = r, m[e >> 2] = i;
            }

            function mi(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 232 | 0, t), i = r, m[e >> 2] = i;
            }

            function ki(n, r) {
              return (0 | n) <= 2 ? b[(n << 2) + (r ? 2008 : 1956) >> 2] : 1705;
            }

            function gi(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 240 | 0, t), i = r, m[e >> 2] = i;
            }

            function _i(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 256 | 0, t), i = r, m[e >> 2] = i;
            }

            function Ci(n, r, t) {
              var e,
                  i = _(0);

              e = wo(n + 272 | 0, t), i = r, m[e >> 2] = i;
            }

            function Ei() {
              var n;
              return n = ie(8), b[n >> 2] = 0, b[n + 4 >> 2] = 0, 0 | n;
            }

            function wi() {
              var n;
              return n = function (n) {
                return b[n + 24 >> 2] = 0, o[n + 20 | 0] = 0, b[n + 16 >> 2] = 1065353216, d[n + 10 >> 1] = 0, d[n + 12 >> 1] = 0, b[n >> 2] = 0, o[n + 9 | 0] = 0, b[n + 4 >> 2] = 2, n;
              }(ie(28)), b[2360] = b[2360] + 1, n;
            }

            function Ni(n, r, t) {
              return n = 1 == (0 | n) ? mt(r, t) : 0;
            }

            function Wi(n) {
              var r;
              fn = r = fn - 16 | 0, function (n) {
                var r, t;
                fn = r = fn - 16 | 0, t = b[no(r + 8 | 0, b[n + 4 >> 2]) >> 2], o[0 | t] = 1, o[b[n + 8 >> 2]] = 1, fn = r + 16 | 0;
              }(ri(r, n)), fn = r + 16 | 0;
            }

            function Zi(n) {
              var r;
              Gi(r = 0 | x(8), n), M(0 | r, 7944, 1), W();
            }

            function Ti(n) {
              return 2139095040 == (2147483647 & (s(n), u(0)));
            }

            function Ii(n, r, t) {
              n |= 0, r |= 0, t = _(t), m[b[n >> 2] + r >> 2] = t;
            }

            function Ri(n, r, t) {
              return 0 | ke(n |= 0, r |= 0, 0);
            }

            function Bi(n) {
              var r;
              return r = ie(4), b[r >> 2] = b[n >> 2], r;
            }

            function Vi(n, r) {
              return r |= 0, _(m[b[(n |= 0) >> 2] + r >> 2]);
            }

            function Gi(n, r) {
              b[n >> 2] = 7872, b[n >> 2] = 7916, function (n, r) {
                var t, e, i, a;
                e = ie((t = or(r)) + 13 | 0), b[e + 8 >> 2] = 0, b[e + 4 >> 2] = t, b[e >> 2] = t, i = n, a = _n(e + 12 | 0, r, t + 1 | 0), b[i >> 2] = a;
              }(n + 4 | 0, r);
            }

            function Fi(n) {
              be(n + 4 | 0, 2, 1), function (n, r) {
                var t;
                if (fn = t = fn - 16 | 0, b[t >> 2] = r, b[t + 8 >> 2] = n, ba(t + 8 | 0, t)) for (; Fi(b[b[t + 8 >> 2] >> 2]), Zo(t + 8 | 0), ba(t + 8 | 0, t);) {
                  ;
                }
                fn = t + 16 | 0;
              }(mo(n = n + 544 | 0), to(n));
            }

            function Xi(n) {
              return b[(n |= 0) >> 2] = 7916, function (n) {
                var r;
                n = b[n >> 2] + -12 | 0, r = b[n + 8 >> 2] + -1 | 0, b[n + 8 >> 2] = r, (0 | r) <= -1 && dn(n);
              }(n + 4 | 0), 0 | n;
            }

            function Oi(n, r) {
              return n = So(n) ? pe(2, r) : 0;
            }

            function Qi(n, r, t, e, i) {
              n || (n = ee()), function (n, r, t, e, i, o) {
                p[n + 9 | 0] ? a[b[n + 4 >> 2]](r, t, e, 0, i, o) : a[b[n + 4 >> 2]](r, t, e, i, o);
              }(n, n, r, t, e, i);
            }

            function Ui(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 16, b[n >> 2] = r;
            }

            function Yi(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 21, b[n >> 2] = r;
            }

            function Pi(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 13, b[n >> 2] = r;
            }

            function Di(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 10, b[n >> 2] = r;
            }

            function Si(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 19, b[n >> 2] = r;
            }

            function Hi(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 17, b[n >> 2] = r;
            }

            function ji(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 4, b[n >> 2] = r;
            }

            function Mi(n, r, t) {
              r = b[r >> 2], b[n + 4 >> 2] = t, b[n >> 2] = r;
            }

            function xi(n, r) {
              m[b[n >> 2] >> 2] = r, b[n >> 2] = b[n >> 2] + 8;
            }

            function Ji(n, r) {
              b[b[n >> 2] >> 2] = r, b[n >> 2] = b[n >> 2] + 8;
            }

            function $i(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 2, b[n >> 2] = r;
            }

            function zi(n, r) {
              r |= 0, b[4 + (n |= 0) >> 2] = 7, b[n >> 2] = r;
            }

            function Li(n) {
              return ga(b[b[n >> 2] >> 2], b[n + 4 >> 2]);
            }

            function Ki(n) {
              return ma(b[b[n >> 2] >> 2], b[n + 4 >> 2]);
            }

            function qi(n) {
              return _a(b[b[n >> 2] >> 2], b[n + 4 >> 2]);
            }

            function na(n) {
              return ya(b[b[n >> 2] >> 2], b[n + 4 >> 2]);
            }

            function ra(n) {
              return ka(b[b[n >> 2] >> 2], b[n + 4 >> 2]);
            }

            function ta(n) {
              return n ? (b[2373] = n, -1) : 0;
            }

            function ea(n, r, t) {
              return xt(Ar(n, r, t), cr(n, r, t));
            }

            function ia(n, r) {
              return n ? function (n, r) {
                n: {
                  if (n) {
                    if (r >>> 0 <= 127) break n;

                    if (b[b[2344] >> 2]) {
                      if (r >>> 0 <= 2047) return o[n + 1 | 0] = 63 & r | 128, o[0 | n] = r >>> 6 | 192, 2;
                      if (!(57344 != (-8192 & r) && r >>> 0 >= 55296)) return o[n + 2 | 0] = 63 & r | 128, o[0 | n] = r >>> 12 | 224, o[n + 1 | 0] = r >>> 6 & 63 | 128, 3;
                      if (r + -65536 >>> 0 <= 1048575) return o[n + 3 | 0] = 63 & r | 128, o[0 | n] = r >>> 18 | 240, o[n + 2 | 0] = r >>> 6 & 63 | 128, o[n + 1 | 0] = r >>> 12 & 63 | 128, 4;
                    } else if (57216 == (-128 & r)) break n;

                    b[2373] = 25, n = -1;
                  } else n = 1;

                  return n;
                }

                return o[0 | n] = r, 1;
              }(n, r) : 0;
            }

            function aa(n, r, t) {
              32 & p[0 | n] || nr(r, t, n);
            }

            function oa(n, r) {
              return r |= 0, 0 | a[n |= 0](r);
            }

            function ua(n) {
              return b[b[(n |= 0) >> 2] + -4 >> 2];
            }

            function fa(n) {
              return n >>> 0 > 60 ? 1868 : 1928 - n | 0;
            }

            function Aa(n) {
              return m[wo(Ko(n) + 16 | 0, 1) >> 2];
            }

            function ca(n) {
              return b[uu(n) >> 2] - b[n >> 2] >> 2;
            }

            function la(n) {
              return m[wo(Ko(n) + 16 | 0, 0) >> 2];
            }

            function sa(n) {
              return go(n) && (n = b[n >> 2]), n;
            }

            function va(n, r) {
              r |= 0, a[b[(n |= 0) >> 2]](r);
            }

            function da(n, r) {
              b[n >> 2] = b[r >> 2], b[r >> 2] = 0;
            }

            function ba(n, r) {
              return b[n >> 2] == b[r >> 2] ^ 1;
            }

            function pa(n) {
              return b[n + 4 >> 2] - b[n >> 2] >> 2;
            }

            function ha(n, r) {
              return b[n >> 2] - b[r >> 2] >> 2;
            }

            function ya(n, r) {
              return (La(oo(1), r) & n) >> r;
            }

            function ma(n, r) {
              return (La(oo(5), r) & n) >> r;
            }

            function ka(n, r) {
              return (La(oo(7), r) & n) >> r;
            }

            function ga(n, r) {
              return (La(oo(3), r) & n) >> r;
            }

            function _a(n, r) {
              return (La(oo(2), r) & n) >> r;
            }

            function Ca(n) {
              return 2141891242 == b[n >> 2];
            }

            function Ea(n, r) {
              return b[n >> 2] = b[r >> 2], n;
            }

            function wa(n, r) {
              return p[0 | $o(n + 20 | 0, r)];
            }

            function Na(n, r) {
              !function (n, r, t) {
                var e, i, a, o;
                e = b[n >> 2], i = La(oo(3), r), a = n, o = La(oo(3), r) & t << r | (-1 ^ i) & e, b[a >> 2] = o;
              }(b[n >> 2], b[n + 4 >> 2], r);
            }

            function Wa(n) {
              b[b[n >> 2] + 4 >> 2] = b[n + 4 >> 2];
            }

            function Za(n, r) {
              !function (n, r, t) {
                var e, i, a, o;
                e = b[n >> 2], i = La(oo(7), r), a = n, o = La(oo(7), r) & t << r | (-1 ^ i) & e, b[a >> 2] = o;
              }(b[n >> 2], b[n + 4 >> 2], r);
            }

            function Ta(n, r) {
              return b[n >> 2] + (r << 2) | 0;
            }

            function Ia(n) {
              return m[wo(Ko(n), 0) >> 2];
            }

            function Ra(n) {
              return m[wo(Ko(n), 1) >> 2];
            }

            function Ba(n) {
              return m[wo(Ko(n), 2) >> 2];
            }

            function Va(n) {
              return m[wo(Ko(n), 3) >> 2];
            }

            function Ga(n, r) {
              return y[n >> 2] < y[r >> 2];
            }

            function Fa(n, r) {
              b[n + 4 >> 2] = 0, b[n >> 2] = r;
            }

            function Xa(n) {
              return Vo(p[n + 72 | 0], 4);
            }

            function Oa(n) {
              return Vo(p[n + 72 | 0], 2);
            }

            function Qa(n) {
              return _a(p[n + 72 | 0], 0);
            }

            function Ua(n, r) {
              r |= 0, a[n |= 0](r);
            }

            function Ya(n) {
              return ka(b[n >> 2], 10);
            }

            function Pa(n) {
              return Vo(p[n + 4 | 0], 2);
            }

            function Da(n) {
              return ya(b[n >> 2], 21);
            }

            function Sa(n) {
              return _a(b[n >> 2], 17);
            }

            function Ha(n) {
              return _a(b[n >> 2], 19);
            }

            function ja(n) {
              return Vo(p[n + 4 | 0], 1);
            }

            function Ma(n, r) {
              pa(n), zt(n, r), cu(n);
            }

            function xa(n) {
              return 0 | a[n |= 0]();
            }

            function Ja(n) {
              return ka(b[n >> 2], 13);
            }

            function $a(n) {
              return ya(b[n >> 2], 16);
            }

            function za(n) {
              To(n = n + 544 | 0), function (n) {
                var r,
                    t = 0;
                fn = r = fn - 32 | 0, ca(n) >>> 0 > pa(n) >>> 0 && (t = uu(n), wt(n, n = Fr(r + 8 | 0, pa(n), pa(n), t)), Je(n)), fn = r + 32 | 0;
              }(n);
            }

            function La(n, r) {
              return (-1 << n ^ -1) << r;
            }

            function Ka(n, r) {
              b[n >> 2] = b[r + 16 >> 2];
            }

            function qa(n) {
              return _a(b[n >> 2], 0);
            }

            function no(n, r) {
              return b[n >> 2] = r, n;
            }

            function ro(n) {
              return ga(b[n >> 2], 2);
            }

            function to(n) {
              return Ke(b[n + 4 >> 2]);
            }

            function eo(n) {
              return ma(b[n >> 2], 4);
            }

            function io(n) {
              return ka(b[n >> 2], 7);
            }

            function ao(n, r) {
              return g(r, 24) + n | 0;
            }

            function oo(n) {
              return n ? 32 - E(n) | 0 : 0;
            }

            function uo(n, r, t) {
              return function (n, r, t) {
                var e,
                    i = 0,
                    u = 0,
                    f = 0;
                return fn = e = fn - 208 | 0, b[e + 204 >> 2] = t, t = 0, Zn(e + 160 | 0, 0, 40), b[e + 200 >> 2] = b[e + 204 >> 2], (0 | vn(0, r, e + 200 | 0, e + 80 | 0, e + 160 | 0)) < 0 ? r = -1 : (t = b[n + 76 >> 2] >= 0 ? 1 : t, i = b[n >> 2], o[n + 74 | 0] <= 0 && (b[n >> 2] = -33 & i), f = 32 & i, b[n + 48 >> 2] ? r = vn(n, r, e + 200 | 0, e + 80 | 0, e + 160 | 0) : (b[n + 48 >> 2] = 80, b[n + 16 >> 2] = e + 80, b[n + 28 >> 2] = e, b[n + 20 >> 2] = e, i = b[n + 44 >> 2], b[n + 44 >> 2] = e, r = u = vn(n, r, e + 200 | 0, e + 80 | 0, e + 160 | 0), i && (a[b[n + 36 >> 2]](n, 0, 0), b[n + 48 >> 2] = 0, b[n + 44 >> 2] = i, b[n + 28 >> 2] = 0, b[n + 16 >> 2] = 0, r = b[n + 20 >> 2], b[n + 20 >> 2] = 0, r = r ? u : -1)), u = n, n = b[n >> 2], b[u >> 2] = n | f, r = 32 & n ? -1 : r), fn = e + 208 | 0, r;
              }(n, r, t);
            }

            function fo(n) {
              return n + -48 >>> 0 < 10;
            }

            function Ao(n, r, t) {
              return function (n, r, t) {
                var e = 0,
                    i = 0,
                    a = 0,
                    o = 0,
                    u = 0,
                    f = 0,
                    A = 0,
                    c = 0,
                    l = 0;

                n: {
                  r: {
                    t: {
                      e: {
                        i: {
                          a: {
                            o: {
                              u: {
                                f: {
                                  if (i = r) {
                                    if (!(e = t)) break f;
                                    break u;
                                  }

                                  return fu((r = n) - g(n = (n >>> 0) / (t >>> 0) | 0, t) | 0, 0), An = 0, n;
                                }

                                if (!n) break o;
                                break a;
                              }

                              if (!((o = e + -1 | 0) & e)) break i;
                              u = 0 - (o = (E(e) + 33 | 0) - E(i) | 0) | 0;
                              break t;
                            }

                            return fu(0, i - g(n = (i >>> 0) / 0 | 0, 0) | 0), An = 0, n;
                          }

                          if ((e = 32 - E(i) | 0) >>> 0 < 31) break e;
                          break r;
                        }

                        if (fu(n & o, 0), 1 == (0 | e)) break n;
                        return t = 31 & (e = e ? 31 - E(e + -1 ^ e) | 0 : 32), 32 <= (63 & e) >>> 0 ? (i = 0, n = r >>> t | 0) : (i = r >>> t | 0, n = ((1 << t) - 1 & r) << 32 - t | n >>> t), An = i, n;
                      }

                      o = e + 1 | 0, u = 63 - e | 0;
                    }

                    if (e = r, a = 31 & (i = 63 & o), 32 <= i >>> 0 ? (i = 0, a = e >>> a | 0) : (i = e >>> a | 0, a = ((1 << a) - 1 & e) << 32 - a | n >>> a), e = 31 & (u &= 63), 32 <= u >>> 0 ? (r = n << e, n = 0) : (r = (1 << e) - 1 & n >>> 32 - e | r << e, n <<= e), o) for (e = -1, (u = t + -1 | 0) >>> 0 < 4294967295 && (e = 0); a = (A = f = a << 1 | r >>> 31) - (c = t & (f = e - ((i = i << 1 | a >>> 31) + (u >>> 0 < f >>> 0) | 0) >> 31)) | 0, i = i - (A >>> 0 < c >>> 0) | 0, r = r << 1 | n >>> 31, n = l | n << 1, l = f &= 1, o = o + -1 | 0;) {
                      ;
                    }
                    return fu(a, i), An = r << 1 | n >>> 31, f | n << 1;
                  }

                  fu(n, r), n = 0, r = 0;
                }

                return An = r, n;
              }(n, r, t);
            }

            function co(n, r, t) {
              return function (n, r, t) {
                var e,
                    i,
                    a,
                    o,
                    u = 0;
                return o = g(e = t >>> 16 | 0, u = n >>> 16 | 0), n = (65535 & (u = ((a = g(i = 65535 & t, n &= 65535)) >>> 16 | 0) + g(u, i) | 0)) + g(n, e) | 0, An = o + g(r, t) + (u >>> 16) + (n >>> 16) | 0, 65535 & a | n << 16;
              }(n, r, t);
            }

            function lo(n, r) {
              return m[n >> 2] = r, n;
            }

            function so(n) {
              return ni(n + 544 | 0), n;
            }

            function vo(n, r, t) {
              return function (n, r, t) {
                var e;
                return e = (r = r - n | 0) >> 2, r && Nn(t, n, r), (e << 2) + t | 0;
              }(n, r, t);
            }

            function bo(n) {
              return 0 != b[n + 8 >> 2];
            }

            function po(n) {
              return lo(n, _(Z)), n;
            }

            function ho(n, r, t) {
              b[r >> 2] = b[t >> 2];
            }

            function yo(n, r) {
              return 1 ^ ct(n, r);
            }

            function mo(n) {
              return Ke(b[n >> 2]);
            }

            function ko(n, r) {
              return (r << 3) + n | 0;
            }

            function go(n) {
              return o[n + 11 | 0] < 0;
            }

            function _o(n) {
              return m[n >> 2] = Z, n;
            }

            function Co(n) {
              (n |= 0) && dn(n);
            }

            function Eo(n) {
              return vu(m[n >> 2]);
            }

            function wo(n, r) {
              return (r << 2) + n | 0;
            }

            function No(n, r) {
              b[n >> 2] = b[r >> 2];
            }

            function Wo(n) {
              ca(n), pa(n), ca(n);
            }

            function Zo(n) {
              b[n >> 2] = b[n >> 2] + 4;
            }

            function To(n) {
              pa(n), iu(n), cu(n);
            }

            function Io(n, r) {
              Yt(b[n + 8 >> 2], r);
            }

            function Ro(n, r) {
              be(n + 288 | 0, 4, r);
            }

            function Bo(n, r) {
              return function (n, r) {
                var t, e;
                return fn = t = fn - 16 | 0, e = Ga(n, r), fn = t + 16 | 0, e ? r : n;
              }(n, r);
            }

            function Vo(n, r) {
              return n >>> r & 1;
            }

            function Go(n) {
              o[4 + (n |= 0) | 0] = 1;
            }

            function Fo(n) {
              return 0 | (n |= 0);
            }

            function Xo(n) {
              return pa(Lo(n));
            }

            function Oo() {
              b[2363] = b[2363] + 1;
            }

            function Qo(n, r) {
              return wo(n, r);
            }

            function Uo(n, r) {
              b[n + 540 >> 2] = r;
            }

            function Yo(n) {
              return 2 == (-2 & n);
            }

            function Po(n, r) {
              m[n + 296 >> 2] = r;
            }

            function Do(n, r) {
              b[n + 292 >> 2] = r;
            }

            function So(n) {
              return n >>> 0 < 2;
            }

            function Ho(n, r) {
              b[n + 20 >> 2] = r;
            }

            function jo(n) {
              return Re(n), n;
            }

            function Mo(n) {
              return n + 164 | 0;
            }

            function xo(n) {
              return n + 128 | 0;
            }

            function Jo(n) {
              return n + 180 | 0;
            }

            function $o(n, r) {
              return n + r | 0;
            }

            function zo(n) {
              return n + 172 | 0;
            }

            function Lo(n) {
              return n + 544 | 0;
            }

            function Ko(n) {
              return n + 216 | 0;
            }

            function qo(n, r) {
              ca(n), ca(n);
            }

            function nu(n) {
              return n + 20 | 0;
            }

            function ru(n) {
              be(n + 4 | 0, 0, 1);
            }

            function tu(n) {
              return n + 92 | 0;
            }

            function eu(n) {
              return n + 12 | 0;
            }

            function iu(n) {
              zt(n, b[n >> 2]);
            }

            function au(n) {
              return n + 24 | 0;
            }

            function ou(n) {
              return n + 56 | 0;
            }

            function uu(n) {
              return n + 8 | 0;
            }

            function fu(n, r) {
              l(0 | n, 0 | r);
            }

            function Au(n) {
              dn(n |= 0);
            }

            function cu(n) {
              ca(n), pa(n);
            }

            function lu(n) {
              un(b[n >> 2]);
            }

            function su() {
              ui(7757), W();
            }

            function vu(n) {
              return n != n;
            }

            function du(n) {
              ni(n + 20 | 0);
            }

            function bu(n, r) {
              !function (n, r) {
                var t;
                fn = t = fn - 16 | 0, be(n + 4 | 0, 4, 0), b[t + 4 >> 2] = r, b[t + 8 >> 2] = r, fe(n, t + 4 | 0), fn = t + 16 | 0;
              }(n, r);
            }

            function pu(n) {
              b[n >> 2] = 0;
            }

            function hu(n, r) {
              mu(n, r);
            }

            function yu(n, r) {
              !function (n, r) {
                var t,
                    e = 0,
                    i = 0;
                ne(n), b[n >> 2] = b[r >> 2], b[n + 4 >> 2] = b[r + 4 >> 2], t = b[uu(r) >> 2], e = uu(n), i = t, b[e >> 2] = i, e = uu(r), i = 0, b[e >> 2] = i, b[r >> 2] = 0, b[r + 4 >> 2] = 0;
              }(n, r);
            }

            function mu(n, r) {
              no(n, r);
            }

            function ku(n) {
              o[0 | n] = 0;
            }

            function gu(n) {
              di(n, 0);
            }

            function _u(n) {
              po(n);
            }

            function Cu(n) {}

            function Eu(n) {
              Ee(n);
            }

            function wu() {
              return e.byteLength / 65536 | 0;
            }

            return a[1] = Xi, a[2] = function (n, r, t, e, i) {
              return e |= 0, i |= 0, (t |= 0) && 5 != (0 | t) ? 0 | uo(b[1918], e, i) : 0 | uo(b[1779], e, i);
            }, a[3] = $i, a[4] = ji, a[5] = zi, a[6] = Di, a[7] = Pi, a[8] = Ui, a[9] = Hi, a[10] = Si, a[11] = Yi, a[12] = Fo, a[13] = Fo, a[14] = Fo, a[15] = Fo, a[16] = Fo, a[17] = Fo, a[18] = Fo, a[19] = Fo, a[20] = Fo, a[21] = Fo, a[22] = Fo, a[23] = Fo, a[24] = Et, a[25] = function (n, r, t, e, i, o) {
              var u;
              n |= 0, r |= 0, t = _(t), e |= 0, i = _(i), o |= 0, u = n, n = b[b[r >> 2] + 4 >> 2], a[b[b[n >> 2] >> 2]](u, n, _(+t), e, _(+i), o);
            }, a[26] = function (n) {
              n = b[b[(n |= 0) >> 2] + 8 >> 2], a[b[b[n >> 2] >> 2]](n);
            }, a[27] = function (n) {
              return 3848;
            }, a[28] = function (n) {
              var r = 0;
              (n |= 0) && ((r = b[n >> 2]) && dn(r), b[2360] = b[2360] + -1, dn(n));
            }, a[29] = function () {
              var n, r, t;
              return r = n = ie(4), t = wi(), b[r >> 2] = t, 0 | n;
            }, a[30] = xa, a[31] = function (n, r, t) {
              var e, i;
              r |= 0, t |= 0, e = $o(b[(n |= 0) >> 2] + 20 | 0, r), i = t, o[0 | e] = i;
            }, a[32] = function (n, r) {
              n |= 0, r = _(r), Ye(n = b[n >> 2], r >= _(0), 1804), m[n + 16 >> 2] = r == _(0) ? _(0) : r;
            }, a[33] = function (n, r) {
              return r |= 0, 0 | wa(b[(n |= 0) >> 2], r);
            }, a[34] = Dt, a[35] = function (n, r, t) {
              n |= 0, r |= 0, t = _(t);
              var e,
                  i = 0;
              i = b[n >> 2], e = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (i = b[i + b[r >> 2] >> 2]), a[i](e, t);
            }, a[36] = St, a[37] = function () {
              return 0 | Zn(ie(48), 0, 48);
            }, a[38] = Co, a[39] = function (n, r) {
              return r |= 0, +k[b[(n |= 0) >> 2] + r >> 3];
            }, a[40] = function (n, r, t) {
              r |= 0, t = +t, k[b[(n |= 0) >> 2] + r >> 3] = t;
            }, a[41] = ua, a[42] = Co, a[43] = ua, a[44] = function (n) {
              var r = 0;
              (n |= 0) && (r = n, b[n >> 2] = 4248, p[n + 4 | 0] && Io(r, 4252), lu(r + 8 | 0), dn(n));
            }, a[45] = ve, a[46] = function (n) {
              var r;
              return n |= 0, function (n, r) {
                b[n >> 2] = 0, b[n >> 2] = 4588, ku(n + 4 | 0), b[n >> 2] = 4248, da(n + 8 | 0, r);
              }(r = ie(12), n), b[r >> 2] = 4576, 0 | r;
            }, a[47] = function (n, r, t) {
              var e, i;
              return n |= 0, t |= 0, fn = i = (fn = e = fn - 32 | 0) - 16 | 0, function (n, r, t) {
                var e,
                    i = 0,
                    a = 0;
                if (fn = e = fn - 16 | 0, 4294967279 >= t >>> 0) return t >>> 0 <= 10 ? (o[n + 11 | 0] = t, i = n) : (4294967295 < (i = a = function (n) {
                  var r = 0;
                  return n = n >>> 0 >= 11 ? 11 == (0 | (n = (r = n + 16 & -16) - 1 | 0)) ? r : n : 10;
                }(t) + 1 | 0) >>> 0 && (ui(7689), W()), i = ie(i), b[n >> 2] = i, b[n + 8 >> 2] = -2147483648 | a, b[n + 4 >> 2] = t), a = i, n = t, t && _n(a, r, n), o[e + 15 | 0] = 0, o[t + i | 0] = p[e + 15 | 0], void (fn = e + 16 | 0);
                ui(7676), W();
              }(e + 8 | 0, 4 + (r |= 0) | 0, b[r >> 2]), fn = i + 16 | 0, hu(e, t), a[n](e + 24 | 0, e + 8 | 0, e), tn(b[e + 24 >> 2]), n = b[e + 24 >> 2], lu(e + 24 | 0), lu(e), go(e + 8 | 0) && dn(b[e + 8 >> 2]), fn = e + 32 | 0, 0 | n;
            }, a[48] = function (n, r, t) {
              t |= 0, mu(n |= 0, 0 | j(0 | sa(r |= 0), 4416, b[t >> 2]));
            }, a[49] = ua, a[50] = Co, a[51] = ua, a[52] = function (n) {
              var r = 0;
              (n |= 0) && (r = n, b[n >> 2] = 4876, p[n + 4 | 0] && Io(r, 4252), lu(r + 8 | 0), dn(n));
            }, a[53] = ve, a[54] = function (n) {
              var r;
              return n |= 0, function (n, r) {
                b[n >> 2] = 0, b[n >> 2] = 5120, ku(n + 4 | 0), b[n >> 2] = 4876, da(n + 8 | 0, r);
              }(r = ie(12), n), b[r >> 2] = 5108, 0 | r;
            }, a[55] = function (n, r, t) {
              t |= 0, mu(n |= 0, 0 | j(0 | sa(r |= 0), 4984, b[t >> 2]));
            }, a[56] = function (n) {
              return 5176;
            }, a[57] = vi, a[58] = function () {
              return 0 | $t(ie(12), 0);
            }, a[59] = xa, a[60] = oa, a[61] = function (n) {
              return n |= 0, 0 | $t(ie(12), n);
            }, a[62] = Ua, a[63] = vi, a[64] = function (n) {
              di(4 + (n |= 0) | 0, 0), di(n + 8 | 0, 0), jr(b[n >> 2]);
            }, a[65] = function (n, r) {
              r |= 0, si(b[(n |= 0) >> 2], b[r >> 2]);
            }, a[66] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 8, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, qr(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[67] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, oi(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 16, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Tr(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[68] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, ai(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 16, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Tr(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[69] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 5, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, rt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[70] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 6, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, rt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[71] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 7, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, rt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[72] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 3, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, ot(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[73] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 9, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, nt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[74] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 4, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, tt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[75] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, oi(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 17, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Ir(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[76] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, ai(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 17, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Ir(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[77] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 32 | 0, se(t + 24 | 0), b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 17, b[t + 4 >> 2] = b[t + 24 >> 2], e = b[t + 20 >> 2], b[t + 8 >> 2] = b[t + 16 >> 2], b[t + 12 >> 2] = e, Ir(n, t + 8 | 0, r, t + 4 | 0), fn = t + 32 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[78] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 10, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, nt(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[79] = function (n, r) {
              r |= 0, function (n, r) {
                var t, e;
                fn = t = fn - 16 | 0, b[t + 12 >> 2] = 0, b[t + 8 >> 2] = 11, e = b[t + 12 >> 2], b[t >> 2] = b[t + 8 >> 2], b[t + 4 >> 2] = e, qr(n, t, r), fn = t + 16 | 0;
              }(b[(n |= 0) >> 2], r);
            }, a[80] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 32 | 0, e = lo(t + 24 | 0, r), b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 12, r = m[e >> 2], e = b[t + 20 >> 2], b[t + 8 >> 2] = b[t + 16 >> 2], b[t + 12 >> 2] = e, et(n, t + 8 | 0, r), fn = t + 32 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[81] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 15, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Ur(n, t + 16 | 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[82] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 15, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Ur(n, t + 16 | 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[83] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 32 | 0, e = lo(t + 24 | 0, r), b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 13, r = m[e >> 2], e = b[t + 20 >> 2], b[t + 8 >> 2] = b[t + 16 >> 2], b[t + 12 >> 2] = e, it(n, t + 8 | 0, r), fn = t + 32 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[84] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 32 | 0, e = lo(t + 24 | 0, r), b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 14, r = m[e >> 2], e = b[t + 20 >> 2], b[t + 8 >> 2] = b[t + 16 >> 2], b[t + 12 >> 2] = e, at(n, t + 8 | 0, r), fn = t + 32 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[85] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 21, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Br(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[86] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 21, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Br(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[87] = function (n) {
              !function (n) {
                var r, t;
                fn = r = fn - 32 | 0, se(r + 24 | 0), b[r + 20 >> 2] = 0, b[r + 16 >> 2] = 21, b[r + 4 >> 2] = b[r + 24 >> 2], t = b[r + 20 >> 2], b[r + 8 >> 2] = b[r + 16 >> 2], b[r + 12 >> 2] = t, Br(n, r + 8 | 0, 0, r + 4 | 0), fn = r + 32 | 0;
              }(b[(n |= 0) >> 2]);
            }, a[88] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 21, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Br(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[89] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 21, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Br(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[90] = function (n) {
              !function (n) {
                var r, t;
                fn = r = fn - 32 | 0, se(r + 24 | 0), b[r + 20 >> 2] = 0, b[r + 16 >> 2] = 21, b[r + 4 >> 2] = b[r + 24 >> 2], t = b[r + 20 >> 2], b[r + 8 >> 2] = b[r + 16 >> 2], b[r + 12 >> 2] = t, Br(n, r + 8 | 0, 1, r + 4 | 0), fn = r + 32 | 0;
              }(b[(n |= 0) >> 2]);
            }, a[91] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 22, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Wr(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[92] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 22, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Wr(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[93] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 22, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Wr(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[94] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 22, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Wr(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[95] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 23, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Zr(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[96] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 23, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Zr(n, t + 16 | 0, 0, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[97] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, oi(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 23, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Zr(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[98] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 48 | 0, ai(t + 40 | 0, r), b[t + 28 >> 2] = 0, b[t + 24 >> 2] = 23, e = b[t + 40 >> 2], b[t + 32 >> 2] = e, b[t + 12 >> 2] = e, e = b[t + 28 >> 2], b[t + 16 >> 2] = b[t + 24 >> 2], b[t + 20 >> 2] = e, Zr(n, t + 16 | 0, 1, t + 12 | 0), fn = t + 48 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[99] = function (n, r) {
              r = +r, function (n, r) {
                var t,
                    e = 0;
                fn = t = fn - 32 | 0, e = lo(t + 24 | 0, r), b[t + 20 >> 2] = 0, b[t + 16 >> 2] = 20, r = m[e >> 2], e = b[t + 20 >> 2], b[t + 8 >> 2] = b[t + 16 >> 2], b[t + 12 >> 2] = e, Kr(n, t + 8 | 0, r), fn = t + 32 | 0;
              }(b[(n |= 0) >> 2], _(r));
            }, a[100] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, oi(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 19, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Nr(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[101] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, oi(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 18, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Rr(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[102] = function (n, r, t) {
              r |= 0, t = +t, function (n, r, t) {
                var e,
                    i = 0;
                fn = e = fn - 48 | 0, ai(e + 40 | 0, t), b[e + 28 >> 2] = 0, b[e + 24 >> 2] = 18, i = b[e + 40 >> 2], b[e + 32 >> 2] = i, b[e + 12 >> 2] = i, i = b[e + 28 >> 2], b[e + 16 >> 2] = b[e + 24 >> 2], b[e + 20 >> 2] = i, Rr(n, e + 16 | 0, r, e + 12 | 0), fn = e + 48 | 0;
              }(b[(n |= 0) >> 2], r, _(t));
            }, a[103] = function (n) {
              return 0 | $a(au(b[(n |= 0) >> 2]));
            }, a[104] = function (n, r, t) {
              t |= 0, rr(n |= 0, Qo(ou(au(b[(r |= 0) >> 2])), t));
            }, a[105] = function (n) {
              return 0 | io(au(b[(n |= 0) >> 2]));
            }, a[106] = function (n) {
              return 0 | Ya(au(b[(n |= 0) >> 2]));
            }, a[107] = function (n) {
              return 0 | Ja(au(b[(n |= 0) >> 2]));
            }, a[108] = function (n) {
              return 0 | ro(au(b[(n |= 0) >> 2]));
            }, a[109] = function (n) {
              return 0 | Sa(au(b[(n |= 0) >> 2]));
            }, a[110] = function (n) {
              return 0 | eo(au(b[(n |= 0) >> 2]));
            }, a[111] = function (n, r, t) {
              t |= 0, rr(n |= 0, Qo(nu(au(b[(r |= 0) >> 2])), t));
            }, a[112] = function (n, r) {
              !function (n, r) {
                var t;
                fn = t = fn - 16 | 0, Ka(t + 8 | 0, au(r)), rr(n, t + 8 | 0);

                n: if (!((r = b[n + 4 >> 2]) >>> 0 > 3)) {
                  r: switch (r - 1 | 0) {
                    case 0:
                    case 1:
                      break n;
                  }

                  b[n >> 2] = 2143289344;
                }

                fn = t + 16 | 0;
              }(n |= 0, b[(r |= 0) >> 2]);
            }, a[113] = function (n) {
              return +function (n) {
                var r,
                    t = _(0),
                    e = 0,
                    i = _(0);

                return fn = r = fn - 16 | 0, e = r, i = m[au(n) + 8 >> 2], m[e + 8 >> 2] = i, Eo(r + 8 | 0) || (e = r, i = m[au(n) + 8 >> 2], m[e >> 2] = i, t = m[r >> 2]), fn = r + 16 | 0, t;
              }(b[(n |= 0) >> 2]);
            }, a[114] = function (n) {
              return +function (n) {
                var r,
                    t = _(0),
                    e = 0,
                    i = _(0);

                return fn = r = fn - 16 | 0, e = r, i = m[au(n) + 12 >> 2], m[e + 8 >> 2] = i, Eo(r + 8 | 0) ? t = p[b[n + 556 >> 2] + 10 | 0] ? _(1) : _(0) : (e = r, i = m[au(n) + 12 >> 2], m[e >> 2] = i, t = m[r >> 2]), fn = r + 16 | 0, t;
              }(b[(n |= 0) >> 2]);
            }, a[115] = function (n, r) {
              rr(n |= 0, Qo(Mo(au(b[(r |= 0) >> 2])), 0));
            }, a[116] = function (n, r) {
              rr(n |= 0, Qo(Mo(au(b[(r |= 0) >> 2])), 1));
            }, a[117] = function (n, r) {
              rr(n |= 0, Qo(zo(au(b[(r |= 0) >> 2])), 0));
            }, a[118] = function (n, r) {
              rr(n |= 0, Qo(zo(au(b[(r |= 0) >> 2])), 1));
            }, a[119] = function (n, r) {
              rr(n |= 0, Qo(Jo(au(b[(r |= 0) >> 2])), 0));
            }, a[120] = function (n, r) {
              rr(n |= 0, Qo(Jo(au(b[(r |= 0) >> 2])), 1));
            }, a[121] = function (n) {
              return +function (n) {
                var r,
                    t,
                    e = _(0),
                    i = _(0);

                return fn = r = fn - 16 | 0, t = r, i = m[au(n) + 188 >> 2], m[t + 8 >> 2] = i, e = _(Z), Eo(r + 8 | 0) || (e = m[r + 8 >> 2]), fn = r + 16 | 0, e;
              }(b[(n |= 0) >> 2]);
            }, a[122] = function (n, r) {
              return r |= 0, +function (n, r) {
                var t,
                    e,
                    i,
                    a = _(0);

                return fn = t = fn - 16 | 0, e = t, i = b[Qo(xo(au(n)), r) >> 2], b[e + 8 >> 2] = i, a = _(Z), Mt(t + 8 | 0) || Ca(t + 8 | 0) || (rr(t, t + 8 | 0), a = m[t >> 2]), fn = t + 16 | 0, a;
              }(b[(n |= 0) >> 2], r);
            }, a[123] = function (n) {
              return 0 | Ha(au(b[(n |= 0) >> 2]));
            }, a[124] = function (n) {
              return 0 | Da(au(b[(n |= 0) >> 2]));
            }, a[125] = function (n, r, t) {
              t |= 0, rr(n |= 0, Qo(tu(au(b[(r |= 0) >> 2])), t));
            }, a[126] = function (n, r, t) {
              r |= 0, t |= 0, function (n, r, t) {
                Ge(n, !b[r + 540 >> 2], 1331), Ge(n, 1 ^ bo(n), 1384), Mr(n, r, t), Uo(r, n), bt(n);
              }(b[(n |= 0) >> 2], b[r >> 2], t);
            }, a[127] = function (n, r) {
              r |= 0, Sr(b[(n |= 0) >> 2], b[r >> 2]);
            }, a[128] = function (n) {
              return 0 | Xo(b[(n |= 0) >> 2]);
            }, a[129] = function (n) {
              return (n = b[b[(n |= 0) >> 2] + 540 >> 2]) ? b[n >> 2] : 0;
            }, a[130] = function (n, r) {
              return r |= 0, (n = ci(b[(n |= 0) >> 2], r)) ? b[n >> 2] : 0;
            }, a[131] = function (n) {
              return 0 | ja(b[(n |= 0) >> 2]);
            }, a[132] = function (n, r) {
              r |= 0, function (n, r) {
                1 == (ja(n) ^ r) && (be(n + 4 | 0, 1, r), bt(n));
              }(b[(n |= 0) >> 2], r);
            }, a[133] = function (n, r) {
              di(4 + (n |= 0) | 0, r |= 0), bu(b[n >> 2], 25);
            }, a[134] = function (n) {
              di(4 + (n |= 0) | 0, 0), bu(b[n >> 2], 0);
            }, a[135] = function (n, r) {
              di(8 + (n |= 0) | 0, r |= 0), Ho(b[n >> 2], 26);
            }, a[136] = function (n) {
              di(8 + (n |= 0) | 0, 0), Ho(b[n >> 2], 0);
            }, a[137] = function (n) {
              Ge(n = b[(n |= 0) >> 2], bo(n), 1453), bt(n);
            }, a[138] = function (n) {
              return 0 | Pa(b[(n |= 0) >> 2]);
            }, a[139] = function (n, r, t, e) {
              r = +r, t = +t, e |= 0, kn(b[(n |= 0) >> 2], _(r), _(t), e);
            }, a[140] = function (n) {
              return +Ia(b[(n |= 0) >> 2]);
            }, a[141] = function (n) {
              return +Ba(b[(n |= 0) >> 2]);
            }, a[142] = function (n) {
              return +Ra(b[(n |= 0) >> 2]);
            }, a[143] = function (n) {
              return +Va(b[(n |= 0) >> 2]);
            }, a[144] = function (n) {
              return +la(b[(n |= 0) >> 2]);
            }, a[145] = function (n) {
              return +Aa(b[(n |= 0) >> 2]);
            }, a[146] = function (n, r) {
              var t = 0,
                  e = 0;
              t = n |= 0, e = +Ia(b[(r |= 0) >> 2]), k[t >> 3] = e, t = n, e = +Ba(b[r >> 2]), k[t + 8 >> 3] = e, t = n, e = +Ra(b[r >> 2]), k[t + 16 >> 3] = e, t = n, e = +Va(b[r >> 2]), k[t + 24 >> 3] = e, t = n, e = +la(b[r >> 2]), k[t + 32 >> 3] = e, t = n, e = +Aa(b[r >> 2]), k[t + 40 >> 3] = e;
            }, a[147] = function (n, r) {
              return r |= 0, +function (n, r) {
                var t = 0;
                Ge(n, (0 | r) < 6, 1539);

                n: if (4 != (0 | r)) {
                  if (t = Ko(n), 5 != (0 | r)) n = wo(t + 24 | 0, r);else {
                    if (r = Qa(t), n = Ko(n) + 24 | 0, 2 == (0 | r)) {
                      n = wo(n, 0);
                      break n;
                    }

                    n = wo(n, 2);
                  }
                } else {
                  if (r = Qa(Ko(n)), n = Ko(n) + 24 | 0, 2 == (0 | r)) {
                    n = wo(n, 2);
                    break n;
                  }

                  n = wo(n, 0);
                }

                return m[n >> 2];
              }(b[(n |= 0) >> 2], r);
            }, a[148] = function (n, r) {
              return r |= 0, +function (n, r) {
                var t = 0;
                Ge(n, (0 | r) < 6, 1539);

                n: if (4 != (0 | r)) {
                  if (t = Ko(n), 5 != (0 | r)) n = wo(t + 40 | 0, r);else {
                    if (r = Qa(t), n = Ko(n) + 40 | 0, 2 == (0 | r)) {
                      n = wo(n, 0);
                      break n;
                    }

                    n = wo(n, 2);
                  }
                } else {
                  if (r = Qa(Ko(n)), n = Ko(n) + 40 | 0, 2 == (0 | r)) {
                    n = wo(n, 2);
                    break n;
                  }

                  n = wo(n, 0);
                }

                return m[n >> 2];
              }(b[(n |= 0) >> 2], r);
            }, a[149] = function (n, r) {
              return r |= 0, +function (n, r) {
                var t = 0;
                Ge(n, (0 | r) < 6, 1539);

                n: if (4 != (0 | r)) {
                  if (t = Ko(n), 5 != (0 | r)) n = wo(t + 56 | 0, r);else {
                    if (r = Qa(t), n = Ko(n) + 56 | 0, 2 == (0 | r)) {
                      n = wo(n, 0);
                      break n;
                    }

                    n = wo(n, 2);
                  }
                } else {
                  if (r = Qa(Ko(n)), n = Ko(n) + 56 | 0, 2 == (0 | r)) {
                    n = wo(n, 2);
                    break n;
                  }

                  n = wo(n, 0);
                }

                return m[n >> 2];
              }(b[(n |= 0) >> 2], r);
            }, a[150] = function (n, r, t, e, i, o) {
              n |= 0, r |= 0, t = _(t), e |= 0, i = _(i), o |= 0;
              var u,
                  f,
                  A,
                  c = 0;
              return fn = u = fn - 16 | 0, c = b[n >> 2], f = u + 8 | 0, A = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (c = b[c + b[r >> 2] >> 2]), a[c](f, A, t, e, i, o), n = Ue(u + 8 | 0), fn = u + 16 | 0, 0 | n;
            }, a[151] = Fo, a[152] = Fo, a[153] = Go, a[154] = va, a[155] = ce, a[156] = Fo, a[157] = Fo, a[158] = Go, a[159] = va, a[160] = Ei, a[161] = Co, a[162] = Vi, a[163] = Ii, a[164] = Ei, a[165] = Co, a[166] = Vi, a[167] = Ii, a[168] = function (n, r) {
              return r |= 0, b[b[(n |= 0) >> 2] + r >> 2];
            }, a[169] = function (n, r, t) {
              r |= 0, t |= 0, b[b[(n |= 0) >> 2] + r >> 2] = t;
            }, a[170] = ce, a[171] = Lt, a[172] = Lt, a[173] = function (n, r, t, e) {
              r |= 0, t |= 0, e = +e;
              var i,
                  o = 0;
              o = b[(n |= 0) >> 2], i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (o = b[o + b[r >> 2] >> 2]), a[o](i, t, e);
            }, a[174] = function (n, r, t) {
              r |= 0, t = +t;
              var e,
                  i = 0;
              i = b[(n |= 0) >> 2], e = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (i = b[i + b[r >> 2] >> 2]), a[i](e, t);
            }, a[175] = Or, a[176] = function (n, r, t) {
              r |= 0, t |= 0;
              var e,
                  i,
                  o,
                  u = 0;
              return fn = e = fn - 16 | 0, u = b[(n |= 0) >> 2], i = e + 8 | 0, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](i, o, t), n = Ue(e + 8 | 0), fn = e + 16 | 0, 0 | n;
            }, a[177] = function (n, r) {
              r |= 0;
              var t,
                  e,
                  i,
                  o = 0;
              return fn = t = fn - 16 | 0, o = b[(n |= 0) >> 2], e = t + 8 | 0, i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (o = b[b[r >> 2] + o >> 2]), a[o](e, i), n = Ue(t + 8 | 0), fn = t + 16 | 0, 0 | n;
            }, a[178] = function (n, r) {
              r |= 0;
              var t,
                  e,
                  i,
                  o,
                  u,
                  f = 0;
              return fn = t = fn - 16 | 0, f = b[(n |= 0) >> 2], e = t, i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (f = b[b[r >> 2] + f >> 2]), o = e, u = +a[f](i), k[o + 8 >> 3] = u, fn = t + 16 | 0, +k[t + 8 >> 3];
            }, a[179] = function (n, r, t) {
              r |= 0, t |= 0;
              var e,
                  i,
                  o,
                  u,
                  f,
                  A = 0;
              return fn = e = fn - 16 | 0, A = b[(n |= 0) >> 2], i = e, o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (A = b[A + b[r >> 2] >> 2]), u = i, f = +a[A](o, t), k[u + 8 >> 3] = f, fn = e + 16 | 0, +k[e + 8 >> 3];
            }, a[180] = Dt, a[181] = Lt, a[182] = Or, a[183] = qt, a[184] = St, a[185] = qt, a[186] = Lt, a[187] = Lt, a[188] = Lt, a[189] = qt, a[190] = function (n, r, t, e, i) {
              r |= 0, t = +t, e = +e, i |= 0;
              var o,
                  u = 0;
              u = b[(n |= 0) >> 2], o = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (u = b[u + b[r >> 2] >> 2]), a[u](o, t, e, i);
            }, a[191] = function (n, r) {
              r |= 0;
              var t,
                  e,
                  i,
                  o = 0;
              return fn = t = fn - 48 | 0, o = b[(n |= 0) >> 2], e = t, i = r = ((n = b[n + 4 >> 2]) >> 1) + r | 0, 1 & n && (o = b[b[r >> 2] + o >> 2]), a[o](e, i), n = _n(ie(48), t, 48), fn = t + 48 | 0, 0 | n;
            }, a[192] = function () {
              W();
            }, a[193] = function (n, r, t, e, i, a) {
              var o;
              n |= 0, r |= 0, t = _(t), e |= 0, i = _(i), a |= 0, fn = o = fn - 16 | 0, b[o + 8 >> 2] = e, m[o + 12 >> 2] = t, m[o + 4 >> 2] = i, b[o >> 2] = a, gr(n, b[r + 8 >> 2], o + 12 | 0, o + 8 | 0, o + 4 | 0, o), fn = o + 16 | 0;
            }, a[194] = function (n) {
              Io(n |= 0, 2531);
            }, a[195] = function (n) {
              var r;
              return n |= 0, fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, n = b[r + 12 >> 2], fr(), fn = r + 16 | 0, 0 | n;
            }, a[196] = function (n) {
              return 0 | K(b[60 + (n |= 0) >> 2]);
            }, a[197] = function (n, r, t) {
              r |= 0, t |= 0;
              var e,
                  i = 0,
                  a = 0,
                  o = 0,
                  u = 0,
                  f = 0;
              fn = e = fn - 32 | 0, i = b[28 + (n |= 0) >> 2], b[e + 16 >> 2] = i, a = b[n + 20 >> 2], b[e + 28 >> 2] = t, b[e + 24 >> 2] = r, r = a - i | 0, b[e + 20 >> 2] = r, i = r + t | 0, u = 2, r = e + 16 | 0;

              n: {
                r: {
                  t: {
                    if (!ta(0 | P(b[n + 60 >> 2], e + 16 | 0, 2, e + 12 | 0))) for (;;) {
                      if ((0 | (a = b[e + 12 >> 2])) == (0 | i)) break t;
                      if ((0 | a) <= -1) break r;
                      if (o = a - ((f = a >>> 0 > (o = b[r + 4 >> 2]) >>> 0) ? o : 0) | 0, b[(r = f ? r + 8 | 0 : r) >> 2] = o + b[r >> 2], b[r + 4 >> 2] = b[r + 4 >> 2] - o, i = i - a | 0, u = u - f | 0, ta(0 | P(b[n + 60 >> 2], 0 | r, 0 | u, e + 12 | 0))) break;
                    }
                    if (b[e + 12 >> 2] = -1, -1 != (0 | i)) break r;
                  }

                  r = b[n + 44 >> 2], b[n + 28 >> 2] = r, b[n + 20 >> 2] = r, b[n + 16 >> 2] = r + b[n + 48 >> 2], n = t;
                  break n;
                }

                b[n + 28 >> 2] = 0, b[n + 16 >> 2] = 0, b[n + 20 >> 2] = 0, b[n >> 2] = 32 | b[n >> 2], n = 0, 2 != (0 | u) && (n = t - b[r + 4 >> 2] | 0);
              }

              return fn = e + 32 | 0, 0 | n;
            }, a[198] = function (n, r, t, e) {
              var i;
              return r |= 0, t |= 0, e |= 0, fn = i = fn - 16 | 0, ta(0 | J(b[60 + (n |= 0) >> 2], 0 | r, 0 | t, 255 & e, i + 8 | 0)) ? (b[i + 8 >> 2] = -1, b[i + 12 >> 2] = -1, r = -1, n = -1) : (r = b[i + 12 >> 2], n = b[i + 8 >> 2]), fn = i + 16 | 0, An = r, 0 | n;
            }, a[199] = function (n, r, t, e, i, a) {
              n |= 0, r = +r, t |= 0, e |= 0, i |= 0, a |= 0;
              var f,
                  A = 0,
                  l = 0,
                  s = 0,
                  v = 0,
                  d = 0,
                  h = 0,
                  y = 0,
                  m = 0,
                  k = 0,
                  _ = 0,
                  E = 0,
                  w = 0,
                  N = 0,
                  W = 0,
                  Z = 0,
                  T = 0,
                  I = 0,
                  R = 0,
                  B = 0,
                  V = 0;
              fn = f = fn - 560 | 0, b[f + 44 >> 2] = 0, c(+r), A = 0 | u(1), B = 1, V = u(0) >>> 0 > 4294967295 ? 0 : 1, ((0 | A) < -1 ? B : (0 | A) <= -1 && V) ? (T = 1, c(+(r = -r)), A = 0 | u(1), I = 7632) : 2048 & i ? (T = 1, I = 7635) : I = (T = 1 & i) ? 7638 : 7633;

              n: if (2146435072 != (2146435072 & A)) {
                N = f + 16 | 0;

                r: {
                  t: {
                    e: {
                      if (r = mr(r, f + 44 | 0), 0 != (r += r)) {
                        if (A = b[f + 44 >> 2], b[f + 44 >> 2] = A + -1, 97 != (0 | (w = 32 | a))) break e;
                        break r;
                      }

                      if (97 == (0 | (w = 32 | a))) break r;
                      v = b[f + 44 >> 2], d = (0 | e) < 0 ? 6 : e;
                      break t;
                    }

                    v = A + -29 | 0, b[f + 44 >> 2] = v, r *= 268435456, d = (0 | e) < 0 ? 6 : e;
                  }

                  for (s = _ = (0 | v) < 0 ? f + 48 | 0 : f + 336 | 0; A = r < 4294967296 & r >= 0 ? ~~r >>> 0 : 0, b[(e = s) >> 2] = A, s = s + 4 | 0, 0 != (r = 1e9 * (r - +(A >>> 0)));) {
                    ;
                  }

                  if ((0 | v) < 1) A = s, l = _;else for (l = _;;) {
                    if (E = (0 | v) < 29 ? v : 29, !((A = s + -4 | 0) >>> 0 < l >>> 0)) {
                      for (e = E, m = 0; k = A, h = 0, R = m, m = b[A >> 2], y = 31 & e, 32 <= (63 & e) >>> 0 ? (v = m << y, y = 0) : (v = (1 << y) - 1 & m >>> 32 - y, y = m << y), h = v + h | 0, h = (m = R + y | 0) >>> 0 < y >>> 0 ? h + 1 | 0 : h, R = k, k = co(m = Ao(y = m, h, 1e9), An, 1e9), b[R >> 2] = y - k, (A = A + -4 | 0) >>> 0 >= l >>> 0;) {
                        ;
                      }

                      (e = m) && (b[(l = l + -4 | 0) >> 2] = e);
                    }

                    for (; (A = s) >>> 0 > l >>> 0 && !b[(s = A + -4 | 0) >> 2];) {
                      ;
                    }

                    if (v = b[f + 44 >> 2] - E | 0, b[f + 44 >> 2] = v, s = A, !((0 | v) > 0)) break;
                  }
                  if ((0 | v) <= -1) for (W = 1 + ((d + 25 | 0) / 9 | 0) | 0, E = 102 == (0 | w);;) {
                    if (m = (0 | v) < -9 ? 9 : 0 - v | 0, l >>> 0 >= A >>> 0) l = b[l >> 2] ? l : l + 4 | 0;else {
                      for (k = 1e9 >>> m | 0, y = -1 << m ^ -1, v = 0, s = l; e = b[s >> 2], b[s >> 2] = (e >>> m | 0) + v, v = g(k, e & y), (s = s + 4 | 0) >>> 0 < A >>> 0;) {
                        ;
                      }

                      l = b[l >> 2] ? l : l + 4 | 0, v && (b[A >> 2] = v, A = A + 4 | 0);
                    }
                    if (v = m + b[f + 44 >> 2] | 0, b[f + 44 >> 2] = v, A = A - (e = E ? _ : l) >> 2 > (0 | W) ? e + (W << 2) | 0 : A, !((0 | v) < 0)) break;
                  }
                  if (s = 0, !(l >>> 0 >= A >>> 0 || (s = g(_ - l >> 2, 9), v = 10, (e = b[l >> 2]) >>> 0 < 10))) for (; s = s + 1 | 0, e >>> 0 >= (v = g(v, 10)) >>> 0;) {
                    ;
                  }

                  if ((0 | (e = (d - (102 == (0 | w) ? 0 : s) | 0) - (103 == (0 | w) & 0 != (0 | d)) | 0)) < (g(A - _ >> 2, 9) + -9 | 0)) {
                    if (h = (_ + ((e = (0 | (y = e + 9216 | 0)) / 9 | 0) << 2) | 0) - 4092 | 0, v = 10, (0 | (e = y - g(e, 9) | 0)) <= 7) for (; v = g(v, 10), 8 != (0 | (e = e + 1 | 0));) {
                      ;
                    }

                    if (W = h + 4 | 0, ((E = (k = b[h >> 2]) - g(v, y = (k >>> 0) / (v >>> 0) | 0) | 0) || (0 | W) != (0 | A)) && (Z = E >>> 0 < (e = v >>> 1 | 0) >>> 0 ? .5 : (0 | A) == (0 | W) && (0 | e) == (0 | E) ? 1 : 1.5, r = 1 & y ? 9007199254740994 : 9007199254740992, !T | 45 != p[0 | I] || (Z = -Z, r = -r), e = k - E | 0, b[h >> 2] = e, r + Z != r)) {
                      if (e = e + v | 0, b[h >> 2] = e, e >>> 0 >= 1e9) for (; b[h >> 2] = 0, (h = h + -4 | 0) >>> 0 < l >>> 0 && (b[(l = l + -4 | 0) >> 2] = 0), e = b[h >> 2] + 1 | 0, b[h >> 2] = e, e >>> 0 > 999999999;) {
                        ;
                      }
                      if (s = g(_ - l >> 2, 9), v = 10, !((e = b[l >> 2]) >>> 0 < 10)) for (; s = s + 1 | 0, e >>> 0 >= (v = g(v, 10)) >>> 0;) {
                        ;
                      }
                    }

                    A = A >>> 0 > (e = h + 4 | 0) >>> 0 ? e : A;
                  }

                  t: {
                    for (;;) {
                      if (E = A, k = 0, A >>> 0 <= l >>> 0) break t;
                      if (b[(A = E + -4 | 0) >> 2]) break;
                    }

                    k = 1;
                  }

                  if (103 == (0 | w)) {
                    if (d = ((e = (0 | (A = d || 1)) > (0 | s) & (0 | s) > -5) ? -1 ^ s : -1) + A | 0, a = (e ? -1 : -2) + a | 0, !(w = 8 & i)) {
                      if (A = 9, k && (y = b[E + -4 >> 2]) && (e = 10, A = 0, !((y >>> 0) % 10))) for (; A = A + 1 | 0, !((y >>> 0) % ((e = g(e, 10)) >>> 0));) {
                        ;
                      }
                      e = g(E - _ >> 2, 9) + -9 | 0, 70 != (-33 & a) ? (w = 0, d = (0 | d) < (0 | (e = (0 | (e = (e + s | 0) - A | 0)) > 0 ? e : 0)) ? d : e) : (w = 0, d = (0 | d) < (0 | (e = (0 | (e = e - A | 0)) > 0 ? e : 0)) ? d : e);
                    }
                  } else w = 8 & i;

                  if (h = 0 != (0 | (v = d | w)), e = n, y = t, A = (0 | s) > 0 ? s : 0, 70 != (0 | (m = -33 & a))) {
                    if ((N - (A = lr((A = s >> 31) + s ^ A, 0, N)) | 0) <= 1) for (; o[0 | (A = A + -1 | 0)] = 48, (N - A | 0) < 2;) {
                      ;
                    }
                    o[0 | (W = A + -2 | 0)] = a, o[A + -1 | 0] = (0 | s) < 0 ? 45 : 43, A = N - W | 0;
                  }

                  Xr(e, 32, y, h = 1 + (A + (h + (d + T | 0) | 0) | 0) | 0, i), aa(n, I, T), Xr(n, 48, t, h, 65536 ^ i);

                  t: {
                    e: {
                      i: {
                        if (70 == (0 | m)) {
                          for (e = f + 16 | 8, s = f + 16 | 9, l = a = l >>> 0 > _ >>> 0 ? _ : l;;) {
                            A = lr(b[l >> 2], 0, s);

                            a: if ((0 | a) == (0 | l)) (0 | A) == (0 | s) && (o[f + 24 | 0] = 48, A = e);else {
                              if (A >>> 0 <= f + 16 >>> 0) break a;

                              for (; o[0 | (A = A + -1 | 0)] = 48, A >>> 0 > f + 16 >>> 0;) {
                                ;
                              }
                            }

                            if (aa(n, A, s - A | 0), !((l = l + 4 | 0) >>> 0 <= _ >>> 0)) break;
                          }

                          if (v && aa(n, 7667, 1), (0 | d) < 1 | l >>> 0 >= E >>> 0) break i;

                          for (;;) {
                            if ((A = lr(b[l >> 2], 0, s)) >>> 0 > f + 16 >>> 0) for (; o[0 | (A = A + -1 | 0)] = 48, A >>> 0 > f + 16 >>> 0;) {
                              ;
                            }
                            if (aa(n, A, (0 | d) < 9 ? d : 9), A = d + -9 | 0, (l = l + 4 | 0) >>> 0 >= E >>> 0) break e;
                            if (e = (0 | d) > 9, d = A, !e) break;
                          }

                          break e;
                        }

                        a: if (!((0 | d) < 0)) for (a = k ? E : l + 4 | 0, e = f + 16 | 8, _ = f + 16 | 9, s = l;;) {
                          (0 | _) == (0 | (A = lr(b[s >> 2], 0, _))) && (o[f + 24 | 0] = 48, A = e);

                          o: if ((0 | l) == (0 | s)) aa(n, A, 1), A = A + 1 | 0, (0 | d) < 1 && !w || aa(n, 7667, 1);else {
                            if (A >>> 0 <= f + 16 >>> 0) break o;

                            for (; o[0 | (A = A + -1 | 0)] = 48, A >>> 0 > f + 16 >>> 0;) {
                              ;
                            }
                          }

                          if (aa(n, m = A, (0 | d) > (0 | (A = _ - A | 0)) ? A : d), d = d - A | 0, (s = s + 4 | 0) >>> 0 >= a >>> 0) break a;
                          if (!((0 | d) > -1)) break;
                        }

                        Xr(n, 48, d + 18 | 0, 18, 0), aa(n, W, N - W | 0);
                        break t;
                      }

                      A = d;
                    }

                    Xr(n, 48, A + 9 | 0, 9, 0);
                  }

                  break n;
                }

                if (y = (d = 32 & a) ? I + 9 | 0 : I, !(e >>> 0 > 11) && (A = 12 - e | 0)) {
                  for (Z = 8; Z *= 16, A = A + -1 | 0;) {
                    ;
                  }

                  r = 45 != p[0 | y] ? r + Z - Z : -(Z + (-r - Z));
                }

                for ((0 | N) == (0 | (A = lr((s = (A = b[f + 44 >> 2]) >> 31) ^ A + s, 0, N))) && (o[f + 15 | 0] = 48, A = f + 15 | 0), _ = 2 | T, s = b[f + 44 >> 2], o[0 | (k = A + -2 | 0)] = a + 15, o[A + -1 | 0] = (0 | s) < 0 ? 45 : 43, A = 8 & i, l = f + 16 | 0; a = l, m = d, s = C(r) < 2147483648 ? ~~r : -2147483648, o[0 | l] = m | p[s + 7616 | 0], 1 != ((l = a + 1 | 0) - (f + 16 | 0) | 0) | (0 == (r = 16 * (r - +(0 | s))) ? !(A | (0 | e) > 0) : 0) || (o[a + 1 | 0] = 46, l = a + 2 | 0), 0 != r;) {
                  ;
                }

                Xr(n, 32, t, h = (a = !e | ((l - f | 0) - 18 | 0) >= (0 | e) ? ((N - (f + 16 | 0) | 0) - k | 0) + l | 0 : 2 + ((e + N | 0) - k | 0) | 0) + _ | 0, i), aa(n, y, _), Xr(n, 48, t, h, 65536 ^ i), aa(n, f + 16 | 0, e = l - (f + 16 | 0) | 0), Xr(n, 48, a - ((A = e) + (e = N - k | 0) | 0) | 0, 0, 0), aa(n, k, e);
              } else Xr(n, 32, t, h = T + 3 | 0, -65537 & i), aa(n, I, T), e = a >>> 5 & 1, aa(n, r != r ? e ? 7659 : 7663 : e ? 7651 : 7655, 3);

              return Xr(n, 32, t, h, 8192 ^ i), fn = f + 560 | 0, 0 | ((0 | h) < (0 | t) ? t : h);
            }, a[200] = function (n, r) {
              var t, e, i;
              n |= 0, t = r |= 0, r = b[r >> 2] + 15 & -16, b[t >> 2] = r + 16, e = n, i = gn(b[r >> 2], b[r + 4 >> 2], b[r + 8 >> 2], b[r + 12 >> 2]), k[e >> 3] = i;
            }, a[201] = function (n) {
              return 0;
            }, a[202] = function (n, r, t, e) {
              return An = 0, 0;
            }, a[203] = Fo, a[204] = Au, a[205] = function (n) {
              return 7848;
            }, a[206] = function (n) {
              dn(Xi(n |= 0));
            }, a[207] = function (n) {
              return b[4 + (n |= 0) >> 2];
            }, a[208] = function (n) {
              Xi(n |= 0), dn(n);
            }, a[209] = Fo, a[210] = Au, a[211] = Cu, a[212] = Cu, a[213] = Ri, a[214] = Au, a[215] = Ri, a[216] = Au, a[217] = function (n, r, t) {
              t |= 0;
              var e,
                  i = 0;
              return fn = e = fn + -64 | 0, i = 1, ke(n |= 0, r |= 0, 0) || (i = 0, r && (i = 0, (r = Xn(r, 8116)) && (b[e + 20 >> 2] = -1, b[e + 16 >> 2] = n, b[e + 12 >> 2] = 0, b[e + 8 >> 2] = r, Zn(e + 24 | 0, 0, 39), b[e + 56 >> 2] = 1, a[b[b[r >> 2] + 28 >> 2]](r, e + 8 | 0, b[t >> 2], 1), i = 0, 1 == b[e + 32 >> 2] && (b[t >> 2] = b[e + 24 >> 2], i = 1)))), fn = e - -64 | 0, 0 | i;
            }, a[218] = function (n, r, t, e, i, a) {
              t |= 0, e |= 0, i |= 0, a |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], a) && ar(r, t, e, i);
            }, a[219] = function (n, r, t, e, i) {
              if (t |= 0, e |= 0, i |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], i)) Ai(r, t, e);else n: if (ke(n, b[r >> 2], i)) {
                if (b[r + 20 >> 2] == (0 | t) || b[r + 16 >> 2] == (0 | t)) {
                  if (1 != (0 | e)) break n;
                  return void (b[r + 32 >> 2] = 1);
                }

                b[r + 20 >> 2] = t, b[r + 32 >> 2] = e, b[r + 40 >> 2] = b[r + 40 >> 2] + 1, 1 != b[r + 36 >> 2] | 2 != b[r + 24 >> 2] || (o[r + 54 | 0] = 1), b[r + 44 >> 2] = 4;
              }
            }, a[220] = function (n, r, t, e) {
              t |= 0, e |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], 0) && Gr(r, t, e);
            }, a[221] = Au, a[222] = function (n, r, t, e, i, o) {
              t |= 0, e |= 0, i |= 0, o |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], o) ? ar(r, t, e, i) : (n = b[n + 8 >> 2], a[b[b[n >> 2] + 20 >> 2]](n, r, t, e, i, o));
            }, a[223] = function (n, r, t, e, i) {
              if (t |= 0, e |= 0, i |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], i)) Ai(r, t, e);else n: {
                if (ke(n, b[r >> 2], i)) {
                  if (b[r + 20 >> 2] == (0 | t) || b[r + 16 >> 2] == (0 | t)) {
                    if (1 != (0 | e)) break n;
                    return void (b[r + 32 >> 2] = 1);
                  }

                  b[r + 32 >> 2] = e;

                  r: if (4 != b[r + 44 >> 2]) {
                    if (d[r + 52 >> 1] = 0, n = b[n + 8 >> 2], a[b[b[n >> 2] + 20 >> 2]](n, r, t, t, 1, i), p[r + 53 | 0]) {
                      if (b[r + 44 >> 2] = 3, !p[r + 52 | 0]) break r;
                      break n;
                    }

                    b[r + 44 >> 2] = 4;
                  }

                  if (b[r + 20 >> 2] = t, b[r + 40 >> 2] = b[r + 40 >> 2] + 1, 1 != b[r + 36 >> 2] | 2 != b[r + 24 >> 2]) break n;
                  return void (o[r + 54 | 0] = 1);
                }

                n = b[n + 8 >> 2], a[b[b[n >> 2] + 24 >> 2]](n, r, t, e, i);
              }
            }, a[224] = function (n, r, t, e) {
              t |= 0, e |= 0, ke(n |= 0, b[8 + (r |= 0) >> 2], 0) ? Gr(r, t, e) : (n = b[n + 8 >> 2], a[b[b[n >> 2] + 28 >> 2]](n, r, t, e));
            }, a[225] = Au, a[226] = function (n, r, t, e, i, a) {
              t |= 0, e |= 0, i |= 0, a |= 0;
              var u = 0,
                  f = 0,
                  A = 0,
                  c = 0,
                  l = 0,
                  s = 0;
              if (ke(n |= 0, b[8 + (r |= 0) >> 2], a)) ar(r, t, e, i);else {
                f = p[r + 53 | 0], u = b[n + 12 >> 2], o[r + 53 | 0] = 0, A = p[r + 52 | 0], o[r + 52 | 0] = 0, gt(c = n + 16 | 0, r, t, e, i, a), f |= l = p[r + 53 | 0], A |= s = p[r + 52 | 0];

                n: if (!((0 | u) < 2)) for (c = c + (u << 3) | 0, u = n + 24 | 0;;) {
                  if (p[r + 54 | 0]) break n;

                  r: {
                    if (s) {
                      if (1 == b[r + 24 >> 2]) break n;
                      if (2 & p[n + 8 | 0]) break r;
                      break n;
                    }

                    if (l && !(1 & o[n + 8 | 0])) break n;
                  }

                  if (d[r + 52 >> 1] = 0, gt(u, r, t, e, i, a), f |= l = p[r + 53 | 0], A |= s = p[r + 52 | 0], !((u = u + 8 | 0) >>> 0 < c >>> 0)) break;
                }

                o[r + 53 | 0] = 0 != (255 & f), o[r + 52 | 0] = 0 != (255 & A);
              }
            }, a[227] = function (n, r, t, e, i) {
              t |= 0, e |= 0, i |= 0;
              var a = 0,
                  u = 0,
                  f = 0,
                  A = 0,
                  c = 0;
              if (ke(n |= 0, b[8 + (r |= 0) >> 2], i)) Ai(r, t, e);else n: {
                if (ke(n, b[r >> 2], i)) {
                  if (b[r + 20 >> 2] == (0 | t) || b[r + 16 >> 2] == (0 | t)) {
                    if (1 != (0 | e)) break n;
                    return void (b[r + 32 >> 2] = 1);
                  }

                  if (b[r + 32 >> 2] = e, 4 != b[r + 44 >> 2]) {
                    A = (a = n + 16 | 0) + (b[n + 12 >> 2] << 3) | 0, c = r;

                    r: {
                      t: {
                        for (; !(a >>> 0 >= A >>> 0 || (d[r + 52 >> 1] = 0, gt(a, r, t, t, 1, i), p[r + 54 | 0]));) {
                          e: if (p[r + 53 | 0]) {
                            if (p[r + 52 | 0]) {
                              if (e = 1, 1 == b[r + 24 >> 2]) break t;
                              if (f = 1, u = 1, 2 & p[n + 8 | 0]) break e;
                              break t;
                            }

                            if (f = 1, e = u, !(1 & o[n + 8 | 0])) break t;
                          }

                          a = a + 8 | 0;
                        }

                        if (e = u, n = 4, !f) break r;
                      }

                      n = 3;
                    }

                    if (b[c + 44 >> 2] = n, 1 & e) break n;
                  }

                  if (b[r + 20 >> 2] = t, b[r + 40 >> 2] = b[r + 40 >> 2] + 1, 1 != b[r + 36 >> 2] | 2 != b[r + 24 >> 2]) break n;
                  return void (o[r + 54 | 0] = 1);
                }

                if (u = b[n + 12 >> 2], Tt(a = n + 16 | 0, r, t, e, i), !((0 | u) < 2)) if (u = a + (u << 3) | 0, a = n + 24 | 0, n = b[n + 8 >> 2], 1 == b[r + 36 >> 2] || 2 & n) for (;;) {
                  if (p[r + 54 | 0]) break n;
                  if (Tt(a, r, t, e, i), !((a = a + 8 | 0) >>> 0 < u >>> 0)) break;
                } else {
                  if (!(1 & n)) for (;;) {
                    if (p[r + 54 | 0] | 1 == b[r + 36 >> 2]) break n;
                    if (Tt(a, r, t, e, i), !((a = a + 8 | 0) >>> 0 < u >>> 0)) break n;
                  }

                  for (;;) {
                    if (p[r + 54 | 0] | (1 == b[r + 24 >> 2] ? 1 == b[r + 36 >> 2] : 0)) break n;
                    if (Tt(a, r, t, e, i), !((a = a + 8 | 0) >>> 0 < u >>> 0)) break;
                  }
                }
              }
            }, a[228] = function (n, r, t, e) {
              t |= 0, e |= 0;
              var i,
                  a = 0;
              if (ke(n |= 0, b[8 + (r |= 0) >> 2], 0)) Gr(r, t, e);else {
                a = b[n + 12 >> 2], Yr(i = n + 16 | 0, r, t, e);

                n: if (!((0 | a) < 2)) for (a = (a << 3) + i | 0, n = n + 24 | 0;;) {
                  if (Yr(n, r, t, e), p[r + 54 | 0]) break n;
                  if (!((n = n + 8 | 0) >>> 0 < a >>> 0)) break;
                }
              }
            }, a[229] = Au, a[230] = function (n, r, t) {
              n |= 0, t |= 0;
              var e,
                  i = 0,
                  u = 0,
                  f = 0;
              fn = e = fn + -64 | 0;

              n: {
                r: {
                  if (ke(r |= 0, 8432, 0)) b[t >> 2] = 0;else {
                    if (function (n, r) {
                      var t, e;
                      t = n, e = r;

                      t: {
                        if (24 & p[n + 8 | 0]) n = 1;else {
                          if (n = 0, !r) break t;
                          if (!(r = Xn(r, 8164))) break t;
                          n = 0 != (24 & p[r + 8 | 0]);
                        }
                        n = ke(t, e, n);
                      }

                      return n;
                    }(n, r)) {
                      if (u = 1, !(n = b[t >> 2])) break n;
                      b[t >> 2] = b[n >> 2];
                      break n;
                    }

                    if (!r) break r;
                    if (!(r = Xn(r, 8212))) break n;
                    if ((i = b[t >> 2]) && (b[t >> 2] = b[i >> 2]), (f = b[r + 8 >> 2]) & (-1 ^ (i = b[n + 8 >> 2])) & 7 | (-1 ^ f) & i & 96) break n;
                    if (u = 1, ke(b[n + 12 >> 2], b[r + 12 >> 2], 0)) break n;

                    if (ke(b[n + 12 >> 2], 8420, 0)) {
                      if (!(n = b[r + 12 >> 2])) break n;
                      u = !Xn(n, 8264);
                      break n;
                    }

                    if (!(i = b[n + 12 >> 2])) break r;

                    if (u = 0, i = Xn(i, 8212)) {
                      if (!(1 & o[n + 8 | 0])) break n;

                      u = function (n, r) {
                        var t = 0,
                            e = 0;

                        t: {
                          for (;;) {
                            if (!r) return 0;
                            if (!(r = Xn(r, 8212)) | b[r + 8 >> 2] & (-1 ^ b[n + 8 >> 2])) break t;
                            if (ke(b[n + 12 >> 2], b[r + 12 >> 2], 0)) return 1;
                            if (!(1 & o[n + 8 | 0])) break t;
                            if (!(t = b[n + 12 >> 2])) break t;
                            if (!(t = Xn(t, 8212))) break;
                            r = b[r + 12 >> 2], n = t;
                          }

                          (n = b[n + 12 >> 2]) && (n = Xn(n, 8324)) && (e = Hr(n, b[r + 12 >> 2]));
                        }

                        return e;
                      }(i, b[r + 12 >> 2]);

                      break n;
                    }

                    if (!(i = b[n + 12 >> 2])) break n;

                    if (i = Xn(i, 8324)) {
                      if (!(1 & o[n + 8 | 0])) break n;
                      u = Hr(i, b[r + 12 >> 2]);
                      break n;
                    }

                    if (!(n = b[n + 12 >> 2])) break n;
                    if (!(i = Xn(n, 8116))) break n;
                    if (!(n = b[r + 12 >> 2])) break n;
                    if (!(n = Xn(n, 8116))) break n;
                    if (b[e + 20 >> 2] = -1, b[e + 16 >> 2] = i, b[e + 12 >> 2] = 0, b[e + 8 >> 2] = n, Zn(e + 24 | 0, 0, 39), b[e + 56 >> 2] = 1, a[b[b[n >> 2] + 28 >> 2]](n, e + 8 | 0, b[t >> 2], 1), 1 != b[e + 32 >> 2]) break n;
                    b[t >> 2] && (b[t >> 2] = b[e + 24 >> 2]);
                  }
                  u = 1;
                  break n;
                }

                u = 0;
              }

              return fn = e - -64 | 0, 0 | u;
            }, {
              __wasm_call_ctors: function __wasm_call_ctors() {
                zn(), function () {
                  var n;
                  fn = n = fn - 16 | 0, X(4008, 2426, 4016, 37, 3917, 38), Xt(Xt(Xt(Xt(Xt(Xt(n + 8 | 0, 2433, 0), 2438, 8), 2444, 16), 2448, 24), 2455, 32), 2461, 40), F(4008), fn = n + 16 | 0;
                }(), ln(), a[195](9480);
              },
              __getTypeName: function __getTypeName(n) {
                var r;
                return n |= 0, fn = r = fn - 16 | 0, b[r + 12 >> 2] = n, n = function (n) {
                  var r, t;
                  return r = or(n) + 1 | 0, (t = cn(r)) ? _n(t, n, r) : 0;
                }(Ve(b[r + 12 >> 2])), fn = r + 16 | 0, 0 | n;
              },
              __embind_register_native_and_builtin_types: fr,
              malloc: cn,
              free: dn,
              __growWasmMemory: function __growWasmMemory(r) {
                return 0 | function (r) {
                  r |= 0;
                  var t = 0 | wu(),
                      a = t + r | 0;

                  if (t < a && a < 65536) {
                    var u = new ArrayBuffer(g(a, 65536)),
                        f = new n.Int8Array(u);
                    f.set(o), o = f, o = new n.Int8Array(u), d = new n.Int16Array(u), b = new n.Int32Array(u), p = new n.Uint8Array(u), h = new n.Uint16Array(u), y = new n.Uint32Array(u), m = new n.Float32Array(u), k = new n.Float64Array(u), e = u, i.buffer = u;
                  }

                  return t;
                }(0 | (r |= 0));
              },
              dynCall_ii: oa,
              dynCall_iiiiii: function dynCall_iiiiii(n, r, t, e, i, o) {
                return r |= 0, t |= 0, e |= 0, i |= 0, o |= 0, 0 | a[n |= 0](r, t, e, i, o);
              },
              dynCall_vii: function dynCall_vii(n, r, t) {
                r |= 0, t |= 0, a[n |= 0](r, t);
              },
              dynCall_viififi: function dynCall_viififi(n, r, t, e, i, o, u) {
                n |= 0, r |= 0, t |= 0, e = _(e), i |= 0, o = _(o), u |= 0, a[n](r, t, e, i, o, u);
              },
              dynCall_vi: Ua,
              dynCall_i: xa,
              dynCall_viii: function dynCall_viii(n, r, t, e) {
                r |= 0, t |= 0, e |= 0, a[n |= 0](r, t, e);
              },
              dynCall_vif: function dynCall_vif(n, r, t) {
                n |= 0, r |= 0, t = _(t), a[n](r, t);
              },
              dynCall_iii: function dynCall_iii(n, r, t) {
                return r |= 0, t |= 0, 0 | a[n |= 0](r, t);
              },
              dynCall_viiii: function dynCall_viiii(n, r, t, e, i) {
                r |= 0, t |= 0, e |= 0, i |= 0, a[n |= 0](r, t, e, i);
              },
              dynCall_viif: function dynCall_viif(n, r, t, e) {
                n |= 0, r |= 0, t |= 0, e = _(e), a[n](r, t, e);
              },
              dynCall_iiii: function dynCall_iiii(n, r, t, e) {
                return r |= 0, t |= 0, e |= 0, 0 | a[n |= 0](r, t, e);
              },
              dynCall_dii: function dynCall_dii(n, r, t) {
                return r |= 0, t |= 0, +a[n |= 0](r, t);
              },
              dynCall_viid: function dynCall_viid(n, r, t, e) {
                r |= 0, t |= 0, e = +e, a[n |= 0](r, t, e);
              },
              dynCall_vid: function dynCall_vid(n, r, t) {
                r |= 0, t = +t, a[n |= 0](r, t);
              },
              dynCall_di: function dynCall_di(n, r) {
                return r |= 0, +a[n |= 0](r);
              },
              dynCall_viddi: function dynCall_viddi(n, r, t, e, i) {
                r |= 0, t = +t, e = +e, i |= 0, a[n |= 0](r, t, e, i);
              },
              dynCall_iiififi: function dynCall_iiififi(n, r, t, e, i, o, u) {
                return n |= 0, r |= 0, t |= 0, e = _(e), i |= 0, o = _(o), u |= 0, 0 | a[n](r, t, e, i, o, u);
              },
              dynCall_fii: function dynCall_fii(n, r, t) {
                return r |= 0, t |= 0, _(_(a[n |= 0](r, t)));
              },
              dynCall_viiid: function dynCall_viiid(n, r, t, e, i) {
                r |= 0, t |= 0, e |= 0, i = +i, a[n |= 0](r, t, e, i);
              },
              dynCall_diii: function dynCall_diii(n, r, t, e) {
                return r |= 0, t |= 0, e |= 0, +a[n |= 0](r, t, e);
              },
              dynCall_viiddi: function dynCall_viiddi(n, r, t, e, i, o) {
                r |= 0, t |= 0, e = +e, i = +i, o |= 0, a[n |= 0](r, t, e, i, o);
              },
              dynCall_v: function dynCall_v(n) {
                a[n |= 0]();
              },
              dynCall_jiji: function dynCall_jiji(n, r, t, e, i) {
                return r |= 0, t |= 0, e |= 0, i |= 0, n = 0 | a[n |= 0](r, t, e, i), $(0 | An), 0 | n;
              },
              dynCall_iidiiii: function dynCall_iidiiii(n, r, t, e, i, o, u) {
                return r |= 0, t = +t, e |= 0, i |= 0, o |= 0, u |= 0, 0 | a[n |= 0](r, t, e, i, o, u);
              },
              dynCall_viiiiii: function dynCall_viiiiii(n, r, t, e, i, o, u) {
                r |= 0, t |= 0, e |= 0, i |= 0, o |= 0, u |= 0, a[n |= 0](r, t, e, i, o, u);
              },
              dynCall_viiiii: function dynCall_viiiii(n, r, t, e, i, o) {
                r |= 0, t |= 0, e |= 0, i |= 0, o |= 0, a[n |= 0](r, t, e, i, o);
              }
            };
          }({
            Int8Array: Int8Array,
            Int16Array: Int16Array,
            Int32Array: Int32Array,
            Uint8Array: Uint8Array,
            Uint16Array: Uint16Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array,
            NaN: NaN,
            Infinity: 1 / 0,
            Math: Math
          }, n, r.buffer);
        }(Ot, p, y)
      };
    },
    instantiate: function instantiate(n, r) {
      return {
        then: function then(r) {
          r({
            instance: new h.Instance(new h.Module(n))
          });
        }
      };
    },
    RuntimeError: Error
  };
  d = [], "object" !== n(h) && v("no native wasm support detected");
  var y = new h.Table({
    initial: 231,
    maximum: 231,
    element: "anyfunc"
  }),
      m = !1;

  function k(n, r) {
    n || ln("Assertion failed: " + r);
  }

  var g = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;

  function _(n, r, t) {
    for (var e = r + t, i = r; n[i] && !(i >= e);) {
      ++i;
    }

    if (i - r > 16 && n.subarray && g) return g.decode(n.subarray(r, i));

    for (var a = ""; r < i;) {
      var o = n[r++];

      if (128 & o) {
        var u = 63 & n[r++];

        if (192 != (224 & o)) {
          var f = 63 & n[r++];
          if ((o = 224 == (240 & o) ? (15 & o) << 12 | u << 6 | f : (7 & o) << 18 | u << 12 | f << 6 | 63 & n[r++]) < 65536) a += String.fromCharCode(o);else {
            var A = o - 65536;
            a += String.fromCharCode(55296 | A >> 10, 56320 | 1023 & A);
          }
        } else a += String.fromCharCode((31 & o) << 6 | u);
      } else a += String.fromCharCode(o);
    }

    return a;
  }

  function C(n, r) {
    return n ? _(X, n, r) : "";
  }

  function E(n, r, t, e) {
    if (!(e > 0)) return 0;

    for (var i = t, a = t + e - 1, o = 0; o < n.length; ++o) {
      var u = n.charCodeAt(o);

      if (u >= 55296 && u <= 57343 && (u = 65536 + ((1023 & u) << 10) | 1023 & n.charCodeAt(++o)), u <= 127) {
        if (t >= a) break;
        r[t++] = u;
      } else if (u <= 2047) {
        if (t + 1 >= a) break;
        r[t++] = 192 | u >> 6, r[t++] = 128 | 63 & u;
      } else if (u <= 65535) {
        if (t + 2 >= a) break;
        r[t++] = 224 | u >> 12, r[t++] = 128 | u >> 6 & 63, r[t++] = 128 | 63 & u;
      } else {
        if (t + 3 >= a) break;
        r[t++] = 240 | u >> 18, r[t++] = 128 | u >> 12 & 63, r[t++] = 128 | u >> 6 & 63, r[t++] = 128 | 63 & u;
      }
    }

    return r[t] = 0, t - i;
  }

  function w(n, r, t) {
    return E(n, X, r, t);
  }

  function N(n) {
    for (var r = 0, t = 0; t < n.length; ++t) {
      var e = n.charCodeAt(t);
      e >= 55296 && e <= 57343 && (e = 65536 + ((1023 & e) << 10) | 1023 & n.charCodeAt(++t)), e <= 127 ? ++r : r += e <= 2047 ? 2 : e <= 65535 ? 3 : 4;
    }

    return r;
  }

  var W = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0;

  function Z(n, r) {
    for (var t = n, e = t >> 1, i = e + r / 2; !(e >= i) && Q[e];) {
      ++e;
    }

    if ((t = e << 1) - n > 32 && W) return W.decode(X.subarray(n, t));

    for (var a = 0, o = "";;) {
      var u = O[n + 2 * a >> 1];
      if (0 == u || a == r / 2) return o;
      ++a, o += String.fromCharCode(u);
    }
  }

  function T(n, r, t) {
    if (void 0 === t && (t = 2147483647), t < 2) return 0;

    for (var e = r, i = (t -= 2) < 2 * n.length ? t / 2 : n.length, a = 0; a < i; ++a) {
      var o = n.charCodeAt(a);
      O[r >> 1] = o, r += 2;
    }

    return O[r >> 1] = 0, r - e;
  }

  function I(n) {
    return 2 * n.length;
  }

  function R(n, r) {
    for (var t = 0, e = ""; !(t >= r / 4);) {
      var i = U[n + 4 * t >> 2];
      if (0 == i) break;

      if (++t, i >= 65536) {
        var a = i - 65536;
        e += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
      } else e += String.fromCharCode(i);
    }

    return e;
  }

  function B(n, r, t) {
    if (void 0 === t && (t = 2147483647), t < 4) return 0;

    for (var e = r, i = e + t - 4, a = 0; a < n.length; ++a) {
      var o = n.charCodeAt(a);
      if (o >= 55296 && o <= 57343 && (o = 65536 + ((1023 & o) << 10) | 1023 & n.charCodeAt(++a)), U[r >> 2] = o, (r += 4) + 4 > i) break;
    }

    return U[r >> 2] = 0, r - e;
  }

  function V(n) {
    for (var r = 0, t = 0; t < n.length; ++t) {
      var e = n.charCodeAt(t);
      e >= 55296 && e <= 57343 && ++t, r += 4;
    }

    return r;
  }

  var G,
      F,
      X,
      O,
      Q,
      U,
      Y,
      P,
      D,
      S = 65536;

  function H(n, r) {
    return n % r > 0 && (n += r - n % r), n;
  }

  function j(n) {
    G = n, r.HEAP8 = F = new Int8Array(n), r.HEAP16 = O = new Int16Array(n), r.HEAP32 = U = new Int32Array(n), r.HEAPU8 = X = new Uint8Array(n), r.HEAPU16 = Q = new Uint16Array(n), r.HEAPU32 = Y = new Uint32Array(n), r.HEAPF32 = P = new Float32Array(n), r.HEAPF64 = D = new Float64Array(n);
  }

  var M = 5254160,
      x = 11120,
      J = r.INITIAL_MEMORY || 16777216;

  function $(n) {
    for (; n.length > 0;) {
      var t = n.shift();

      if ("function" != typeof t) {
        var e = t.func;
        "number" == typeof e ? void 0 === t.arg ? r.dynCall_v(e) : r.dynCall_vi(e, t.arg) : e(void 0 === t.arg ? null : t.arg);
      } else t(r);
    }
  }

  (p = r.wasmMemory ? r.wasmMemory : new h.Memory({
    initial: J / S,
    maximum: 2147483648 / S
  })) && (G = p.buffer), J = G.byteLength, j(G), U[x >> 2] = M;
  var z = [],
      L = [],
      K = [],
      q = [];

  function nn() {
    if (r.preRun) for ("function" == typeof r.preRun && (r.preRun = [r.preRun]); r.preRun.length;) {
      an(r.preRun.shift());
    }
    $(z);
  }

  function rn() {
    $(L);
  }

  function tn() {
    $(K);
  }

  function en() {
    if (r.postRun) for ("function" == typeof r.postRun && (r.postRun = [r.postRun]); r.postRun.length;) {
      on(r.postRun.shift());
    }
    $(q);
  }

  function an(n) {
    z.unshift(n);
  }

  function on(n) {
    q.unshift(n);
  }

  var un = 0,
      fn = null;

  function An(n) {
    un++, r.monitorRunDependencies && r.monitorRunDependencies(un);
  }

  function cn(n) {
    if (un--, r.monitorRunDependencies && r.monitorRunDependencies(un), 0 == un && fn) {
      var t = fn;
      fn = null, t();
    }
  }

  function ln(n) {
    throw r.onAbort && r.onAbort(n), s(n += ""), v(n), m = !0, n = "abort(" + n + "). Build with -s ASSERTIONS=1 for more info.", new h.RuntimeError(n);
  }

  function sn(n, r) {
    return String.prototype.startsWith ? n.startsWith(r) : 0 === n.indexOf(r);
  }

  r.preloadedImages = {}, r.preloadedAudios = {};
  var vn = "data:application/octet-stream;base64,";

  function dn(n) {
    return sn(n, vn);
  }

  var bn = "yoga.asm.wasm";

  function pn() {
    try {
      if (d) return new Uint8Array(d);
      var n = Xt(bn);
      if (n) return n;
      if (A) return A(bn);
      throw "both async and sync fetching of the wasm failed";
    } catch (n) {
      ln(n);
    }
  }

  function hn() {
    return d || !a && !u || "function" != typeof fetch ? new Promise(function (n, r) {
      n(pn());
    }) : fetch(bn, {
      credentials: "same-origin"
    }).then(function (n) {
      if (!n.ok) throw "failed to load wasm binary file at '" + bn + "'";
      return n.arrayBuffer();
    }).catch(function () {
      return pn();
    });
  }

  function yn() {
    var n = {
      env: Ot,
      wasi_snapshot_preview1: Ot
    };

    function t(n, t) {
      var e = n.exports;
      r.asm = e, cn();
    }

    function e(n) {
      t(n.instance);
    }

    function i(r) {
      return hn().then(function (r) {
        return h.instantiate(r, n);
      }).then(r, function (n) {
        v("failed to asynchronously prepare wasm: " + n), ln(n);
      });
    }

    if (An(), r.instantiateWasm) try {
      return r.instantiateWasm(n, t);
    } catch (n) {
      return v("Module.instantiateWasm callback failed with error: " + n), !1;
    }
    return function () {
      if (d || "function" != typeof h.instantiateStreaming || dn(bn) || "function" != typeof fetch) return i(e);
      fetch(bn, {
        credentials: "same-origin"
      }).then(function (r) {
        return h.instantiateStreaming(r, n).then(e, function (n) {
          v("wasm streaming compile failed: " + n), v("falling back to ArrayBuffer instantiation"), i(e);
        });
      });
    }(), {};
  }

  function mn() {
    v("missing function: _ZN8facebook4yoga24LayoutPassReasonToStringENS0_16LayoutPassReasonE"), ln(-1);
  }

  function kn(n) {
    return Dt(n);
  }

  function gn(n, r, t) {
    throw n;
  }

  dn(bn) || (bn = l(bn)), L.push({
    func: function func() {
      Yt();
    }
  });
  var _n = 48,
      Cn = 57;

  function En(n) {
    if (void 0 === n) return "_unknown";
    var r = (n = n.replace(/[^a-zA-Z0-9_]/g, "$")).charCodeAt(0);
    return r >= _n && r <= Cn ? "_" + n : n;
  }

  function wn(n, r) {
    return n = En(n), new Function("body", "return function " + n + '() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(r);
  }

  var Nn = [],
      Wn = [{}, {
    value: void 0
  }, {
    value: null
  }, {
    value: !0
  }, {
    value: !1
  }];

  function Zn() {
    for (var n = 0, r = 5; r < Wn.length; ++r) {
      void 0 !== Wn[r] && ++n;
    }

    return n;
  }

  function Tn() {
    for (var n = 5; n < Wn.length; ++n) {
      if (void 0 !== Wn[n]) return Wn[n];
    }

    return null;
  }

  function In() {
    r.count_emval_handles = Zn, r.get_first_emval = Tn;
  }

  function Rn(n) {
    switch (n) {
      case void 0:
        return 1;

      case null:
        return 2;

      case !0:
        return 3;

      case !1:
        return 4;

      default:
        var r = Nn.length ? Nn.pop() : Wn.length;
        return Wn[r] = {
          refcount: 1,
          value: n
        }, r;
    }
  }

  function Bn(n, r) {
    var t = wn(r, function (n) {
      this.name = r, this.message = n;
      var t = new Error(n).stack;
      void 0 !== t && (this.stack = this.toString() + "\n" + t.replace(/^Error(:[^\n]*)?\n/, ""));
    });
    return t.prototype = Object.create(n.prototype), t.prototype.constructor = t, t.prototype.toString = function () {
      return void 0 === this.message ? this.name : this.name + ": " + this.message;
    }, t;
  }

  var Vn = void 0;

  function Gn() {
    for (var n = new Array(256), r = 0; r < 256; ++r) {
      n[r] = String.fromCharCode(r);
    }

    Fn = n;
  }

  var Fn = void 0;

  function Xn(n) {
    for (var r = "", t = n; X[t];) {
      r += Fn[X[t++]];
    }

    return r;
  }

  function On() {
    return Object.keys(Hn).length;
  }

  function Qn() {
    var n = [];

    for (var r in Hn) {
      Hn.hasOwnProperty(r) && n.push(Hn[r]);
    }

    return n;
  }

  var Un = [];

  function Yn() {
    for (; Un.length;) {
      var n = Un.pop();
      n.$$.deleteScheduled = !1, n.delete();
    }
  }

  var Pn = void 0;

  function Dn(n) {
    Pn = n, Un.length && Pn && Pn(Yn);
  }

  function Sn() {
    r.getInheritedInstanceCount = On, r.getLiveInheritedInstances = Qn, r.flushPendingDeletes = Yn, r.setDelayFunction = Dn;
  }

  var Hn = {},
      jn = void 0;

  function Mn(n) {
    throw new jn(n);
  }

  function xn(n, r) {
    for (void 0 === r && Mn("ptr should not be undefined"); n.baseClass;) {
      r = n.upcast(r), n = n.baseClass;
    }

    return r;
  }

  function Jn(n, r, t) {
    r = xn(n, r), Hn.hasOwnProperty(r) ? Mn("Tried to register registered instance: " + r) : Hn[r] = t;
  }

  function $n(n) {
    return n || Mn("Cannot use deleted val. handle = " + n), Wn[n].value;
  }

  var zn = {};

  function Ln(n) {
    var r = Pt(n),
        t = Xn(r);
    return St(r), t;
  }

  function Kn(n, r) {
    var t = zn[n];
    return void 0 === t && Mn(r + " has unknown type " + Ln(n)), t;
  }

  function qn(n, r) {
    r = xn(n, r), Hn.hasOwnProperty(r) ? delete Hn[r] : Mn("Tried to unregister unregistered instance: " + r);
  }

  function nr(n) {}

  var rr = !1;

  function tr(n) {
    n.smartPtr ? n.smartPtrType.rawDestructor(n.smartPtr) : n.ptrType.registeredClass.rawDestructor(n.ptr);
  }

  function er(n) {
    n.count.value -= 1, 0 === n.count.value && tr(n);
  }

  function ir(n) {
    return "undefined" == typeof FinalizationGroup ? (ir = function ir(n) {
      return n;
    }, n) : (rr = new FinalizationGroup(function (n) {
      for (var r = n.next(); !r.done; r = n.next()) {
        var t = r.value;
        t.ptr ? er(t) : console.warn("object already deleted: " + t.ptr);
      }
    }), nr = function nr(n) {
      rr.unregister(n.$$);
    }, (ir = function ir(n) {
      return rr.register(n, n.$$, n.$$), n;
    })(n));
  }

  function ar(n, r, t) {
    n = Xn(n), r = Kn(r, "wrapper"), t = $n(t);
    var e = [].slice,
        i = r.registeredClass,
        a = i.instancePrototype,
        o = i.baseClass.instancePrototype,
        u = i.baseClass.constructor,
        f = wn(n, function () {
      i.baseClass.pureVirtualFunctions.forEach(function (n) {
        if (this[n] === o[n]) throw new Vn("Pure virtual function " + n + " must be implemented in JavaScript");
      }.bind(this)), Object.defineProperty(this, "__parent", {
        value: a
      }), this.__construct.apply(this, e.call(arguments));
    });

    for (var A in a.__construct = function () {
      this === a && Mn("Pass correct 'this' to __construct");
      var n = u.implement.apply(void 0, [this].concat(e.call(arguments)));
      nr(n);
      var r = n.$$;
      n.notifyOnDestruction(), r.preservePointerOnDelete = !0, Object.defineProperties(this, {
        $$: {
          value: r
        }
      }), ir(this), Jn(i, r.ptr, this);
    }, a.__destruct = function () {
      this === a && Mn("Pass correct 'this' to __destruct"), nr(this), qn(i, this.$$.ptr);
    }, f.prototype = Object.create(a), t) {
      f.prototype[A] = t[A];
    }

    return Rn(f);
  }

  var or = {};

  function ur(n) {
    for (; n.length;) {
      var r = n.pop();
      n.pop()(r);
    }
  }

  function fr(n) {
    return this.fromWireType(Y[n >> 2]);
  }

  var Ar = {},
      cr = {},
      lr = void 0;

  function sr(n) {
    throw new lr(n);
  }

  function vr(n, r, t) {
    function e(r) {
      var e = t(r);
      e.length !== n.length && sr("Mismatched type converter count");

      for (var i = 0; i < n.length; ++i) {
        pr(n[i], e[i]);
      }
    }

    n.forEach(function (n) {
      cr[n] = r;
    });
    var i = new Array(r.length),
        a = [],
        o = 0;
    r.forEach(function (n, r) {
      zn.hasOwnProperty(n) ? i[r] = zn[n] : (a.push(n), Ar.hasOwnProperty(n) || (Ar[n] = []), Ar[n].push(function () {
        i[r] = zn[n], ++o === a.length && e(i);
      }));
    }), 0 === a.length && e(i);
  }

  function dr(n) {
    var r = or[n];
    delete or[n];
    var t = r.rawConstructor,
        e = r.rawDestructor,
        i = r.fields;
    vr([n], i.map(function (n) {
      return n.getterReturnType;
    }).concat(i.map(function (n) {
      return n.setterArgumentType;
    })), function (n) {
      var a = {};
      return i.forEach(function (r, t) {
        var e = r.fieldName,
            o = n[t],
            u = r.getter,
            f = r.getterContext,
            A = n[t + i.length],
            c = r.setter,
            l = r.setterContext;
        a[e] = {
          read: function read(n) {
            return o.fromWireType(u(f, n));
          },
          write: function write(n, r) {
            var t = [];
            c(l, n, A.toWireType(t, r)), ur(t);
          }
        };
      }), [{
        name: r.name,
        fromWireType: function fromWireType(n) {
          var r = {};

          for (var t in a) {
            r[t] = a[t].read(n);
          }

          return e(n), r;
        },
        toWireType: function toWireType(n, r) {
          for (var i in a) {
            if (!(i in r)) throw new TypeError("Missing field");
          }

          var o = t();

          for (i in a) {
            a[i].write(o, r[i]);
          }

          return null !== n && n.push(e, o), o;
        },
        argPackAdvance: 8,
        readValueFromPointer: fr,
        destructorFunction: e
      }];
    });
  }

  function br(n) {
    switch (n) {
      case 1:
        return 0;

      case 2:
        return 1;

      case 4:
        return 2;

      case 8:
        return 3;

      default:
        throw new TypeError("Unknown type size: " + n);
    }
  }

  function pr(n, r, t) {
    if (t = t || {}, !("argPackAdvance" in r)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
    var e = r.name;

    if (n || Mn('type "' + e + '" must have a positive integer typeid pointer'), zn.hasOwnProperty(n)) {
      if (t.ignoreDuplicateRegistrations) return;
      Mn("Cannot register type '" + e + "' twice");
    }

    if (zn[n] = r, delete cr[n], Ar.hasOwnProperty(n)) {
      var i = Ar[n];
      delete Ar[n], i.forEach(function (n) {
        n();
      });
    }
  }

  function hr(n, r, t, e, i) {
    var a = br(t);
    pr(n, {
      name: r = Xn(r),
      fromWireType: function fromWireType(n) {
        return !!n;
      },
      toWireType: function toWireType(n, r) {
        return r ? e : i;
      },
      argPackAdvance: 8,
      readValueFromPointer: function readValueFromPointer(n) {
        var e;
        if (1 === t) e = F;else if (2 === t) e = O;else {
          if (4 !== t) throw new TypeError("Unknown boolean type size: " + r);
          e = U;
        }
        return this.fromWireType(e[n >> a]);
      },
      destructorFunction: null
    });
  }

  function yr(n) {
    if (!(this instanceof Nr)) return !1;
    if (!(n instanceof Nr)) return !1;

    for (var r = this.$$.ptrType.registeredClass, t = this.$$.ptr, e = n.$$.ptrType.registeredClass, i = n.$$.ptr; r.baseClass;) {
      t = r.upcast(t), r = r.baseClass;
    }

    for (; e.baseClass;) {
      i = e.upcast(i), e = e.baseClass;
    }

    return r === e && t === i;
  }

  function mr(n) {
    return {
      count: n.count,
      deleteScheduled: n.deleteScheduled,
      preservePointerOnDelete: n.preservePointerOnDelete,
      ptr: n.ptr,
      ptrType: n.ptrType,
      smartPtr: n.smartPtr,
      smartPtrType: n.smartPtrType
    };
  }

  function kr(n) {
    Mn(n.$$.ptrType.registeredClass.name + " instance already deleted");
  }

  function gr() {
    if (this.$$.ptr || kr(this), this.$$.preservePointerOnDelete) return this.$$.count.value += 1, this;
    var n = ir(Object.create(Object.getPrototypeOf(this), {
      $$: {
        value: mr(this.$$)
      }
    }));
    return n.$$.count.value += 1, n.$$.deleteScheduled = !1, n;
  }

  function _r() {
    this.$$.ptr || kr(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Mn("Object already scheduled for deletion"), nr(this), er(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
  }

  function Cr() {
    return !this.$$.ptr;
  }

  function Er() {
    return this.$$.ptr || kr(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Mn("Object already scheduled for deletion"), Un.push(this), 1 === Un.length && Pn && Pn(Yn), this.$$.deleteScheduled = !0, this;
  }

  function wr() {
    Nr.prototype.isAliasOf = yr, Nr.prototype.clone = gr, Nr.prototype.delete = _r, Nr.prototype.isDeleted = Cr, Nr.prototype.deleteLater = Er;
  }

  function Nr() {}

  var Wr = {};

  function Zr(n, r, t) {
    if (void 0 === n[r].overloadTable) {
      var e = n[r];
      n[r] = function () {
        return n[r].overloadTable.hasOwnProperty(arguments.length) || Mn("Function '" + t + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + n[r].overloadTable + ")!"), n[r].overloadTable[arguments.length].apply(this, arguments);
      }, n[r].overloadTable = [], n[r].overloadTable[e.argCount] = e;
    }
  }

  function Tr(n, t, e) {
    r.hasOwnProperty(n) ? ((void 0 === e || void 0 !== r[n].overloadTable && void 0 !== r[n].overloadTable[e]) && Mn("Cannot register public name '" + n + "' twice"), Zr(r, n, n), r.hasOwnProperty(e) && Mn("Cannot register multiple overloads of a function with the same number of arguments (" + e + ")!"), r[n].overloadTable[e] = t) : (r[n] = t, void 0 !== e && (r[n].numArguments = e));
  }

  function Ir(n, r, t, e, i, a, o, u) {
    this.name = n, this.constructor = r, this.instancePrototype = t, this.rawDestructor = e, this.baseClass = i, this.getActualType = a, this.upcast = o, this.downcast = u, this.pureVirtualFunctions = [];
  }

  function Rr(n, r, t) {
    for (; r !== t;) {
      r.upcast || Mn("Expected null or instance of " + t.name + ", got an instance of " + r.name), n = r.upcast(n), r = r.baseClass;
    }

    return n;
  }

  function Br(n, r) {
    if (null === r) return this.isReference && Mn("null is not a valid " + this.name), 0;
    r.$$ || Mn('Cannot pass "' + et(r) + '" as a ' + this.name), r.$$.ptr || Mn("Cannot pass deleted object as a pointer of type " + this.name);
    var t = r.$$.ptrType.registeredClass;
    return Rr(r.$$.ptr, t, this.registeredClass);
  }

  function Vr(n, r) {
    var t;
    if (null === r) return this.isReference && Mn("null is not a valid " + this.name), this.isSmartPointer ? (t = this.rawConstructor(), null !== n && n.push(this.rawDestructor, t), t) : 0;
    r.$$ || Mn('Cannot pass "' + et(r) + '" as a ' + this.name), r.$$.ptr || Mn("Cannot pass deleted object as a pointer of type " + this.name), !this.isConst && r.$$.ptrType.isConst && Mn("Cannot convert argument of type " + (r.$$.smartPtrType ? r.$$.smartPtrType.name : r.$$.ptrType.name) + " to parameter type " + this.name);
    var e = r.$$.ptrType.registeredClass;
    if (t = Rr(r.$$.ptr, e, this.registeredClass), this.isSmartPointer) switch (void 0 === r.$$.smartPtr && Mn("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
      case 0:
        r.$$.smartPtrType === this ? t = r.$$.smartPtr : Mn("Cannot convert argument of type " + (r.$$.smartPtrType ? r.$$.smartPtrType.name : r.$$.ptrType.name) + " to parameter type " + this.name);
        break;

      case 1:
        t = r.$$.smartPtr;
        break;

      case 2:
        if (r.$$.smartPtrType === this) t = r.$$.smartPtr;else {
          var i = r.clone();
          t = this.rawShare(t, Rn(function () {
            i.delete();
          })), null !== n && n.push(this.rawDestructor, t);
        }
        break;

      default:
        Mn("Unsupporting sharing policy");
    }
    return t;
  }

  function Gr(n, r) {
    if (null === r) return this.isReference && Mn("null is not a valid " + this.name), 0;
    r.$$ || Mn('Cannot pass "' + et(r) + '" as a ' + this.name), r.$$.ptr || Mn("Cannot pass deleted object as a pointer of type " + this.name), r.$$.ptrType.isConst && Mn("Cannot convert argument of type " + r.$$.ptrType.name + " to parameter type " + this.name);
    var t = r.$$.ptrType.registeredClass;
    return Rr(r.$$.ptr, t, this.registeredClass);
  }

  function Fr(n) {
    return this.rawGetPointee && (n = this.rawGetPointee(n)), n;
  }

  function Xr(n) {
    this.rawDestructor && this.rawDestructor(n);
  }

  function Or(n) {
    null !== n && n.delete();
  }

  function Qr(n, r, t) {
    if (r === t) return n;
    if (void 0 === t.baseClass) return null;
    var e = Qr(n, r, t.baseClass);
    return null === e ? null : t.downcast(e);
  }

  function Ur(n, r) {
    return r = xn(n, r), Hn[r];
  }

  function Yr(n, r) {
    return r.ptrType && r.ptr || sr("makeClassHandle requires ptr and ptrType"), !!r.smartPtrType != !!r.smartPtr && sr("Both smartPtrType and smartPtr must be specified"), r.count = {
      value: 1
    }, ir(Object.create(n, {
      $$: {
        value: r
      }
    }));
  }

  function Pr(n) {
    var r = this.getPointee(n);
    if (!r) return this.destructor(n), null;
    var t = Ur(this.registeredClass, r);

    if (void 0 !== t) {
      if (0 === t.$$.count.value) return t.$$.ptr = r, t.$$.smartPtr = n, t.clone();
      var e = t.clone();
      return this.destructor(n), e;
    }

    function i() {
      return this.isSmartPointer ? Yr(this.registeredClass.instancePrototype, {
        ptrType: this.pointeeType,
        ptr: r,
        smartPtrType: this,
        smartPtr: n
      }) : Yr(this.registeredClass.instancePrototype, {
        ptrType: this,
        ptr: n
      });
    }

    var a,
        o = this.registeredClass.getActualType(r),
        u = Wr[o];
    if (!u) return i.call(this);
    a = this.isConst ? u.constPointerType : u.pointerType;
    var f = Qr(r, this.registeredClass, a.registeredClass);
    return null === f ? i.call(this) : this.isSmartPointer ? Yr(a.registeredClass.instancePrototype, {
      ptrType: a,
      ptr: f,
      smartPtrType: this,
      smartPtr: n
    }) : Yr(a.registeredClass.instancePrototype, {
      ptrType: a,
      ptr: f
    });
  }

  function Dr() {
    Sr.prototype.getPointee = Fr, Sr.prototype.destructor = Xr, Sr.prototype.argPackAdvance = 8, Sr.prototype.readValueFromPointer = fr, Sr.prototype.deleteObject = Or, Sr.prototype.fromWireType = Pr;
  }

  function Sr(n, r, t, e, i, a, o, u, f, A, c) {
    this.name = n, this.registeredClass = r, this.isReference = t, this.isConst = e, this.isSmartPointer = i, this.pointeeType = a, this.sharingPolicy = o, this.rawGetPointee = u, this.rawConstructor = f, this.rawShare = A, this.rawDestructor = c, i || void 0 !== r.baseClass ? this.toWireType = Vr : e ? (this.toWireType = Br, this.destructorFunction = null) : (this.toWireType = Gr, this.destructorFunction = null);
  }

  function Hr(n, t, e) {
    r.hasOwnProperty(n) || sr("Replacing nonexistant public symbol"), void 0 !== r[n].overloadTable && void 0 !== e ? r[n].overloadTable[e] = t : (r[n] = t, r[n].argCount = e);
  }

  function jr(n, t) {
    n = Xn(n);

    var e = function (r) {
      for (var e = [], i = 1; i < n.length; ++i) {
        e.push("a" + i);
      }

      var a = "return function dynCall_" + n + "_" + t + "(" + e.join(", ") + ") {\n";
      return a += "    return dynCall(rawFunction" + (e.length ? ", " : "") + e.join(", ") + ");\n", a += "};\n", new Function("dynCall", "rawFunction", a)(r, t);
    }(r["dynCall_" + n]);

    return "function" != typeof e && Mn("unknown function pointer with signature " + n + ": " + t), e;
  }

  var Mr = void 0;

  function xr(n, r) {
    var t = [],
        e = {};
    throw r.forEach(function n(r) {
      e[r] || zn[r] || (cr[r] ? cr[r].forEach(n) : (t.push(r), e[r] = !0));
    }), new Mr(n + ": " + t.map(Ln).join([", "]));
  }

  function Jr(n, r, t, e, i, a, o, u, f, A, c, l, s) {
    c = Xn(c), a = jr(i, a), u && (u = jr(o, u)), A && (A = jr(f, A)), s = jr(l, s);
    var v = En(c);
    Tr(v, function () {
      xr("Cannot construct " + c + " due to unbound types", [e]);
    }), vr([n, r, t], e ? [e] : [], function (r) {
      var t, i;
      r = r[0], i = e ? (t = r.registeredClass).instancePrototype : Nr.prototype;
      var o = wn(v, function () {
        if (Object.getPrototypeOf(this) !== f) throw new jn("Use 'new' to construct " + c);
        if (void 0 === l.constructor_body) throw new jn(c + " has no accessible constructor");
        var n = l.constructor_body[arguments.length];
        if (void 0 === n) throw new jn("Tried to invoke ctor of " + c + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(l.constructor_body).toString() + ") parameters instead!");
        return n.apply(this, arguments);
      }),
          f = Object.create(i, {
        constructor: {
          value: o
        }
      });
      o.prototype = f;
      var l = new Ir(c, o, f, s, t, a, u, A),
          d = new Sr(c, l, !0, !1, !1),
          b = new Sr(c + "*", l, !1, !1, !1),
          p = new Sr(c + " const*", l, !1, !0, !1);
      return Wr[n] = {
        pointerType: b,
        constPointerType: p
      }, Hr(v, o), [d, b, p];
    });
  }

  function $r(r, t) {
    if (!(r instanceof Function)) throw new TypeError("new_ called with constructor type " + n(r) + " which is not a function");
    var e = wn(r.name || "unknownFunctionName", function () {});
    e.prototype = r.prototype;
    var i = new e(),
        a = r.apply(i, t);
    return a instanceof Object ? a : i;
  }

  function zr(n, r, t, e, i) {
    var a = r.length;
    a < 2 && Mn("argTypes array size mismatch! Must at least get return value and 'this' types!");

    for (var o = null !== r[1] && null !== t, u = !1, f = 1; f < r.length; ++f) {
      if (null !== r[f] && void 0 === r[f].destructorFunction) {
        u = !0;
        break;
      }
    }

    var A = "void" !== r[0].name,
        c = "",
        l = "";

    for (f = 0; f < a - 2; ++f) {
      c += (0 !== f ? ", " : "") + "arg" + f, l += (0 !== f ? ", " : "") + "arg" + f + "Wired";
    }

    var s = "return function " + En(n) + "(" + c + ") {\nif (arguments.length !== " + (a - 2) + ") {\nthrowBindingError('function " + n + " called with ' + arguments.length + ' arguments, expected " + (a - 2) + " args!');\n}\n";
    u && (s += "var destructors = [];\n");
    var v = u ? "destructors" : "null",
        d = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"],
        b = [Mn, e, i, ur, r[0], r[1]];

    for (o && (s += "var thisWired = classParam.toWireType(" + v + ", this);\n"), f = 0; f < a - 2; ++f) {
      s += "var arg" + f + "Wired = argType" + f + ".toWireType(" + v + ", arg" + f + "); // " + r[f + 2].name + "\n", d.push("argType" + f), b.push(r[f + 2]);
    }

    if (o && (l = "thisWired" + (l.length > 0 ? ", " : "") + l), s += (A ? "var rv = " : "") + "invoker(fn" + (l.length > 0 ? ", " : "") + l + ");\n", u) s += "runDestructors(destructors);\n";else for (f = o ? 1 : 2; f < r.length; ++f) {
      var p = 1 === f ? "thisWired" : "arg" + (f - 2) + "Wired";
      null !== r[f].destructorFunction && (s += p + "_dtor(" + p + "); // " + r[f].name + "\n", d.push(p + "_dtor"), b.push(r[f].destructorFunction));
    }
    return A && (s += "var ret = retType.fromWireType(rv);\nreturn ret;\n"), s += "}\n", d.push(s), $r(Function, d).apply(null, b);
  }

  function Lr(n, r) {
    for (var t = [], e = 0; e < n; e++) {
      t.push(U[(r >> 2) + e]);
    }

    return t;
  }

  function Kr(n, r, t, e, i, a, o) {
    var u = Lr(t, e);
    r = Xn(r), a = jr(i, a), vr([], [n], function (n) {
      var e = (n = n[0]).name + "." + r;

      function i() {
        xr("Cannot call " + e + " due to unbound types", u);
      }

      var f = n.registeredClass.constructor;
      return void 0 === f[r] ? (i.argCount = t - 1, f[r] = i) : (Zr(f, r, e), f[r].overloadTable[t - 1] = i), vr([], u, function (n) {
        var i = [n[0], null].concat(n.slice(1)),
            u = zr(e, i, null, a, o);
        return void 0 === f[r].overloadTable ? (u.argCount = t - 1, f[r] = u) : f[r].overloadTable[t - 1] = u, [];
      }), [];
    });
  }

  function qr(n, r, t, e, i, a) {
    k(r > 0);
    var o = Lr(r, t);
    i = jr(e, i);
    var u = [a],
        f = [];
    vr([], [n], function (n) {
      var t = "constructor " + (n = n[0]).name;
      if (void 0 === n.registeredClass.constructor_body && (n.registeredClass.constructor_body = []), void 0 !== n.registeredClass.constructor_body[r - 1]) throw new jn("Cannot register multiple constructors with identical number of parameters (" + (r - 1) + ") for class '" + n.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
      return n.registeredClass.constructor_body[r - 1] = function () {
        xr("Cannot construct " + n.name + " due to unbound types", o);
      }, vr([], o, function (e) {
        return n.registeredClass.constructor_body[r - 1] = function () {
          arguments.length !== r - 1 && Mn(t + " called with " + arguments.length + " arguments, expected " + (r - 1)), f.length = 0, u.length = r;

          for (var n = 1; n < r; ++n) {
            u[n] = e[n].toWireType(f, arguments[n - 1]);
          }

          var a = i.apply(null, u);
          return ur(f), e[0].fromWireType(a);
        }, [];
      }), [];
    });
  }

  function nt(n, r, t, e, i, a, o, u) {
    var f = Lr(t, e);
    r = Xn(r), a = jr(i, a), vr([], [n], function (n) {
      var e = (n = n[0]).name + "." + r;

      function i() {
        xr("Cannot call " + e + " due to unbound types", f);
      }

      u && n.registeredClass.pureVirtualFunctions.push(r);
      var A = n.registeredClass.instancePrototype,
          c = A[r];
      return void 0 === c || void 0 === c.overloadTable && c.className !== n.name && c.argCount === t - 2 ? (i.argCount = t - 2, i.className = n.name, A[r] = i) : (Zr(A, r, e), A[r].overloadTable[t - 2] = i), vr([], f, function (i) {
        var u = zr(e, i, n, a, o);
        return void 0 === A[r].overloadTable ? (u.argCount = t - 2, A[r] = u) : A[r].overloadTable[t - 2] = u, [];
      }), [];
    });
  }

  function rt(n) {
    n > 4 && 0 == --Wn[n].refcount && (Wn[n] = void 0, Nn.push(n));
  }

  function tt(n, r) {
    pr(n, {
      name: r = Xn(r),
      fromWireType: function fromWireType(n) {
        var r = Wn[n].value;
        return rt(n), r;
      },
      toWireType: function toWireType(n, r) {
        return Rn(r);
      },
      argPackAdvance: 8,
      readValueFromPointer: fr,
      destructorFunction: null
    });
  }

  function et(r) {
    if (null === r) return "null";
    var t = n(r);
    return "object" === t || "array" === t || "function" === t ? r.toString() : "" + r;
  }

  function it(n, r) {
    switch (r) {
      case 2:
        return function (n) {
          return this.fromWireType(P[n >> 2]);
        };

      case 3:
        return function (n) {
          return this.fromWireType(D[n >> 3]);
        };

      default:
        throw new TypeError("Unknown float type: " + n);
    }
  }

  function at(n, r, t) {
    var e = br(t);
    pr(n, {
      name: r = Xn(r),
      fromWireType: function fromWireType(n) {
        return n;
      },
      toWireType: function toWireType(n, r) {
        if ("number" != typeof r && "boolean" != typeof r) throw new TypeError('Cannot convert "' + et(r) + '" to ' + this.name);
        return r;
      },
      argPackAdvance: 8,
      readValueFromPointer: it(r, e),
      destructorFunction: null
    });
  }

  function ot(n, r, t) {
    switch (r) {
      case 0:
        return t ? function (n) {
          return F[n];
        } : function (n) {
          return X[n];
        };

      case 1:
        return t ? function (n) {
          return O[n >> 1];
        } : function (n) {
          return Q[n >> 1];
        };

      case 2:
        return t ? function (n) {
          return U[n >> 2];
        } : function (n) {
          return Y[n >> 2];
        };

      default:
        throw new TypeError("Unknown integer type: " + n);
    }
  }

  function ut(n, r, t, e, i) {
    r = Xn(r), -1 === i && (i = 4294967295);

    var a = br(t),
        o = function o(n) {
      return n;
    };

    if (0 === e) {
      var u = 32 - 8 * t;

      o = function o(n) {
        return n << u >>> u;
      };
    }

    var f = -1 != r.indexOf("unsigned");
    pr(n, {
      name: r,
      fromWireType: o,
      toWireType: function toWireType(n, t) {
        if ("number" != typeof t && "boolean" != typeof t) throw new TypeError('Cannot convert "' + et(t) + '" to ' + this.name);
        if (t < e || t > i) throw new TypeError('Passing a number "' + et(t) + '" from JS side to C/C++ side to an argument of type "' + r + '", which is outside the valid range [' + e + ", " + i + "]!");
        return f ? t >>> 0 : 0 | t;
      },
      argPackAdvance: 8,
      readValueFromPointer: ot(r, a, 0 !== e),
      destructorFunction: null
    });
  }

  function ft(n, r, t) {
    var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][r];

    function i(n) {
      var r = Y,
          t = r[n >>= 2],
          i = r[n + 1];
      return new e(G, i, t);
    }

    pr(n, {
      name: t = Xn(t),
      fromWireType: i,
      argPackAdvance: 8,
      readValueFromPointer: i
    }, {
      ignoreDuplicateRegistrations: !0
    });
  }

  function At(n, r) {
    var t = "std::string" === (r = Xn(r));
    pr(n, {
      name: r,
      fromWireType: function fromWireType(n) {
        var r,
            e = Y[n >> 2];
        if (t) for (var i = n + 4, a = 0; a <= e; ++a) {
          var o = n + 4 + a;

          if (0 == X[o] || a == e) {
            var u = C(i, o - i);
            void 0 === r ? r = u : (r += String.fromCharCode(0), r += u), i = o + 1;
          }
        } else {
          var f = new Array(e);

          for (a = 0; a < e; ++a) {
            f[a] = String.fromCharCode(X[n + 4 + a]);
          }

          r = f.join("");
        }
        return St(n), r;
      },
      toWireType: function toWireType(n, r) {
        r instanceof ArrayBuffer && (r = new Uint8Array(r));
        var e = "string" == typeof r;
        e || r instanceof Uint8Array || r instanceof Uint8ClampedArray || r instanceof Int8Array || Mn("Cannot pass non-string to std::string");
        var i = (t && e ? function () {
          return N(r);
        } : function () {
          return r.length;
        })(),
            a = Dt(4 + i + 1);
        if (Y[a >> 2] = i, t && e) w(r, a + 4, i + 1);else if (e) for (var o = 0; o < i; ++o) {
          var u = r.charCodeAt(o);
          u > 255 && (St(a), Mn("String has UTF-16 code units that do not fit in 8 bits")), X[a + 4 + o] = u;
        } else for (o = 0; o < i; ++o) {
          X[a + 4 + o] = r[o];
        }
        return null !== n && n.push(St, a), a;
      },
      argPackAdvance: 8,
      readValueFromPointer: fr,
      destructorFunction: function destructorFunction(n) {
        St(n);
      }
    });
  }

  function ct(n, r, t) {
    var e, i, a, o, u;
    t = Xn(t), 2 === r ? (e = Z, i = T, o = I, a = function a() {
      return Q;
    }, u = 1) : 4 === r && (e = R, i = B, o = V, a = function a() {
      return Y;
    }, u = 2), pr(n, {
      name: t,
      fromWireType: function fromWireType(n) {
        for (var t, i = Y[n >> 2], o = a(), f = n + 4, A = 0; A <= i; ++A) {
          var c = n + 4 + A * r;

          if (0 == o[c >> u] || A == i) {
            var l = e(f, c - f);
            void 0 === t ? t = l : (t += String.fromCharCode(0), t += l), f = c + r;
          }
        }

        return St(n), t;
      },
      toWireType: function toWireType(n, e) {
        "string" != typeof e && Mn("Cannot pass non-string to C++ string type " + t);
        var a = o(e),
            f = Dt(4 + a + r);
        return Y[f >> 2] = a >> u, i(e, f + 4, a + r), null !== n && n.push(St, f), f;
      },
      argPackAdvance: 8,
      readValueFromPointer: fr,
      destructorFunction: function destructorFunction(n) {
        St(n);
      }
    });
  }

  function lt(n, r, t, e, i, a) {
    or[n] = {
      name: Xn(r),
      rawConstructor: jr(t, e),
      rawDestructor: jr(i, a),
      fields: []
    };
  }

  function st(n, r, t, e, i, a, o, u, f, A) {
    or[n].fields.push({
      fieldName: Xn(r),
      getterReturnType: t,
      getter: jr(e, i),
      getterContext: a,
      setterArgumentType: o,
      setter: jr(u, f),
      setterContext: A
    });
  }

  function vt(n, r) {
    pr(n, {
      isVoid: !0,
      name: r = Xn(r),
      argPackAdvance: 0,
      fromWireType: function fromWireType() {},
      toWireType: function toWireType(n, r) {}
    });
  }

  function dt(n) {
    var r = [];
    return U[n >> 2] = Rn(r), r;
  }

  var bt = {};

  function pt(n) {
    var r = bt[n];
    return void 0 === r ? Xn(n) : r;
  }

  var ht = [];

  function yt(n, r, t, e, i) {
    return (n = ht[n])(r = $n(r), t = pt(t), dt(e), i);
  }

  function mt(n, r, t, e) {
    (n = ht[n])(r = $n(r), t = pt(t), null, e);
  }

  function kt(n) {
    var r = ht.length;
    return ht.push(n), r;
  }

  function gt(n, r) {
    for (var t = new Array(n), e = 0; e < n; ++e) {
      t[e] = Kn(U[(r >> 2) + e], "parameter " + e);
    }

    return t;
  }

  function _t(n, r) {
    for (var t = gt(n, r), e = t[0], i = e.name + "_$" + t.slice(1).map(function (n) {
      return n.name;
    }).join("_") + "$", a = ["retType"], o = [e], u = "", f = 0; f < n - 1; ++f) {
      u += (0 !== f ? ", " : "") + "arg" + f, a.push("argType" + f), o.push(t[1 + f]);
    }

    var A = "return function " + En("methodCaller_" + i) + "(handle, name, destructors, args) {\n",
        c = 0;

    for (f = 0; f < n - 1; ++f) {
      A += "    var arg" + f + " = argType" + f + ".readValueFromPointer(args" + (c ? "+" + c : "") + ");\n", c += t[f + 1].argPackAdvance;
    }

    for (A += "    var rv = handle[name](" + u + ");\n", f = 0; f < n - 1; ++f) {
      t[f + 1].deleteObject && (A += "    argType" + f + ".deleteObject(arg" + f + ");\n");
    }

    return e.isVoid || (A += "    return retType.toWireType(destructors, rv);\n"), A += "};\n", a.push(A), kt($r(Function, a).apply(null, o));
  }

  function Ct(n) {
    n > 4 && (Wn[n].refcount += 1);
  }

  function Et(n) {
    ur(Wn[n].value), rt(n);
  }

  function wt() {
    ln();
  }

  function Nt(n, r, t) {
    X.copyWithin(n, r, r + t);
  }

  function Wt() {
    return X.length;
  }

  function Zt(n) {
    try {
      return p.grow(n - G.byteLength + 65535 >>> 16), j(p.buffer), 1;
    } catch (n) {}
  }

  function Tt(n) {
    n >>>= 0;
    var r = Wt();
    if (n > 2147483648) return !1;

    for (var t = 1; t <= 4; t *= 2) {
      var e = r * (1 + .2 / t);
      if (e = Math.min(e, n + 100663296), Zt(Math.min(2147483648, H(Math.max(16777216, n, e), 65536)))) return !0;
    }

    return !1;
  }

  var It = {
    mappings: {},
    buffers: [null, [], []],
    printChar: function printChar(n, r) {
      var t = It.buffers[n];
      0 === r || 10 === r ? ((1 === n ? s : v)(_(t, 0)), t.length = 0) : t.push(r);
    },
    varargs: void 0,
    get: function get() {
      return It.varargs += 4, U[It.varargs - 4 >> 2];
    },
    getStr: function getStr(n) {
      return C(n);
    },
    get64: function get64(n, r) {
      return n;
    }
  };

  function Rt(n) {
    return 0;
  }

  function Bt(n, r, t, e, i) {}

  function Vt(n, r, t, e) {
    for (var i = 0, a = 0; a < t; a++) {
      for (var o = U[r + 8 * a >> 2], u = U[r + (8 * a + 4) >> 2], f = 0; f < u; f++) {
        It.printChar(n, X[o + f]);
      }

      i += u;
    }

    return U[e >> 2] = i, 0;
  }

  In(), Vn = r.PureVirtualError = Bn(Error, "PureVirtualError"), Gn(), Sn(), jn = r.BindingError = Bn(Error, "BindingError"), lr = r.InternalError = Bn(Error, "InternalError"), wr(), Dr(), Mr = r.UnboundTypeError = Bn(Error, "UnboundTypeError");
  var Gt = "function" == typeof atob ? atob : function (n) {
    var r,
        t,
        e,
        i,
        a,
        o,
        u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        f = "",
        A = 0;
    n = n.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    do {
      r = u.indexOf(n.charAt(A++)) << 2 | (i = u.indexOf(n.charAt(A++))) >> 4, t = (15 & i) << 4 | (a = u.indexOf(n.charAt(A++))) >> 2, e = (3 & a) << 6 | (o = u.indexOf(n.charAt(A++))), f += String.fromCharCode(r), 64 !== a && (f += String.fromCharCode(t)), 64 !== o && (f += String.fromCharCode(e));
    } while (A < n.length);

    return f;
  };

  function Ft(n) {
    try {
      for (var r = Gt(n), t = new Uint8Array(r.length), e = 0; e < r.length; ++e) {
        t[e] = r.charCodeAt(e);
      }

      return t;
    } catch (n) {
      throw new Error("Converting base64 string to bytes failed.");
    }
  }

  function Xt(n) {
    if (dn(n)) return Ft(n.slice(vn.length));
  }

  var Ot = {
    _ZN8facebook4yoga24LayoutPassReasonToStringENS0_16LayoutPassReasonE: mn,
    __cxa_allocate_exception: kn,
    __cxa_throw: gn,
    _embind_create_inheriting_constructor: ar,
    _embind_finalize_value_object: dr,
    _embind_register_bool: hr,
    _embind_register_class: Jr,
    _embind_register_class_class_function: Kr,
    _embind_register_class_constructor: qr,
    _embind_register_class_function: nt,
    _embind_register_emval: tt,
    _embind_register_float: at,
    _embind_register_integer: ut,
    _embind_register_memory_view: ft,
    _embind_register_std_string: At,
    _embind_register_std_wstring: ct,
    _embind_register_value_object: lt,
    _embind_register_value_object_field: st,
    _embind_register_void: vt,
    _emval_call_method: yt,
    _emval_call_void_method: mt,
    _emval_decref: rt,
    _emval_get_method_caller: _t,
    _emval_incref: Ct,
    _emval_run_destructors: Et,
    abort: wt,
    emscripten_memcpy_big: Nt,
    emscripten_resize_heap: Tt,
    fd_close: Rt,
    fd_seek: Bt,
    fd_write: Vt,
    memory: p,
    setTempRet0: b,
    table: y
  },
      Qt = yn();
  r.asm = Qt;

  var Ut,
      Yt = r.___wasm_call_ctors = function () {
    return (Yt = r.___wasm_call_ctors = r.asm.__wasm_call_ctors).apply(null, arguments);
  },
      Pt = r.___getTypeName = function () {
    return (Pt = r.___getTypeName = r.asm.__getTypeName).apply(null, arguments);
  },
      Dt = (r.___embind_register_native_and_builtin_types = function () {
    return (r.___embind_register_native_and_builtin_types = r.asm.__embind_register_native_and_builtin_types).apply(null, arguments);
  }, r._malloc = function () {
    return (Dt = r._malloc = r.asm.malloc).apply(null, arguments);
  }),
      St = r._free = function () {
    return (St = r._free = r.asm.free).apply(null, arguments);
  },
      Ht = r.__growWasmMemory = function () {
    return (Ht = r.__growWasmMemory = r.asm.__growWasmMemory).apply(null, arguments);
  };

  function jt(n) {
    function e() {
      Ut || (Ut = !0, r.calledRun = !0, m || (rn(), tn(), t(r), r.onRuntimeInitialized && r.onRuntimeInitialized(), en()));
    }

    un > 0 || (nn(), un > 0 || (r.setStatus ? (r.setStatus("Running..."), setTimeout(function () {
      setTimeout(function () {
        r.setStatus("");
      }, 1), e();
    }, 1)) : e()));
  }

  if (r.dynCall_ii = function () {
    return (r.dynCall_ii = r.asm.dynCall_ii).apply(null, arguments);
  }, r.dynCall_iiiiii = function () {
    return (r.dynCall_iiiiii = r.asm.dynCall_iiiiii).apply(null, arguments);
  }, r.dynCall_vii = function () {
    return (r.dynCall_vii = r.asm.dynCall_vii).apply(null, arguments);
  }, r.dynCall_viififi = function () {
    return (r.dynCall_viififi = r.asm.dynCall_viififi).apply(null, arguments);
  }, r.dynCall_vi = function () {
    return (r.dynCall_vi = r.asm.dynCall_vi).apply(null, arguments);
  }, r.dynCall_i = function () {
    return (r.dynCall_i = r.asm.dynCall_i).apply(null, arguments);
  }, r.dynCall_viii = function () {
    return (r.dynCall_viii = r.asm.dynCall_viii).apply(null, arguments);
  }, r.dynCall_vif = function () {
    return (r.dynCall_vif = r.asm.dynCall_vif).apply(null, arguments);
  }, r.dynCall_iii = function () {
    return (r.dynCall_iii = r.asm.dynCall_iii).apply(null, arguments);
  }, r.dynCall_viiii = function () {
    return (r.dynCall_viiii = r.asm.dynCall_viiii).apply(null, arguments);
  }, r.dynCall_viif = function () {
    return (r.dynCall_viif = r.asm.dynCall_viif).apply(null, arguments);
  }, r.dynCall_iiii = function () {
    return (r.dynCall_iiii = r.asm.dynCall_iiii).apply(null, arguments);
  }, r.dynCall_dii = function () {
    return (r.dynCall_dii = r.asm.dynCall_dii).apply(null, arguments);
  }, r.dynCall_viid = function () {
    return (r.dynCall_viid = r.asm.dynCall_viid).apply(null, arguments);
  }, r.dynCall_vid = function () {
    return (r.dynCall_vid = r.asm.dynCall_vid).apply(null, arguments);
  }, r.dynCall_di = function () {
    return (r.dynCall_di = r.asm.dynCall_di).apply(null, arguments);
  }, r.dynCall_viddi = function () {
    return (r.dynCall_viddi = r.asm.dynCall_viddi).apply(null, arguments);
  }, r.dynCall_iiififi = function () {
    return (r.dynCall_iiififi = r.asm.dynCall_iiififi).apply(null, arguments);
  }, r.dynCall_fii = function () {
    return (r.dynCall_fii = r.asm.dynCall_fii).apply(null, arguments);
  }, r.dynCall_viiid = function () {
    return (r.dynCall_viiid = r.asm.dynCall_viiid).apply(null, arguments);
  }, r.dynCall_diii = function () {
    return (r.dynCall_diii = r.asm.dynCall_diii).apply(null, arguments);
  }, r.dynCall_viiddi = function () {
    return (r.dynCall_viiddi = r.asm.dynCall_viiddi).apply(null, arguments);
  }, r.dynCall_v = function () {
    return (r.dynCall_v = r.asm.dynCall_v).apply(null, arguments);
  }, r.dynCall_jiji = function () {
    return (r.dynCall_jiji = r.asm.dynCall_jiji).apply(null, arguments);
  }, r.dynCall_iidiiii = function () {
    return (r.dynCall_iidiiii = r.asm.dynCall_iidiiii).apply(null, arguments);
  }, r.dynCall_viiiiii = function () {
    return (r.dynCall_viiiiii = r.asm.dynCall_viiiiii).apply(null, arguments);
  }, r.dynCall_viiiii = function () {
    return (r.dynCall_viiiii = r.asm.dynCall_viiiii).apply(null, arguments);
  }, r.asm = Qt, fn = function n() {
    Ut || jt(), Ut || (fn = n);
  }, r.run = jt, r.preInit) for ("function" == typeof r.preInit && (r.preInit = [r.preInit]); r.preInit.length > 0;) {
    r.preInit.pop()();
  }
  return jt(), r.ready;
});

function v(n, r) {
  return r;
}

var d = {
  init: function init() {
    var n = s().then(function (n) {
      return Object.assign(d, l(v, n));
    });
    return d.init = function () {
      return n;
    }, n;
  }
};
module.exports = d;